import React, { Children, isValidElement, cloneElement, Component, useEffect, useState, useRef, useCallback, Fragment, useMemo } from 'react';
import ReactDOM from 'react-dom';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var reactIs_development = createCommonjsModule(function (module, exports) {



{
  (function() {

Object.defineProperty(exports, '__esModule', { value: true });

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;

var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' ||
  // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE);
}

/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

{
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`lowPriorityWarning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

var lowPriorityWarning$1 = lowPriorityWarning;

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;
    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;
          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;
              default:
                return $$typeof;
            }
        }
      case REACT_LAZY_TYPE:
      case REACT_MEMO_TYPE:
      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
}

// AsyncMode is deprecated along with isAsyncMode
var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;

var hasWarnedAboutDeprecatedIsAsyncMode = false;

// AsyncMode should be deprecated
function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true;
      lowPriorityWarning$1(false, 'The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }
  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.typeOf = typeOf;
exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isValidElementType = isValidElementType;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
  })();
}
});

unwrapExports(reactIs_development);
var reactIs_development_1 = reactIs_development.typeOf;
var reactIs_development_2 = reactIs_development.AsyncMode;
var reactIs_development_3 = reactIs_development.ConcurrentMode;
var reactIs_development_4 = reactIs_development.ContextConsumer;
var reactIs_development_5 = reactIs_development.ContextProvider;
var reactIs_development_6 = reactIs_development.Element;
var reactIs_development_7 = reactIs_development.ForwardRef;
var reactIs_development_8 = reactIs_development.Fragment;
var reactIs_development_9 = reactIs_development.Lazy;
var reactIs_development_10 = reactIs_development.Memo;
var reactIs_development_11 = reactIs_development.Portal;
var reactIs_development_12 = reactIs_development.Profiler;
var reactIs_development_13 = reactIs_development.StrictMode;
var reactIs_development_14 = reactIs_development.Suspense;
var reactIs_development_15 = reactIs_development.isValidElementType;
var reactIs_development_16 = reactIs_development.isAsyncMode;
var reactIs_development_17 = reactIs_development.isConcurrentMode;
var reactIs_development_18 = reactIs_development.isContextConsumer;
var reactIs_development_19 = reactIs_development.isContextProvider;
var reactIs_development_20 = reactIs_development.isElement;
var reactIs_development_21 = reactIs_development.isForwardRef;
var reactIs_development_22 = reactIs_development.isFragment;
var reactIs_development_23 = reactIs_development.isLazy;
var reactIs_development_24 = reactIs_development.isMemo;
var reactIs_development_25 = reactIs_development.isPortal;
var reactIs_development_26 = reactIs_development.isProfiler;
var reactIs_development_27 = reactIs_development.isStrictMode;
var reactIs_development_28 = reactIs_development.isSuspense;

var reactIs = createCommonjsModule(function (module) {

{
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var printWarning = function() {};

{
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning$1 = function() {};

{
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$1(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      {
        if (arguments.length > 1) {
          printWarning$1(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.');
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

{
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
}
});

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

var config = {
  disabled: false
};

var timeoutsShape = propTypes.oneOfType([propTypes.number, propTypes.shape({
  enter: propTypes.number,
  exit: propTypes.number,
  appear: propTypes.number
}).isRequired]);
var classNamesShape = propTypes.oneOfType([propTypes.string, propTypes.shape({
  enter: propTypes.string,
  exit: propTypes.string,
  active: propTypes.string
}), propTypes.shape({
  enter: propTypes.string,
  enterDone: propTypes.string,
  enterActive: propTypes.string,
  exit: propTypes.string,
  exitDone: propTypes.string,
  exitActive: propTypes.string
})]);

var TransitionGroupContext = React.createContext(null);

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = ReactDOM.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose$1(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      // allows for nested Transitions
      return React.createElement(TransitionGroupContext.Provider, {
        value: null
      }, children(status, childProps));
    }

    var child = React.Children.only(children);
    return (// allows for nested Transitions
      React.createElement(TransitionGroupContext.Provider, {
        value: null
      }, React.cloneElement(child, childProps))
    );
  };

  return Transition;
}(React.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: propTypes.oneOfType([propTypes.func.isRequired, propTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: propTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: propTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: propTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the
   * `<Transition>` component mounts. If you want to transition on the first
   * mount set `appear` to `true`, and the component will transition in as soon
   * as the `<Transition>` mounts.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: propTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: propTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: propTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: propTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: propTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: propTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: propTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: propTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: propTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: propTypes.func // Name the function so it is clearer in the documentation

};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _addClass = function addClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass(node, c);
  });
};

var removeClass$1 = function removeClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (node, appearing) {
      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    if (type === 'appear' && phase === 'done') {
      className += " " + this.getClassNames('enter').doneClassName;
    } // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
    }

    this.appliedClasses[type][phase] = className;

    _addClass(node, className);
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass$1(node, baseClassName);
    }

    if (activeClassName) {
      removeClass$1(node, activeClassName);
    }

    if (doneClassName) {
      removeClass$1(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        _ = _this$props.classNames,
        props = _objectWithoutPropertiesLoose$1(_this$props, ["classNames"]);

    return React.createElement(Transition, _extends$1({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(React.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes = _extends$1({}, Transition.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided and it
   * will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-appear`, `fade-appear-active`,
   * `fade-appear-done`, `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, and `fade-exit-done`.
   *
   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
   * This allows you to define different behavior for when appearing is done and
   * when regular entering is done, using selectors like
   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
   * epic entrance animation when element first appears in the DOM using
   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   * simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: propTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: propTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: propTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: propTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: propTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: propTypes.func
});

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && isValidElement(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!isValidElement(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = isValidElement(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && isValidElement(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized$1(_assertThisInitialized$1(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends$1({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose$1(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return React.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }

    return React.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, React.createElement(Component, props, children));
  };

  return TransitionGroup;
}(React.Component);

TransitionGroup.propTypes = {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: propTypes.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: propTypes.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: propTypes.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: propTypes.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: propTypes.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: propTypes.func
};
TransitionGroup.defaultProps = defaultProps;

/**
 * Inspired by code from reactStrap - https://github.com/reactstrap/reactstrap
 */

/**
 * Returns a new object with the key/value pairs from `obj` that are not in the array `omitKeys`.
 */
function omit(obj, omitKeys) {
  var result = {};
  Object.keys(obj).forEach(function (key) {
    if (omitKeys.indexOf(key) === -1) {
      result[key] = obj[key];
    }
  });
  return result;
}
/**
 * Returns a filtered copy of an object with only the specified keys.
 */

function pick(obj, keys) {
  var pickKeys = Array.isArray(keys) ? keys : [keys];
  var length = pickKeys.length;
  var key;
  var result = {};

  while (length > 0) {
    length -= 1;
    key = pickKeys[length];
    result[key] = obj[key];
  }

  return result;
} // Duplicated Transition.propType keys to ensure that Reactstrap builds
// for distribution properly exclude these keys for nested child HTML attributes
// since `react-transition-group` removes propTypes in production builds.

var TransitionPropTypeKeys = ['in', 'mountOnEnter', 'unmountOnExit', 'appear', 'enter', 'exit', 'timeout', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'];
var TransitionStatuses = {
  ENTERING: 'entering',
  ENTERED: 'entered',
  EXITING: 'exiting',
  EXITED: 'exited'
};

var _transitionStatusToCl;
var transitionStatusToClassHash = (_transitionStatusToCl = {}, _defineProperty(_transitionStatusToCl, TransitionStatuses.ENTERING, 'collapsing'), _defineProperty(_transitionStatusToCl, TransitionStatuses.ENTERED, 'collapse show'), _defineProperty(_transitionStatusToCl, TransitionStatuses.EXITING, 'collapsing'), _defineProperty(_transitionStatusToCl, TransitionStatuses.EXITED, 'collapse'), _transitionStatusToCl);

function getTransitionClass(status) {
  return transitionStatusToClassHash[status] || 'collapse';
}

function getHeight(node) {
  return node.scrollHeight;
}

var Collapse =
/*#__PURE__*/
function (_Component) {
  _inherits(Collapse, _Component);

  function Collapse(props) {
    var _this;

    _classCallCheck(this, Collapse);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Collapse).call(this, props));
    _this.state = {
      height: null
    };
    ['onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'].forEach(function (name) {
      _this[name] = _this[name].bind(_assertThisInitialized(_this));
    });
    return _this;
  }

  _createClass(Collapse, [{
    key: "onEntering",
    value: function onEntering(node, isAppearing) {
      var onEntering = this.props.onEntering;
      this.setState({
        height: getHeight(node)
      });
      onEntering(node, isAppearing);
    }
  }, {
    key: "onEntered",
    value: function onEntered(node, isAppearing) {
      var onEntered = this.props.onEntered;
      this.setState({
        height: null
      });
      onEntered(node, isAppearing);
    }
  }, {
    key: "onExit",
    value: function onExit(node) {
      var onExit = this.props.onExit;
      this.setState({
        height: getHeight(node)
      });
      onExit(node);
    }
  }, {
    key: "onExiting",
    value: function onExiting(node) {
      var onExiting = this.props.onExiting; // getting this variable triggers a reflow

      var unused = node.offsetHeight; // eslint-disable-line no-unused-vars

      this.setState({
        height: 0
      });
      onExiting(node);
    }
  }, {
    key: "onExited",
    value: function onExited(node) {
      var onExited = this.props.onExited;
      this.setState({
        height: null
      });
      onExited(node);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Tag = _this$props.tag,
          isOpen = _this$props.isOpen,
          children = _this$props.children,
          otherProps = _objectWithoutProperties(_this$props, ["tag", "isOpen", "children"]);

      var height = this.state.height;
      var transitionProps = pick(otherProps, TransitionPropTypeKeys);
      var childProps = omit(otherProps, TransitionPropTypeKeys);
      return React.createElement(Transition, _extends({}, transitionProps, {
        "in": isOpen,
        onEntering: this.onEntering,
        onEntered: this.onEntered,
        onExit: this.onExit,
        onExiting: this.onExiting,
        onExited: this.onExited
      }), function (status) {
        var collapseClass = getTransitionClass(status);
        var style = height === null ? null : {
          height: height
        };
        return React.createElement(Tag, _extends({}, childProps, {
          style: _objectSpread({}, childProps.style, style),
          className: classnames(collapseClass),
          "aria-expanded": isOpen ? 'true' : 'false'
        }), children);
      });
    }
  }]);

  return Collapse;
}(Component);

Collapse.propTypes = _objectSpread({}, Transition.propTypes, {
  isOpen: propTypes.bool,
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  tag: propTypes.oneOfType([propTypes.func, propTypes.string, propTypes.shape({
    $$typeof: propTypes.symbol,
    render: propTypes.func
  }), propTypes.arrayOf(propTypes.oneOfType([propTypes.func, propTypes.string, propTypes.shape({
    $$typeof: propTypes.symbol,
    render: propTypes.func
  })]))])
});
Collapse.defaultProps = _objectSpread({}, Transition.defaultProps, {
  isOpen: false,
  appear: false,
  enter: true,
  exit: true,
  tag: 'div',
  timeout: 350
});

// eslint-disable-next-line import/prefer-default-export

var Accordion =
/*#__PURE__*/
function (_Component) {
  _inherits(Accordion, _Component);

  function Accordion(props) {
    var _this;

    _classCallCheck(this, Accordion);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Accordion).call(this, props));
    var items = props.items,
        collapsed = props.collapsed;
    var selectedItems = collapsed ? [] : items.map(function (item) {
      return item.id;
    });
    _this.state = {
      selectedItems: selectedItems
    };
    return _this;
  }

  _createClass(Accordion, [{
    key: "toggleItem",
    value: function toggleItem(item) {
      var id = item.id;
      var _this$props = this.props,
          allowMultiple = _this$props.allowMultiple,
          trackClicked = _this$props.trackClicked;
      var selectedItems = this.state.selectedItems;
      var isOpen = selectedItems.indexOf(id) >= 0;

      if (trackClicked && !isOpen) {
        trackClicked(item);
      }

      var updatedItems = [];

      if (allowMultiple) {
        updatedItems = isOpen ? selectedItems.filter(function (i) {
          return i !== id;
        }) : [].concat(_toConsumableArray(selectedItems), [id]);
      } else if (!isOpen) {
        updatedItems = [id];
      }

      return this.setState(function () {
        return {
          selectedItems: updatedItems
        };
      });
    }
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      var title = this.props.title;

      if (title && typeof title === 'string') {
        return React.createElement("h2", {
          className: "accordion-container__title"
        }, title);
      }

      return title;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          items = _this$props2.items,
          className = _this$props2.className,
          arrowOnLeft = _this$props2.arrowOnLeft,
          title = _this$props2.title;
      var selectedItems = this.state.selectedItems;
      return React.createElement("div", {
        className: "accordion-container"
      }, title && React.createElement("div", {
        className: "accordion-container__title-container"
      }, this.renderTitle()), React.createElement("div", {
        className: classnames('accordion', className)
      }, items && items.map(function (item) {
        var isOpen = selectedItems.indexOf(item.id) >= 0;
        return React.createElement("div", {
          className: classnames('accordion__section', {
            'accordion__section--open': isOpen
          }),
          key: item.id
        }, React.createElement("button", {
          onClick: function onClick() {
            return _this2.toggleItem(item);
          },
          type: "button",
          className: classnames('accordion__button', {
            'accordion__button--leftAlign': arrowOnLeft
          })
        }, React.createElement("span", {
          className: "accordion__section-heading"
        }, item.hed), React.createElement("i", {
          className: classnames('accordion__chevron', {
            'accordion__chevron--left': arrowOnLeft,
            'zola-ui-icon-chevron-up': isOpen,
            'zola-ui-icon-chevron-down': !isOpen
          })
        })), React.createElement(Collapse, {
          isOpen: isOpen
        }, React.createElement("div", {
          className: "accordion__body"
        }, item.dek)));
      })));
    }
  }]);

  return Accordion;
}(Component);

Accordion.propTypes = {
  className: propTypes.string,
  title: propTypes.oneOfType([propTypes.string, propTypes.node]),
  items: propTypes.arrayOf(propTypes.shape({
    hed: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired,
    dek: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired,
    id: propTypes.oneOfType([propTypes.string, propTypes.number]).isRequired
  })).isRequired,

  /* Whether multiple items are allowed to be open simultaneously */
  allowMultiple: propTypes.bool,

  /* Whether the arrow appears on the left or the right (default) */
  arrowOnLeft: propTypes.bool,

  /* Whether the initial state is collapsed (default) or open */
  collapsed: propTypes.bool,

  /** Callback when an item is expanded */
  trackClicked: propTypes.func
};
Accordion.defaultProps = {
  allowMultiple: false,
  arrowOnLeft: false,
  collapsed: true
};

var ArrowButton = function ArrowButton(_ref) {
  var _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'a' : _ref$component,
      className = _ref.className,
      direction = _ref.direction,
      children = _ref.children,
      _ref$smaller = _ref.smaller,
      smaller = _ref$smaller === void 0 ? false : _ref$smaller,
      props = _objectWithoutProperties(_ref, ["component", "className", "direction", "children", "smaller"]);

  var classes = classnames('arrow-button', {
    'arrow-button--smaller': smaller
  }, "arrow-button--".concat(direction), className);
  return React.createElement(Component, _extends({
    className: classes
  }, props), children);
};

ArrowButton.propTypes = {
  className: propTypes.string,
  children: propTypes.oneOfType([propTypes.node, propTypes.arrayOf(propTypes.node)]),
  component: propTypes.oneOf(['button', 'a', 'div']),
  direction: propTypes.oneOf(['left', 'right', 'down', 'up']).isRequired,
  smaller: propTypes.bool
};

var Banner = function Banner(_ref) {
  var text = _ref.text,
      type = _ref.type,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["text", "type", "children"]);

  return React.createElement("div", _extends({
    className: classnames('zola-ui', 'banner', type)
  }, rest), typeof text === 'string' ? text : children);
};

Banner.defaultProps = {
  type: 'informational'
};
Banner.propTypes = {
  text: propTypes.string,
  type: propTypes.oneOf(['informational', 'error', 'warning', 'marketing']),
  children: propTypes.node
};

var Breadcrumbs = function Breadcrumbs(_ref) {
  var linkItems = _ref.linkItems,
      currentSelectionLabel = _ref.currentSelectionLabel,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["linkItems", "currentSelectionLabel", "className"]);

  var CurrentSelection = function CurrentSelection() {
    return React.createElement("div", {
      className: "breadcrumb__text breadcrumb__last-item"
    }, currentSelectionLabel);
  };

  return React.createElement("div", _extends({
    className: classnames('breadcrumb', className)
  }, props), linkItems.map(function (item, index) {
    var CurrentLink = function CurrentLink() {
      return React.createElement("a", {
        className: "breadcrumb__text breadcrumb__link",
        key: "breadcrumb-item-".concat(index),
        href: item.to
      }, item.label);
    };

    var lastIndex = index === linkItems.length - 1;

    if (lastIndex && !currentSelectionLabel) {
      return React.createElement(CurrentLink, {
        key: "breadcrumb-divider-".concat(index)
      });
    }

    return React.createElement(React.Fragment, {
      key: "breadcrumb-divider-".concat(index)
    }, React.createElement(CurrentLink, null), React.createElement("div", {
      className: "breadcrumb__text breadcrumb__divider"
    }, "/"), lastIndex && React.createElement(CurrentSelection, null));
  }));
};

Breadcrumbs.propTypes = {
  linkItems: propTypes.arrayOf(propTypes.shape({
    to: propTypes.string,
    label: propTypes.string
  })),
  currentSelectionLabel: propTypes.string,
  className: propTypes.string
};

/**
 * Simple button (For redesign)
 * @param {object} props - Button props
 * @param {string} props.component - Button component to be used ('button' | 'a' | 'div')
 * @param {object} props.children - Child elements
 * @param {(event) => void} props.onClick - onClick event handler
 * @param {string} props.variant - Button variant method ('primary' | 'secondary')
 * @param {string} props.className - class property
 */

var ButtonV2 = function ButtonV2(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      Component = _ref.component,
      variant = _ref.variant,
      bordered = _ref.bordered,
      compact = _ref.compact,
      fullWidth = _ref.fullWidth,
      className = _ref.className,
      type = _ref.type,
      role = _ref.role,
      target = _ref.target,
      rel = _ref.rel,
      disabled = _ref.disabled,
      tabIndex = _ref.tabIndex,
      href = _ref.href,
      props = _objectWithoutProperties(_ref, ["children", "onClick", "component", "variant", "bordered", "compact", "fullWidth", "className", "type", "role", "target", "rel", "disabled", "tabIndex", "href"]);

  var classes = classnames('v2-button', {
    'primary-button': variant === 'primary'
  }, {
    'primary-button--bordered': bordered
  }, {
    'secondary-button': variant === 'secondary'
  }, {
    'tertiary-button': variant === 'tertiary'
  }, {
    'transparent-button': variant === 'transparent'
  }, {
    'danger-button': variant === 'danger'
  }, {
    'button--compact': compact
  }, {
    'button--fullWidth': fullWidth
  }, {
    'button--disabled': disabled
  }, className);

  var elementProps = _objectSpread({
    onClick: !disabled && onClick ? onClick : undefined,
    className: classes,
    href: Component === 'a' ? href : undefined,
    tabIndex: Component === 'button' ? tabIndex : undefined
  }, props);

  if (disabled) elementProps.disabled = disabled;

  if (Component === 'button') {
    elementProps.type = type;
    elementProps.role = role;

    if (tabIndex === undefined && disabled) {
      elementProps.tabIndex = -1;
    }
  } else if (Component === 'a') {
    if (target !== '') {
      elementProps.target = target;

      if (target === '_blank') {
        elementProps.rel = "noopener noreferrer ".concat(rel);
      }
    }

    if (!href) {
      elementProps.href = '#';
    }
  }

  return React.createElement(Component, elementProps, children);
};

ButtonV2.defaultProps = {
  component: 'button',
  variant: 'primary',
  disabled: false,
  bordered: false,
  compact: false,
  fullWidth: false,
  type: 'button',
  role: 'button',
  target: '',
  rel: ''
};
ButtonV2.propTypes = {
  component: propTypes.oneOf(['button', 'a']),
  variant: propTypes.oneOf(['primary', 'secondary', 'tertiary', 'transparent', 'danger']),
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  bordered: propTypes.bool,
  compact: propTypes.bool,
  fullWidth: propTypes.bool,
  disabled: propTypes.bool,
  onClick: propTypes.func,
  className: propTypes.string,
  type: propTypes.oneOf(['button', 'submit', 'reset']),
  role: propTypes.oneOf(['button', 'link']),
  target: propTypes.string,
  rel: propTypes.string,
  tabIndex: propTypes.oneOfType([propTypes.number, propTypes.string]),
  href: propTypes.string
};

var IconButton = function IconButton(props) {
  var iconClassName = props.iconClassName,
      btnStyle = props.btnStyle,
      className = props.className,
      onClick = props.onClick;
  var classes = classnames('zola-ui', 'icon-button', 'btn', "icon-button--".concat(btnStyle), className);
  return React.createElement("button", {
    className: classes,
    onClick: onClick,
    type: "button"
  }, React.createElement("span", {
    className: "icon-button_icon ".concat(iconClassName)
  }));
};

IconButton.propTypes = {
  onClick: propTypes.func,
  btnStyle: propTypes.oneOf(['primary', 'secondary', 'tertiary']),
  className: propTypes.string,
  iconClassName: propTypes.string
};
IconButton.defaultProps = {
  btnStyle: 'primary',
  className: ''
};

var Card = function Card(_ref) {
  var copy = _ref.copy,
      subCopy = _ref.subCopy,
      isLoading = _ref.isLoading,
      iconSrc = _ref.iconSrc,
      ctaIcon = _ref.ctaIcon,
      onClick = _ref.onClick,
      ctaIconClassName = _ref.ctaIconClassName;
  return React.createElement("div", {
    className: "zola-ui card__container"
  }, React.createElement("div", {
    className: classnames('card', {
      card__with__subcopy: subCopy
    }),
    onClick: onClick
  }, !isLoading && React.createElement("div", null, React.createElement("div", {
    className: "card__body"
  }, React.createElement("img", {
    src: iconSrc,
    alt: "icon",
    className: "card__icon"
  }), React.createElement("div", {
    className: "card__text"
  }, React.createElement("p", {
    className: "card__copy"
  }, copy), subCopy && React.createElement("p", {
    className: "card__subcopy"
  }, subCopy))), ctaIcon && React.createElement(IconButton, {
    iconClassName: ctaIcon,
    className: "card__ctaButton ".concat(ctaIconClassName)
  })), isLoading && React.createElement("div", {
    className: "card__loading"
  }, React.createElement("div", {
    className: "card__loading__circle"
  }), React.createElement("div", {
    className: "card__loading__div-body"
  }, React.createElement("div", {
    className: "card__loading__div1"
  }), React.createElement("div", {
    className: "card__loading__div2"
  })))));
};

Card.propTypes = {
  copy: propTypes.node,
  subCopy: propTypes.node,
  iconSrc: propTypes.string,
  ctaIcon: propTypes.string,
  isLoading: propTypes.bool,
  onClick: propTypes.func,
  ctaIconClassName: propTypes.string
};

/**
 * InfoCard - simple container that has selcted and disabled states renders passed in content
 */

var InfoCard = function InfoCard(_ref) {
  var isActionable = _ref.isActionable,
      isDisabled = _ref.isDisabled,
      isSelected = _ref.isSelected,
      children = _ref.children;
  return React.createElement("div", {
    className: classnames('zola-ui', 'info-card', {
      'is-selected': isSelected
    }, {
      'is-actionable': isActionable
    }, {
      'is-disabled': isDisabled
    })
  }, children);
};

InfoCard.propTypes = {
  /** Disabled (usually applied to Actionable tile) will not react on hover */
  isDisabled: propTypes.bool,

  /** Actionable cards - expand on hover and have borders applied */
  isActionable: propTypes.bool,

  /** Selected state adds teal border to the info card */
  isSelected: propTypes.bool,

  /** Children will be rendered within the card */
  children: propTypes.node
};

var initialState_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false,
  // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: {
    startX: 0,
    startY: 0,
    curX: 0,
    curY: 0
  },
  trackStyle: {},
  trackWidth: 0
};
var _default = initialState;
exports["default"] = _default;
});

unwrapExports(initialState_1);

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_debounce = debounce;

var innerSliderUtils = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = void 0;

var _react = _interopRequireDefault(React);

var _reactDom = _interopRequireDefault(ReactDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }

  return onDemandSlides;
}; // return list of slides that need to be present


exports.getOnDemandLazySlides = getOnDemandLazySlides;

var getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }

  return requiredSlides;
}; // startIndex that needs to be present


exports.getRequiredLazySlides = getRequiredLazySlides;

var lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};

exports.lazyStartIndex = lazyStartIndex;

var lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};

exports.lazyEndIndex = lazyEndIndex;

var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};

exports.lazySlidesOnLeft = lazySlidesOnLeft;

var lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
}; // get width of an element


exports.lazySlidesOnRight = lazySlidesOnRight;

var getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};

exports.getWidth = getWidth;

var getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};

exports.getHeight = getHeight;

var getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);

  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }

  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }

  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }

  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
}; // whether or not we can go next


exports.getSwipeDirection = getSwipeDirection;

var canGoNext = function canGoNext(spec) {
  var canGo = true;

  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }

  return canGo;
}; // given an object and a list of keys, return new object with given keys


exports.canGoNext = canGoNext;

var extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
}; // get initialized state


exports.extractObject = extractObject;

var initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react["default"].Children.count(spec.children);

  var listWidth = Math.ceil(getWidth(_reactDom["default"].findDOMNode(spec.listRef)));
  var trackWidth = Math.ceil(getWidth(_reactDom["default"].findDOMNode(spec.trackRef)));
  var slideWidth;

  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;

    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }

    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }

  var slideHeight = _reactDom["default"].findDOMNode(spec.listRef) && getHeight(_reactDom["default"].findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;

  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }

  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides({
    currentSlide: currentSlide,
    lazyLoadedList: lazyLoadedList
  });
  lazyLoadedList.concat(slidesToLoad);
  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

exports.initializedState = initializedState;

var slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoadedList = spec.lazyLoadedList,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;
  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide,
      animationLeft,
      finalLeft;
  var state = {},
      nextState = {};

  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};

    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }

    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList.push(animationSlide);
    }

    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList
    };
    nextState = {
      animating: false
    };
  } else {
    finalSlide = animationSlide;

    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }

    animationLeft = getTrackLeft(_objectSpread({}, spec, {
      slideIndex: animationSlide
    }));
    finalLeft = getTrackLeft(_objectSpread({}, spec, {
      slideIndex: finalSlide
    }));

    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }

    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread({}, spec, {
      currentSlide: animationSlide
    })));

    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread({}, spec, {
          left: finalLeft
        })),
        lazyLoadedList: lazyLoadedList
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_objectSpread({}, spec, {
          left: animationLeft
        })),
        lazyLoadedList: lazyLoadedList
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread({}, spec, {
          left: finalLeft
        })),
        swipeLeft: null
      };
    }
  }

  return {
    state: state,
    nextState: nextState
  };
};

exports.slideHandler = slideHandler;

var changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;
  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;

    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;

    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;

    if (targetSlide === options.currentSlide) {
      return null;
    }
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;

    if (targetSlide === options.currentSlide) {
      return null;
    }

    if (infinite) {
      var direction = siblingDirection(_objectSpread({}, spec, {
        targetSlide: targetSlide
      }));

      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);

    if (targetSlide === options.currentSlide) {
      return null;
    }
  }

  return targetSlide;
};

exports.changeSlide = changeSlide;

var keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

exports.keyHandler = keyHandler;

var swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && e.preventDefault();
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};

exports.swipeStart = swipeStart;

var swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;
  if (scrolling) return;
  if (animating) return e.preventDefault();
  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
  var swipeLeft,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));

  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return {
      scrolling: true
    };
  }

  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;

  if (!infinite) {
    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;

      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }

  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }

  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }

  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }

  state = _objectSpread({}, state, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_objectSpread({}, spec, {
      left: swipeLeft
    }))
  });

  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }

  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    e.preventDefault();
  }

  return state;
};

exports.swipeMove = swipeMove;

var swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      currentSlide = spec.currentSlide,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe;

  if (!dragging) {
    if (swipe) e.preventDefault();
    return {};
  }

  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.

  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };

  if (scrolling) {
    return state;
  }

  if (!touchObject.swipeLength) {
    return state;
  }

  if (touchObject.swipeLength > minSwipe) {
    e.preventDefault();

    if (onSwipe) {
      onSwipe(swipeDirection);
    }

    var slideCount, newSlide;

    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = currentSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;

      case "right":
      case "down":
        newSlide = currentSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;

      default:
        slideCount = currentSlide;
    }

    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_objectSpread({}, spec, {
      left: currentLeft
    }));
  }

  return state;
};

exports.swipeEnd = swipeEnd;

var getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];

  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }

  return indexes;
};

exports.getNavigableIndexes = getNavigableIndexes;

var checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;

  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }

      prevNavigable = navigables[n];
    }
  }

  return index;
};

exports.checkNavigable = checkNavigable;

var getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;

  if (spec.swipeToSlide) {
    var swipedSlide;

    var slickList = _reactDom["default"].findDOMNode(spec.listRef);

    var slides = slickList.querySelectorAll(".slick-slide");
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }

    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

exports.getSlideCount = getSlideCount;

var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

exports.checkSpecKeys = checkSpecKeys;

var getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth, trackHeight;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;

  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }

  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };

  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _objectSpread({}, style, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }

  if (spec.fade) style = {
    opacity: 1
  };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight; // Fallback for IE8

  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};

exports.getTrackCSS = getTrackCSS;

var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined

  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

exports.getTrackAnimateCSS = getTrackAnimateCSS;

var getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;
  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;

  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children

    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    } // shift current slide to center of the frame


    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }

    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }

  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;

    var trackElem = _reactDom["default"].findDOMNode(trackRef);

    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;

    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;

      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }

      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

exports.getTrackLeft = getTrackLeft;

var getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  if (spec.variableWidth) {
    return spec.slideCount;
  }

  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

exports.getPreClones = getPreClones;

var getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  return spec.slideCount;
};

exports.getPostClones = getPostClones;

var getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};

exports.getTotalSlides = getTotalSlides;

var siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }

    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }

    return "left";
  }
};

exports.siblingDirection = siblingDirection;

var slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }

  if (rtl) {
    return 0;
  }

  return slidesToShow - 1;
};

exports.slidesOnRight = slidesOnRight;

var slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }

  if (rtl) {
    return slidesToShow - 1;
  }

  return 0;
};

exports.slidesOnLeft = slidesOnLeft;

var canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

exports.canUseDOM = canUseDOM;
});

unwrapExports(innerSliderUtils);
var innerSliderUtils_1 = innerSliderUtils.canUseDOM;
var innerSliderUtils_2 = innerSliderUtils.slidesOnLeft;
var innerSliderUtils_3 = innerSliderUtils.slidesOnRight;
var innerSliderUtils_4 = innerSliderUtils.siblingDirection;
var innerSliderUtils_5 = innerSliderUtils.getTotalSlides;
var innerSliderUtils_6 = innerSliderUtils.getPostClones;
var innerSliderUtils_7 = innerSliderUtils.getPreClones;
var innerSliderUtils_8 = innerSliderUtils.getTrackLeft;
var innerSliderUtils_9 = innerSliderUtils.getTrackAnimateCSS;
var innerSliderUtils_10 = innerSliderUtils.getTrackCSS;
var innerSliderUtils_11 = innerSliderUtils.checkSpecKeys;
var innerSliderUtils_12 = innerSliderUtils.getSlideCount;
var innerSliderUtils_13 = innerSliderUtils.checkNavigable;
var innerSliderUtils_14 = innerSliderUtils.getNavigableIndexes;
var innerSliderUtils_15 = innerSliderUtils.swipeEnd;
var innerSliderUtils_16 = innerSliderUtils.swipeMove;
var innerSliderUtils_17 = innerSliderUtils.swipeStart;
var innerSliderUtils_18 = innerSliderUtils.keyHandler;
var innerSliderUtils_19 = innerSliderUtils.changeSlide;
var innerSliderUtils_20 = innerSliderUtils.slideHandler;
var innerSliderUtils_21 = innerSliderUtils.initializedState;
var innerSliderUtils_22 = innerSliderUtils.extractObject;
var innerSliderUtils_23 = innerSliderUtils.canGoNext;
var innerSliderUtils_24 = innerSliderUtils.getSwipeDirection;
var innerSliderUtils_25 = innerSliderUtils.getHeight;
var innerSliderUtils_26 = innerSliderUtils.getWidth;
var innerSliderUtils_27 = innerSliderUtils.lazySlidesOnRight;
var innerSliderUtils_28 = innerSliderUtils.lazySlidesOnLeft;
var innerSliderUtils_29 = innerSliderUtils.lazyEndIndex;
var innerSliderUtils_30 = innerSliderUtils.lazyStartIndex;
var innerSliderUtils_31 = innerSliderUtils.getRequiredLazySlides;
var innerSliderUtils_32 = innerSliderUtils.getOnDemandLazySlides;

var track = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Track = void 0;

var _react = _interopRequireDefault(React);

var _classnames = _interopRequireDefault(classnames);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }

  slickCloned = index < 0 || index >= spec.slideCount;

  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;

    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }

  var slickCurrent = index === spec.currentSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL

  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";

    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }

    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];

  var childrenCount = _react["default"].Children.count(spec.children);

  var startIndex = (0, innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, innerSliderUtils.lazyEndIndex)(spec);

  _react["default"].Children.forEach(spec.children, function (elem, index) {
    var child;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    }; // in case of lazyLoad, whether or not we want to fetch the slide

    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = _react["default"].createElement("div", null);
    }

    var childStyle = getSlideStyle(_objectSpread({}, spec, {
      index: index
    }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_objectSpread({}, spec, {
      index: index
    })); // push a cloned element of the desired slide

    slides.push(_react["default"].cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames["default"])(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _objectSpread({
        outline: "none"
      }, child.props.style || {}, {}, childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);

        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    })); // if slide needs to be precloned or postcloned

    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;

      if (preCloneNo <= (0, innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;

        if (key >= startIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread({}, spec, {
          index: key
        }));
        preCloneSlides.push(_react["default"].cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread({}, child.props.style || {}, {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;

        if (key < endIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread({}, spec, {
          index: key
        }));
        postCloneSlides.push(_react["default"].cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread({}, child.props.style || {}, {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  function Track() {
    _classCallCheck(this, Track);

    return _possibleConstructorReturn(this, _getPrototypeOf(Track).apply(this, arguments));
  }

  _createClass(Track, [{
    key: "render",
    value: function render() {
      var slides = renderSlides(this.props);
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      return _react["default"].createElement("div", _extends({
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents), slides);
    }
  }]);

  return Track;
}(_react["default"].PureComponent);

exports.Track = Track;
});

unwrapExports(track);
var track_1 = track.Track;

var dots = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dots = void 0;

var _react = _interopRequireDefault(React);

var _classnames = _interopRequireDefault(classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  function Dots() {
    _classCallCheck(this, Dots);

    return _possibleConstructorReturn(this, _getPrototypeOf(Dots).apply(this, arguments));
  }

  _createClass(Dots, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      // In Autoplay the focus stays on clicked button even after transition
      // to next slide. That only goes away by click somewhere outside
      e.preventDefault();
      this.props.clickHandler(options);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var dotCount = getDotCount({
        slideCount: this.props.slideCount,
        slidesToScroll: this.props.slidesToScroll,
        slidesToShow: this.props.slidesToShow,
        infinite: this.props.infinite
      }); // Apply join & split to Array to pre-fill it for IE8
      //
      // Credit: http://stackoverflow.com/a/13735425/1849458

      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
        var leftBound = i * _this.props.slidesToScroll;
        var rightBound = i * _this.props.slidesToScroll + (_this.props.slidesToScroll - 1);
        var className = (0, _classnames["default"])({
          "slick-active": _this.props.currentSlide >= leftBound && _this.props.currentSlide <= rightBound
        });
        var dotOptions = {
          message: "dots",
          index: i,
          slidesToScroll: _this.props.slidesToScroll,
          currentSlide: _this.props.currentSlide
        };

        var onClick = _this.clickHandler.bind(_this, dotOptions);

        return _react["default"].createElement("li", {
          key: i,
          className: className
        }, _react["default"].cloneElement(_this.props.customPaging(i), {
          onClick: onClick
        }));
      });
      return _react["default"].cloneElement(this.props.appendDots(dots), _objectSpread({
        className: this.props.dotsClass
      }, mouseEvents));
    }
  }]);

  return Dots;
}(_react["default"].PureComponent);

exports.Dots = Dots;
});

unwrapExports(dots);
var dots_1 = dots.Dots;

var arrows = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NextArrow = exports.PrevArrow = void 0;

var _react = _interopRequireDefault(React);

var _classnames = _interopRequireDefault(classnames);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PrevArrow =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _possibleConstructorReturn(this, _getPrototypeOf(PrevArrow).apply(this, arguments));
  }

  _createClass(PrevArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var prevClasses = {
        "slick-arrow": true,
        "slick-prev": true
      };
      var prevHandler = this.clickHandler.bind(this, {
        message: "previous"
      });

      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
        prevClasses["slick-disabled"] = true;
        prevHandler = null;
      }

      var prevArrowProps = {
        key: "0",
        "data-role": "none",
        className: (0, _classnames["default"])(prevClasses),
        style: {
          display: "block"
        },
        onClick: prevHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var prevArrow;

      if (this.props.prevArrow) {
        prevArrow = _react["default"].cloneElement(this.props.prevArrow, _objectSpread({}, prevArrowProps, {}, customProps));
      } else {
        prevArrow = _react["default"].createElement("button", _extends({
          key: "0",
          type: "button"
        }, prevArrowProps), " ", "Previous");
      }

      return prevArrow;
    }
  }]);

  return PrevArrow;
}(_react["default"].PureComponent);

exports.PrevArrow = PrevArrow;

var NextArrow =
/*#__PURE__*/
function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _possibleConstructorReturn(this, _getPrototypeOf(NextArrow).apply(this, arguments));
  }

  _createClass(NextArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var nextClasses = {
        "slick-arrow": true,
        "slick-next": true
      };
      var nextHandler = this.clickHandler.bind(this, {
        message: "next"
      });

      if (!(0, innerSliderUtils.canGoNext)(this.props)) {
        nextClasses["slick-disabled"] = true;
        nextHandler = null;
      }

      var nextArrowProps = {
        key: "1",
        "data-role": "none",
        className: (0, _classnames["default"])(nextClasses),
        style: {
          display: "block"
        },
        onClick: nextHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var nextArrow;

      if (this.props.nextArrow) {
        nextArrow = _react["default"].cloneElement(this.props.nextArrow, _objectSpread({}, nextArrowProps, {}, customProps));
      } else {
        nextArrow = _react["default"].createElement("button", _extends({
          key: "1",
          type: "button"
        }, nextArrowProps), " ", "Next");
      }

      return nextArrow;
    }
  }]);

  return NextArrow;
}(_react["default"].PureComponent);

exports.NextArrow = NextArrow;
});

unwrapExports(arrows);
var arrows_1 = arrows.NextArrow;
var arrows_2 = arrows.PrevArrow;

/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

var innerSlider = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InnerSlider = void 0;

var _react = _interopRequireDefault(React);

var _reactDom = _interopRequireDefault(ReactDOM);

var _initialState = _interopRequireDefault(initialState_1);

var _lodash = _interopRequireDefault(lodash_debounce);

var _classnames = _interopRequireDefault(classnames);









var _resizeObserverPolyfill = _interopRequireDefault(index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InnerSlider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  function InnerSlider(props) {
    var _this;

    _classCallCheck(this, InnerSlider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InnerSlider).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "listRefHandler", function (ref) {
      return _this.list = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "trackRefHandler", function (ref) {
      return _this.track = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "adaptHeight", function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));

        _this.list.style.height = (0, innerSliderUtils.getHeight)(elem) + "px";
      }
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      _this.ssrInit();

      _this.props.onInit && _this.props.onInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, innerSliderUtils.getOnDemandLazySlides)(_objectSpread({}, _this.props, {}, _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props);

      _this.updateState(spec, true, function () {
        _this.adaptHeight();

        _this.props.autoplay && _this.autoPlay("update");
      });

      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }

      _this.ro = new _resizeObserverPolyfill["default"](function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation


          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });

      _this.ro.observe(_this.list);

      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      }); // To support server-side rendering

      if (!window) {
        return;
      }

      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }

      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }

      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });

        _this.callbackTimers = [];
      }

      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }

      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, nextProps, {}, _this.state);

      var setTrackStyle = false;

      for (var _i = 0, _Object$keys = Object.keys(_this.props); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];

        if (!nextProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }

        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
          continue;
        }

        if (nextProps[key] !== _this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }

      _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react["default"].Children.count(nextProps.children)) {
          _this.changeSlide({
            message: "index",
            index: _react["default"].Children.count(nextProps.children) - nextProps.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }

        if (nextProps.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function () {
      _this.checkImagesLoad();

      _this.props.onReInit && _this.props.onReInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, innerSliderUtils.getOnDemandLazySlides)(_objectSpread({}, _this.props, {}, _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      } // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }


      _this.adaptHeight();
    });

    _defineProperty(_assertThisInitialized(_this), "onWindowResized", function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash["default"])(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);

      _this.debouncedResize();
    });

    _defineProperty(_assertThisInitialized(_this), "resizeWindow", function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (!_reactDom["default"].findDOMNode(_this.track)) return;

      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props, {}, _this.state);

      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      }); // animating state should be cleared while resizing, otherwise autoplay stops working


      _this.setState({
        animating: false
      });

      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    });

    _defineProperty(_assertThisInitialized(_this), "updateState", function (spec, setTrackStyle, callback) {
      var updatedState = (0, innerSliderUtils.initializedState)(spec);
      spec = _objectSpread({}, spec, {}, updatedState, {
        slideIndex: updatedState.currentSlide
      });
      var targetLeft = (0, innerSliderUtils.getTrackLeft)(spec);
      spec = _objectSpread({}, spec, {
        left: targetLeft
      });
      var trackStyle = (0, innerSliderUtils.getTrackCSS)(spec);

      if (setTrackStyle || _react["default"].Children.count(_this.props.children) !== _react["default"].Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }

      _this.setState(updatedState, callback);
    });

    _defineProperty(_assertThisInitialized(_this), "ssrInit", function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, innerSliderUtils.getPreClones)(_objectSpread({}, _this.props, {}, _this.state, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, innerSliderUtils.getPostClones)(_objectSpread({}, _this.props, {}, _this.state, {
          slideCount: _this.props.children.length
        }));

        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });

        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }

        for (var _i2 = 0; _i2 < postClones; _i2++) {
          _trackWidth += childrenWidths[_i2];
        }

        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
          _trackLeft += childrenWidths[_i3];
        }

        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };

        if (_this.props.centerMode) {
          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
        }

        _this.setState({
          trackStyle: _trackStyle
        });

        return;
      }

      var childrenCount = _react["default"].Children.count(_this.props.children);

      var spec = _objectSpread({}, _this.props, {}, _this.state, {
        slideCount: childrenCount
      });

      var slideCount = (0, innerSliderUtils.getPreClones)(spec) + (0, innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;

      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }

      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };

      _this.setState({
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      });
    });

    _defineProperty(_assertThisInitialized(_this), "checkImagesLoad", function () {
      var images = document.querySelectorAll(".slick-slide img");
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };

        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;

          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }

        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();

              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;

            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "progressiveLazyLoad", function () {
      var slidesToLoad = [];

      var spec = _objectSpread({}, _this.props, {}, _this.state);

      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }

      for (var _index = _this.state.currentSlide - 1; _index >= -(0, innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }

      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });

        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "slideHandler", function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange; // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, innerSliderUtils.slideHandler)(_objectSpread({
        index: index
      }, _this.props, {}, _this.state, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);

      _this.setState(state, function () {
        asNavFor && asNavFor.innerSlider.slideHandler(index);
        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({
                animating: animating
              });
            }, 10));

            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "changeSlide", function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _objectSpread({}, _this.props, {}, _this.state);

      var targetSlide = (0, innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;

      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clickHandler", function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }

      _this.clickable = true;
    });

    _defineProperty(_assertThisInitialized(_this), "keyHandler", function (e) {
      var dir = (0, innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({
        message: dir
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectHandler", function (options) {
      _this.changeSlide(options);
    });

    _defineProperty(_assertThisInitialized(_this), "disableBodyScroll", function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };

      window.ontouchmove = preventDefault;
    });

    _defineProperty(_assertThisInitialized(_this), "enableBodyScroll", function () {
      window.ontouchmove = null;
    });

    _defineProperty(_assertThisInitialized(_this), "swipeStart", function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }

      var state = (0, innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this), "swipeMove", function (e) {
      var state = (0, innerSliderUtils.swipeMove)(e, _objectSpread({}, _this.props, {}, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;

      if (state["swiping"]) {
        _this.clickable = false;
      }

      _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this), "swipeEnd", function (e) {
      var state = (0, innerSliderUtils.swipeEnd)(e, _objectSpread({}, _this.props, {}, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];

      _this.setState(state);

      if (triggerSlideHandler === undefined) return;

      _this.slideHandler(triggerSlideHandler);

      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "previous"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "next"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      slide = Number(slide);
      if (isNaN(slide)) return "";

      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "play", function () {
      var nextIndex;

      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, innerSliderUtils.canGoNext)(_objectSpread({}, _this.props, {}, _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "autoPlay", function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      var autoplaying = _this.state.autoplaying;

      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }

      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);

      _this.setState({
        autoplaying: "playing"
      });
    });

    _defineProperty(_assertThisInitialized(_this), "pause", function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }

      var autoplaying = _this.state.autoplaying;

      if (pauseType === "paused") {
        _this.setState({
          autoplaying: "paused"
        });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({
            autoplaying: "focused"
          });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({
            autoplaying: "hovered"
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDotsOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_this), "onDotsLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_this), "onTrackOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_this), "onTrackLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_this), "onSlideFocus", function () {
      return _this.props.autoplay && _this.pause("focused");
    });

    _defineProperty(_assertThisInitialized(_this), "onSlideBlur", function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var className = (0, _classnames["default"])("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });

      var spec = _objectSpread({}, _this.props, {}, _this.state);

      var trackProps = (0, innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
      var pauseOnHover = _this.props.pauseOnHover;
      trackProps = _objectSpread({}, trackProps, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
      });
      var dots$1;

      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
        dotProps = _objectSpread({}, dotProps, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots$1 = _react["default"].createElement(dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = _react["default"].createElement(arrows.PrevArrow, arrowProps);
        nextArrow = _react["default"].createElement(arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _objectSpread({}, verticalHeightStyle, {}, centerPaddingStyle);

      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.swipeEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };
      var innerSliderProps = {
        className: className,
        dir: "ltr",
        style: _this.props.style
      };

      if (_this.props.unslick) {
        listProps = {
          className: "slick-list"
        };
        innerSliderProps = {
          className: className
        };
      }

      return _react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", _react["default"].createElement("div", _extends({
        ref: _this.listRefHandler
      }, listProps), _react["default"].createElement(track.Track, _extends({
        ref: _this.trackRefHandler
      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots$1 : "");
    });

    _this.list = null;
    _this.track = null;
    _this.state = _objectSpread({}, _initialState["default"], {
      currentSlide: _this.props.initialSlide,
      slideCount: _react["default"].Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;
    return _this;
  }

  return InnerSlider;
}(_react["default"].Component);

exports.InnerSlider = InnerSlider;
});

unwrapExports(innerSlider);
var innerSlider_1 = innerSlider.InnerSlider;

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

var camel2hyphen_1 = camel2hyphen;

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen_1(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and ';
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', ';
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

var json2mq_1 = json2mq;

var defaultProps_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(React);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return _react["default"].createElement("ul", {
      style: {
        display: "block"
      }
    }, dots);
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return _react["default"].createElement("button", null, i + 1);
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};
var _default = defaultProps;
exports["default"] = _default;
});

unwrapExports(defaultProps_1);

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

var QueryHandler_1 = QueryHandler;

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

var Util = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};

var each$1 = Util.each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler_1(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each$1(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each$1(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each$1(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

var MediaQuery_1 = MediaQuery;

var each$2 = Util.each;
var isFunction$1 = Util.isFunction;
var isArray$1 = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery_1(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction$1(options)) {
            options = { match : options };
        }
        if(!isArray$1(options)) {
            options = [options];
        }
        each$2(options, function(handler) {
            if (isFunction$1(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

var MediaQueryDispatch_1 = MediaQueryDispatch;

var src = new MediaQueryDispatch_1();

var slider = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(React);



var _json2mq = _interopRequireDefault(json2mq_1);

var _defaultProps = _interopRequireDefault(defaultProps_1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var enquire = (0, innerSliderUtils.canUseDOM)() && src;

var Slider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    var _this;

    _classCallCheck(this, Slider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Slider).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "innerSliderRefHandler", function (ref) {
      return _this.innerSlider = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      return _this.innerSlider.slickPrev();
    });

    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      return _this.innerSlider.slickNext();
    });

    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    });

    _defineProperty(_assertThisInitialized(_this), "slickPause", function () {
      return _this.innerSlider.pause("paused");
    });

    _defineProperty(_assertThisInitialized(_this), "slickPlay", function () {
      return _this.innerSlider.autoPlay("play");
    });

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  _createClass(Slider, [{
    key: "media",
    value: function media(query, handler) {
      // javascript handler for  css media query
      enquire.register(query, handler);

      this._responsiveMediaHandlers.push({
        query: query,
        handler: handler
      });
    } // handles responsive breakpoints

  }, {
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var _this2 = this;

      // performance monitoring
      //if ("development" !== 'production') {
      //const { whyDidYouUpdate } = require('why-did-you-update')
      //whyDidYouUpdate(React)
      //}
      if (this.props.responsive) {
        var breakpoints = this.props.responsive.map(function (breakpt) {
          return breakpt.breakpoint;
        }); // sort them in increasing order of their numerical value

        breakpoints.sort(function (x, y) {
          return x - y;
        });
        breakpoints.forEach(function (breakpoint, index) {
          // media query for each breakpoint
          var bQuery;

          if (index === 0) {
            bQuery = (0, _json2mq["default"])({
              minWidth: 0,
              maxWidth: breakpoint
            });
          } else {
            bQuery = (0, _json2mq["default"])({
              minWidth: breakpoints[index - 1] + 1,
              maxWidth: breakpoint
            });
          } // when not using server side rendering


          (0, innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
            _this2.setState({
              breakpoint: breakpoint
            });
          });
        }); // Register media query for full screen. Need to support resize from small to large
        // convert javascript object to media query string

        var query = (0, _json2mq["default"])({
          minWidth: breakpoints.slice(-1)[0]
        });
        (0, innerSliderUtils.canUseDOM)() && this.media(query, function () {
          _this2.setState({
            breakpoint: null
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._responsiveMediaHandlers.forEach(function (obj) {
        enquire.unregister(obj.query, obj.handler);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var settings;
      var newProps;

      if (this.state.breakpoint) {
        newProps = this.props.responsive.filter(function (resp) {
          return resp.breakpoint === _this3.state.breakpoint;
        });
        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread({}, _defaultProps["default"], {}, this.props, {}, newProps[0].settings);
      } else {
        settings = _objectSpread({}, _defaultProps["default"], {}, this.props);
      } // force scrolling by one if centerMode is on


      if (settings.centerMode) {
        if (settings.slidesToScroll > 1 && "development" !== "production") {
          console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
        }

        settings.slidesToScroll = 1;
      } // force showing one slide and scrolling by one if the fade mode is on


      if (settings.fade) {
        if (settings.slidesToShow > 1 && "development" !== "production") {
          console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
        }

        if (settings.slidesToScroll > 1 && "development" !== "production") {
          console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
        }

        settings.slidesToShow = 1;
        settings.slidesToScroll = 1;
      } // makes sure that children is an array, even when there is only 1 child


      var children = _react["default"].Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
      // children may also contain string filled with spaces (in certain cases where we use jsx strings)


      children = children.filter(function (child) {
        if (typeof child === "string") {
          return !!child.trim();
        }

        return !!child;
      }); // rows and slidesPerRow logic is handled here

      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
        settings.variableWidth = false;
      }

      var newChildren = [];
      var currentWidth = null;

      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
        var newSlide = [];

        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
          var row = [];

          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
            if (settings.variableWidth && children[k].props.style) {
              currentWidth = children[k].props.style.width;
            }

            if (k >= children.length) break;
            row.push(_react["default"].cloneElement(children[k], {
              key: 100 * i + 10 * j + k,
              tabIndex: -1,
              style: {
                width: "".concat(100 / settings.slidesPerRow, "%"),
                display: "inline-block"
              }
            }));
          }

          newSlide.push(_react["default"].createElement("div", {
            key: 10 * i + j
          }, row));
        }

        if (settings.variableWidth) {
          newChildren.push(_react["default"].createElement("div", {
            key: i,
            style: {
              width: currentWidth
            }
          }, newSlide));
        } else {
          newChildren.push(_react["default"].createElement("div", {
            key: i
          }, newSlide));
        }
      }

      if (settings === "unslick") {
        var className = "regular slider " + (this.props.className || "");
        return _react["default"].createElement("div", {
          className: className
        }, newChildren);
      } else if (newChildren.length <= settings.slidesToShow) {
        settings.unslick = true;
      }

      return _react["default"].createElement(innerSlider.InnerSlider, _extends({
        style: this.props.style,
        ref: this.innerSliderRefHandler
      }, settings), newChildren);
    }
  }]);

  return Slider;
}(_react["default"].Component);

exports["default"] = Slider;
});

unwrapExports(slider);

var lib = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slider = _interopRequireDefault(slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _slider["default"];
exports["default"] = _default;
});

var Slider = unwrapExports(lib);

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var _arrayEach = arrayEach;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var _createBaseFor = createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = _createBaseFor();

var _baseFor = baseFor;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes;

/** Detect free variable `global` from Node.js. */
var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal$1;

/** Detect free variable `self`. */
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$1 = _freeGlobal || freeSelf$1 || Function('return this')();

var _root = root$1;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$1.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$1.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$2.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString$1;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$1(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}

var _baseIsArguments = baseIsArguments;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return isObjectLike_1(value) && hasOwnProperty$2.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

var isArguments_1 = isArguments;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray$2 = Array.isArray;

var isArray_1 = isArray$2;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

var isBuffer_1 = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse_1;

module.exports = isBuffer;
});

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

var isLength_1 = isLength;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike_1(value) &&
    isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
});

/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

var isTypedArray_1 = isTypedArray;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
      isArg = !isArr && isArguments_1(value),
      isBuff = !isArr && !isArg && isBuffer_1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$3.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$5;

  return value === proto;
}

var _isPrototype = isPrototype;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

var _nativeKeys = nativeKeys;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$6.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$4.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$1;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag$1 = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$2(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction$2;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

var keys_1 = keys;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && _baseFor(object, iteratee, keys_1);
}

var _baseForOwn = baseForOwn;

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike_1(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

var _createBaseEach = createBaseEach;

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = _createBaseEach(_baseForOwn);

var _baseEach = baseEach;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

var identity_1 = identity;

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity_1;
}

var _castFunction = castFunction;

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray_1(collection) ? _arrayEach : _baseEach;
  return func(collection, _castFunction(iteratee));
}

var forEach_1 = forEach;

/**
 * Directional button to move to a different section on the same page
 * Note: The disabled line is to address a screen reader issue: https://hub.accessible360.com/issues/60593/edit
 */

var ChevronButton = function ChevronButton(props) {
  var direction = props.direction,
      btnStyle = props.btnStyle,
      className = props.className,
      onClick = props.onClick,
      ariaLabel = props.ariaLabel,
      inverse = props.inverse,
      anchor = props.anchor;
  var classes = classnames('zola-ui', 'chevron-button', 'btn', "chevron-button--".concat(btnStyle), inverse ? 'chevron-button--inverse' : '', className);

  if (anchor) {
    return React.createElement("a", {
      href: "#".concat(anchor),
      className: classes,
      onClick: onClick,
      "aria-label": ariaLabel || "navigate ".concat(direction)
    }, ' ', React.createElement("span", {
      className: "chevron-button_icon chevron-button_icon--".concat(direction, " zola-ui-icon-chevron-").concat(direction),
      "aria-hidden": "true"
    }));
  }

  return React.createElement("button", {
    "aria-label": ariaLabel || "navigate ".concat(direction),
    type: "button",
    className: classes,
    onClick: onClick
  }, React.createElement("span", {
    className: "chevron-button_icon chevron-button_icon--".concat(direction, " zola-ui-icon-chevron-").concat(direction),
    "aria-hidden": "true"
  }));
};

ChevronButton.propTypes = {
  onClick: propTypes.func,
  direction: propTypes.oneOf(['left', 'right', 'up', 'down']).isRequired,
  btnStyle: propTypes.oneOf(['primary', 'secondary', 'tertiary']),
  className: propTypes.string,
  ariaLabel: propTypes.string,
  inverse: propTypes.bool,
  anchor: propTypes.string
};
ChevronButton.defaultProps = {
  btnStyle: 'primary',
  className: '',
  inverse: false
};

// eslint-disable-next-line react/prop-types

var SlickButtonFix = function SlickButtonFix(_ref) {
  var currentSlide = _ref.currentSlide,
      slideCount = _ref.slideCount,
      props = _objectWithoutProperties(_ref, ["currentSlide", "slideCount"]);

  return React.createElement(ArrowButton, props);
};

var defaultSettings = {
  dots: false,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 4,
  lazyLoad: 'ondemand',
  // 'ondemand' is default, other option is 'progressive'
  responsive: [{
    breakpoint: 992,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3
    }
  }, {
    breakpoint: 768,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }]
};

var Carousel =
/*#__PURE__*/
function (_Component) {
  _inherits(Carousel, _Component);

  function Carousel(props) {
    var _this;

    _classCallCheck(this, Carousel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Carousel).call(this, props));
    _this.state = {
      isTransitioning: false,
      extraSlides: [],
      lastScreenWidth: null
    };
    _this.afterChange = _this.afterChange.bind(_assertThisInitialized(_this));
    _this.beforeChange = _this.beforeChange.bind(_assertThisInitialized(_this));
    _this.getVisibleSlideCount = _this.getVisibleSlideCount.bind(_assertThisInitialized(_this));
    _this.onInit = _this.onInit.bind(_assertThisInitialized(_this));
    _this.onLazyLoad = _this.onLazyLoad.bind(_assertThisInitialized(_this));
    _this.onReInit = _this.onReInit.bind(_assertThisInitialized(_this));
    _this.updateActiveDots = _this.updateActiveDots.bind(_assertThisInitialized(_this));
    _this.updateVisibility = _this.updateVisibility.bind(_assertThisInitialized(_this));
    _this.updateDimensions = _this.updateDimensions.bind(_assertThisInitialized(_this));
    _this.getExtraSlides = _this.getExtraSlides.bind(_assertThisInitialized(_this));
    _this.sliderRef = React.createRef();
    return _this;
  }

  _createClass(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateDimensions();
      window.addEventListener('resize', this.updateDimensions);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions);
    }
  }, {
    key: "onInit",
    value: function onInit() {
      this.updateActiveDots();
      this.updateVisibility();
    }
  }, {
    key: "onLazyLoad",
    value: function onLazyLoad() {
      var isTransitioning = this.state.isTransitioning;
      if (isTransitioning) return;
      this.onInit();
    }
  }, {
    key: "onReInit",
    value: function onReInit() {
      var isTransitioning = this.state.isTransitioning;
      if (isTransitioning) return;
      this.onInit();
    }
  }, {
    key: "getVisibleSlideCount",
    value: function getVisibleSlideCount() {
      if (!this.node) return 0;
      var slides = this.node.querySelectorAll('.slick-slide.slick-active') || [];
      return slides.length;
    }
    /**
     * When the screen resizes, or initially draws, this will, if configured,
     * create fake slides and add them to the carousel.   This works around
     * a bug with our attempts to set visibility for items in the carousel.
     * For accessibility reasons, we need visible=false, aria-hidden=true on
     * any slide that is not visible.  The underlying react-slick component does
     * some interesting things to show slides (cloning and using css transforms)
     * that makes it difficult to get the visibility settings correct.  However,
     * if we have the an even multiple of the slides in the carousel it works.
     *
     */

  }, {
    key: "getExtraSlides",
    value: function getExtraSlides(width) {
      var _this$props = this.props,
          settings = _this$props.settings,
          padSlides = _this$props.padSlides;
      if (!padSlides) return;
      var content = this.props.content;
      var numActuallyShown = settings.slidesToShow;

      if (settings.responsive) {
        var sortedResponsiveSettings = settings.responsive.sort(function (a, b) {
          return a.breakpoint - b.breakpoint;
        });
        var appliedSetting = sortedResponsiveSettings.find(function (setting) {
          return setting.breakpoint >= width;
        });

        if (appliedSetting && appliedSetting.settings) {
          numActuallyShown = appliedSetting.settings.slidesToShow;
        }
      }

      var fakeSlides = [];

      if (content.length % numActuallyShown !== 0) {
        var fakeSlideCount = numActuallyShown - content.length % numActuallyShown;

        for (var i = 0; i < fakeSlideCount; i += 1) {
          fakeSlides.push(React.createElement("div", {
            className: "fake-slide",
            key: "fake-slide-".concat(i),
            style: {
              visibility: 'hidden'
            }
          }));
        }
      }

      this.setState({
        extraSlides: fakeSlides
      });
    }
  }, {
    key: "updateDimensions",
    value: function updateDimensions() {
      // On mobile, resize events will fire as you scroll the screen
      // so we need anything dealing with resize to only fire if the
      // width has actually changed.  Its subtle, but on actual devices
      // (or simulators) the brower nav bar and nav buttons change sizes
      // during scroll, changing the height, but not the width.
      var currenScreenWidth = window.innerWidth;
      var lastScreenWidth = this.state.lastScreenWidth;
      var hasWidthChanged = currenScreenWidth !== lastScreenWidth;

      if (hasWidthChanged) {
        // When the screen resizes, we _could_ end up in a situtation where we
        // showing a page that no longer exists, or we're offset into the slide
        // index incorrectly because of the fake cards we've added, so we'll
        // jump back to the first card.  This isn't ideal.
        if (this.sliderRef.current) {
          this.sliderRef.current.slickGoTo(0);
        }

        this.getExtraSlides();
      }

      this.setState({
        lastScreenWidth: currenScreenWidth
      });
    }
  }, {
    key: "afterChange",
    value: function afterChange() {
      this.setState({
        isTransitioning: false
      });
      this.updateActiveDots();
      this.updateVisibility();
    }
  }, {
    key: "beforeChange",
    value: function beforeChange() {
      this.setState({
        isTransitioning: true
      });
      if (!this.node) return;
      var slides = this.node.querySelectorAll('.slick-slide') || [];

      forEach_1(slides, function (s) {
        // eslint-disable-next-line no-param-reassign
        s.style.visibility = 'visible';
      });
    }
  }, {
    key: "customPaging",
    value: function customPaging(index) {
      var slideNumber = index + 1;
      return React.createElement("button", {
        type: "button",
        className: "carousel-dot__container",
        "aria-label": "Select Slide ".concat(slideNumber)
      }, React.createElement("div", {
        className: "carousel-dot"
      }));
    }
  }, {
    key: "updateVisibility",
    value: function updateVisibility() {
      var padSlides = this.props.padSlides;
      if (!this.node) return;
      var slides = this.node.querySelectorAll('.slick-slide') || [];

      forEach_1(slides, function (s) {
        var visibility = 'hidden';

        if (s.className.indexOf('slick-active') > -1) {
          visibility = 'visible';

          if (padSlides) {
            // If we created fake slides, we should hide them from screen readers.
            if ((s.querySelectorAll('.fake-slide') || []).length > 0) {
              visibility = 'hidden';
              s.setAttribute('aria-hidden', true);
            }
          } else if (s.getAttribute('aria-hidden') === 'false') {
            // Remove aria-hidden="false" for web accessibility
            s.removeAttribute('aria-hidden');
          }
        } // eslint-disable-next-line no-param-reassign


        s.style.visibility = visibility;
      });
    }
  }, {
    key: "updateActiveDots",
    value: function updateActiveDots() {
      if (!this.node) return;
      var dots = this.node.querySelectorAll('.carousel-dot') || [];

      forEach_1(dots, function (dot) {
        var classNames = dot.parentNode.parentNode.className || '';
        var isSelected = classNames.indexOf('slick-active') > -1;
        var ariaCurrent = isSelected ? 'true' : 'false';
        dot.parentNode.setAttribute('aria-current', ariaCurrent);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          content = _this$props2.content,
          settings = _this$props2.settings,
          btnStyle = _this$props2.btnStyle,
          className = _this$props2.className,
          ariaLabelSlideType = _this$props2.ariaLabelSlideType,
          useV2ArrowStyles = _this$props2.useV2ArrowStyles,
          btnInverse = _this$props2.btnInverse,
          useSmallerV2Arrows = _this$props2.useSmallerV2Arrows;
      var classes = classnames('zola-ui', 'carousel__container', className);
      var visibleSlideCount = this.getVisibleSlideCount();
      var multipleVisibleSlides = visibleSlideCount > 1;
      var countText = multipleVisibleSlides ? " ".concat(visibleSlideCount) : '';
      var typeText = multipleVisibleSlides ? "".concat(ariaLabelSlideType, "s") : ariaLabelSlideType;
      var ariaLabelNext = "Next".concat(countText, " ").concat(typeText);
      var ariaLabelPrevious = "Previous".concat(countText, " ").concat(typeText);
      var extraSlides = this.state.extraSlides;
      return React.createElement("div", {
        className: classes,
        ref: function ref(node) {
          _this2.node = node;
        }
      }, React.createElement(Slider, _extends({
        nextArrow: useV2ArrowStyles ? React.createElement(SlickButtonFix, {
          smaller: useSmallerV2Arrows,
          direction: "right",
          component: "button",
          "aria-label": ariaLabelNext
        }) : React.createElement(ChevronButton, {
          direction: "right",
          btnStyle: btnStyle,
          inverse: btnInverse,
          ariaLabel: ariaLabelNext
        }),
        prevArrow: useV2ArrowStyles ? React.createElement(SlickButtonFix, {
          smaller: useSmallerV2Arrows,
          direction: "left",
          component: "button",
          "aria-label": ariaLabelPrevious
        }) : React.createElement(ChevronButton, {
          direction: "left",
          btnStyle: btnStyle,
          inverse: btnInverse,
          ariaLabel: ariaLabelPrevious
        }),
        afterChange: this.afterChange,
        beforeChange: this.beforeChange,
        customPaging: this.customPaging,
        onInit: this.onInit,
        onLazyLoad: this.onLazyLoad,
        onReInit: this.onReInit,
        ref: this.sliderRef
      }, settings), content, extraSlides));
    }
  }]);

  return Carousel;
}(Component);

Carousel.propTypes = {
  content: propTypes.node.isRequired,

  /** settings to configure the underlying carousel.  See https://react-slick.neostack.com/docs/api/  */
  settings: propTypes.shape({}),
  btnStyle: propTypes.oneOf(['primary', 'secondary', 'tertiary']),
  className: propTypes.string,
  ariaLabelSlideType: propTypes.string,

  /** If set to true, the slides will be padded to an even multiple of the slidesToShow setting to prevent dissapearing slides. */
  padSlides: propTypes.bool,
  useV2ArrowStyles: propTypes.bool,
  useSmallerV2Arrows: propTypes.bool,
  btnInverse: propTypes.bool,
  noArrows: propTypes.bool
};
Carousel.defaultProps = {
  btnStyle: 'primary',
  settings: defaultSettings,
  ariaLabelSlideType: 'Slide',
  padSlides: false,
  useV2ArrowStyles: false,
  btnInverse: false
};

var WhiteCircleIcon = function WhiteCircleIcon(props) {
  return React.createElement(CircleIcon, _extends({
    variant: "white"
  }, props));
};
var CreamCircleIcon = function CreamCircleIcon(props) {
  return React.createElement(CircleIcon, _extends({
    variant: "cream"
  }, props));
};
var ClearCircleIcon = function ClearCircleIcon(props) {
  return React.createElement(CircleIcon, _extends({
    variant: "transparent"
  }, props));
};

var CircleIcon = function CircleIcon(props) {
  var alt = props.alt,
      className = props.className,
      image = props.image,
      size = props.size,
      variant = props.variant,
      rest = _objectWithoutProperties(props, ["alt", "className", "image", "size", "variant"]);

  var classes = classnames('zola-ui', 'circle-icon', className, variant);
  var defaults = {
    height: size,
    width: size
  };
  var imageProps = Object.assign({}, defaults, rest);
  return React.createElement("img", _extends({
    className: classes,
    src: image,
    alt: alt
  }, imageProps));
};

CircleIcon.propTypes = {
  /**
   * Alt text for img element
   */
  alt: propTypes.string,

  /**
   * Custom CSS classes for the element
   */
  className: propTypes.string,

  /**
   * The SVG image to render.
   */
  image: propTypes.string.isRequired,

  /**
   * Desired height/width, in pixels
   */
  size: propTypes.number,

  /**
   * Specify a variant background color
   */
  variant: propTypes.oneOf(['cream', 'white', 'transparent'])
};
CircleIcon.defaultProps = {
  alt: '',
  size: 50,
  variant: 'cream'
};

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

var _apply = apply;

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag$1);
}

var isSymbol_1 = isSymbol$1;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray_1(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol_1(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey;

/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];

var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
    objectProto$7 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$1.call(hasOwnProperty$5).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

var _nativeCreate = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$6.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$7.call(data, key);
}

var _hashHas = hashHas;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

var _Hash = Hash;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

var _ListCache = ListCache;

/* Built-in method references that are verified to be native. */
var Map$1 = _getNative(_root, 'Map');

var _Map = Map$1;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

var _mapCacheClear = mapCacheClear;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

var _MapCache = MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || _MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = _MapCache;

var memoize_1 = memoize;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize_1(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (isSymbol_1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

var _baseToString = baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1 = toString;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray_1(value)) {
    return value;
  }
  return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
}

var _castPath = castPath;

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

var last_1 = last;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol_1(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

var _toKey = toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = _castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

var _baseSlice = baseSlice;

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : _baseGet(object, _baseSlice(path, 0, -1));
}

var _parent = parent;

/**
 * The base implementation of `_.invoke` without support for individual
 * method arguments.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {Array} args The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 */
function baseInvoke(object, path, args) {
  path = _castPath(path, object);
  object = _parent(object, path);
  var func = object == null ? object : object[_toKey(last_1(path))];
  return func == null ? undefined : _apply(func, object, args);
}

var _baseInvoke = baseInvoke;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax$1(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax$1(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

var _overRest = overRest;

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

var constant_1 = constant;

var defineProperty = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty$1 = defineProperty;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !_defineProperty$1 ? identity_1 : function(func, string) {
  return _defineProperty$1(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant_1(string),
    'writable': true
  });
};

var _baseSetToString = baseSetToString;

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = _shortOut(_baseSetToString);

var _setToString = setToString;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return _setToString(_overRest(func, start, identity_1), func + '');
}

var _baseRest = baseRest;

/**
 * Invokes the method at `path` of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {...*} [args] The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
 *
 * _.invoke(object, 'a[0].b.c.slice', 1, 3);
 * // => [2, 3]
 */
var invoke = _baseRest(_baseInvoke);

var invoke_1 = invoke;

var hasChildren = function hasChildren(children) {
  return !(children === null || children === undefined || Array.isArray(children) && children.length === 0);
};

var getUnusedProps = function getUnusedProps(definedProps, allProps) {
  return Object.keys(allProps).reduce(function (acc, prop) {
    if (!Object.prototype.hasOwnProperty.call(definedProps, prop)) acc[prop] = allProps[prop];
    return acc;
  }, {});
};

var componentUtils = {
  getUnusedProps: getUnusedProps,
  hasChildren: hasChildren
};

var propTypes$1 = {
  /** default size tries to inherit from page/parent context,
   *  but you can explicitly set it yourself using these props
   */
  size: propTypes.oneOf(['inherit', 'extra-small', 'smaller', 'small', 'regular', 'large', 'larger', 'semi-huge', 'huge']),
  children: propTypes.node,
  active: propTypes.bool,
  className: propTypes.string,
  href: propTypes.string,
  onClick: propTypes.func,

  /** DEPRECATED */
  caret: propTypes.bool,

  /** DEPRECATED */
  caretPosition: propTypes.oneOf(['prefix', 'postfix']),
  arrow: propTypes.bool,

  /** position of the arrow icon
   *  NOTE: arrowPosition should be used with arrow flag
   */
  arrowPosition: propTypes.oneOf(['prefix', 'postfix']),
  target: propTypes.string,
  subtle: propTypes.bool,
  inline: propTypes.bool,
  capitalize: propTypes.bool,
  role: propTypes.oneOf(['button', 'link']),
  color: propTypes.oneOf(['default', 'red', 'black']),
  disabled: propTypes.bool,
  rel: propTypes.string,
  selected: propTypes.bool,
  variant: propTypes.oneOf(['primary', 'secondary', 'tertiary'])
};

var Link =
/*#__PURE__*/
function (_Component) {
  _inherits(Link, _Component);

  function Link(props) {
    var _this;

    _classCallCheck(this, Link);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Link).call(this, props));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Link, [{
    key: "handleClick",
    value: function handleClick(e) {
      var disabled = this.props.disabled;

      if (disabled) {
        e.preventDefault();
        return;
      }

      invoke_1(this.props, 'onClick', e, this.props);
    }
  }, {
    key: "render",
    value: function render() {
      var _cx;

      var _this$props = this.props,
          size = _this$props.size,
          children = _this$props.children,
          active = _this$props.active,
          className = _this$props.className,
          target = _this$props.target,
          href = _this$props.href,
          rel = _this$props.rel,
          caret = _this$props.caret,
          arrow = _this$props.arrow,
          selected = _this$props.selected,
          inline = _this$props.inline,
          subtle = _this$props.subtle,
          onClick = _this$props.onClick,
          role = _this$props.role,
          caretPosition = _this$props.caretPosition,
          arrowPosition = _this$props.arrowPosition,
          capitalize = _this$props.capitalize,
          variant = _this$props.variant,
          _this$props$color = _this$props.color,
          color = _this$props$color === void 0 ? 'default' : _this$props$color;
      var classes = classnames('zola-ui', 'link', className, (_cx = {
        prefix: caretPosition === 'prefix' || arrowPosition === 'prefix',
        'link-arrow': caret || arrow,
        'link-danger': color === 'red',
        'link-black': color === 'black'
      }, _defineProperty(_cx, size, size !== 'inherit'), _defineProperty(_cx, variant, variant !== 'primary'), _defineProperty(_cx, "active", active), _defineProperty(_cx, "selected", selected), _defineProperty(_cx, "inline", inline), _defineProperty(_cx, "subtle", subtle), _defineProperty(_cx, "capitalize", capitalize), _cx));
      var rest = componentUtils.getUnusedProps(propTypes$1, this.props); // eslint-disable-line react/forbid-foreign-prop-types

      var hasChildren = componentUtils.hasChildren(children);

      if (role === 'button' && onClick) {
        return React.createElement("button", _extends({}, rest, {
          onClick: this.handleClick,
          className: classes,
          type: "button"
        }), hasChildren && children);
      }

      return React.createElement("a", _extends({}, rest, {
        href: href,
        onClick: this.handleClick,
        target: target,
        rel: rel,
        className: classes
      }), hasChildren && children);
    }
  }]);

  return Link;
}(Component);

Link.defaultProps = {
  size: 'inherit',
  role: 'link',
  caretPosition: 'postfix',
  arrowPosition: 'postfix',
  variant: 'primary',
  href: '#'
};
Link.propTypes = propTypes$1;

var getOffsetTop = function getOffsetTop(element) {
  var firstChildOfBody = document.getElementsByTagName('body')[0];
  var currentEl = element;
  var _currentEl = currentEl,
      offsetTop = _currentEl.offsetTop;

  while (currentEl.offsetParent && currentEl !== firstChildOfBody) {
    offsetTop += currentEl.offsetParent.offsetTop;
    currentEl = currentEl.offsetParent;
  }

  return offsetTop;
};

var scrollViewTo = function scrollViewTo(_ref) {
  var id = _ref.id,
      offset = _ref.offset,
      el = _ref.el,
      _ref$behavior = _ref.behavior,
      behavior = _ref$behavior === void 0 ? 'auto' : _ref$behavior;
  var element = el || document.getElementById(id);

  if (element) {
    window.scrollTo({
      left: 0,
      top: getOffsetTop(element) - (offset || 0),
      behavior: behavior
    });
  }
};

var ALLOWED_BACKGROUND_CLASSES = ['fade-bottom--secondary-gray', 'fade-bottom--background-gray', ''];

var Drawer =
/*#__PURE__*/
function (_Component) {
  _inherits(Drawer, _Component);

  function Drawer(props) {
    var _this;

    _classCallCheck(this, Drawer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Drawer).call(this, props));
    _this.toggleSection = _this.toggleSection.bind(_assertThisInitialized(_this));
    _this.renderButtons = _this.renderButtons.bind(_assertThisInitialized(_this));
    _this.state = {
      sectionExpanded: props.expandedByDefault
    };
    _this.topOfFAQs = React.createRef();
    return _this;
  }

  _createClass(Drawer, [{
    key: "toggleSection",
    value: function toggleSection() {
      var _this2 = this;

      var _this$props = this.props,
          offset = _this$props.offset,
          skipScrollToTop = _this$props.skipScrollToTop;
      this.setState(function (prevState) {
        if (prevState.sectionExpanded && !skipScrollToTop) {
          scrollViewTo({
            el: _this2.topOfFAQs.current,
            offset: offset
          });
        }

        return {
          sectionExpanded: !prevState.sectionExpanded
        };
      });
    }
  }, {
    key: "renderButtons",
    value: function renderButtons(sectionExpanded) {
      var _this3 = this;

      var _this$props2 = this.props,
          buttonText = _this$props2.buttonText,
          arrowV2 = _this$props2.arrowV2;

      if (buttonText.open && buttonText.close) {
        return React.createElement("div", null, buttonText.appearance === 'button' ? React.createElement(ButtonV2, {
          className: "drawer__button",
          onClick: this.toggleSection,
          variant: "secondary"
        }, sectionExpanded ? buttonText.close : buttonText.open) : React.createElement(Link, {
          className: "drawer__button-link",
          onClick: this.toggleSection,
          role: "button"
        }, sectionExpanded ? buttonText.close : buttonText.open));
      }

      var renderArrows = function renderArrows() {
        if (arrowV2) {
          return React.createElement(ArrowButton, {
            component: "button",
            onClick: _this3.toggleSection,
            direction: sectionExpanded ? 'up' : 'down',
            "aria-label": sectionExpanded ? 'close section' : 'expand section',
            smaller: true
          });
        }

        return React.createElement(ChevronButton, {
          direction: sectionExpanded ? 'up' : 'down',
          btnStyle: "secondary",
          onClick: _this3.toggleSection,
          ariaLabel: sectionExpanded ? 'close section' : 'expand section'
        });
      };

      return renderArrows();
    }
  }, {
    key: "render",
    value: function render() {
      var sectionExpanded = this.state.sectionExpanded;
      var _this$props3 = this.props,
          backgroundOverrideClass = _this$props3.backgroundOverrideClass,
          children = _this$props3.children,
          className = _this$props3.className,
          maxHeight = _this$props3.maxHeight,
          maxExpandedHeight = _this$props3.maxExpandedHeight,
          _this$props3$drawerV = _this$props3.drawerV2,
          drawerV2 = _this$props3$drawerV === void 0 ? false : _this$props3$drawerV;
      var currentHeight = sectionExpanded ? maxExpandedHeight : maxHeight;
      var classes = classnames({
        'zola-ui': !drawerV2
      }, 'drawer', className, backgroundOverrideClass);
      return React.createElement("div", {
        ref: this.topOfFAQs,
        className: "".concat(classes).concat(sectionExpanded ? '' : ' fade-bottom')
      }, React.createElement("div", {
        className: "drawer__content",
        style: {
          maxHeight: currentHeight
        }
      }, children), React.createElement("div", {
        className: "drawer__expand-button-container"
      }, this.renderButtons(sectionExpanded)));
    }
  }]);

  return Drawer;
}(Component);

Drawer.propTypes = {
  children: propTypes.node,
  className: propTypes.string,

  /**
   *  Default expanding state. This value will not change it after the component is rendered
   */
  expandedByDefault: propTypes.bool,
  backgroundOverrideClass: propTypes.oneOf(ALLOWED_BACKGROUND_CLASSES),

  /**
   * Max height when drawer is closed
   */
  maxHeight: propTypes.string.isRequired,

  /**
   * Max height when drawer is expanded
   * */
  maxExpandedHeight: propTypes.string,
  offset: propTypes.number,
  skipScrollToTop: propTypes.bool,
  arrowV2: propTypes.bool,
  drawerV2: propTypes.bool,

  /* Replace default Chevron Button */
  buttonText: propTypes.shape({
    open: propTypes.string,
    close: propTypes.string,
    appearance: propTypes.oneOf(['button', 'link'])
  })
};
Drawer.defaultProps = {
  offset: 0,
  maxExpandedHeight: '3000px',
  backgroundOverrideClass: '',
  expandedByDefault: false,
  buttonText: {
    open: null,
    close: null,
    appearance: 'link'
  },
  arrowV2: false,
  drawerV2: false
};

var ALLOWED_BACKGROUND_CLASSES$1 = ['fade-bottom--secondary-gray', 'fade-bottom--background-gray', ''];

var DrawerV2 =
/*#__PURE__*/
function (_Component) {
  _inherits(DrawerV2, _Component);

  function DrawerV2(props) {
    var _this;

    _classCallCheck(this, DrawerV2);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DrawerV2).call(this, props));
    _this.toggleSection = _this.toggleSection.bind(_assertThisInitialized(_this));
    _this.renderButtons = _this.renderButtons.bind(_assertThisInitialized(_this));
    _this.state = {
      sectionExpanded: props.expandedByDefault
    };
    _this.topOfFAQs = React.createRef();
    return _this;
  }

  _createClass(DrawerV2, [{
    key: "toggleSection",
    value: function toggleSection() {
      var _this2 = this;

      var _this$props = this.props,
          offset = _this$props.offset,
          skipScrollToTop = _this$props.skipScrollToTop;
      this.setState(function (prevState) {
        if (prevState.sectionExpanded && !skipScrollToTop) {
          scrollViewTo({
            el: _this2.topOfFAQs.current,
            offset: offset
          });
        }

        return {
          sectionExpanded: !prevState.sectionExpanded
        };
      });
    }
  }, {
    key: "renderButtons",
    value: function renderButtons(sectionExpanded) {
      var _this3 = this;

      var _this$props2 = this.props,
          buttonText = _this$props2.buttonText,
          smallerArrows = _this$props2.smallerArrows;

      if (buttonText.open && buttonText.close) {
        return React.createElement("div", null, buttonText.appearance === 'button' ? React.createElement(ButtonV2, {
          variant: "secondary",
          className: "drawer__button",
          onClick: this.toggleSection
        }, sectionExpanded ? buttonText.close : buttonText.open) : React.createElement(Link, {
          className: "drawer__button-link",
          onClick: this.toggleSection,
          role: "button"
        }, sectionExpanded ? buttonText.close : buttonText.open));
      }

      var renderArrows = function renderArrows() {
        return React.createElement(ArrowButton, {
          component: "button",
          onClick: _this3.toggleSection,
          direction: sectionExpanded ? 'up' : 'down',
          "aria-label": sectionExpanded ? 'close section' : 'expand section',
          smaller: smallerArrows
        });
      };

      return renderArrows();
    }
  }, {
    key: "render",
    value: function render() {
      var sectionExpanded = this.state.sectionExpanded;
      var _this$props3 = this.props,
          backgroundOverrideClass = _this$props3.backgroundOverrideClass,
          children = _this$props3.children,
          className = _this$props3.className,
          maxHeight = _this$props3.maxHeight,
          maxExpandedHeight = _this$props3.maxExpandedHeight;
      var currentHeight = sectionExpanded ? maxExpandedHeight : maxHeight;
      var classes = classnames('drawer', className, backgroundOverrideClass, {
        'fade-bottom': !sectionExpanded
      });
      return React.createElement("div", {
        ref: this.topOfFAQs,
        className: classes
      }, React.createElement("div", {
        className: "drawer__content",
        style: {
          maxHeight: currentHeight
        }
      }, children), React.createElement("div", {
        className: "drawer__expand-button-container"
      }, this.renderButtons(sectionExpanded)));
    }
  }]);

  return DrawerV2;
}(Component);

DrawerV2.propTypes = {
  children: propTypes.node,
  className: propTypes.string,
  backgroundOverrideClass: propTypes.oneOf(ALLOWED_BACKGROUND_CLASSES$1),

  /**
   *  Default expanding state. This value will not change it after the component is rendered
   */
  expandedByDefault: propTypes.bool,

  /* Max height when drawer is closed */
  maxHeight: propTypes.string.isRequired,

  /* Max height when drawer is expanded */
  maxExpandedHeight: propTypes.string,
  offset: propTypes.number,
  smallerArrows: propTypes.bool,
  skipScrollToTop: propTypes.bool,

  /* Replace default Chevron Button */
  buttonText: propTypes.shape({
    open: propTypes.string,
    close: propTypes.string,
    appearance: propTypes.oneOf(['button', 'link'])
  })
};
DrawerV2.defaultProps = {
  offset: 0,
  maxExpandedHeight: '3000px',
  backgroundOverrideClass: '',
  expandedByDefault: false,
  smallerArrows: true,
  buttonText: {
    open: null,
    close: null,
    appearance: 'link'
  }
};

var AboutAndHelp = function AboutAndHelp() {
  return React.createElement("div", {
    className: "common-footer__about-and-help"
  }, React.createElement("div", {
    className: "common-footer__about"
  }, React.createElement("h3", null, "About Zola"), React.createElement("ul", {
    className: "about-and-help-links"
  }, React.createElement("li", null, React.createElement(Link, {
    href: "/about/index",
    subtle: true
  }, "Our Story")), React.createElement("li", null, React.createElement(Link, {
    href: "/about/press",
    subtle: true
  }, "Press")), React.createElement("li", null, React.createElement(Link, {
    href: "/about/team",
    subtle: true
  }, "Jobs")), React.createElement("li", null, React.createElement(Link, {
    href: "/inspiration/become-a-vendor",
    subtle: true
  }, "Wedding Vendors")), React.createElement("li", null, React.createElement(Link, {
    href: "/wedding-registry/invite",
    subtle: true
  }, "Refer a Friend")), React.createElement("li", null, React.createElement(Link, {
    href: "/wedding-registry/couple-reviews",
    subtle: true
  }, "Zola Reviews")))), React.createElement("div", {
    className: "common-footer__help"
  }, React.createElement("h3", null, "Help"), React.createElement("ul", {
    className: "about-and-help-links"
  }, React.createElement("li", null, React.createElement(Link, {
    href: "/expert-advice",
    subtle: true
  }, "Expert Advice")), React.createElement("li", null, React.createElement(Link, {
    href: "/search/wedding-registry",
    subtle: true
  }, "Find a Couple on Zola")), React.createElement("li", null, React.createElement(Link, {
    href: "https://help.zola.com/hc",
    target: "_blank",
    rel: "noopener noreferrer",
    subtle: true
  }, "FAQs")), React.createElement("li", null, React.createElement(Link, {
    href: "/order-status",
    subtle: true
  }, "Order Status")), React.createElement("li", null, React.createElement(Link, {
    href: "/returns",
    subtle: true
  }, "Return Policy")), React.createElement("li", null, React.createElement(Link, {
    href: "mailto:support@zola.com",
    subtle: true,
    inline: true
  }, "support@zola.com")), React.createElement("li", null, React.createElement(Link, {
    href: "tel:1-408-657-9652",
    subtle: true
  }, "1-408-657-ZOLA")))));
};

var appStoreBadge = "data:image/svg+xml;base64,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";

var googlePlayBadge = "data:image/svg+xml;base64,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";

var MobileApps = function MobileApps(_ref) {
  var isAndroid = _ref.isAndroid,
      isIos = _ref.isIos;
  var appStoreClassNames = classnames('common-footer__app-store-link', {
    'hide-mobile': isAndroid
  }, {
    'full-width-mobile': isIos
  });
  var googlePlayClassNames = classnames('common-footer__google-play-link', {
    'hide-mobile': isIos
  }, {
    'full-width-mobile': isAndroid
  });
  return React.createElement("div", {
    className: "common-footer__mobile-apps"
  }, React.createElement("h3", {
    className: "common-footer__mobile-apps-title"
  }, "Download the Zola App"), React.createElement("ul", {
    className: "common-footer__mobile-apps-items"
  }, React.createElement("li", {
    className: "common-footer__mobile-apps-item"
  }, React.createElement("a", {
    className: appStoreClassNames,
    href: "https://itunes.apple.com/us/app/zola-wedding-registry-gifts/id852691916",
    target: "_blank",
    rel: "noopener noreferrer"
  }, React.createElement("img", {
    src: appStoreBadge,
    alt: "Download On The App Store"
  }))), React.createElement("li", {
    className: "common-footer__mobile-apps-item"
  }, React.createElement("a", {
    className: googlePlayClassNames,
    href: "https://play.google.com/store/apps/details?id=com.zola.android.wedding&hl=en",
    target: "_blank",
    rel: "noopener noreferrer"
  }, React.createElement("img", {
    src: googlePlayBadge,
    alt: "Get It On Google Play"
  })))));
};

MobileApps.defaultProps = {
  isAndroid: false,
  isIos: false
};
MobileApps.propTypes = {
  isAndroid: propTypes.bool,
  isIos: propTypes.bool
};

var dateHelper = {
  getFullYear: function getFullYear() {
    return new Date().getFullYear();
  }
};

var svg = "data:image/svg+xml;base64,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";

var SocialAndTerms = function SocialAndTerms() {
  var year = dateHelper.getFullYear();
  return React.createElement("div", {
    className: "common-footer__social-and-terms"
  }, React.createElement("div", {
    className: "zola-logo",
    style: {
      backgroundImage: "url(".concat(svg, ")")
    }
  }), React.createElement("div", {
    className: "tagline"
  }, "The wedding company that'll do anything for love."), React.createElement("ul", {
    className: "social-icons"
  }, React.createElement("li", null, React.createElement(Link, {
    href: "https://www.facebook.com/zola",
    "aria-label": "Facebook",
    target: "_blank",
    rel: "noopener noreferrer",
    subtle: true
  }, React.createElement("i", {
    className: "zola-ui-icon zola-ui-icon-facebook",
    "aria-hidden": "true"
  }))), React.createElement("li", null, React.createElement(Link, {
    href: "https://pinterest.com/zola",
    "aria-label": "Pinterest",
    target: "_blank",
    rel: "noopener noreferrer",
    subtle: true
  }, React.createElement("i", {
    className: "zola-ui-icon zola-ui-icon-pinterest-circled",
    "aria-hidden": "true"
  }))), React.createElement("li", null, React.createElement(Link, {
    href: "https://twitter.com/zola",
    "aria-label": "Twitter",
    target: "_blank",
    rel: "noopener noreferrer",
    subtle: true
  }, React.createElement("i", {
    className: "zola-ui-icon zola-ui-icon-twitter",
    "aria-hidden": "true"
  }))), React.createElement("li", null, React.createElement(Link, {
    href: "https://instagram.com/zola",
    "aria-label": "Instagram",
    target: "_blank",
    rel: "noopener noreferrer",
    subtle: true
  }, React.createElement("i", {
    className: "zola-ui-icon zola-ui-icon-instagram",
    "aria-hidden": "true"
  })))), React.createElement("div", {
    className: "hashtag"
  }, "@ZOLA | #ANYTHINGFORLOVE"), React.createElement("div", {
    className: "copyright"
  }, "\xA9 ", React.createElement("span", {
    className: "date"
  }, year), " Zola, Inc. All rights reserved."), React.createElement("ul", {
    className: "terms-links"
  }, React.createElement("li", null, React.createElement(Link, {
    href: "/privacy",
    target: "_blank",
    rel: "noopener noreferrer",
    subtle: true
  }, "Privacy Policy")), React.createElement("li", null, React.createElement(Link, {
    href: "/terms",
    target: "_blank",
    rel: "noopener noreferrer",
    subtle: true
  }, "Terms of Use")), React.createElement("li", null, React.createElement(Link, {
    href: "/webaccessibility",
    target: "_self",
    subtle: true
  }, "Web Accessibility")), React.createElement("li", null, React.createElement(Link, {
    href: "/privacy#CA-privacy-rights",
    target: "_blank",
    rel: "noopener noreferrer",
    subtle: true
  }, "Your CA Privacy Rights"))));
};

var svg$1 = "data:image/svg+xml;base64,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";

var StoreLinks = function StoreLinks() {
  var year = dateHelper.getFullYear();
  return React.createElement("div", {
    className: "common-footer__social-and-terms store-links"
  }, React.createElement("div", {
    id: "zola-store-logo",
    className: "zola-store-logo",
    style: {
      backgroundImage: "url(".concat(svg$1, ")")
    }
  }), React.createElement("div", {
    className: "store-footer-links__cols-container"
  }, React.createElement("ul", {
    className: "store-footer-links left-col"
  }, React.createElement("li", null, React.createElement(Link, {
    href: "/wedding-registry/couple-reviews",
    subtle: true
  }, "Zola Reviews")), React.createElement("li", null, React.createElement(Link, {
    href: "https://help.zola.com/hc",
    target: "_blank",
    rel: "noopener noreferrer",
    subtle: true
  }, "FAQs"))), React.createElement("ul", {
    className: "store-footer-links right-col"
  }, React.createElement("li", null, React.createElement(Link, {
    href: "/order-status",
    subtle: true
  }, "Track Order")), React.createElement("li", null, React.createElement(Link, {
    href: "/returns",
    subtle: true
  }, "Return Policy")), React.createElement("li", null, React.createElement(Link, {
    href: "mailto:support@zola.com",
    subtle: true,
    inline: true
  }, "support@zola.com")), React.createElement("li", null, React.createElement(Link, {
    href: "tel:1-408-657-9652",
    subtle: true
  }, "1-408-657-ZOLA")))), React.createElement("ul", {
    className: "store-footer-links"
  }, React.createElement("li", null, React.createElement(Link, {
    href: "/wedding-registry/couple-reviews",
    subtle: true
  }, "Zola Reviews")), React.createElement("li", null, React.createElement(Link, {
    href: "https://help.zola.com/hc",
    target: "_blank",
    rel: "noopener noreferrer",
    subtle: true
  }, "FAQs")), React.createElement("li", null, React.createElement(Link, {
    href: "/order-status",
    subtle: true
  }, "Track Order")), React.createElement("li", null, React.createElement(Link, {
    href: "/returns",
    subtle: true
  }, "Return Policy")), React.createElement("li", null, React.createElement(Link, {
    href: "mailto:support@zola.com",
    subtle: true,
    inline: true
  }, "support@zola.com")), React.createElement("li", null, React.createElement(Link, {
    href: "tel:1-408-657-9652",
    subtle: true
  }, "1-408-657-ZOLA"))), React.createElement("div", {
    className: "copyright"
  }, "\xA9 ", React.createElement("span", {
    className: "date"
  }, year), " Zola, Inc. All rights reserved."), React.createElement("ul", {
    className: "terms-links store-footer"
  }, React.createElement("li", null, React.createElement(Link, {
    href: "/privacy",
    target: "_blank",
    rel: "noopener noreferrer",
    subtle: true
  }, "Privacy Policy")), React.createElement("li", null, React.createElement(Link, {
    href: "/terms",
    target: "_blank",
    rel: "noopener noreferrer",
    subtle: true
  }, "Terms of Use")), React.createElement("li", null, React.createElement(Link, {
    href: "/webaccessibility",
    target: "_self",
    subtle: true
  }, "Web Accessibility")), React.createElement("li", null, React.createElement(Link, {
    href: "/privacy#CA-privacy-rights",
    target: "_blank",
    rel: "noopener noreferrer",
    subtle: true
  }, "Your CA Privacy Rights"))));
};

var HomeStoreFooter = function HomeStoreFooter() {
  return React.createElement("footer", {
    className: "zola-ui common-footer home-store"
  }, React.createElement("div", {
    className: "common-footer__container"
  }, React.createElement("div", {
    className: "common-footer__desktop"
  }, React.createElement(StoreLinks, null)), React.createElement("div", {
    className: "common-footer__mobile"
  }, React.createElement(StoreLinks, null))));
};

var Footer =
/*#__PURE__*/
function (_Component) {
  _inherits(Footer, _Component);

  function Footer(props) {
    var _this;

    _classCallCheck(this, Footer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Footer).call(this, props));
    _this.state = {
      isIos: /iP(hone|od|ad)/i.test(navigator.userAgent),
      isAndroid: /Android/i.test(navigator.userAgent)
    };
    return _this;
  }

  _createClass(Footer, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          isIos = _this$state.isIos,
          isAndroid = _this$state.isAndroid;
      var isWebStore = this.props.isWebStore;

      if (isWebStore) {
        return HomeStoreFooter();
      }

      return React.createElement("footer", {
        className: "zola-ui common-footer"
      }, React.createElement("div", {
        className: "common-footer__container"
      }, React.createElement("div", {
        className: "common-footer__desktop"
      }, React.createElement(SocialAndTerms, null), React.createElement(AboutAndHelp, null), React.createElement(MobileApps, {
        isAndroid: isAndroid,
        isIos: isIos
      })), React.createElement("div", {
        className: "common-footer__mobile"
      }, React.createElement(MobileApps, {
        isAndroid: isAndroid,
        isIos: isIos
      }), React.createElement(AboutAndHelp, null), React.createElement(SocialAndTerms, null))));
    }
  }]);

  return Footer;
}(Component);

Footer.propTypes = {
  isWebStore: propTypes.bool
};

var MinimalFooter = function MinimalFooter() {
  var year = dateHelper.getFullYear();
  return React.createElement("footer", {
    id: "zola-footer",
    className: "zola-footer footer footer-minimal text-center"
  }, React.createElement("div", {
    className: "row"
  }, React.createElement("div", {
    className: "col-xs-12 text-center padding-bottom-2x"
  }, React.createElement("small", null, React.createElement("span", null, "\xA9 ", React.createElement("span", {
    className: "date"
  }, year), " Zola, Inc.", ' '), React.createElement("span", {
    className: "hidden-xs"
  }, " All rights reserved. "), React.createElement("span", {
    className: "terms-privacy-links"
  }, React.createElement("span", null, React.createElement("a", {
    href: "/privacy",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Privacy Policy"), ' ', "/", ' '), React.createElement("span", null, React.createElement("a", {
    href: "/terms",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Terms of Use")), React.createElement("span", {
    className: "hidden-xs"
  }, " / "), React.createElement("br", {
    className: "visible-xs"
  }), React.createElement("span", null, React.createElement("a", {
    href: "/webaccessibility",
    target: "_self"
  }, "Web Accessibility"), ' ', "/", ' '), React.createElement("span", null, React.createElement("a", {
    href: "/privacy#CA-privacy-rights",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Your CA Privacy Rights")))))));
};

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

var _baseFindIndex = baseFindIndex;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

var _stackClear = stackClear;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

var _Stack = Stack;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED$2);
  return this;
}

var _setCacheAdd = setCacheAdd;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new _MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd;
SetCache.prototype.has = _setCacheHas;

var _SetCache = SetCache;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new _SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!_arraySome(other, function(othValue, othIndex) {
            if (!_cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays;

/** Built-in value references. */
var Uint8Array = _root.Uint8Array;

var _Uint8Array = Uint8Array;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag$1 = '[object Error]',
    mapTag$1 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag$2 = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$1:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag$1:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new _Uint8Array(object), new _Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag$1:
    case dateTag$1:
    case numberTag$1:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq_1(+object, +other);

    case errorTag$1:
      return object.name == other.name && object.message == other.message;

    case regexpTag$1:
    case stringTag$1:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag$1:
      var convert = _mapToArray;

    case setTag$1:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1;
      convert || (convert = _setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$1;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = _equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag$2:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

var stubArray_1 = stubArray;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$a.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray_1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};

var _getSymbols = getSymbols;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return _baseGetAllKeys(object, keys_1, _getSymbols);
}

var _getAllKeys = getAllKeys;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$b.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2,
      objProps = _getAllKeys(object),
      objLength = objProps.length,
      othProps = _getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$8.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects;

/* Built-in method references that are verified to be native. */
var DataView = _getNative(_root, 'DataView');

var _DataView = DataView;

/* Built-in method references that are verified to be native. */
var Promise = _getNative(_root, 'Promise');

var _Promise = Promise;

/* Built-in method references that are verified to be native. */
var Set = _getNative(_root, 'Set');

var _Set = Set;

/* Built-in method references that are verified to be native. */
var WeakMap$1 = _getNative(_root, 'WeakMap');

var _WeakMap = WeakMap$1;

/** `Object#toString` result references. */
var mapTag$2 = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$2 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';

var dataViewTag$2 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$2) ||
    (_Map && getTag(new _Map) != mapTag$2) ||
    (_Promise && getTag(_Promise.resolve()) != promiseTag) ||
    (_Set && getTag(new _Set) != setTag$2) ||
    (_WeakMap && getTag(new _WeakMap) != weakMapTag$1)) {
  getTag = function(value) {
    var result = _baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$2;
        case mapCtorString: return mapTag$2;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$2;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

var _getTag = getTag;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    objectTag$2 = '[object Object]';

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$c.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray_1(object),
      othIsArr = isArray_1(other),
      objTag = objIsArr ? arrayTag$1 : _getTag(object),
      othTag = othIsArr ? arrayTag$1 : _getTag(other);

  objTag = objTag == argsTag$2 ? objectTag$2 : objTag;
  othTag = othTag == argsTag$2 ? objectTag$2 : othTag;

  var objIsObj = objTag == objectTag$2,
      othIsObj = othTag == objectTag$2,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer_1(object)) {
    if (!isBuffer_1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new _Stack);
    return (objIsArr || isTypedArray_1(object))
      ? _equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : _equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$3)) {
    var objIsWrapped = objIsObj && hasOwnProperty$9.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$9.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new _Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new _Stack);
  return _equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike_1(value) && !isObjectLike_1(other))) {
    return value !== value && other !== other;
  }
  return _baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

var _baseIsEqual = baseIsEqual;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new _Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? _baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$4 | COMPARE_UNORDERED_FLAG$2, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

var _baseIsMatch = baseIsMatch;

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject_1(value);
}

var _isStrictComparable = isStrictComparable;

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys_1(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, _isStrictComparable(value)];
  }
  return result;
}

var _getMatchData = getMatchData;

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

var _matchesStrictComparable = matchesStrictComparable;

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = _getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return _matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || _baseIsMatch(object, source, matchData);
  };
}

var _baseMatches = baseMatches;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : _baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

var _baseHasIn = baseHasIn;

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = _castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = _toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength_1(length) && _isIndex(key, length) &&
    (isArray_1(object) || isArguments_1(object));
}

var _hasPath = hasPath;

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && _hasPath(object, path, _baseHasIn);
}

var hasIn_1 = hasIn;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (_isKey(path) && _isStrictComparable(srcValue)) {
    return _matchesStrictComparable(_toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get_1(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn_1(object, path)
      : _baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$5 | COMPARE_UNORDERED_FLAG$3);
  };
}

var _baseMatchesProperty = baseMatchesProperty;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

var _baseProperty = baseProperty;

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return _baseGet(object, path);
  };
}

var _basePropertyDeep = basePropertyDeep;

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return _isKey(path) ? _baseProperty(_toKey(path)) : _basePropertyDeep(path);
}

var property_1 = property;

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity_1;
  }
  if (typeof value == 'object') {
    return isArray_1(value)
      ? _baseMatchesProperty(value[0], value[1])
      : _baseMatches(value);
  }
  return property_1(value);
}

var _baseIteratee = baseIteratee;

/** Used as references for various `Number` constants. */
var NAN$1 = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim$1 = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary$1 = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal$1 = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt$1 = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$1(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol_1(value)) {
    return NAN$1;
  }
  if (isObject_1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject_1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim$1, '');
  var isBinary = reIsBinary$1.test(value);
  return (isBinary || reIsOctal$1.test(value))
    ? freeParseInt$1(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex$1.test(value) ? NAN$1 : +value);
}

var toNumber_1 = toNumber$1;

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber_1(value);
  if (value === INFINITY$2 || value === -INFINITY$2) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

var toFinite_1 = toFinite;

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite_1(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

var toInteger_1 = toInteger;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$2 = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger_1(fromIndex);
  if (index < 0) {
    index = nativeMax$2(length + index, 0);
  }
  return _baseFindIndex(array, _baseIteratee(predicate), index);
}

var findIndex_1 = findIndex;

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike_1(collection)) {
      var iteratee = _baseIteratee(predicate);
      collection = keys_1(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

var _createFind = createFind;

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = _createFind(findIndex_1);

var find_1 = find;

var useOutsideClick = function useOutsideClick(ref, callback) {
  var handleClick = function handleClick(e) {
    if (ref.current && !ref.current.contains(e.target)) {
      callback();
    }
  };

  useEffect(function () {
    document.addEventListener('click', handleClick);
    return function () {
      document.removeEventListener('click', handleClick);
    };
  });
};

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString_1(prefix) + id;
}

var uniqueId_1 = uniqueId;

var CreateIconComponent = function CreateIconComponent(_ref) {
  var children = _ref.children,
      title = _ref.title,
      width = _ref.width,
      height = _ref.height,
      unit = _ref.unit,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      className = _ref.className,
      viewBox = _ref.viewBox,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      rest = _objectWithoutProperties(_ref, ["children", "title", "width", "height", "unit", "fill", "className", "viewBox", "style"]);

  var _useState = useState(uniqueId_1(title)),
      _useState2 = _slicedToArray(_useState, 1),
      titleId = _useState2[0];

  var defaultViewBox = viewBox || "0 0 ".concat(width, " ").concat(height);

  var addunit = function addunit(val) {
    return "".concat(val).concat(unit);
  };

  var styleAttr = Object.assign({}, {
    width: addunit(width),
    height: addunit(height)
  }, style); // will help IE11, especially if child of flexbox

  var classes = classnames('zui-svg-icon', className);
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    role: "img",
    className: classes,
    width: style.width,
    height: style.height,
    viewBox: defaultViewBox,
    fill: fill,
    style: styleAttr
  }, rest), React.createElement("title", {
    id: titleId
  }, title), children);
};

CreateIconComponent.propTypes = {
  children: propTypes.node.isRequired,
  title: propTypes.string.isRequired,
  width: propTypes.number,
  height: propTypes.number,
  style: propTypes.shape({}),
  unit: propTypes.string,
  className: propTypes.string,
  fill: propTypes.string,
  viewBox: propTypes.string
};
CreateIconComponent.defaultProps = {
  height: 16,
  width: 16,
  unit: 'px'
};

var Remove = function Remove(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Info' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: "0 0 72 72"
  }, props), React.createElement("path", {
    d: "M36 2c18.778 0 34 15.222 34 34S54.778 70 36 70 2 54.778 2 36 17.222 2 36 2zM23.587 21.072a2 2 0 00-2.719 2.93l12.174 12.172-11.869 11.87-.101.109a2 2 0 002.93 2.719l11.868-11.87 11.868 11.87.11.102a2 2 0 002.719-2.93l-11.869-11.87 12.174-12.172.102-.11a2 2 0 00-2.93-2.719L35.87 33.346 23.697 21.173z",
    fill: "evenodd"
  }));
};

Remove.propTypes = {
  title: propTypes.string
};

var Error$1 = function Error(_ref) {
  var message = _ref.message,
      _ref$iconSize = _ref.iconSize,
      iconSize = _ref$iconSize === void 0 ? 12 : _ref$iconSize,
      className = _ref.className;
  return React.createElement("span", {
    className: "error-message ".concat(className || '')
  }, React.createElement(Remove, {
    className: "error-icon",
    width: iconSize,
    height: iconSize,
    title: "remove-icon"
  }), React.createElement("span", {
    className: "error-copy"
  }, message));
};

Error$1.propTypes = {
  message: propTypes.string,
  iconSize: propTypes.number,
  className: propTypes.string
};

var debounce$1 = function debounce(func, wait) {
  var timeout;
  return function executedFunction() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var later = function later() {
      clearTimeout(timeout);
      func.apply(void 0, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}; // https://stackoverflow.com/questions/45408920/plain-javascript-scrollintoview-inside-div


function scrollParentToChild(parent, child) {
  // Where is the parent on page
  var parentRect = parent.getBoundingClientRect(); // What can you see?

  var parentViewableArea = {
    height: parent.clientHeight,
    width: parent.clientWidth
  }; // Where is the child

  var childRect = child.getBoundingClientRect(); // Is the child viewable?

  var isViewable = childRect.top >= parentRect.top && childRect.top <= parentRect.top + parentViewableArea.height; // if you can't see the child try to scroll parent

  if (!isViewable) {
    // scroll by offset relative to parent
    // console.log('NOT VIEWABLE');
    parent.scrollTop = childRect.top + parent.scrollTop - parentRect.top; // eslint-disable-line
  }
}
/* eslint-disable */


var uuidv4 = function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};
/* eslint-enable */

/**
 *
 * @param {*} props
 *
 * This listbox follows the WAI-ARIA standards listed in https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html for listboxes.
 */


var DropdownV2 = function DropdownV2(props) {
  var onSelect = props.onSelect,
      options = props.options,
      label = props.label,
      placeholder = props.placeholder,
      inline = props.inline,
      errorMessage = props.errorMessage,
      className = props.className,
      inlineLabel = props.inlineLabel,
      nullable = props.nullable,
      nullOptionLabel = props.nullOptionLabel,
      isRequired = props.isRequired,
      id = props.id,
      disabled = props.disabled,
      value = props.value;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedOption = _useState4[0],
      setSelectedOption = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      prevValue = _useState6[0],
      setPrevValue = _useState6[1];

  var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      search = _useState8[0],
      setSearch = _useState8[1]; // Closes dropdown if click outside


  var ref = useRef(null);
  useOutsideClick(ref, function () {
    setExpanded(false);
  }); // Set up debounce on clearing internal search

  var debouncedClear = useCallback(debounce$1(function () {
    return setSearch('');
  }, 250), []);
  useEffect(function () {
    if (!search) return;

    var newSelection = find_1(options, function (o) {
      return o.label.toLowerCase().includes(search);
    });

    if (newSelection) {
      setSelectedOption(newSelection);
    }
  }, [options, search]); // Sets class names for different sections

  var _useState9 = useState('dropdown-v2__container zola-ui v2-render-field'),
      _useState10 = _slicedToArray(_useState9, 2),
      classNames = _useState10[0],
      setClassNames = _useState10[1];

  useEffect(function () {
    setClassNames(classnames('dropdown-v2__container zola-ui v2-render-field', className, {
      inline: inline,
      'inline-label': inlineLabel
    }));
  }, [className, inline, inlineLabel]);

  var _useState11 = useState('dropdown-v2__selection-box zola-ui v2-render-field'),
      _useState12 = _slicedToArray(_useState11, 2),
      selectionBoxClassNames = _useState12[0],
      setSelectionBoxClassNames = _useState12[1]; // updates classnames based off various state bits


  useEffect(function () {
    setSelectionBoxClassNames(classnames('dropdown-v2__selection-box zola-ui v2-render-field', {
      expanded: expanded,
      'has-error': errorMessage,
      'is-disabled': disabled,
      'no-option-selected': !selectedOption || nullable && selectedOption && selectedOption.value === null
    }));
  }, [disabled, errorMessage, expanded, nullable, selectedOption]);

  var _useState13 = useState([]),
      _useState14 = _slicedToArray(_useState13, 2),
      modifiedOptions = _useState14[0],
      setModifiedOptions = _useState14[1]; // Adds the placeholder to the expanded dropdown options if dropdown can be null


  useEffect(function () {
    var labelText = nullOptionLabel || placeholder;
    setModifiedOptions(nullable ? [{
      label: labelText,
      value: null,
      placeholder: true
    }].concat(_toConsumableArray(options)) : options);
  }, [nullable, options, placeholder, nullOptionLabel]); // if value is forcibly changed, select the option with new value

  useEffect(function () {
    if (value !== prevValue && value) {
      var foundOption = modifiedOptions.filter(function (opt) {
        return opt.value === value;
      })[0];
      setSelectedOption(foundOption);

      if (foundOption) {
        setPrevValue(value);
      }
    }
  }, [modifiedOptions, prevValue, selectedOption, value]); // This is used to give each element in the dropdown a unique Id to facilite
  // scrolling to the element when the dropdown is expanded.  There may be
  // other ways to do this.

  var _useState15 = useState(null),
      _useState16 = _slicedToArray(_useState15, 2),
      idPrefix = _useState16[0],
      setIdPrefix = _useState16[1];

  useEffect(function () {
    // This shouldn't be needed, id is a required prop, but if its not provided
    // we'll still generate an id for all the dropdown options so they can be
    // scrolled
    setIdPrefix(uuidv4());
  }, []);
  useEffect(function () {
    if (id) {
      setIdPrefix(id);
    }
  }, [id]); // if an option is selected and it's not in full view of the user while the dropdown is expanded, scroll to the newly selected option

  useEffect(function () {
    if (!selectedOption) return;

    var currentIndex = findIndex_1(options, function (x) {
      return x.value === selectedOption.value;
    });

    if ((currentIndex || currentIndex === 0) && expanded && document.getElementById("".concat(idPrefix, "-").concat(currentIndex))) {
      scrollParentToChild(ref.current.getElementsByClassName('dropdown-v2__options')[0], document.getElementById("".concat(idPrefix, "-").concat(currentIndex)));
    }
  }, [selectedOption, expanded, setSelectedOption, options, idPrefix]); // handle all key presses required by WAI-ARIA standards

  var handleKeyDown = function handleKeyDown(e) {
    // If ESC, close the dropdown and move focus to next element
    if (e.key === 'Escape') {
      e.preventDefault();
      setExpanded(false);
      var form = e.target.form;
      var index = Array.prototype.indexOf.call(form, e.target);
      form.elements[index + 1].focus();
      e.preventDefault();
    }

    if (e.key === 'Tab') {
      // DON'T prevent default here, we want
      // the tab key to move the user to the next
      // form element!
      setExpanded(false);
    } // If HOME, open dropdown and move to first element


    if (e.key === 'Home') {
      e.preventDefault();
      setExpanded(true);
      setSelectedOption(options[0]);
    } // If END, open dropdown and move to last element


    if (e.key === 'End') {
      e.preventDefault();
      setExpanded(true);
      setSelectedOption(options[options.length - 1]);
    } // If UP:


    if (e.key === 'ArrowUp') {
      e.preventDefault(); // if no option has been selected, select last option

      if (!selectedOption || selectedOption.value === null) {
        setSelectedOption(options[options.length - 1]);
      } // If closed, open


      if (!expanded) {
        setExpanded(true);
        return;
      } // Otherwise, move one option up. If at the top of the list, circle back to the bottom


      var currentIndex = findIndex_1(options, function (x) {
        return x.value === selectedOption.value;
      });

      if (currentIndex === 0) {
        setSelectedOption(options[options.length - 1]);
        return;
      }

      setSelectedOption(options[Math.max(currentIndex - 1, 0)]);
      return;
    } // If DOWN


    if (e.key === 'ArrowDown') {
      e.preventDefault(); // If no selected option, select the first option

      if (!selectedOption || selectedOption.value === null) {
        setSelectedOption(options[0]);
      } // If closed, open


      if (!expanded) {
        setExpanded(true);
        return;
      } // Otherwise, move one option down. If at the bottom of the list, circle back to the top


      var _currentIndex = findIndex_1(options, function (x) {
        return x.value === selectedOption.value;
      });

      if (_currentIndex === options.length - 1) {
        setSelectedOption(options[0]);
        return;
      }

      setSelectedOption(options[Math.min(_currentIndex + 1, options.length - 1)]);
      return;
    } // I need a better test here probably, but this seemed like a good first pass
    // If the name of the key is only one letter long, treat it as search input


    if (e.key.length === 1) {
      e.preventDefault();
      setSearch(search + e.key);
      debouncedClear(); // clear the search string if it's been longer than 0.25sec
    } else if (e.key === 'Enter') {
      e.preventDefault();
      setExpanded(!expanded); // enter key toggles the dropdown open and closed
    }
  };

  return React.createElement("div", {
    ref: ref,
    className: classNames
  }, label && React.createElement("label", {
    className: "dropdown-v2__label",
    htmlFor: id
  }, label), isRequired && React.createElement("span", {
    className: "text-danger danger-asterisk"
  }, "*"), React.createElement("div", {
    className: "input-field__container"
  }, React.createElement("div", {
    className: selectionBoxClassNames,
    onClick: function onClick() {
      return !disabled && setExpanded(!expanded);
    },
    id: id,
    tabIndex: 0 //eslint-disable-line
    ,
    onKeyDown: handleKeyDown
  }, React.createElement("span", {
    className: "dropdown-v2__selection-box-label"
  }, selectedOption ? selectedOption.label : placeholder), React.createElement("span", {
    className: "dropdown-v2__selection-box-icon zolaicon zola-ui-icon-chevron-right-bold"
  })), options.length && expanded && React.createElement("div", {
    className: "dropdown-v2__options"
  }, React.createElement("div", {
    className: "dropdown-v2__options-mobile-header"
  }, React.createElement("div", null, "Select One"), React.createElement("div", {
    className: "options-header-icon zolaicon zola-ui-icon-close",
    onClick: function onClick() {
      return setExpanded(false);
    }
  })), React.createElement("ul", {
    className: "dropdown-v2__options-wrapper"
  }, modifiedOptions.map(function (opt, index) {
    return React.createElement("li", {
      key: opt.value,
      className: classnames('dropdown-v2__option', {
        'dropdown-v2__option-selected': selectedOption && selectedOption.value === opt.value && !opt.placeholder,
        'dropdown-v2__option-placeholder': opt.placeholder
      }),
      id: "".concat(idPrefix, "-").concat(index),
      onClick: function onClick() {
        setSelectedOption(opt);
        setExpanded(false);

        if (onSelect) {
          onSelect(opt.value);
        }
      }
    }, opt.label);
  })))), errorMessage && React.createElement(Error$1, {
    message: errorMessage,
    iconSize: 12
  }));
};

DropdownV2.defaultProps = {
  nullable: false,
  inlineLabel: false,
  inline: false,
  errorMessage: '',
  placeholder: 'Please select'
};
DropdownV2.propTypes = {
  /** Any external effect you want to happen when the user selects an item */
  onSelect: propTypes.func,

  /** The items in the dropdown */
  options: propTypes.arrayOf(propTypes.shape({
    label: propTypes.string,
    value: propTypes.oneOfType([propTypes.bool, propTypes.number, propTypes.string, propTypes.shape({})])
  })).isRequired,

  /** The form label that appears above the select box */
  label: propTypes.string,

  /** The text that goes in the input box by default */
  placeholder: propTypes.string,

  /** Make the whole dropdown an inline element, instead of a block */
  inline: propTypes.bool,

  /** The text to be displayed in the error message. If it doesn't evaluate to false, the component will be in an error state. */
  errorMessage: propTypes.string,

  /** A standard class string for the dropdown's outermost div */
  className: propTypes.string,

  /** Place the label to the side of the dropdown instead of over it */
  inlineLabel: propTypes.bool,

  /** Allow user to select a null-value option with the text from the placeholder */
  nullable: propTypes.bool,

  /**
   * Alternative text (different from the placeholder) that goes in the options list
   * when the dropdown is nullable.  If not provided, will default to the placeholder.
   */
  nullOptionLabel: propTypes.string,
  isRequired: propTypes.bool,
  value: propTypes.oneOfType([propTypes.bool, propTypes.number, propTypes.string, propTypes.shape({})]),
  id: propTypes.string.isRequired,
  disabled: propTypes.bool
};

var DropdownV2Adapter = function DropdownV2Adapter(_ref) {
  var input = _ref.input,
      meta = _ref.meta,
      _onSelect = _ref.onSelect,
      rest = _objectWithoutProperties(_ref, ["input", "meta", "onSelect"]);

  // this hook lets this component manage the state inside the dropdown
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var errorMessage = meta && meta.touched && meta.error ? meta.error : '';

  if (input && input.value !== value) {
    setValue(input.value);
  }

  return React.createElement(DropdownV2, _extends({
    value: value,
    id: "dropdown-".concat(input.name),
    onSelect: function onSelect(val) {
      if (_onSelect) {
        // Lets you set state outside the component
        _onSelect(val);
      }

      setValue(val);
      return input.onChange(val);
    },
    errorMessage: errorMessage
  }, rest));
};

DropdownV2Adapter.propTypes = {
  input: propTypes.shape({
    name: propTypes.string.isRequired,
    value: propTypes.any
  }).isRequired,
  meta: propTypes.shape({
    touched: propTypes.bool,
    error: propTypes.string,
    asyncValidating: propTypes.bool
  }).isRequired,
  onSelect: propTypes.func
};

var RenderField = function RenderField(_ref) {
  var autoComplete = _ref.autoComplete,
      input = _ref.input,
      label = _ref.label,
      labelClass = _ref.labelClass,
      helperText = _ref.helperText,
      lastPassIgnore = _ref.lastPassIgnore,
      type = _ref.type,
      id = _ref.id,
      required = _ref.required,
      placeholder = _ref.placeholder,
      disabled = _ref.disabled,
      onBlurFunction = _ref.onBlurFunction,
      className = _ref.className,
      meta = _ref.meta,
      autoFocus = _ref.autoFocus,
      onKeyDown = _ref.onKeyDown,
      pattern = _ref.pattern,
      maxChars = _ref.maxChars,
      addOn = _ref.addOn,
      onCopyLink = _ref.onCopyLink,
      readOnly = _ref.readOnly;
  var hasError = meta && meta.touched && meta.error;

  var optionalAttr = _objectSpread({}, autoComplete && {
    autoComplete: autoComplete
  }, lastPassIgnore && {
    'data-lpignore': true
  });

  return React.createElement("div", {
    className: classnames('zola-ui render-field', {
      'has-error': hasError
    }, {
      'has-add-on': addOn
    }, className)
  }, label && React.createElement("label", {
    htmlFor: id,
    className: labelClass
  }, label, required && React.createElement("span", {
    className: "text-danger danger-asterisk"
  }, "*")), React.createElement("div", {
    className: "input-field__container"
  }, addOn && React.createElement("div", {
    className: "input-addon"
  }, React.createElement("div", {
    className: "input-addon-icon"
  }, addOn)), React.createElement("input", _extends({}, input, optionalAttr, {
    className: "input-field",
    type: type,
    id: id,
    placeholder: placeholder,
    disabled: disabled,
    autoFocus: autoFocus,
    onBlur: function onBlur(e) {
      if (onBlurFunction && input) {
        onBlurFunction(input.value);
      }

      if (input) {
        input.onBlur(e);
      }
    },
    onKeyDown: onKeyDown,
    pattern: pattern,
    readOnly: readOnly
  })), onCopyLink && React.createElement(Link, {
    onClick: onCopyLink,
    size: "lg",
    className: "copy-link-cta copy-link-cta__desktop"
  }, "Copy Link"), onCopyLink && React.createElement(Link, {
    onClick: onCopyLink,
    className: "copy-link-cta copy-link-cta__mobile"
  }, React.createElement("i", {
    onClick: onCopyLink,
    className: "zola-ui-icon zola-ui-icon-link"
  })), maxChars && React.createElement("span", {
    className: classnames('help-block max-characters-block', {
      'text-danger': input.value.length > maxChars
    }, {
      hidden: input.value.length <= maxChars
    })
  }, "You are ", input.value.length - maxChars, " characters over maximum."), meta && meta.touched && meta.error && React.createElement("span", {
    className: "help-block text-danger"
  }, meta.error), meta && meta.asyncValidating && React.createElement("span", {
    className: "help-block text-danger"
  }, "Checking availability...")), maxChars && React.createElement("div", {
    className: "secondary-help-block max-characters-block"
  }, React.createElement("span", null, "Maximum ", maxChars, " characters"), React.createElement("span", null, input.value.length, "/", maxChars)), helperText && React.createElement("div", {
    className: "secondary-help-block max-characters-block"
  }, helperText));
};

RenderField.propTypes = {
  autoComplete: propTypes.oneOfType([propTypes.bool, propTypes.string]),
  input: propTypes.shape({
    name: propTypes.string.isRequired,
    value: propTypes.any
  }),
  id: propTypes.string,
  label: propTypes.string,
  helperText: propTypes.string,
  labelClass: propTypes.string,
  lastPassIgnore: propTypes.bool,
  type: propTypes.oneOf(['text', 'email', 'password', 'tel', 'number', 'url', 'search', 'date', 'time']).isRequired,
  required: propTypes.bool,
  placeholder: propTypes.string,
  disabled: propTypes.bool,
  onBlurFunction: propTypes.func,
  className: propTypes.string,
  meta: propTypes.shape({
    touched: propTypes.bool,
    error: propTypes.string,
    asyncValidating: propTypes.bool
  }),
  autoFocus: propTypes.bool,
  onKeyDown: propTypes.func,
  pattern: propTypes.string,
  maxChars: propTypes.number,
  addOn: propTypes.string,
  onCopyLink: propTypes.func,
  readOnly: propTypes.bool
};

var InputField =
/*#__PURE__*/
function (_Component) {
  _inherits(InputField, _Component);

  function InputField(props) {
    var _this;

    _classCallCheck(this, InputField);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputField).call(this, props));
    _this.state = {
      inputValue: props.defaultValue || ''
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(InputField, [{
    key: "handleChange",
    value: function handleChange(e) {
      var onChange = this.props.onChange;
      this.setState({
        inputValue: e.target.value
      });

      if (onChange && typeof onChange === 'function') {
        onChange(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          labelClass = _this$props.labelClass,
          helperText = _this$props.helperText,
          type = _this$props.type,
          id = _this$props.id,
          required = _this$props.required,
          placeholder = _this$props.placeholder,
          disabled = _this$props.disabled,
          onBlurFunction = _this$props.onBlurFunction,
          className = _this$props.className,
          autoFocus = _this$props.autoFocus,
          onKeyDown = _this$props.onKeyDown,
          pattern = _this$props.pattern,
          defaultValue = _this$props.defaultValue,
          errorMessage = _this$props.errorMessage,
          maxChars = _this$props.maxChars,
          name = _this$props.name,
          addOn = _this$props.addOn,
          onCopyLink = _this$props.onCopyLink;
      var inputValue = this.state.inputValue;
      var rest = componentUtils.getUnusedProps(this.constructor.propTypes, this.props);
      return React.createElement("div", {
        className: classnames('zola-ui render-field', {
          'has-error': errorMessage
        }, {
          'has-add-on': addOn
        }, className)
      }, label && React.createElement("label", {
        htmlFor: id,
        className: labelClass
      }, label, required && React.createElement("span", {
        className: "text-danger danger-asterisk"
      }, "*")), React.createElement("div", {
        className: "input-field__container"
      }, addOn && React.createElement("div", {
        className: "input-addon"
      }, React.createElement("div", {
        className: "input-addon-icon"
      }, addOn)), React.createElement("input", _extends({}, rest, {
        name: name,
        className: "input-field",
        defaultValue: defaultValue,
        type: type,
        id: id,
        placeholder: placeholder,
        disabled: disabled,
        autoFocus: autoFocus,
        onBlur: function onBlur(e) {
          if (onBlurFunction && e) {
            onBlurFunction(e.target.value);
          }
        },
        onKeyDown: onKeyDown,
        pattern: pattern,
        onChange: this.handleChange
      })), onCopyLink && React.createElement(Link, {
        onClick: onCopyLink,
        size: "lg",
        className: "copy-link-cta copy-link-cta__desktop"
      }, "Copy Link"), onCopyLink && React.createElement(Link, {
        onClick: onCopyLink,
        className: "copy-link-cta copy-link-cta__mobile"
      }, React.createElement("i", {
        onClick: onCopyLink,
        className: "zola-ui-icon zola-ui-icon-link"
      })), maxChars && React.createElement("span", {
        className: classnames('help-block max-characters-block', {
          'text-danger': inputValue.length > maxChars
        }, {
          hidden: inputValue.length <= maxChars
        })
      }, "You are ", inputValue.length - maxChars, " characters over maximum."), errorMessage && React.createElement("span", {
        className: "help-block text-danger"
      }, errorMessage)), maxChars && React.createElement("div", {
        className: "secondary-help-block max-characters-block"
      }, React.createElement("span", null, "Maximum ", maxChars, " characters"), React.createElement("span", null, inputValue.length, "/", maxChars)), helperText && React.createElement("div", {
        className: "secondary-help-block max-characters-block"
      }, helperText));
    }
  }]);

  return InputField;
}(Component);

InputField.propTypes = {
  defaultValue: propTypes.string,
  id: propTypes.string,
  label: propTypes.string,
  labelClass: propTypes.string,
  helperText: propTypes.string,
  type: propTypes.oneOf(['text', 'email', 'password', 'tel', 'number', 'url', 'search', 'date', 'time']).isRequired,
  required: propTypes.bool,
  placeholder: propTypes.string,
  disabled: propTypes.bool,
  onBlurFunction: propTypes.func,
  className: propTypes.string,
  name: propTypes.string,
  errorMessage: propTypes.string,
  autoFocus: propTypes.bool,
  onKeyDown: propTypes.func,
  pattern: propTypes.string,
  maxChars: propTypes.number,
  addOn: propTypes.string,
  onCopyLink: propTypes.func,
  onChange: propTypes.func
};

var Checkmark = function Checkmark(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Checkmark' : _ref$title,
      viewBox = _ref.viewBox,
      props = _objectWithoutProperties(_ref, ["title", "viewBox"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: viewBox
  }, props), React.createElement("path", {
    fillOpacity: ".01",
    d: "M0 1h16v16H0z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4 6.156a.92.92 0 00-1.263-1.339l-.04.037-7.592 7.593-2.603-2.603a.92.92 0 00-1.262-.038l-.04.038a.92.92 0 00-.036 1.262l.037.04 3.904 3.904L14.4 6.156z"
  }));
};

Checkmark.propTypes = {
  title: propTypes.string,
  viewBox: propTypes.string
};
Checkmark.defaultProps = {
  viewBox: '0 0 16 16'
};

var Info = function Info(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Info' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: "0 0 72 72"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 0C16.118 0 0 16.118 0 36s16.118 36 36 36 36-16.118 36-36S55.882 0 36 0zm4.142 21.417a4.53 4.53 0 00-4.553-4.554 4.53 4.53 0 00-4.554 4.554 4.53 4.53 0 004.554 4.553 4.53 4.53 0 004.553-4.553zm-.49 34.86V33.452H31.53v22.827h8.123zm24.9-20.279C64.552 20.23 51.769 7.446 36 7.446S7.448 20.23 7.448 35.998 20.231 64.55 36 64.55s28.552-12.783 28.552-28.552z"
  }));
};

Info.propTypes = {
  title: propTypes.string
};

var Hashtag = function Hashtag(props) {
  return React.createElement(CreateIconComponent, _extends({
    viewBox: "0 0 20 20"
  }, props), React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, React.createElement("path", {
    d: "M14.81 1.405c.564.1.948.623.882 1.185l-.009.062-.532 3.014h2.384a1.076 1.076 0 01.063 2.15l-.063.003h-2.763l-.76 4.305h3.523a1.076 1.076 0 01.063 2.151l-.063.002h-3.902l-.567 3.216a1.076 1.076 0 01-2.129-.311l.01-.063.5-2.842H7.175l-.567 3.216a1.076 1.076 0 01-2.13-.311l.01-.063.5-2.842H2.466a1.076 1.076 0 01-.063-2.151l.063-.002h2.903l.76-4.306H2.465a1.076 1.076 0 01-.063-2.15l.063-.002h4.042l.598-3.387a1.076 1.076 0 012.129.31l-.01.063-.531 3.014h4.273l.597-3.387a1.076 1.076 0 011.247-.874zM12.586 7.82H8.314l-.76 4.305h4.273l.76-4.305z"
  })));
};

Hashtag.propTypes = {
  title: propTypes.string,
  style: propTypes.shape({})
};
Hashtag.defaultProps = {
  title: 'Hashtag',
  style: {
    // This icon was initially imported with a fill color
    color: '#505050'
  }
};

var Cash = function Cash(props) {
  return React.createElement(CreateIconComponent, _extends({
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.678 2.402a1.076 1.076 0 00-2.151.063v1.858c-2.364.225-4.019 1.601-4.019 3.493 0 1.848 1.144 2.715 3.538 3.353l.48.122v2.928a4.985 4.985 0 01-2.741-1.39c-.525-.528-1.28-.53-1.74-.065-.48.485-.43 1.245.181 1.854 1.049 1.048 2.511 1.693 4.3 1.84v1.077l.003.063a1.076 1.076 0 002.15-.063V16.39c2.351-.37 3.656-1.737 3.656-3.609 0-1.224-.562-2.106-1.597-2.722-.566-.337-1.118-.547-2.058-.799V6.72c.613.185 1.16.483 1.612.89l.09.083c.572.546 1.341.562 1.802.085.474-.49.394-1.258-.241-1.842-.87-.8-1.966-1.314-3.263-1.53v-1.94l-.002-.063zM9.527 6.53c-.873.132-1.402.585-1.402 1.169 0 .44.356.713 1.402 1.018V6.53zm2.153 5.339v2.247c.709-.23 1.057-.668 1.057-1.185 0-.477-.272-.775-1.057-1.062z"
  }));
};

Cash.propTypes = {
  title: propTypes.string,
  style: propTypes.shape({})
};
Cash.defaultProps = {
  title: 'Cash',
  style: {
    // This icon was initially imported with a fill color
    color: '#505050'
  }
};

var CalendarDay = function CalendarDay(props) {
  return React.createElement(CreateIconComponent, _extends({
    viewBox: "0 0 24 25"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85644 1.29822C8.8155 0.591623 8.22948 0.03125 7.51257 0.03125C6.76911 0.03125 6.16642 0.6339 6.16642 1.37731V1.82589H2.57662C1.83316 1.82589 1.23047 2.42854 1.23047 3.17195V9.00486V22.0168C1.23047 22.7602 1.83316 23.3628 2.57662 23.3628H21.4228C22.1662 23.3628 22.7689 22.7602 22.7689 22.0168V9.00486V3.17195C22.7689 2.42854 22.1662 1.82589 21.4228 1.82589H17.8329V1.37731L17.8306 1.29822C17.7897 0.591623 17.2037 0.03125 16.4868 0.03125C15.7433 0.03125 15.1406 0.6339 15.1406 1.37731V1.82589H8.85872V1.37731L8.85644 1.29822ZM20.0767 7.65881V4.51836H17.8329V5.86416C17.8329 6.60757 17.2302 7.21022 16.4868 7.21022C15.7698 7.21022 15.1838 6.64985 15.1429 5.94326L15.1406 5.86416V4.51836H8.85872V5.86416C8.85872 6.60757 8.25603 7.21022 7.51257 7.21022C6.79566 7.21022 6.20965 6.64985 6.1687 5.94326L6.16642 5.86416V4.51836H3.92288V7.65881H20.0767ZM3.92288 10.3509H20.0767V20.671H3.92288V10.3509ZM14.6436 18.4267V16.6894H12.304C14.071 15.6529 14.5844 14.9126 14.5844 14.0143C14.5844 12.6916 13.4689 11.744 11.761 11.744C10.843 11.744 9.73732 12.05 8.97719 12.8594L10.0631 14.1822C10.5666 13.7577 11.0996 13.5011 11.761 13.5011C12.225 13.5011 12.5607 13.6985 12.5607 14.0143C12.5607 14.5079 12.2744 14.7547 9.26348 16.877V18.4267H14.6436Z"
  }));
};

CalendarDay.propTypes = {
  title: propTypes.string,
  style: propTypes.shape({})
};
CalendarDay.defaultProps = {
  title: 'CalendarDay',
  style: {
    // This icon was initially imported with a fill color
    color: '#21201F'
  }
};

var GeoPin = function GeoPin(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'GeoPin' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: "0 0 18 23"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25.507C4.456.507.583 4.475.583 9.352c0 3.22 2.585 7.357 7.683 12.633.538.556 1.43.556 1.968 0l.437-.456c4.809-5.059 7.246-9.05 7.246-12.177 0-4.877-3.873-8.845-8.667-8.845zm0 2.737c3.268 0 5.93 2.727 5.93 6.108l-.002.103c-.06 2.047-1.887 5.15-5.53 9.155l-.398.433-.014-.015C5.273 14.75 3.32 11.467 3.32 9.352c0-3.381 2.663-6.108 5.93-6.108zm0 1.368a4.105 4.105 0 100 8.21 4.105 4.105 0 000-8.21zm0 2.737a1.368 1.368 0 110 2.737 1.368 1.368 0 010-2.737z"
  }));
};

GeoPin.propTypes = {
  title: propTypes.string
};

var Tooltip = function Tooltip(_ref) {
  var text = _ref.text,
      htmlText = _ref.htmlText,
      className = _ref.className,
      popIn = _ref.popIn;
  return React.createElement("div", {
    className: classnames('zola-ui', 'tooltip__container', className)
  }, React.createElement("div", {
    className: classnames('tooltip', {
      'pop-in': popIn
    })
  }, text, htmlText && React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: "".concat(htmlText)
    }
  })));
};

Tooltip.propTypes = {
  text: propTypes.string,
  htmlText: propTypes.string,
  className: propTypes.string,
  popIn: propTypes.bool
};

var renderLabelLink = function renderLabelLink(screenSize, labelLink) {
  if (labelLink) {
    var url = labelLink.url,
        copy = labelLink.copy;
    var labelLinkClass = screenSize === 'desktop' ? 'label__link-desktop' : 'label__link-mobile';
    var labelLinkSize = screenSize === 'desktop' ? 'small' : 'large';
    return React.createElement("span", {
      className: labelLinkClass
    }, React.createElement(Link, {
      href: url,
      arrow: true,
      size: labelLinkSize
    }, copy));
  }

  return null;
};
var calculateNotificationStyle = function calculateNotificationStyle(notificationTyle, totalLimit, inputLength, warningLimit, minCount) {
  switch (notificationTyle) {
    case 'warning':
      return totalLimit && inputLength && inputLength > totalLimit - warningLimit && inputLength <= totalLimit;

    case 'min_invalid':
      return inputLength < minCount;

    case 'max_invalid':
      return totalLimit && inputLength && inputLength > totalLimit;

    default:
  }

  return null;
};

var useConditionalCallbacks = function useConditionalCallbacks(condition, callbacks) {
  useEffect(function () {
    if (condition) {
      forEach_1(callbacks, function (fn) {
        if (typeof fn === 'function') fn();
      });
    }
  });
};

var InputFieldV2 = function InputFieldV2(props) {
  var label = props.label,
      helperText = props.helperText,
      type = props.type,
      id = props.id,
      isRequired = props.isRequired,
      clear = props.clear,
      tooltip = props.tooltip,
      labelLink = props.labelLink,
      placeholder = props.placeholder,
      onClear = props.onClear,
      defaultValue = props.defaultValue,
      className = props.className,
      errorMessage = props.errorMessage,
      isAvailable = props.isAvailable,
      maxChars = props.maxChars,
      addOn = props.addOn,
      inline = props.inline,
      _props$value = props.value,
      externalValue = _props$value === void 0 ? '' : _props$value,
      allowChangeToEmpty = props.allowChangeToEmpty,
      rest = _objectWithoutProperties(props, ["label", "helperText", "type", "id", "isRequired", "clear", "tooltip", "labelLink", "placeholder", "onClear", "defaultValue", "className", "errorMessage", "isAvailable", "maxChars", "addOn", "inline", "value", "allowChangeToEmpty"]);

  var phoneNumber = type === 'tel';
  var initialInputValue = externalValue || defaultValue || '';

  var _useState = useState(initialInputValue),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isVisibleTooltip = _useState4[0],
      setIsVisibleTooltip = _useState4[1]; // this helps facilitate an external value from the InputFieldV2Adapter
  // example: form data fetched from front end, and loaded into react-final-form
  // after the input has already mounted


  useConditionalCallbacks(inputValue === '' && inputValue !== externalValue, [function () {
    return setInputValue(externalValue);
  }]);

  var showTooltip = function showTooltip() {
    setIsVisibleTooltip(true);
  };

  var hideTooltip = function hideTooltip() {
    setIsVisibleTooltip(false);
  };

  var handleClear = function handleClear() {
    if (onClear && typeof onClear === 'function') {
      onClear();
    } else {
      setInputValue('');
    }
  };

  var handleChange = function handleChange(e) {
    var onChange = props.onChange;

    if (onChange && typeof onChange === 'function') {
      onChange(e);
    }

    setInputValue(e.target.value);
  };

  var maxInvalid = maxChars && calculateNotificationStyle('max_invalid', maxChars, inputValue.length);
  var maxWarning = maxChars && calculateNotificationStyle('warning', maxChars, inputValue.length, 5);
  var inputContainerClasses = classnames('zola-ui v2-render-field', {
    inline: inline
  }, {
    'has-error': errorMessage || maxInvalid
  }, {
    'has-add-on': addOn
  }, {
    'has-warning': maxWarning
  }, {
    'is-available': isAvailable
  }, className);
  useEffect(function () {
    if (allowChangeToEmpty || externalValue && externalValue !== inputValue) {
      setInputValue(externalValue);
    }
  }, [externalValue, allowChangeToEmpty, inputValue, setInputValue]);
  return React.createElement("div", {
    className: inputContainerClasses
  }, label && React.createElement("label", {
    htmlFor: id
  }, React.createElement("span", {
    className: "label__text"
  }, label), isRequired && React.createElement("span", {
    className: "text-danger danger-asterisk"
  }, "*"), tooltip && React.createElement("span", {
    className: "label__tooltip"
  }, React.createElement(Info, {
    className: "form-field__icon info",
    width: 14,
    height: 14,
    title: "info-icon",
    onMouseEnter: showTooltip,
    onMouseLeave: hideTooltip
  }), isVisibleTooltip && React.createElement(Tooltip, {
    text: tooltip
  })), renderLabelLink('desktop', labelLink)), React.createElement("div", {
    className: "input-field__container"
  }, addOn && addOn === 'hashtag' && React.createElement("div", {
    className: "input-addon"
  }, React.createElement("div", {
    className: "input-addon-icon"
  }, React.createElement(Hashtag, {
    className: classnames('form-field__icon addon', addOn),
    width: 16,
    height: 16,
    title: "hashtag-icon"
  }))), addOn && addOn === 'cash' && React.createElement("div", {
    className: "input-addon"
  }, React.createElement("div", {
    className: "input-addon-icon"
  }, React.createElement(Cash, {
    className: classnames('form-field__icon addon', addOn),
    width: 16,
    height: 16,
    title: "cash-icon"
  }))), addOn && addOn === 'calendar' && React.createElement("div", {
    className: "input-addon"
  }, React.createElement("div", {
    className: "input-addon-icon"
  }, React.createElement(CalendarDay, {
    width: 18,
    height: 18,
    className: classnames('form-field__icon addon', addOn),
    title: "calendar-icon"
  }))), addOn && addOn === 'geopin' && React.createElement("div", {
    className: "input-addon"
  }, React.createElement("div", {
    className: "input-addon-icon"
  }, React.createElement(GeoPin, {
    className: "form-field__icon addon calendar",
    width: 18,
    height: 18,
    title: "geopin-icon"
  }))), React.createElement("input", _extends({}, rest, {
    value: inputValue,
    className: "input-field",
    type: type,
    id: id,
    placeholder: phoneNumber ? '(         )   ___-____' : placeholder,
    onChange: handleChange
  })), clear && inputValue.length !== 0 && React.createElement("span", {
    className: "remove-icon__container"
  }, React.createElement(Remove, {
    className: "form-field__icon remove",
    width: 12,
    height: 12,
    title: "remove-icon",
    onClick: function onClick() {
      return handleClear();
    }
  })), maxChars && React.createElement("span", {
    className: "field-message"
  }, React.createElement("span", {
    className: classnames('max-characters', {
      'text-danger': maxInvalid
    }, {
      'text-warning': maxWarning
    })
  }, inputValue.length, "/", maxChars)), renderLabelLink('mobile', labelLink), helperText && !errorMessage && React.createElement("div", {
    className: "field-message"
  }, helperText), errorMessage && React.createElement(Error$1, {
    message: errorMessage,
    iconSize: 12
  }), isAvailable && React.createElement("span", {
    className: "field-message"
  }, React.createElement(Checkmark, {
    className: "form-field__icon success",
    width: 12,
    height: 12,
    title: "checkmark-icon"
  }), React.createElement("span", {
    className: "text-success"
  }, "That one is available"))));
};

InputFieldV2.propTypes = {
  id: propTypes.oneOfType([propTypes.string, propTypes.node]),
  label: propTypes.string,
  defaultValue: propTypes.string,
  helperText: propTypes.oneOfType([propTypes.string, propTypes.node]),

  /** using 'date' is not recommended. Use 'form/DatePicker/DatePickerInput' */
  type: propTypes.oneOf(['text', 'email', 'password', 'tel', 'number', 'url', 'search', 'date', 'time']).isRequired,
  isRequired: propTypes.bool,
  tooltip: propTypes.string,
  labelLink: propTypes.shape({
    url: propTypes.string,
    copy: propTypes.string
  }),
  placeholder: propTypes.string,
  clear: propTypes.bool,
  onClear: propTypes.func,
  className: propTypes.string,
  errorMessage: propTypes.string,
  isAvailable: propTypes.bool,
  maxChars: propTypes.number,
  addOn: propTypes.oneOf(['hashtag', 'cash', 'calendar', 'geopin']),
  onChange: propTypes.func,
  inline: propTypes.bool,
  value: propTypes.oneOfType([propTypes.string, propTypes.number]),

  /** use this prop if you are using a RFF mutator to clear a field and change a previous input value to an empty string. */
  allowChangeToEmpty: propTypes.bool
};

var InputFieldV2Adapter = function InputFieldV2Adapter(_ref) {
  var input = _ref.input,
      meta = _ref.meta,
      inputOnChange = _ref.inputOnChange,
      onBlurFunction = _ref.onBlurFunction,
      formatOnChange = _ref.formatOnChange,
      rest = _objectWithoutProperties(_ref, ["input", "meta", "inputOnChange", "onBlurFunction", "formatOnChange"]);

  var hasError = meta && meta.touched && (meta.submitError || meta.error);
  var errorMessage = hasError ? meta.submitError || meta.error : '';

  var inputProps = _objectSpread({}, input, {
    onChange: function onChange(e) {
      var text = e.target.value;

      if (formatOnChange) {
        text = formatOnChange(text);
      }

      input.onChange({
        target: {
          value: text
        }
      }); // eslint-disable-next-line no-unused-expressions

      inputOnChange && inputOnChange(e);
    },
    onBlur: function onBlur(e) {
      input.onBlur(e); // eslint-disable-next-line no-unused-expressions

      onBlurFunction && onBlurFunction(e);
    },
    errorMessage: errorMessage
  }, rest);

  return React.createElement(InputFieldV2, inputProps);
};

InputFieldV2Adapter.propTypes = {
  input: propTypes.shape({
    name: propTypes.string.isRequired,
    value: propTypes.any
  }),
  inputOnChange: propTypes.func,
  formatOnChange: propTypes.func,
  onBlurFunction: propTypes.func,
  meta: propTypes.shape({
    touched: propTypes.bool,
    error: propTypes.string,
    asyncValidating: propTypes.bool
  })
};

var SearchField =
/*#__PURE__*/
function (_Component) {
  _inherits(SearchField, _Component);

  function SearchField(props) {
    var _this;

    _classCallCheck(this, SearchField);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SearchField).call(this, props));
    _this.state = {
      searchWord: props.searchWord || '',
      focus: false
    };
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_this));
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    _this.clearSearch = _this.clearSearch.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SearchField, [{
    key: "onFocus",
    value: function onFocus(e) {
      var handleFocus = this.props.handleFocus;
      this.setState({
        focus: true
      });

      if (handleFocus) {
        handleFocus(e);
      }
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      var handleBlur = this.props.handleBlur;
      this.setState({
        focus: false
      });

      if (handleBlur) {
        handleBlur(e);
      }
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      var handleOnChange = this.props.handleOnChange;
      this.setState({
        searchWord: e.target.value
      });

      if (handleOnChange) {
        handleOnChange(e);
      }
    }
  }, {
    key: "clearSearch",
    value: function clearSearch() {
      var handleOnChange = this.props.handleOnChange;
      this.setState({
        searchWord: ''
      });

      if (handleOnChange) {
        handleOnChange('');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          placeholder = _this$props.placeholder,
          showClearSearch = _this$props.showClearSearch,
          className = _this$props.className,
          showSearchCta = _this$props.showSearchCta,
          handleKeyPress = _this$props.handleKeyPress,
          handleSearch = _this$props.handleSearch;
      var _this$state = this.state,
          searchWord = _this$state.searchWord,
          focus = _this$state.focus;
      return React.createElement("div", {
        className: classnames('zola-ui search-field__container', {
          'search-field__container-active': searchWord
        }, {
          'search-icon-visible': showSearchCta
        }, {
          'search-field-focus': focus
        }, className)
      }, !showSearchCta && React.createElement("i", {
        className: "zola-ui-icon zola-ui-icon-magnifying-glass"
      }), React.createElement("input", {
        placeholder: placeholder,
        value: searchWord,
        onChange: this.onChange,
        onKeyPress: handleKeyPress,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      }), showSearchCta && React.createElement("div", {
        className: "search-icon",
        onClick: handleSearch
      }, React.createElement("i", {
        className: "zola-ui-icon zola-ui-icon-magnifying-glass"
      })), showClearSearch && searchWord && React.createElement("i", {
        className: classnames({
          'zola-ui-icon zola-ui-icon-close': showClearSearch && searchWord
        }),
        onClick: this.clearSearch
      }));
    }
  }]);

  return SearchField;
}(Component);

SearchField.propTypes = {
  className: propTypes.string,
  handleKeyPress: propTypes.func,
  handleSearch: propTypes.func,
  placeholder: propTypes.string,
  handleFocus: propTypes.func,
  handleBlur: propTypes.func,
  searchWord: propTypes.string,
  showClearSearch: propTypes.bool,
  showSearchCta: propTypes.bool,
  handleOnChange: propTypes.func
};

var RadioField = function RadioField(props) {
  var id = props.id,
      label = props.label,
      labelElem = props.labelElem,
      className = props.className,
      useCompletedStyle = props.useCompletedStyle,
      inline = props.inline,
      disabled = props.disabled,
      tooltip = props.tooltip,
      errorMessage = props.errorMessage,
      isExpanded = props.isExpanded,
      children = props.children,
      checked = props.checked,
      useSelectorStyle = props.useSelectorStyle,
      dek = props.dek,
      rightSideZolaIconPath = props.rightSideZolaIconPath,
      rightSideText = props.rightSideText,
      rightSideHtml = props.rightSideHtml,
      rest = _objectWithoutProperties(props, ["id", "label", "labelElem", "className", "useCompletedStyle", "inline", "disabled", "tooltip", "errorMessage", "isExpanded", "children", "checked", "useSelectorStyle", "dek", "rightSideZolaIconPath", "rightSideText", "rightSideHtml"]);

  var shownIcon = rightSideZolaIconPath ? React.createElement("div", {
    className: "icon-wrapper"
  }, React.createElement(ClearCircleIcon, {
    image: rightSideZolaIconPath,
    size: 36
  })) : null;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isVisibleTooltip = _useState2[0],
      setIsVisibleTooltip = _useState2[1];

  var showTooltip = function showTooltip() {
    setIsVisibleTooltip(true);
  };

  var hideTooltip = function hideTooltip() {
    setIsVisibleTooltip(false);
  };

  var tooltipProp = tooltip ? {
    'data-tooltip': tooltip
  } : {};
  var componentClassName = classnames('zola-ui v2-render-radio-field v2-render-selector-field', className, {
    inline: inline,
    'has-error': errorMessage,
    'use-completed': useCompletedStyle,
    'uses-selector-style': useSelectorStyle || !!children,
    'is-checked': checked,
    'is-disabled': disabled,
    'is-expandable': children
  });
  var iconWrapperClassName = classnames('selector-icon-wrapper radio-icon-wrapper', {
    'selector-icon-wrapper--checked': checked,
    'selector-icon-wrapper--disabled': disabled,
    'selector-icon-wrapper--errored': errorMessage
  });
  var selectorLabelClassName = classnames('selector-label', {
    'selector-label--checked': checked,
    'selector-label--disabled': disabled,
    'selector-label--errored': errorMessage
  });
  return React.createElement("div", _extends({
    className: componentClassName
  }, tooltipProp), React.createElement("label", {
    htmlFor: id,
    className: "field-wrapper"
  }, React.createElement("input", _extends({}, rest, {
    type: "radio",
    id: id,
    disabled: disabled,
    checked: checked
  })), React.createElement("div", {
    className: "field-wrapper-inner"
  }, React.createElement("div", {
    className: iconWrapperClassName
  }), React.createElement("div", {
    className: "selector-label-wrapper"
  }, React.createElement("span", {
    className: selectorLabelClassName
  }, label && label, tooltip && React.createElement("span", {
    className: "label__tooltip"
  }, React.createElement(Info, {
    className: "form-field__icon info",
    width: 14,
    height: 14,
    title: "info-icon",
    onMouseEnter: showTooltip,
    onMouseLeave: hideTooltip
  }), isVisibleTooltip && React.createElement(Tooltip, {
    text: tooltip
  })), labelElem && labelElem, tooltip && React.createElement("i", {
    className: "zolaicon zolaicon-info",
    "aria-label": "Information Icon"
  }), dek && React.createElement("p", {
    className: "selector-dek"
  }, dek)), (rightSideText || rightSideZolaIconPath || rightSideHtml) && React.createElement("span", {
    className: "selector-label-right"
  }, rightSideText && rightSideText, shownIcon && shownIcon, rightSideHtml && rightSideHtml))), errorMessage && React.createElement(Error$1, {
    message: errorMessage,
    iconSize: 11
  })), isExpanded && children && React.createElement("div", {
    className: "expanded-area"
  }, children));
};

RadioField.propTypes = {
  /** mandatory id for label matching */
  id: propTypes.string.isRequired,

  /** make a checkbox inline-block */
  inline: propTypes.bool,

  /** label for the checkbox button */
  label: propTypes.oneOfType([propTypes.string, propTypes.node]),

  /** React Element as a label for the checkbox button */
  labelElem: propTypes.element,

  /** custom function that triggered by onChange event of the input */
  onChange: propTypes.func,

  /** disable default action for onChange event of the input */
  disableDefaultAction: propTypes.bool,

  /** custom class name */
  className: propTypes.string,

  /** use completed style instead of regular select style */
  useCompletedStyle: propTypes.bool,

  /** disable the checkbox button */
  disabled: propTypes.bool,

  /** NOTE: it still uses bootstrap to handle tooltip at the moment */
  tooltip: propTypes.string,

  /** The text of any error message */
  errorMessage: propTypes.string,

  /** Whether or not the checkbox should show its children. Only used for checkboxes which should be expandable. */
  isExpanded: propTypes.bool,

  /** The contents that are shown when a checkbox is expanded */
  children: propTypes.element,

  /** Whether or not the checkbox is checked / === true  */
  checked: propTypes.bool,

  /** Whether or not the checkbox uses the selector style, i.e. the big, bordered version */
  useSelectorStyle: propTypes.bool,

  /** The text that appears below the label */
  dek: propTypes.oneOfType([propTypes.string, propTypes.node]),

  /** The path to the zola icon that can appear to the right of the label */
  rightSideZolaIconPath: propTypes.string,

  /** Text that can appear to the right of the label, bolded */
  rightSideText: propTypes.string,

  /** Typically an <img> or <svg> tag. Should be 36px tall */
  rightSideHtml: propTypes.node
};

var RadioFieldAdapter = function RadioFieldAdapter(_ref) {
  var input = _ref.input,
      meta = _ref.meta,
      _onChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, ["input", "meta", "onChange"]);

  var errorMessage = meta && meta.touched && meta.error ? meta.error : '';
  return React.createElement(RadioField, _extends({}, input, rest, {
    errorMessage: errorMessage,
    onChange: function onChange(e) {
      input.onChange(e.target.value);

      if (_onChange) {
        _onChange(e);
      }
    }
  }));
};

RadioFieldAdapter.propTypes = {
  input: propTypes.shape({
    name: propTypes.string.isRequired
  }),
  meta: propTypes.shape({
    touched: propTypes.bool,
    error: propTypes.string
  }),
  onChange: propTypes.func
};

var RenderRadioField = function RenderRadioField(_ref) {
  var input = _ref.input,
      inline = _ref.inline,
      label = _ref.label,
      labelElem = _ref.labelElem,
      className = _ref.className,
      id = _ref.id,
      onChangeAction = _ref.onChangeAction,
      disableDefaultAction = _ref.disableDefaultAction,
      disabled = _ref.disabled,
      tooltip = _ref.tooltip,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error;
  var hasError = touched && error;
  var tooltipProp = tooltip ? {
    'data-tooltip': tooltip
  } : {};
  var componentClassName = classnames('zola-ui render-radio-field', className, {
    inline: inline,
    'has-error': hasError
  });
  return React.createElement("div", _extends({
    className: componentClassName
  }, tooltipProp), React.createElement("input", _extends({}, input, {
    type: "radio",
    id: id,
    disabled: disabled,
    onChange: function onChange(e) {
      if (onChangeAction) {
        onChangeAction();
      }

      if (!disableDefaultAction) {
        input.onChange(e);
      }
    }
  })), React.createElement("label", {
    htmlFor: id
  }, label && label, labelElem && labelElem, tooltip && React.createElement("i", {
    className: "zolaicon zolaicon-info",
    "aria-label": "Information Icon"
  })), touched && error && React.createElement("span", {
    className: "help-block error-block"
  }, error), error && React.createElement("p", {
    style: {
      color: 'red'
    }
  }, error));
};

RenderRadioField.defaultProps = {
  tooltip: ''
};
RenderRadioField.propTypes = {
  /**
   * Input information
   * name: name to group buttons
   * checked: checked a radio button
   */
  input: propTypes.shape({
    name: propTypes.string.isRequired,
    checked: propTypes.bool
  }).isRequired,

  /** mandatory id for label matching */
  id: propTypes.string.isRequired,

  /** make a radio button inline-block */
  inline: propTypes.bool,

  /** label for the radio button */
  label: propTypes.string,

  /** React Element as a label for the radio button */
  labelElem: propTypes.element,

  /** type of the input */
  type: propTypes.oneOf(['radio']).isRequired,

  /** custom function that triggered by onChange event of the input */
  onChangeAction: propTypes.func,

  /** disable default action for onChange event of the input */
  disableDefaultAction: propTypes.bool,

  /** custom class name */
  className: propTypes.string,

  /** disable the radio button
   * NOTE: Currently, you much have to manfully disable all buttons in the same group
   * to make CSS hover style consist.
   * */
  disabled: propTypes.bool,

  /** NOTE: it still uses bootstrap to handle tooltip at the moment */
  tooltip: propTypes.string,

  /** This prop is provided by Redux Form directly.  */
  meta: propTypes.shape({
    touched: propTypes.bool,
    error: propTypes.string
  })
};

var RenderCheckBoxField = function RenderCheckBoxField(_ref) {
  var id = _ref.id,
      input = _ref.input,
      label = _ref.label,
      labelElem = _ref.labelElem,
      className = _ref.className,
      useCompletedStyle = _ref.useCompletedStyle,
      inline = _ref.inline,
      onChangeAction = _ref.onChangeAction,
      disableDefaultAction = _ref.disableDefaultAction,
      disabled = _ref.disabled,
      tooltip = _ref.tooltip,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      form = _ref$meta.form,
      touch = _ref.touch;
  var hasError = touched && error;
  var tooltipProp = tooltip ? {
    'data-tooltip': tooltip
  } : {};
  var componentClassName = classnames('zola-ui render-checkbox-field', className, {
    inline: inline,
    'has-error': hasError,
    'use-completed': useCompletedStyle
  });
  return React.createElement("div", _extends({
    className: componentClassName
  }, tooltipProp), React.createElement("input", _extends({}, input, {
    type: "checkbox",
    id: id,
    disabled: disabled,
    onChange: function onChange(e) {
      if (onChangeAction) {
        onChangeAction();
      }

      if (!disableDefaultAction) {
        input.onChange(e);
      }

      if (touch) {
        touch(form, input.name);
      }
    }
  })), React.createElement("label", {
    htmlFor: id
  }, React.createElement("div", {
    className: "checkbox-icon-wrapper"
  }, React.createElement("i", {
    className: "zola-ui-icon zola-ui-icon-checkmark",
    "aria-label": "Check Mark Icon"
  })), React.createElement("span", null, label && label, labelElem && labelElem, tooltip && React.createElement("i", {
    className: "zolaicon zolaicon-info",
    "aria-label": "Information Icon"
  }))), touched && error && React.createElement("span", {
    className: "help-block error-block"
  }, error));
};

RenderCheckBoxField.defaultProps = {
  tooltip: ''
};
RenderCheckBoxField.propTypes = {
  /**
   * Input information
   * name: name to group buttons
   * checked: checked a checkbox button
   */
  input: propTypes.shape({
    name: propTypes.string,
    checked: propTypes.bool
  }).isRequired,

  /** mandatory id for label matching */
  id: propTypes.string.isRequired,

  /** make a checkbox inline-block */
  inline: propTypes.bool,

  /** label for the checkbox button */
  label: propTypes.string,

  /** React Element as a label for the checkbox button */
  labelElem: propTypes.element,

  /** type of the input */
  type: propTypes.oneOf(['checkbox']).isRequired,

  /** custom function that triggered by onChange event of the input */
  onChangeAction: propTypes.func,

  /** disable default action for onChange event of the input */
  disableDefaultAction: propTypes.bool,

  /** custom class name */
  className: propTypes.string,

  /** use completed style instead of regular select style */
  useCompletedStyle: propTypes.bool,

  /** disable the checkbox button */
  disabled: propTypes.bool,

  /** NOTE: it still uses bootstrap to handle tooltip at the moment */
  tooltip: propTypes.string,

  /** This prop is provided by Redux Form directly.  */
  meta: propTypes.shape({
    touched: propTypes.bool,
    error: propTypes.string,
    form: propTypes.string
  }),

  /**
   * The redux form touch callback to signal redux form that the checkbox has been modified.
   * By default, redux form will only set touched on checkboxes when the form
   * has been submitted.  To show validation errors when the user clicks and
   * unclicks (for instance, if the form submit button is disabled) the touch
   * callback is used.  Used with required checkboxes.
   */
  touch: propTypes.func
};

var CheckBoxField = function CheckBoxField(props) {
  var id = props.id,
      label = props.label,
      labelElem = props.labelElem,
      className = props.className,
      inline = props.inline,
      onChange = props.onChange,
      disabled = props.disabled,
      tooltip = props.tooltip,
      errorMessage = props.errorMessage,
      isExpanded = props.isExpanded,
      children = props.children,
      checked = props.checked,
      useSelectorStyle = props.useSelectorStyle,
      dek = props.dek,
      rightSideZolaIconPath = props.rightSideZolaIconPath,
      rightSideText = props.rightSideText,
      rightSideHtml = props.rightSideHtml,
      rest = _objectWithoutProperties(props, ["id", "label", "labelElem", "className", "inline", "onChange", "disabled", "tooltip", "errorMessage", "isExpanded", "children", "checked", "useSelectorStyle", "dek", "rightSideZolaIconPath", "rightSideText", "rightSideHtml"]);

  var shownIcon = rightSideZolaIconPath ? React.createElement("div", {
    className: "icon-wrapper"
  }, React.createElement(ClearCircleIcon, {
    image: rightSideZolaIconPath,
    size: 36
  })) : null;
  var tooltipProp = tooltip ? {
    'data-tooltip': tooltip
  } : {};
  var componentClassName = classnames('zola-ui v2-render-checkbox-field v2-render-selector-field', className, {
    inline: inline,
    'has-error': errorMessage,
    'uses-selector-style': useSelectorStyle || !!children,
    'is-checked': checked,
    'is-disabled': disabled,
    'is-expandable': children
  });
  var iconWrapperClassName = classnames('selector-icon-wrapper checkbox-icon-wrapper', {
    'selector-icon-wrapper--checked': checked,
    'selector-icon-wrapper--disabled': disabled,
    'selector-icon-wrapper--errored': errorMessage
  });
  var iconClassName = classnames('zola-ui-icon zola-ui-icon-checkmark', {
    'selector-icon--checked': checked,
    'selector-icon--disabled': disabled,
    'selector-icon--errored': errorMessage
  });
  var selectorLabelClassName = classnames('selector-label', {
    'selector-label--checked': checked,
    'selector-label--disabled': disabled,
    'selector-label--errored': errorMessage
  });
  var labelWrapperClassName = classnames('selector-label-wrapper', {
    'has-icon': shownIcon
  });
  return React.createElement("div", _extends({
    className: componentClassName
  }, tooltipProp), React.createElement("label", {
    className: "field-wrapper",
    htmlFor: id
  }, React.createElement("input", _extends({}, rest, {
    type: "checkbox",
    id: id,
    disabled: disabled,
    checked: checked,
    onChange: onChange
  })), React.createElement("div", {
    className: "field-wrapper-inner"
  }, React.createElement("div", {
    className: iconWrapperClassName
  }, React.createElement("i", {
    className: iconClassName,
    "aria-label": "Check Mark Icon"
  })), React.createElement("div", {
    className: "field-body"
  }, React.createElement("div", {
    className: labelWrapperClassName
  }, React.createElement("span", {
    className: selectorLabelClassName
  }, label && label, labelElem && labelElem, tooltip && React.createElement("i", {
    className: "zolaicon zolaicon-info",
    "aria-label": "Information Icon"
  })), (rightSideText || rightSideZolaIconPath || rightSideHtml) && React.createElement("span", {
    className: "selector-label-right"
  }, rightSideText && rightSideText, shownIcon && shownIcon, rightSideHtml && rightSideHtml)), dek && React.createElement("p", {
    className: "selector-dek"
  }, dek)))), errorMessage && React.createElement(Error$1, {
    message: errorMessage
  }), isExpanded && children && React.createElement("div", {
    className: "expanded-area"
  }, children));
};

CheckBoxField.defaultProps = {
  tooltip: ''
};
CheckBoxField.propTypes = {
  /** mandatory id for label matching */
  id: propTypes.string.isRequired,

  /** make a checkbox inline-block */
  inline: propTypes.bool,

  /** label for the checkbox button */
  label: propTypes.oneOfType([propTypes.string, propTypes.node]),

  /** React Element as a label for the checkbox button */
  labelElem: propTypes.element,

  /** custom function that triggered by onChange event of the input */
  onChange: propTypes.func,

  /** disable default action for onChange event of the input */
  disableDefaultAction: propTypes.bool,

  /** custom class name */
  className: propTypes.string,

  /** use completed style instead of regular select style */
  useCompletedStyle: propTypes.bool,

  /** disable the checkbox button */
  disabled: propTypes.bool,

  /** NOTE: it still uses bootstrap to handle tooltip at the moment */
  tooltip: propTypes.string,

  /** The text of any error message */
  errorMessage: propTypes.string,

  /** Whether or not the checkbox should show its children. Only used for checkboxes which should be expandable. */
  isExpanded: propTypes.bool,

  /** The contents that are shown when a checkbox is expanded */
  children: propTypes.element,

  /** Whether or not the checkbox is checked / === true  */
  checked: propTypes.bool,

  /** Whether or not the checkbox uses the selector style, i.e. the big, bordered version */
  useSelectorStyle: propTypes.bool,

  /** The text that appears below the label */
  dek: propTypes.oneOfType([propTypes.string, propTypes.node]),

  /** The path to the zola icon that can appear to the right of the label */
  rightSideZolaIconPath: propTypes.string,

  /** Text that can appear to the right of the label, bolded */
  rightSideText: propTypes.string,

  /** Typically an <img> or <svg> tag. Should be 36px tall */
  rightSideHtml: propTypes.node
};

var CheckboxFieldAdapter = function CheckboxFieldAdapter(_ref) {
  var input = _ref.input,
      meta = _ref.meta,
      _onChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, ["input", "meta", "onChange"]);

  var errorMessage = meta && meta.touched && meta.error ? meta.error : '';
  return React.createElement(CheckBoxField, _extends({}, input, rest, {
    errorMessage: errorMessage,
    onChange: function onChange(e) {
      input.onChange(e.target.checked);

      if (_onChange) {
        _onChange(e);
      }
    }
  }));
};

CheckboxFieldAdapter.propTypes = {
  input: propTypes.shape({
    name: propTypes.string
  }).isRequired,
  meta: propTypes.shape({
    touched: propTypes.bool,
    error: propTypes.string
  }),
  value: propTypes.bool,
  onChange: propTypes.func
};

var CheckboxList = function CheckboxList(_ref) {
  var fields = _ref.fields,
      options = _ref.options,
      inline = _ref.inline,
      label = _ref.label,
      meta = _ref.meta,
      useSelectorStyle = _ref.useSelectorStyle,
      className = _ref.className,
      checkboxClassName = _ref.checkboxClassName,
      listClassName = _ref.listClassName;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      touched = _useState2[0],
      setTouched = _useState2[1];

  var toggle = function toggle(event, option) {
    setTouched(true);
    if (event.target.checked) fields.push(option);else fields.remove(fields.value.indexOf(option));
  };

  var errorMessage = meta && (touched || meta.submitFailed) && meta.error;
  return React.createElement("div", {
    className: classnames('checkbox-list-wrapper', className)
  }, label && React.createElement("p", {
    className: "label"
  }, label), React.createElement("div", {
    className: classnames(listClassName, {
      inline: inline
    })
  }, options.map(function (opt) {
    var value = opt.value,
        checkboxLabel = opt.label,
        rest = _objectWithoutProperties(opt, ["value", "label"]);

    return React.createElement(CheckBoxField, _extends({
      className: classnames('checkbox-list-item', checkboxClassName),
      key: value,
      id: value,
      onChange: function onChange(event) {
        return toggle(event, value);
      },
      label: checkboxLabel,
      checked: !!fields.value && fields.value.includes(value),
      useSelectorStyle: useSelectorStyle
    }, rest));
  })), errorMessage && React.createElement(Error$1, {
    message: errorMessage
  }));
};

CheckboxList.propTypes = {
  options: propTypes.arrayOf(propTypes.shape({
    label: propTypes.string,
    value: propTypes.oneOfType([propTypes.string, propTypes.number, propTypes.shape({})])
  })),

  /** Essentially a managed array with dettached array methods */
  fields: propTypes.shape({}),

  /** Whether the checkboxes are horizontal or vertical */
  inline: propTypes.string,

  /** The label for the checkbox list (at the top) */
  label: propTypes.string,
  meta: propTypes.shape({
    error: propTypes.string
  }),
  useSelectorStyle: propTypes.bool,
  className: propTypes.string,
  listClassName: propTypes.string,
  checkboxClassName: propTypes.string
};

var RenderCardCheckBoxField = function RenderCardCheckBoxField(_ref) {
  var id = _ref.id,
      input = _ref.input,
      label = _ref.label,
      meta = _ref.meta,
      icon = _ref.icon,
      disabled = _ref.disabled,
      className = _ref.className;

  var onClick = function onClick(e) {
    e.preventDefault();
    input.onChange();
  };

  return React.createElement("div", {
    className: classnames('zola-ui__form-card__container', {
      selected: input.checked
    }, className),
    onClick: onClick
  }, React.createElement("div", {
    className: "zola-ui__form-card__inner-container"
  }, React.createElement("div", {
    className: "zola-ui__form-card__left-container"
  }, icon && React.createElement("div", {
    className: "zola-ui__form-card__icon-container"
  }, icon), React.createElement("span", {
    className: "zola-ui__form-card__label"
  }, label)), React.createElement("div", {
    className: "zola-ui__form-card__right-container"
  }, React.createElement(RenderCheckBoxField, {
    id: id,
    name: input.name,
    input: input,
    type: "checkbox",
    meta: meta,
    disabled: disabled
  }))));
};

RenderCardCheckBoxField.propTypes = {
  /** label for the radio button */
  label: propTypes.string.isRequired,

  /** mandatory id for label matching */
  id: propTypes.string.isRequired,

  /**
   * Input information
   * name: name to group buttons
   * checked: checked a radio button
   */
  input: propTypes.shape({
    name: propTypes.string.isRequired,
    onChange: propTypes.func.isRequired,
    checked: propTypes.bool
  }).isRequired,

  /** This prop is provided by Redux Form directly.  */
  meta: propTypes.shape({
    touched: propTypes.bool
  }).isRequired,

  /** Optional icon passed as complete DOM element eg. <img /> */
  icon: propTypes.node,

  /** Disable checkbox */
  disabled: propTypes.bool,
  className: propTypes.string
};
RenderCardCheckBoxField.defaultProps = {
  disabled: false
};

// only works with Redux Form Fields
// pass type as `checkbox` or `radio`
// pass cardType as `card-field`, `pill-field` or `icon-field`

var CardField =
/*#__PURE__*/
function (_Component) {
  _inherits(CardField, _Component);

  function CardField(props) {
    var _this;

    _classCallCheck(this, CardField);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CardField).call(this, props));
    _this.state = {
      active: false
    };
    return _this;
  }

  _createClass(CardField, [{
    key: "setActive",
    value: function setActive(e) {
      var checkbox = e.target.type === 'checkbox';

      if (checkbox) {
        if (e.target.checked) {
          this.setState({
            active: true
          });
        } else {
          this.setState({
            active: false
          });
        }
      } else if (e.target.value) {
        this.setState({
          active: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          input = _this$props.input,
          header = _this$props.header,
          subText = _this$props.subText,
          id = _this$props.id,
          type = _this$props.type,
          disabled = _this$props.disabled,
          handleOnClick = _this$props.handleOnClick,
          className = _this$props.className,
          label = _this$props.label,
          blurb = _this$props.blurb,
          selectedValue = _this$props.selectedValue,
          selectedCheck = _this$props.selectedCheck,
          subTextHtml = _this$props.subTextHtml,
          fallbackHeader = _this$props.fallbackHeader,
          handleOnChange = _this$props.handleOnChange,
          cardType = _this$props.cardType,
          meta = _this$props.meta,
          subTextInnerHtml = _this$props.subTextInnerHtml;
      var active = this.state.active;

      var inputAttr = _objectSpread({}, input);

      var containerClassName = "".concat(cardType, "__container");
      var showActiveCheckmark = active || selectedCheck;
      return React.createElement("div", {
        className: classnames(className, containerClassName, {
          'has-error': meta && meta.touched && meta.error
        })
      }, React.createElement("div", {
        className: "zola-ui field-input"
      }, React.createElement("input", _extends({}, inputAttr, {
        type: type,
        id: id,
        disabled: disabled,
        onChange: function onChange(e) {
          input.onChange(e);

          _this2.setActive(e);

          if (handleOnChange) {
            setTimeout(function () {
              return handleOnChange(e);
            });
          }
        },
        onClick: function onClick(e) {
          if (handleOnClick) {
            handleOnClick(e);
          }
        }
      })), React.createElement("label", {
        htmlFor: id,
        className: classnames({
          active: selectedValue,
          'is-selected': showActiveCheckmark
        })
      }, showActiveCheckmark && React.createElement("div", {
        className: "checkmark-icon"
      }, React.createElement("i", {
        className: "zola-ui-icon zola-ui-icon-checkmark"
      })), fallbackHeader && React.createElement("span", {
        className: "field-header"
      }, fallbackHeader), header && !fallbackHeader && React.createElement("span", {
        className: "field-header"
      }, header), subText && React.createElement("span", {
        className: "field-text"
      }, subText), subTextHtml && React.createElement("span", {
        className: "field-text",
        dangerouslySetInnerHTML: {
          __html: "".concat(subTextHtml)
        }
      }), subTextInnerHtml, blurb && React.createElement("span", {
        className: "field-blurb"
      }, blurb)), label && React.createElement("span", {
        className: "field-label"
      }, label)), meta && meta.touched && meta.error && React.createElement("span", {
        className: "help-block error-block"
      }, meta.error));
    }
  }]);

  return CardField;
}(Component);

CardField.propTypes = {
  input: propTypes.shape({
    name: propTypes.string.isRequired,
    checked: propTypes.bool
  }).isRequired,
  id: propTypes.string.isRequired,
  cardType: propTypes.oneOf(['card-field', 'card-field-lg card-field', 'pill-field', 'icon-field', 'simple-card-field card-field', 'simple-card-field-lg card-field']).isRequired,
  header: propTypes.oneOfType([propTypes.string, propTypes.node]),
  fallbackHeader: propTypes.string,
  type: propTypes.oneOf(['checkbox', 'radio']).isRequired,
  subText: propTypes.string,
  disabled: propTypes.bool,
  active: propTypes.bool,
  handleOnClick: propTypes.func,
  handleOnChange: propTypes.func,
  className: propTypes.string,
  label: propTypes.string,
  blurb: propTypes.string,
  selectedValue: propTypes.bool,
  selectedCheck: propTypes.bool,

  /** Sringified html */
  subTextHtml: propTypes.string,
  meta: propTypes.shape({
    touched: propTypes.bool,
    error: propTypes.string
  }),

  /** Allows for directly passing html to be rendered as sub-text  */
  subTextInnerHtml: propTypes.node
};

var Stepper =
/*#__PURE__*/
function (_Component) {
  _inherits(Stepper, _Component);

  function Stepper(props) {
    var _this;

    _classCallCheck(this, Stepper);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Stepper).call(this, props));
    _this.state = {
      deactivateDecrease: false,
      deactivateIncrease: false
    };
    _this.handleDecrease = _this.handleDecrease.bind(_assertThisInitialized(_this));
    _this.handleIncrease = _this.handleIncrease.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Stepper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var quantity = this.props.quantity;
      this.setState({
        deactivateDecrease: quantity === 1
      });
    }
  }, {
    key: "handleDecrease",
    value: function handleDecrease() {
      var _this$props = this.props,
          handleDecrease = _this$props.handleDecrease,
          quantity = _this$props.quantity;
      var newCount = quantity - 1;

      if (newCount === 1) {
        this.setState({
          deactivateDecrease: true
        });
      }

      if (newCount > 0) {
        this.setState({
          deactivateIncrease: false
        });
        handleDecrease();
      }
    }
  }, {
    key: "handleIncrease",
    value: function handleIncrease() {
      var _this$props2 = this.props,
          handleIncrease = _this$props2.handleIncrease,
          limit = _this$props2.limit,
          quantity = _this$props2.quantity;

      if (quantity + 1 === limit) {
        this.setState({
          deactivateIncrease: true
        });
        handleIncrease();
      } else if (quantity + 1 < limit) {
        this.setState({
          deactivateIncrease: false,
          deactivateDecrease: false
        });
        handleIncrease();
      }
    } // the stepper expects a RenderField to be passed in as displayField
    // the displayField is populated by redux-form using the `name` property

  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          quantity = _this$props3.quantity,
          displayField = _this$props3.displayField,
          limit = _this$props3.limit;
      var _this$state = this.state,
          deactivateDecrease = _this$state.deactivateDecrease,
          deactivateIncrease = _this$state.deactivateIncrease;
      return React.createElement("div", {
        className: "zola-ui stepper"
      }, React.createElement("div", {
        className: classnames('stepper-decrease', {
          deactivate: deactivateDecrease || quantity === 1
        }),
        onClick: this.handleDecrease
      }), displayField, React.createElement("div", {
        className: classnames('stepper-increase', {
          deactivate: deactivateIncrease || quantity > limit
        }),
        onClick: this.handleIncrease
      }));
    }
  }]);

  return Stepper;
}(Component);

Stepper.defaultProps = {
  quantity: 0
};
Stepper.propTypes = {
  quantity: propTypes.number,
  displayField: propTypes.element.isRequired,
  handleIncrease: propTypes.func.isRequired,
  handleDecrease: propTypes.func.isRequired,
  limit: propTypes.number
};

var RenderPillField = function RenderPillField(_ref) {
  var input = _ref.input,
      id = _ref.id,
      disabled = _ref.disabled,
      label = _ref.label,
      type = _ref.type,
      className = _ref.className,
      imgSrc = _ref.imgSrc;
  return React.createElement("div", {
    className: classnames('render-pill-field__container', {
      isDisabled: disabled
    }, className)
  }, React.createElement("div", {
    className: "render-pill-field__input"
  }, React.createElement("label", {
    htmlFor: id,
    className: classnames({
      active: input.checked
    }, 'render-pill-field__label')
  }, React.createElement("input", _extends({}, input, {
    type: type,
    id: id,
    disabled: disabled
  })), label && React.createElement("span", {
    className: "render-pill-field__text"
  }, label, " "), imgSrc && React.createElement("img", {
    alt: "pill illustration",
    className: "render-pill-image",
    src: imgSrc
  }))));
};

RenderPillField.defaultProps = {};
RenderPillField.propTypes = {
  input: propTypes.shape({
    name: propTypes.string.isRequired,
    checked: propTypes.bool
  }).isRequired,
  type: propTypes.oneOf(['radio', 'checkbox']).isRequired,
  id: propTypes.string.isRequired,
  label: propTypes.string,
  disabled: propTypes.bool,
  imgSrc: propTypes.string,
  className: propTypes.string
};

var RenderTextareaField = function RenderTextareaField(props) {
  var input = props.input,
      label = props.label,
      id = props.id,
      rows = props.rows,
      cols = props.cols,
      required = props.required,
      placeholder = props.placeholder,
      maxChars = props.maxChars,
      disabled = props.disabled,
      meta = props.meta,
      className = props.className,
      wrap = props.wrap,
      onKeyDown = props.onKeyDown,
      autoFocus = props.autoFocus,
      readOnly = props.readOnly,
      minChars = props.minChars;
  var touched = meta && meta.touched;
  var error = meta && meta.error;
  var hasError = touched && error;
  var inputLength = input && input.value && input.value.length || 0;
  var classes = classnames('textarea-field', 'render-field', 'zola-ui', 'form-group', className, {
    'has-error': hasError
  });
  var maxInvlaid = maxChars && inputLength > maxChars;
  var lengthInvalid = maxInvlaid; // we don't treat min as invalid as that is the default state

  return React.createElement("div", {
    className: classes
  }, label && id && React.createElement("label", {
    htmlFor: id
  }, label, required && React.createElement("span", {
    className: "text-danger danger-asterisk"
  }, "*")), React.createElement("textarea", _extends({}, input, {
    className: "form-control",
    id: id,
    rows: rows,
    cols: cols,
    placeholder: placeholder,
    disabled: disabled,
    onKeyDown: onKeyDown,
    wrap: wrap,
    style: {
      verticalAlign: 'top'
    },
    autoFocus: autoFocus,
    readOnly: readOnly
  })), (maxChars || minChars) && // min only:
  //  - too short   : 14 (min 30)
  //  - okay : 784 (min 30)
  // max only:
  //  - too long     : 568/500
  //  - okay : 468/500
  // min+max:
  //  - too short:   14/500 (min 30)
  //  - too long:    568/500 (min 30)
  //  - okay:  310/500 (min 30)
  React.createElement("span", {
    className: "pull-right char-count text-".concat(lengthInvalid ? 'danger' : 'muted')
  }, inputLength, maxChars && "/".concat(maxChars), minChars && minChars && " (min ".concat(minChars, ")")), touched && error && React.createElement("span", {
    className: "help-block text-danger"
  }, error));
};

RenderTextareaField.propTypes = {
  input: propTypes.shape({
    name: propTypes.string.isRequired
  }).isRequired,
  rows: propTypes.number,
  cols: propTypes.number,
  id: propTypes.string,

  /** Required for accessibility with label */
  label: propTypes.string,

  /** An id is also required for the label to appear. */
  required: propTypes.bool,
  placeholder: propTypes.string,

  /** Maximum number of characters.  Displayed as a character counter below.  Client is responsible for additional validation. */
  maxChars: propTypes.number,

  /** Minimum number of characters.  Displayed as a character counter below.  Client is responsible for additional validation. */
  minChars: propTypes.number,
  disabled: propTypes.bool,
  meta: propTypes.shape({
    touched: propTypes.bool.isRequired,
    error: propTypes.string
  }),
  className: propTypes.string,
  wrap: propTypes.string,
  onKeyDown: propTypes.func,
  autoFocus: propTypes.bool,
  readOnly: propTypes.bool
};

var TextareaField = function TextareaField(props) {
  var id = props.id,
      required = props.required,
      defaultValue = props.defaultValue,
      _props$value = props.value,
      externalValue = _props$value === void 0 ? '' : _props$value;

  var label = props.label,
      maxChars = props.maxChars,
      _props$minChars = props.minChars,
      minChars = _props$minChars === void 0 ? 0 : _props$minChars,
      labelLink = props.labelLink,
      textareaStyle = props.textareaStyle,
      textareaClassName = props.textareaClassName,
      textareaProps = props.textareaProps,
      className = props.className,
      rest = _objectWithoutProperties(props, ["label", "maxChars", "minChars", "labelLink", "textareaStyle", "textareaClassName", "textareaProps", "className"]);

  var _useState = useState(defaultValue || ''),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      focus = _useState4[0],
      setFocus = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      hasText = _useState6[0],
      setHasText = _useState6[1]; // this helps facilitate an external value from the InputFieldV2Adapter
  // example: form data fetched from front end, and loaded into react-final-form
  // after the input has already mounted


  useConditionalCallbacks(inputValue === '' && inputValue !== externalValue, [function () {
    return setInputValue(externalValue);
  }, function () {
    return setHasText(true);
  }]);

  var handleChange = function handleChange(e) {
    var onChange = props.onChange;
    setInputValue(e.target.value);
    setHasText(e.target.value);

    if (onChange && typeof onChange === 'function') {
      onChange(e);
    }
  };

  var maxInvalid = maxChars && calculateNotificationStyle('max_invalid', maxChars, inputValue.length);
  var maxWarning = maxChars && calculateNotificationStyle('warning', maxChars, inputValue.length, 20);
  var minInvalid = minChars && calculateNotificationStyle('min_invalid', false, inputValue.length, 0, minChars);
  var textareaWrapperClassNames = classnames('v2-textarea-field', 'v2-render-field', 'zola-ui', className, {
    'has-error': maxInvalid || !focus && hasText && minInvalid
  }, {
    'has-warning': maxWarning
  });
  var minCharVisibility = inputValue.length < minChars ? 'visible' : 'hidden';
  var maxCharVisibility = inputValue.length >= minChars ? 'visible' : 'hidden';
  var minCharClassNames = classnames('pull-right', 'char-count__min', minCharVisibility);
  var maxCharClassNames = classnames('pull-right', 'char-count__max', maxCharVisibility, {
    'text-danger': maxInvalid
  }, {
    'text-warning': maxWarning
  });
  return React.createElement("div", {
    className: textareaWrapperClassNames
  }, label && id && React.createElement("label", {
    htmlFor: id,
    className: ""
  }, label, required && React.createElement("span", {
    className: "text-danger danger-asterisk"
  }, "*")), renderLabelLink('desktop', labelLink), React.createElement("textarea", _extends({}, rest, textareaProps, {
    onFocus: function onFocus() {
      return setFocus(true);
    },
    onBlur: function onBlur() {
      return setFocus(false);
    },
    className: classnames('form-control', textareaClassName),
    onChange: handleChange,
    style: _objectSpread({
      verticalAlign: 'top'
    }, textareaStyle)
  })), maxChars && React.createElement("span", {
    className: "char-count"
  }, React.createElement("span", {
    className: maxCharClassNames
  }, "".concat(inputValue.length, " / ").concat(maxChars))), minChars > 0 && React.createElement("span", {
    className: "char-count"
  }, React.createElement("span", {
    className: classnames(minCharClassNames, {
      'has-error': !focus && hasText && minInvalid
    })
  }, "Minimum ", minChars, " characters")), renderLabelLink('mobile', labelLink));
};

TextareaField.propTypes = {
  id: propTypes.string,
  defaultValue: propTypes.string,

  /** Required for accessibility with label */
  label: propTypes.string,

  /** An id is also required for the label to appear. */
  required: propTypes.bool,

  /** Maximum number of characters.  Displayed as a character counter below.  Client is responsible for additional validation. */
  maxChars: propTypes.number,

  /** Minimum number of characters.  Displayed as a character counter below.  Client is responsible for additional validation. */
  minChars: propTypes.number,
  className: propTypes.string,
  onChange: propTypes.func,
  labelLink: propTypes.shape({
    url: propTypes.string,
    copy: propTypes.string
  }),
  value: propTypes.string,

  /** Adds styles directly to the <textarea /> */
  textareaStyle: propTypes.shape({}),

  /** DEPRECRATED: Adds classes directly to the <textarea /> */
  textareaClassName: propTypes.string,

  /** Other props applied directly to textarea, likes rows or cols */
  textareaProps: propTypes.shape({})
};

var TextareaFieldAdapter = function TextareaFieldAdapter(_ref) {
  var input = _ref.input,
      meta = _ref.meta,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["input", "meta", "className"]);

  var touched = meta && meta.touched;
  var error = meta && meta.error;
  var errorMessage = touched && error;
  var textareaWrapperClassNames = classnames({
    'has-error': errorMessage
  }, className);
  return React.createElement(TextareaField, _extends({}, input, rest, {
    className: textareaWrapperClassNames
  }));
};

TextareaFieldAdapter.propTypes = {
  input: propTypes.shape({
    name: propTypes.string.isRequired,
    value: propTypes.any
  }),
  meta: propTypes.shape({
    touched: propTypes.bool.isRequired,
    error: propTypes.string
  }),
  className: propTypes.string
};

var LocaleUtils = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDay = formatDay;
exports.formatMonthTitle = formatMonthTitle;
exports.formatWeekdayShort = formatWeekdayShort;
exports.formatWeekdayLong = formatWeekdayLong;
exports.getFirstDayOfWeek = getFirstDayOfWeek;
exports.getMonths = getMonths;
var WEEKDAYS_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

var WEEKDAYS_SHORT = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

function formatDay(day) {
  return day.toDateString();
}

function formatMonthTitle(d) {
  return MONTHS[d.getMonth()] + ' ' + d.getFullYear();
}

function formatWeekdayShort(i) {
  return WEEKDAYS_SHORT[i];
}

function formatWeekdayLong(i) {
  return WEEKDAYS_LONG[i];
}

function getFirstDayOfWeek() {
  return 0;
}

function getMonths() {
  return MONTHS;
}

exports.default = {
  formatDay: formatDay,
  formatMonthTitle: formatMonthTitle,
  formatWeekdayShort: formatWeekdayShort,
  formatWeekdayLong: formatWeekdayLong,
  getFirstDayOfWeek: getFirstDayOfWeek,
  getMonths: getMonths
};

});

unwrapExports(LocaleUtils);
var LocaleUtils_1 = LocaleUtils.formatDay;
var LocaleUtils_2 = LocaleUtils.formatMonthTitle;
var LocaleUtils_3 = LocaleUtils.formatWeekdayShort;
var LocaleUtils_4 = LocaleUtils.formatWeekdayLong;
var LocaleUtils_5 = LocaleUtils.getFirstDayOfWeek;
var LocaleUtils_6 = LocaleUtils.getMonths;

var keys$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var LEFT = exports.LEFT = 37;
var UP = exports.UP = 38;
var RIGHT = exports.RIGHT = 39;
var DOWN = exports.DOWN = 40;
var ENTER = exports.ENTER = 13;
var SPACE = exports.SPACE = 32;
var ESC = exports.ESC = 27;
var TAB = exports.TAB = 9;

});

unwrapExports(keys$1);
var keys_1$1 = keys$1.LEFT;
var keys_2 = keys$1.UP;
var keys_3 = keys$1.RIGHT;
var keys_4 = keys$1.DOWN;
var keys_5 = keys$1.ENTER;
var keys_6 = keys$1.SPACE;
var keys_7 = keys$1.ESC;
var keys_8 = keys$1.TAB;

var Caption_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(propTypes);



var _LocaleUtils2 = _interopRequireDefault(LocaleUtils);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Caption = function (_Component) {
  _inherits(Caption, _Component);

  function Caption(props) {
    _classCallCheck(this, Caption);

    var _this = _possibleConstructorReturn(this, (Caption.__proto__ || Object.getPrototypeOf(Caption)).call(this, props));

    _this.handleKeyUp = _this.handleKeyUp.bind(_this);
    return _this;
  }

  _createClass(Caption, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.locale !== this.props.locale || nextProps.classNames !== this.props.classNames || nextProps.date.getMonth() !== this.props.date.getMonth() || nextProps.date.getFullYear() !== this.props.date.getFullYear();
    }
  }, {
    key: 'handleKeyUp',
    value: function handleKeyUp(e) {
      if (e.keyCode === keys$1.ENTER) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          date = _props.date,
          months = _props.months,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          onClick = _props.onClick;

      return _react2.default.createElement(
        'div',
        { className: classNames.caption, role: 'heading' },
        _react2.default.createElement(
          'div',
          { onClick: onClick, onKeyUp: this.handleKeyUp },
          months ? months[date.getMonth()] + ' ' + date.getFullYear() : localeUtils.formatMonthTitle(date, locale)
        )
      );
    }
  }]);

  return Caption;
}(React.Component);

Caption.propTypes = {
  date: _propTypes2.default.instanceOf(Date),
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.object,
  onClick: _propTypes2.default.func,
  classNames: _propTypes2.default.shape({
    caption: _propTypes2.default.string.isRequired
  }).isRequired
};
Caption.defaultProps = {
  localeUtils: _LocaleUtils2.default
};
exports.default = Caption;

});

unwrapExports(Caption_1);

var classNames = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Proxy object to map classnames when css modules are not used

exports.default = {
  container: 'DayPicker',
  wrapper: 'DayPicker-wrapper',
  interactionDisabled: 'DayPicker--interactionDisabled',
  months: 'DayPicker-Months',
  month: 'DayPicker-Month',

  navBar: 'DayPicker-NavBar',
  navButtonPrev: 'DayPicker-NavButton DayPicker-NavButton--prev',
  navButtonNext: 'DayPicker-NavButton DayPicker-NavButton--next',
  navButtonInteractionDisabled: 'DayPicker-NavButton--interactionDisabled',

  caption: 'DayPicker-Caption',
  weekdays: 'DayPicker-Weekdays',
  weekdaysRow: 'DayPicker-WeekdaysRow',
  weekday: 'DayPicker-Weekday',
  body: 'DayPicker-Body',
  week: 'DayPicker-Week',
  weekNumber: 'DayPicker-WeekNumber',
  day: 'DayPicker-Day',
  footer: 'DayPicker-Footer',
  todayButton: 'DayPicker-TodayButton',

  // default modifiers
  today: 'today',
  selected: 'selected',
  disabled: 'disabled',
  outside: 'outside'
};

});

unwrapExports(classNames);

var Navbar_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(propTypes);



var _classNames2 = _interopRequireDefault(classNames);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Navbar = function (_Component) {
  _inherits(Navbar, _Component);

  function Navbar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Navbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Navbar.__proto__ || Object.getPrototypeOf(Navbar)).call.apply(_ref, [this].concat(args))), _this), _this.handleNextClick = function () {
      if (_this.props.onNextClick) {
        _this.props.onNextClick();
      }
    }, _this.handlePreviousClick = function () {
      if (_this.props.onPreviousClick) {
        _this.props.onPreviousClick();
      }
    }, _this.handleNextKeyDown = function (e) {
      if (e.keyCode !== keys$1.ENTER && e.keyCode !== keys$1.SPACE) {
        return;
      }
      e.preventDefault();
      _this.handleNextClick();
    }, _this.handlePreviousKeyDown = function (e) {
      if (e.keyCode !== keys$1.ENTER && e.keyCode !== keys$1.SPACE) {
        return;
      }
      e.preventDefault();
      _this.handlePreviousClick();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Navbar, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.labels !== this.props.labels || nextProps.dir !== this.props.dir || this.props.showPreviousButton !== nextProps.showPreviousButton || this.props.showNextButton !== nextProps.showNextButton;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          className = _props.className,
          showPreviousButton = _props.showPreviousButton,
          showNextButton = _props.showNextButton,
          labels = _props.labels,
          dir = _props.dir;


      var previousClickHandler = void 0;
      var nextClickHandler = void 0;
      var previousKeyDownHandler = void 0;
      var nextKeyDownHandler = void 0;
      var shouldShowPrevious = void 0;
      var shouldShowNext = void 0;

      if (dir === 'rtl') {
        previousClickHandler = this.handleNextClick;
        nextClickHandler = this.handlePreviousClick;
        previousKeyDownHandler = this.handleNextKeyDown;
        nextKeyDownHandler = this.handlePreviousKeyDown;
        shouldShowNext = showPreviousButton;
        shouldShowPrevious = showNextButton;
      } else {
        previousClickHandler = this.handlePreviousClick;
        nextClickHandler = this.handleNextClick;
        previousKeyDownHandler = this.handlePreviousKeyDown;
        nextKeyDownHandler = this.handleNextKeyDown;
        shouldShowNext = showNextButton;
        shouldShowPrevious = showPreviousButton;
      }

      var previousClassName = shouldShowPrevious ? classNames.navButtonPrev : classNames.navButtonPrev + ' ' + classNames.navButtonInteractionDisabled;

      var nextClassName = shouldShowNext ? classNames.navButtonNext : classNames.navButtonNext + ' ' + classNames.navButtonInteractionDisabled;

      var previousButton = _react2.default.createElement('span', {
        tabIndex: '0',
        role: 'button',
        'aria-label': labels.previousMonth,
        key: 'previous',
        className: previousClassName,
        onKeyDown: shouldShowPrevious ? previousKeyDownHandler : undefined,
        onClick: shouldShowPrevious ? previousClickHandler : undefined
      });

      var nextButton = _react2.default.createElement('span', {
        tabIndex: '0',
        role: 'button',
        'aria-label': labels.nextMonth,
        key: 'right',
        className: nextClassName,
        onKeyDown: shouldShowNext ? nextKeyDownHandler : undefined,
        onClick: shouldShowNext ? nextClickHandler : undefined
      });

      return _react2.default.createElement(
        'div',
        { className: className || classNames.navBar },
        dir === 'rtl' ? [nextButton, previousButton] : [previousButton, nextButton]
      );
    }
  }]);

  return Navbar;
}(React.Component);

Navbar.propTypes = {
  classNames: _propTypes2.default.shape({
    navBar: _propTypes2.default.string.isRequired,
    navButtonPrev: _propTypes2.default.string.isRequired,
    navButtonNext: _propTypes2.default.string.isRequired,
    navButtonInteractionDisabled: _propTypes2.default.string.isRequired
  }),
  className: _propTypes2.default.string,
  showPreviousButton: _propTypes2.default.bool,
  showNextButton: _propTypes2.default.bool,
  onPreviousClick: _propTypes2.default.func,
  onNextClick: _propTypes2.default.func,
  dir: _propTypes2.default.string,
  labels: _propTypes2.default.shape({
    previousMonth: _propTypes2.default.string.isRequired,
    nextMonth: _propTypes2.default.string.isRequired
  })
};
Navbar.defaultProps = {
  classNames: _classNames2.default,
  dir: 'ltr',
  labels: {
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month'
  },
  showPreviousButton: true,
  showNextButton: true
};
exports.default = Navbar;

});

unwrapExports(Navbar_1);

var Weekdays_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Weekdays = function (_Component) {
  _inherits(Weekdays, _Component);

  function Weekdays() {
    _classCallCheck(this, Weekdays);

    return _possibleConstructorReturn(this, (Weekdays.__proto__ || Object.getPrototypeOf(Weekdays)).apply(this, arguments));
  }

  _createClass(Weekdays, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props !== nextProps;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          firstDayOfWeek = _props.firstDayOfWeek,
          showWeekNumbers = _props.showWeekNumbers,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          weekdayElement = _props.weekdayElement;

      var days = [];
      for (var i = 0; i < 7; i += 1) {
        var weekday = (i + firstDayOfWeek) % 7;
        var elementProps = {
          key: i,
          className: classNames.weekday,
          weekday: weekday,
          weekdaysLong: weekdaysLong,
          weekdaysShort: weekdaysShort,
          localeUtils: localeUtils,
          locale: locale
        };
        var element = _react2.default.isValidElement(weekdayElement) ? _react2.default.cloneElement(weekdayElement, elementProps) : _react2.default.createElement(weekdayElement, elementProps);
        days.push(element);
      }

      return _react2.default.createElement(
        'div',
        { className: classNames.weekdays, role: 'rowgroup' },
        _react2.default.createElement(
          'div',
          { className: classNames.weekdaysRow, role: 'row' },
          showWeekNumbers && _react2.default.createElement('div', { className: classNames.weekday }),
          days
        )
      );
    }
  }]);

  return Weekdays;
}(React.Component);

Weekdays.propTypes = {
  classNames: _propTypes2.default.shape({
    weekday: _propTypes2.default.string.isRequired,
    weekdays: _propTypes2.default.string.isRequired,
    weekdaysRow: _propTypes2.default.string.isRequired
  }).isRequired,

  firstDayOfWeek: _propTypes2.default.number.isRequired,
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
  showWeekNumbers: _propTypes2.default.bool,
  locale: _propTypes2.default.string.isRequired,
  localeUtils: _propTypes2.default.object.isRequired,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)])
};
exports.default = Weekdays;

});

unwrapExports(Weekdays_1);

var DateUtils = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clone = clone;
exports.isDate = isDate;
exports.addMonths = addMonths;
exports.isSameDay = isSameDay;
exports.isSameMonth = isSameMonth;
exports.isDayBefore = isDayBefore;
exports.isDayAfter = isDayAfter;
exports.isPastDay = isPastDay;
exports.isFutureDay = isFutureDay;
exports.isDayBetween = isDayBetween;
exports.addDayToRange = addDayToRange;
exports.isDayInRange = isDayInRange;
exports.getWeekNumber = getWeekNumber;
/**
 * Clone a date object.
 *
 * @export
 * @param  {Date} d The date to clone
 * @return {Date} The cloned date
 */
function clone(d) {
  return new Date(d.getTime());
}

/**
 * Return `true` if the passed value is a valid JavaScript Date object.
 *
 * @export
 * @param {any} value
 * @returns {Boolean}
 */
function isDate(value) {
  return value instanceof Date && !isNaN(value.valueOf());
}

/**
 * Return `d` as a new date with `n` months added.
 *
 * @export
 * @param {Date} d
 * @param {number} n
 */
function addMonths(d, n) {
  var newDate = clone(d);
  newDate.setMonth(d.getMonth() + n);
  return newDate;
}

/**
 * Return `true` if two dates are the same day, ignoring the time.
 *
 * @export
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isSameDay(d1, d2) {
  if (!d1 || !d2) {
    return false;
  }
  return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}

/**
 * Return `true` if two dates fall in the same month.
 *
 * @export
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isSameMonth(d1, d2) {
  if (!d1 || !d2) {
    return false;
  }
  return d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}

/**
 * Returns `true` if the first day is before the second day.
 *
 * @export
 * @param {Date} d1
 * @param {Date} d2
 * @returns {Boolean}
 */
function isDayBefore(d1, d2) {
  var day1 = clone(d1).setHours(0, 0, 0, 0);
  var day2 = clone(d2).setHours(0, 0, 0, 0);
  return day1 < day2;
}

/**
 * Returns `true` if the first day is after the second day.
 *
 * @export
 * @param {Date} d1
 * @param {Date} d2
 * @returns {Boolean}
 */
function isDayAfter(d1, d2) {
  var day1 = clone(d1).setHours(0, 0, 0, 0);
  var day2 = clone(d2).setHours(0, 0, 0, 0);
  return day1 > day2;
}

/**
 * Return `true` if a day is in the past, e.g. yesterday or any day
 * before yesterday.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */
function isPastDay(d) {
  var today = new Date();
  today.setHours(0, 0, 0, 0);
  return isDayBefore(d, today);
}

/**
 * Return `true` if a day is in the future, e.g. tomorrow or any day
 * after tomorrow.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */
function isFutureDay(d) {
  var tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
  tomorrow.setHours(0, 0, 0, 0);
  return d >= tomorrow;
}

/**
 * Return `true` if day `d` is between days `d1` and `d2`,
 * without including them.
 *
 * @export
 * @param  {Date}  d
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isDayBetween(d, d1, d2) {
  var date = clone(d);
  date.setHours(0, 0, 0, 0);
  return isDayAfter(date, d1) && isDayBefore(date, d2) || isDayAfter(date, d2) && isDayBefore(date, d1);
}

/**
 * Add a day to a range and return a new range. A range is an object with
 * `from` and `to` days.
 *
 * @export
 * @param {Date} day
 * @param {Object} range
 * @return {Object} Returns a new range object
 */
function addDayToRange(day) {
  var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { from: null, to: null };
  var from = range.from,
      to = range.to;

  if (!from) {
    from = day;
  } else if (from && to && isSameDay(from, to) && isSameDay(day, from)) {
    from = null;
    to = null;
  } else if (to && isDayBefore(day, from)) {
    from = day;
  } else if (to && isSameDay(day, to)) {
    from = day;
    to = day;
  } else {
    to = day;
    if (isDayBefore(to, from)) {
      to = from;
      from = day;
    }
  }

  return { from: from, to: to };
}

/**
 * Return `true` if a day is included in a range of days.
 *
 * @export
 * @param  {Date}  day
 * @param  {Object}  range
 * @return {Boolean}
 */
function isDayInRange(day, range) {
  var from = range.from,
      to = range.to;

  return from && isSameDay(day, from) || to && isSameDay(day, to) || from && to && isDayBetween(day, from, to);
}

/**
 * Return the year's week number (as per ISO, i.e. with the week starting from monday)
 * for the given day.
 *
 * @export
 * @param {Date} day
 * @returns {Number}
 */
function getWeekNumber(day) {
  var date = clone(day);
  date.setHours(0, 0, 0);
  date.setDate(date.getDate() + 4 - (date.getDay() || 7));
  return Math.ceil(((date - new Date(date.getFullYear(), 0, 1)) / 8.64e7 + 1) / 7);
}

exports.default = {
  addDayToRange: addDayToRange,
  addMonths: addMonths,
  clone: clone,
  getWeekNumber: getWeekNumber,
  isDate: isDate,
  isDayAfter: isDayAfter,
  isDayBefore: isDayBefore,
  isDayBetween: isDayBetween,
  isDayInRange: isDayInRange,
  isFutureDay: isFutureDay,
  isPastDay: isPastDay,
  isSameDay: isSameDay,
  isSameMonth: isSameMonth
};

});

unwrapExports(DateUtils);
var DateUtils_1 = DateUtils.clone;
var DateUtils_2 = DateUtils.isDate;
var DateUtils_3 = DateUtils.addMonths;
var DateUtils_4 = DateUtils.isSameDay;
var DateUtils_5 = DateUtils.isSameMonth;
var DateUtils_6 = DateUtils.isDayBefore;
var DateUtils_7 = DateUtils.isDayAfter;
var DateUtils_8 = DateUtils.isPastDay;
var DateUtils_9 = DateUtils.isFutureDay;
var DateUtils_10 = DateUtils.isDayBetween;
var DateUtils_11 = DateUtils.addDayToRange;
var DateUtils_12 = DateUtils.isDayInRange;
var DateUtils_13 = DateUtils.getWeekNumber;

var Helpers = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.cancelEvent = cancelEvent;
exports.getFirstDayOfMonth = getFirstDayOfMonth;
exports.getDaysInMonth = getDaysInMonth;
exports.getModifiersFromProps = getModifiersFromProps;
exports.getFirstDayOfWeekFromProps = getFirstDayOfWeekFromProps;
exports.isRangeOfDates = isRangeOfDates;
exports.getMonthsDiff = getMonthsDiff;
exports.getWeekArray = getWeekArray;
exports.startOfMonth = startOfMonth;
exports.getDayNodes = getDayNodes;
exports.nodeListToArray = nodeListToArray;
exports.hasOwnProp = hasOwnProp;







var _classNames2 = _interopRequireDefault(classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function cancelEvent(e) {
  e.preventDefault();
  e.stopPropagation();
}

function getFirstDayOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth(), 1, 12);
}

function getDaysInMonth(d) {
  var resultDate = getFirstDayOfMonth(d);

  resultDate.setMonth(resultDate.getMonth() + 1);
  resultDate.setDate(resultDate.getDate() - 1);

  return resultDate.getDate();
}

function getModifiersFromProps(props) {
  var modifiers = _extends({}, props.modifiers);
  if (props.selectedDays) {
    modifiers[props.classNames.selected] = props.selectedDays;
  }
  if (props.disabledDays) {
    modifiers[props.classNames.disabled] = props.disabledDays;
  }
  return modifiers;
}

function getFirstDayOfWeekFromProps(props) {
  var firstDayOfWeek = props.firstDayOfWeek,
      _props$locale = props.locale,
      locale = _props$locale === undefined ? 'en' : _props$locale,
      _props$localeUtils = props.localeUtils,
      localeUtils = _props$localeUtils === undefined ? {} : _props$localeUtils;

  if (!isNaN(firstDayOfWeek)) {
    return firstDayOfWeek;
  }
  if (localeUtils.getFirstDayOfWeek) {
    return localeUtils.getFirstDayOfWeek(locale);
  }
  return 0;
}

function isRangeOfDates(value) {
  return !!(value && value.from && value.to);
}

function getMonthsDiff(d1, d2) {
  return d2.getMonth() - d1.getMonth() + 12 * (d2.getFullYear() - d1.getFullYear());
}

function getWeekArray(d) {
  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, LocaleUtils.getFirstDayOfWeek)();
  var fixedWeeks = arguments[2];

  var daysInMonth = getDaysInMonth(d);
  var dayArray = [];

  var week = [];
  var weekArray = [];

  for (var i = 1; i <= daysInMonth; i += 1) {
    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i, 12));
  }

  dayArray.forEach(function (day) {
    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
      weekArray.push(week);
      week = [];
    }
    week.push(day);
    if (dayArray.indexOf(day) === dayArray.length - 1) {
      weekArray.push(week);
    }
  });

  // unshift days to start the first week
  var firstWeek = weekArray[0];
  for (var _i = 7 - firstWeek.length; _i > 0; _i -= 1) {
    var outsideDate = (0, DateUtils.clone)(firstWeek[0]);
    outsideDate.setDate(firstWeek[0].getDate() - 1);
    firstWeek.unshift(outsideDate);
  }

  // push days until the end of the last week
  var lastWeek = weekArray[weekArray.length - 1];
  for (var _i2 = lastWeek.length; _i2 < 7; _i2 += 1) {
    var _outsideDate = (0, DateUtils.clone)(lastWeek[lastWeek.length - 1]);
    _outsideDate.setDate(lastWeek[lastWeek.length - 1].getDate() + 1);
    lastWeek.push(_outsideDate);
  }

  // add extra weeks to reach 6 weeks
  if (fixedWeeks && weekArray.length < 6) {
    var lastExtraWeek = void 0;

    for (var _i3 = weekArray.length; _i3 < 6; _i3 += 1) {
      lastExtraWeek = weekArray[weekArray.length - 1];
      var lastDay = lastExtraWeek[lastExtraWeek.length - 1];
      var extraWeek = [];

      for (var j = 0; j < 7; j += 1) {
        var _outsideDate2 = (0, DateUtils.clone)(lastDay);
        _outsideDate2.setDate(lastDay.getDate() + j + 1);
        extraWeek.push(_outsideDate2);
      }

      weekArray.push(extraWeek);
    }
  }

  return weekArray;
}

function startOfMonth(d) {
  var newDate = (0, DateUtils.clone)(d);
  newDate.setDate(1);
  newDate.setHours(12, 0, 0, 0); // always set noon to avoid time zone issues
  return newDate;
}

function getDayNodes(node, classNames) {
  var outsideClassName = void 0;
  if (classNames === _classNames2.default) {
    // When using CSS modules prefix the modifier as required by the BEM syntax
    outsideClassName = classNames.day + '--' + classNames.outside;
  } else {
    outsideClassName = '' + classNames.outside;
  }
  var dayQuery = classNames.day.replace(/ /g, '.');
  var outsideDayQuery = outsideClassName.replace(/ /g, '.');
  var selector = '.' + dayQuery + ':not(.' + outsideDayQuery + ')';
  return node.querySelectorAll(selector);
}

function nodeListToArray(nodeList) {
  return Array.prototype.slice.call(nodeList, 0);
}

function hasOwnProp(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

});

unwrapExports(Helpers);
var Helpers_1 = Helpers.cancelEvent;
var Helpers_2 = Helpers.getFirstDayOfMonth;
var Helpers_3 = Helpers.getDaysInMonth;
var Helpers_4 = Helpers.getModifiersFromProps;
var Helpers_5 = Helpers.getFirstDayOfWeekFromProps;
var Helpers_6 = Helpers.isRangeOfDates;
var Helpers_7 = Helpers.getMonthsDiff;
var Helpers_8 = Helpers.getWeekArray;
var Helpers_9 = Helpers.startOfMonth;
var Helpers_10 = Helpers.getDayNodes;
var Helpers_11 = Helpers.nodeListToArray;
var Helpers_12 = Helpers.hasOwnProp;

var Day_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(propTypes);







var _classNames2 = _interopRequireDefault(classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/no-static-element-interactions, react/forbid-prop-types */

function handleEvent(handler, day, modifiers) {
  if (!handler) {
    return undefined;
  }
  return function (e) {
    e.persist();
    handler(day, modifiers, e);
  };
}

var Day = function (_Component) {
  _inherits(Day, _Component);

  function Day() {
    _classCallCheck(this, Day);

    return _possibleConstructorReturn(this, (Day.__proto__ || Object.getPrototypeOf(Day)).apply(this, arguments));
  }

  _createClass(Day, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var _this2 = this;

      var propNames = Object.keys(this.props);
      var nextPropNames = Object.keys(nextProps);
      if (propNames.length !== nextPropNames.length) {
        return true;
      }
      return propNames.some(function (name) {
        if (name === 'modifiers' || name === 'modifiersStyles' || name === 'classNames') {
          var prop = _this2.props[name];
          var nextProp = nextProps[name];
          var modifiers = Object.keys(prop);
          var nextModifiers = Object.keys(nextProp);
          if (modifiers.length !== nextModifiers.length) {
            return true;
          }
          return modifiers.some(function (mod) {
            return !(0, Helpers.hasOwnProp)(nextProp, mod) || prop[mod] !== nextProp[mod];
          });
        }
        if (name === 'day') {
          return !(0, DateUtils.isSameDay)(_this2.props[name], nextProps[name]);
        }
        return !(0, Helpers.hasOwnProp)(nextProps, name) || _this2.props[name] !== nextProps[name];
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          modifiersStyles = _props.modifiersStyles,
          day = _props.day,
          tabIndex = _props.tabIndex,
          empty = _props.empty,
          modifiers = _props.modifiers,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          onMouseUp = _props.onMouseUp,
          onMouseDown = _props.onMouseDown,
          onClick = _props.onClick,
          onKeyDown = _props.onKeyDown,
          onTouchStart = _props.onTouchStart,
          onTouchEnd = _props.onTouchEnd,
          onFocus = _props.onFocus,
          ariaLabel = _props.ariaLabel,
          ariaDisabled = _props.ariaDisabled,
          ariaSelected = _props.ariaSelected,
          children = _props.children;


      var className = classNames.day;
      if (classNames !== _classNames2.default) {
        // When using CSS modules prefix the modifier as required by the BEM syntax
        className += ' ' + Object.keys(modifiers).join(' ');
      } else {
        className += Object.keys(modifiers).map(function (modifier) {
          return ' ' + className + '--' + modifier;
        }).join('');
      }

      var style = void 0;
      if (modifiersStyles) {
        Object.keys(modifiers).filter(function (modifier) {
          return !!modifiersStyles[modifier];
        }).forEach(function (modifier) {
          style = _extends({}, style, modifiersStyles[modifier]);
        });
      }

      if (empty) {
        return _react2.default.createElement('div', { 'aria-disabled': true, className: className, style: style });
      }
      return _react2.default.createElement(
        'div',
        {
          className: className,
          tabIndex: tabIndex,
          style: style,
          role: 'gridcell',
          'aria-label': ariaLabel,
          'aria-disabled': ariaDisabled,
          'aria-selected': ariaSelected,
          onClick: handleEvent(onClick, day, modifiers),
          onKeyDown: handleEvent(onKeyDown, day, modifiers),
          onMouseEnter: handleEvent(onMouseEnter, day, modifiers),
          onMouseLeave: handleEvent(onMouseLeave, day, modifiers),
          onMouseUp: handleEvent(onMouseUp, day, modifiers),
          onMouseDown: handleEvent(onMouseDown, day, modifiers),
          onTouchEnd: handleEvent(onTouchEnd, day, modifiers),
          onTouchStart: handleEvent(onTouchStart, day, modifiers),
          onFocus: handleEvent(onFocus, day, modifiers)
        },
        children
      );
    }
  }]);

  return Day;
}(React.Component);

Day.propTypes = {
  classNames: _propTypes2.default.shape({
    day: _propTypes2.default.string.isRequired
  }).isRequired,

  day: _propTypes2.default.instanceOf(Date).isRequired,
  children: _propTypes2.default.node.isRequired,

  ariaDisabled: _propTypes2.default.bool,
  ariaLabel: _propTypes2.default.string,
  ariaSelected: _propTypes2.default.bool,
  empty: _propTypes2.default.bool,
  modifiers: _propTypes2.default.object,
  modifiersStyles: _propTypes2.default.object,
  onClick: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onMouseEnter: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  onMouseDown: _propTypes2.default.func,
  onMouseUp: _propTypes2.default.func,
  onTouchEnd: _propTypes2.default.func,
  onTouchStart: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  tabIndex: _propTypes2.default.number
};
Day.defaultProps = {
  tabIndex: -1
};
Day.defaultProps = {
  modifiers: {},
  modifiersStyles: {},
  empty: false
};
exports.default = Day;

});

unwrapExports(Day_1);

var ModifiersUtils = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dayMatchesModifier = dayMatchesModifier;
exports.getModifiersForDay = getModifiersForDay;





/**
 * Return `true` if a date matches the specified modifier.
 *
 * @export
 * @param {Date} day
 * @param {Any} modifier
 * @return {Boolean}
 */
function dayMatchesModifier(day, modifier) {
  if (!modifier) {
    return false;
  }
  var arr = Array.isArray(modifier) ? modifier : [modifier];
  return arr.some(function (mod) {
    if (!mod) {
      return false;
    }
    if (mod instanceof Date) {
      return (0, DateUtils.isSameDay)(day, mod);
    }
    if ((0, Helpers.isRangeOfDates)(mod)) {
      return (0, DateUtils.isDayInRange)(day, mod);
    }
    if (mod.after && mod.before && (0, DateUtils.isDayAfter)(mod.before, mod.after)) {
      return (0, DateUtils.isDayAfter)(day, mod.after) && (0, DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.after && mod.before && ((0, DateUtils.isDayAfter)(mod.after, mod.before) || (0, DateUtils.isSameDay)(mod.after, mod.before))) {
      return (0, DateUtils.isDayAfter)(day, mod.after) || (0, DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.after) {
      return (0, DateUtils.isDayAfter)(day, mod.after);
    }
    if (mod.before) {
      return (0, DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.daysOfWeek) {
      return mod.daysOfWeek.some(function (dayOfWeek) {
        return day.getDay() === dayOfWeek;
      });
    }
    if (typeof mod === 'function') {
      return mod(day);
    }
    return false;
  });
}

/**
 * Return the modifiers matching the given day for the given
 * object of modifiers.
 *
 * @export
 * @param {Date} day
 * @param {Object} [modifiersObj={}]
 * @return {Array}
 */
function getModifiersForDay(day) {
  var modifiersObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.keys(modifiersObj).reduce(function (modifiers, modifierName) {
    var value = modifiersObj[modifierName];
    if (dayMatchesModifier(day, value)) {
      modifiers.push(modifierName);
    }
    return modifiers;
  }, []);
}

exports.default = { dayMatchesModifier: dayMatchesModifier, getModifiersForDay: getModifiersForDay };

});

unwrapExports(ModifiersUtils);
var ModifiersUtils_1 = ModifiersUtils.dayMatchesModifier;
var ModifiersUtils_2 = ModifiersUtils.getModifiersForDay;

var Month_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(propTypes);



var _Weekdays2 = _interopRequireDefault(Weekdays_1);



var _Day2 = _interopRequireDefault(Day_1);





var ModifiersUtils$1 = _interopRequireWildcard(ModifiersUtils);



var Helpers$1 = _interopRequireWildcard(Helpers);



var DateUtils$1 = _interopRequireWildcard(DateUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Month = function (_Component) {
  _inherits(Month, _Component);

  function Month() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Month);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Month.__proto__ || Object.getPrototypeOf(Month)).call.apply(_ref, [this].concat(args))), _this), _this.renderDay = function (day) {
      var monthNumber = _this.props.month.getMonth();
      var propModifiers = Helpers$1.getModifiersFromProps(_this.props);
      var dayModifiers = ModifiersUtils$1.getModifiersForDay(day, propModifiers);
      if (DateUtils$1.isSameDay(day, new Date()) && !Object.prototype.hasOwnProperty.call(propModifiers, _this.props.classNames.today)) {
        dayModifiers.push(_this.props.classNames.today);
      }
      if (day.getMonth() !== monthNumber) {
        dayModifiers.push(_this.props.classNames.outside);
      }

      var isOutside = day.getMonth() !== monthNumber;
      var tabIndex = -1;
      // Focus on the first day of the month
      if (_this.props.onDayClick && !isOutside && day.getDate() === 1) {
        tabIndex = _this.props.tabIndex; // eslint-disable-line prefer-destructuring
      }
      var key = '' + day.getFullYear() + day.getMonth() + day.getDate();
      var modifiers = {};
      dayModifiers.forEach(function (modifier) {
        modifiers[modifier] = true;
      });

      return _react2.default.createElement(
        _Day2.default,
        {
          key: '' + (isOutside ? 'outside-' : '') + key,
          classNames: _this.props.classNames,
          day: day,
          modifiers: modifiers,
          modifiersStyles: _this.props.modifiersStyles,
          empty: isOutside && !_this.props.showOutsideDays && !_this.props.fixedWeeks,
          tabIndex: tabIndex,
          ariaLabel: _this.props.localeUtils.formatDay(day, _this.props.locale),
          ariaDisabled: isOutside || dayModifiers.indexOf(_this.props.classNames.disabled) > -1,
          ariaSelected: dayModifiers.indexOf(_this.props.classNames.selected) > -1,
          onClick: _this.props.onDayClick,
          onFocus: _this.props.onDayFocus,
          onKeyDown: _this.props.onDayKeyDown,
          onMouseEnter: _this.props.onDayMouseEnter,
          onMouseLeave: _this.props.onDayMouseLeave,
          onMouseDown: _this.props.onDayMouseDown,
          onMouseUp: _this.props.onDayMouseUp,
          onTouchEnd: _this.props.onDayTouchEnd,
          onTouchStart: _this.props.onDayTouchStart
        },
        _this.props.renderDay(day, modifiers)
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Month, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          classNames = _props.classNames,
          month = _props.month,
          months = _props.months,
          fixedWeeks = _props.fixedWeeks,
          captionElement = _props.captionElement,
          weekdayElement = _props.weekdayElement,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          firstDayOfWeek = _props.firstDayOfWeek,
          onCaptionClick = _props.onCaptionClick,
          showWeekNumbers = _props.showWeekNumbers,
          showWeekDays = _props.showWeekDays,
          onWeekClick = _props.onWeekClick;


      var captionProps = {
        date: month,
        classNames: classNames,
        months: months,
        localeUtils: localeUtils,
        locale: locale,
        onClick: onCaptionClick ? function (e) {
          return onCaptionClick(month, e);
        } : undefined
      };
      var caption = _react2.default.isValidElement(captionElement) ? _react2.default.cloneElement(captionElement, captionProps) : _react2.default.createElement(captionElement, captionProps);

      var weeks = Helpers$1.getWeekArray(month, firstDayOfWeek, fixedWeeks);
      return _react2.default.createElement(
        'div',
        { className: classNames.month, role: 'grid' },
        caption,
        showWeekDays && _react2.default.createElement(_Weekdays2.default, {
          classNames: classNames,
          weekdaysShort: weekdaysShort,
          weekdaysLong: weekdaysLong,
          firstDayOfWeek: firstDayOfWeek,
          showWeekNumbers: showWeekNumbers,
          locale: locale,
          localeUtils: localeUtils,
          weekdayElement: weekdayElement
        }),
        _react2.default.createElement(
          'div',
          { className: classNames.body, role: 'rowgroup' },
          weeks.map(function (week) {
            var weekNumber = void 0;
            if (showWeekNumbers) {
              weekNumber = DateUtils$1.getWeekNumber(week[6]);
            }
            return _react2.default.createElement(
              'div',
              {
                key: week[0].getTime(),
                className: classNames.week,
                role: 'row'
              },
              showWeekNumbers && _react2.default.createElement(
                'div',
                {
                  className: classNames.weekNumber,
                  tabIndex: onWeekClick ? 0 : -1,
                  role: 'gridcell',
                  onClick: onWeekClick ? function (e) {
                    return onWeekClick(weekNumber, week, e);
                  } : undefined,
                  onKeyUp: onWeekClick ? function (e) {
                    return e.keyCode === keys$1.ENTER && onWeekClick(weekNumber, week, e);
                  } : undefined
                },
                _this2.props.renderWeek(weekNumber, week, month)
              ),
              week.map(_this2.renderDay)
            );
          })
        )
      );
    }
  }]);

  return Month;
}(React.Component);

Month.propTypes = {
  classNames: _propTypes2.default.shape({
    body: _propTypes2.default.string.isRequired,
    month: _propTypes2.default.string.isRequired,
    outside: _propTypes2.default.string.isRequired,
    today: _propTypes2.default.string.isRequired,
    week: _propTypes2.default.string.isRequired,
    weekNumber: _propTypes2.default.string.isRequired,
    disabled: _propTypes2.default.string.isRequired,
    selected: _propTypes2.default.string.isRequired
  }).isRequired,
  tabIndex: _propTypes2.default.number,

  month: _propTypes2.default.instanceOf(Date).isRequired,
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),

  modifiersStyles: _propTypes2.default.object,

  showWeekDays: _propTypes2.default.bool,
  showOutsideDays: _propTypes2.default.bool,

  renderDay: _propTypes2.default.func.isRequired,
  renderWeek: _propTypes2.default.func.isRequired,

  captionElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)]).isRequired,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)]),

  fixedWeeks: _propTypes2.default.bool,
  showWeekNumbers: _propTypes2.default.bool,

  locale: _propTypes2.default.string.isRequired,
  localeUtils: _propTypes2.default.object.isRequired,
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
  firstDayOfWeek: _propTypes2.default.number.isRequired,

  onCaptionClick: _propTypes2.default.func,
  onDayClick: _propTypes2.default.func,
  onDayFocus: _propTypes2.default.func,
  onDayKeyDown: _propTypes2.default.func,
  onDayMouseEnter: _propTypes2.default.func,
  onDayMouseLeave: _propTypes2.default.func,
  onDayMouseDown: _propTypes2.default.func,
  onDayMouseUp: _propTypes2.default.func,
  onDayTouchEnd: _propTypes2.default.func,
  onDayTouchStart: _propTypes2.default.func,
  onWeekClick: _propTypes2.default.func
};
exports.default = Month;

});

unwrapExports(Month_1);

var Weekday_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Weekday = function (_Component) {
  _inherits(Weekday, _Component);

  function Weekday() {
    _classCallCheck(this, Weekday);

    return _possibleConstructorReturn(this, (Weekday.__proto__ || Object.getPrototypeOf(Weekday)).apply(this, arguments));
  }

  _createClass(Weekday, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props !== nextProps;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          weekday = _props.weekday,
          className = _props.className,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          localeUtils = _props.localeUtils,
          locale = _props.locale;

      var title = void 0;
      if (weekdaysLong) {
        title = weekdaysLong[weekday];
      } else {
        title = localeUtils.formatWeekdayLong(weekday, locale);
      }
      var content = void 0;
      if (weekdaysShort) {
        content = weekdaysShort[weekday];
      } else {
        content = localeUtils.formatWeekdayShort(weekday, locale);
      }

      return _react2.default.createElement(
        'div',
        { className: className, role: 'columnheader' },
        _react2.default.createElement(
          'abbr',
          { title: title },
          content
        )
      );
    }
  }]);

  return Weekday;
}(React.Component);

Weekday.propTypes = {
  weekday: _propTypes2.default.number,
  className: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.object,

  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string)
};
exports.default = Weekday;

});

unwrapExports(Weekday_1);

var DayPicker_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModifiersUtils = exports.LocaleUtils = exports.DateUtils = exports.DayPicker = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(propTypes);



var _Caption2 = _interopRequireDefault(Caption_1);



var _Navbar2 = _interopRequireDefault(Navbar_1);



var _Month2 = _interopRequireDefault(Month_1);



var _Weekday2 = _interopRequireDefault(Weekday_1);



var Helpers$1 = _interopRequireWildcard(Helpers);



var DateUtils$1 = _interopRequireWildcard(DateUtils);



var LocaleUtils$1 = _interopRequireWildcard(LocaleUtils);



var ModifiersUtils$1 = _interopRequireWildcard(ModifiersUtils);



var _classNames2 = _interopRequireDefault(classNames);



function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DayPicker = exports.DayPicker = function (_Component) {
  _inherits(DayPicker, _Component);

  function DayPicker(props) {
    _classCallCheck(this, DayPicker);

    var _this = _possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));

    _this.dayPicker = null;

    _this.showNextMonth = function (callback) {
      if (!_this.allowNextMonth()) {
        return;
      }
      var deltaMonths = _this.props.pagedNavigation ? _this.props.numberOfMonths : 1;
      var nextMonth = DateUtils$1.addMonths(_this.state.currentMonth, deltaMonths);
      _this.showMonth(nextMonth, callback);
    };

    _this.showPreviousMonth = function (callback) {
      if (!_this.allowPreviousMonth()) {
        return;
      }
      var deltaMonths = _this.props.pagedNavigation ? _this.props.numberOfMonths : 1;
      var previousMonth = DateUtils$1.addMonths(_this.state.currentMonth, -deltaMonths);
      _this.showMonth(previousMonth, callback);
    };

    _this.handleKeyDown = function (e) {
      e.persist();

      switch (e.keyCode) {
        case keys$1.LEFT:
          if (_this.props.dir === 'rtl') {
            _this.showNextMonth();
          } else {
            _this.showPreviousMonth();
          }
          Helpers$1.cancelEvent(e);
          break;
        case keys$1.RIGHT:
          if (_this.props.dir === 'rtl') {
            _this.showPreviousMonth();
          } else {
            _this.showNextMonth();
          }
          Helpers$1.cancelEvent(e);
          break;
        case keys$1.UP:
          _this.showPreviousYear();
          Helpers$1.cancelEvent(e);
          break;
        case keys$1.DOWN:
          _this.showNextYear();
          Helpers$1.cancelEvent(e);
          break;
        default:
          break;
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(e);
      }
    };

    _this.handleDayKeyDown = function (day, modifiers, e) {
      e.persist();

      switch (e.keyCode) {
        case keys$1.LEFT:
          Helpers$1.cancelEvent(e);
          if (_this.props.dir === 'rtl') {
            _this.focusNextDay(e.target);
          } else {
            _this.focusPreviousDay(e.target);
          }
          break;
        case keys$1.RIGHT:
          Helpers$1.cancelEvent(e);
          if (_this.props.dir === 'rtl') {
            _this.focusPreviousDay(e.target);
          } else {
            _this.focusNextDay(e.target);
          }
          break;
        case keys$1.UP:
          Helpers$1.cancelEvent(e);
          _this.focusPreviousWeek(e.target);
          break;
        case keys$1.DOWN:
          Helpers$1.cancelEvent(e);
          _this.focusNextWeek(e.target);
          break;
        case keys$1.ENTER:
        case keys$1.SPACE:
          Helpers$1.cancelEvent(e);
          if (_this.props.onDayClick) {
            _this.handleDayClick(day, modifiers, e);
          }
          break;
        default:
          break;
      }
      if (_this.props.onDayKeyDown) {
        _this.props.onDayKeyDown(day, modifiers, e);
      }
    };

    _this.handleDayClick = function (day, modifiers, e) {
      e.persist();

      if (modifiers[_this.props.classNames.outside] && _this.props.enableOutsideDaysClick) {
        _this.handleOutsideDayClick(day);
      }
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, modifiers, e);
      }
    };

    _this.handleTodayButtonClick = function (e) {
      var today = new Date();
      var month = new Date(today.getFullYear(), today.getMonth());
      _this.showMonth(month);
      e.target.blur();
      if (_this.props.onTodayButtonClick) {
        e.persist();
        _this.props.onTodayButtonClick(new Date(today.getFullYear(), today.getMonth(), today.getDate()), ModifiersUtils$1.getModifiersForDay(today, _this.props.modifiers), e);
      }
    };

    var currentMonth = _this.getCurrentMonthFromProps(props);
    _this.state = { currentMonth: currentMonth };
    return _this;
  }

  _createClass(DayPicker, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // Changing the `month` props means changing the current displayed month
      if (prevProps.month !== this.props.month && !DateUtils$1.isSameMonth(prevProps.month, this.props.month)) {
        var currentMonth = this.getCurrentMonthFromProps(this.props);
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ currentMonth: currentMonth });
      }
    }
  }, {
    key: 'getCurrentMonthFromProps',


    /**
     * Return the month to be shown in the calendar based on the component props.
     *
     * @param {Object} props
     * @returns Date
     * @memberof DayPicker
     * @private
     */
    value: function getCurrentMonthFromProps(props) {
      var initialMonth = Helpers$1.startOfMonth(props.month || props.initialMonth || new Date());
      var currentMonth = initialMonth;

      if (props.pagedNavigation && props.numberOfMonths > 1 && props.fromMonth) {
        var fromMonth = Helpers$1.startOfMonth(props.fromMonth);
        var diffInMonths = Helpers$1.getMonthsDiff(fromMonth, currentMonth);
        currentMonth = DateUtils$1.addMonths(fromMonth, Math.floor(diffInMonths / props.numberOfMonths) * props.numberOfMonths);
      } else if (props.toMonth && props.numberOfMonths > 1 && Helpers$1.getMonthsDiff(currentMonth, props.toMonth) <= 0) {
        currentMonth = DateUtils$1.addMonths(Helpers$1.startOfMonth(props.toMonth), 1 - this.props.numberOfMonths);
      }
      return currentMonth;
    }
  }, {
    key: 'getNextNavigableMonth',
    value: function getNextNavigableMonth() {
      return DateUtils$1.addMonths(this.state.currentMonth, this.props.numberOfMonths);
    }
  }, {
    key: 'getPreviousNavigableMonth',
    value: function getPreviousNavigableMonth() {
      return DateUtils$1.addMonths(this.state.currentMonth, -1);
    }
  }, {
    key: 'allowPreviousMonth',
    value: function allowPreviousMonth() {
      var previousMonth = DateUtils$1.addMonths(this.state.currentMonth, -1);
      return this.allowMonth(previousMonth);
    }
  }, {
    key: 'allowNextMonth',
    value: function allowNextMonth() {
      var nextMonth = DateUtils$1.addMonths(this.state.currentMonth, this.props.numberOfMonths);
      return this.allowMonth(nextMonth);
    }
  }, {
    key: 'allowMonth',
    value: function allowMonth(d) {
      var _props = this.props,
          fromMonth = _props.fromMonth,
          toMonth = _props.toMonth,
          canChangeMonth = _props.canChangeMonth;

      if (!canChangeMonth || fromMonth && Helpers$1.getMonthsDiff(fromMonth, d) < 0 || toMonth && Helpers$1.getMonthsDiff(toMonth, d) > 0) {
        return false;
      }
      return true;
    }
  }, {
    key: 'allowYearChange',
    value: function allowYearChange() {
      return this.props.canChangeMonth;
    }
  }, {
    key: 'showMonth',
    value: function showMonth(d, callback) {
      var _this2 = this;

      if (!this.allowMonth(d)) {
        return;
      }
      this.setState({ currentMonth: Helpers$1.startOfMonth(d) }, function () {
        if (callback) {
          callback();
        }
        if (_this2.props.onMonthChange) {
          _this2.props.onMonthChange(_this2.state.currentMonth);
        }
      });
    }
  }, {
    key: 'showNextYear',
    value: function showNextYear() {
      if (!this.allowYearChange()) {
        return;
      }
      var nextMonth = DateUtils$1.addMonths(this.state.currentMonth, 12);
      this.showMonth(nextMonth);
    }
  }, {
    key: 'showPreviousYear',
    value: function showPreviousYear() {
      if (!this.allowYearChange()) {
        return;
      }
      var nextMonth = DateUtils$1.addMonths(this.state.currentMonth, -12);
      this.showMonth(nextMonth);
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.wrapper.focus();
    }
  }, {
    key: 'focusFirstDayOfMonth',
    value: function focusFirstDayOfMonth() {
      Helpers$1.getDayNodes(this.dayPicker, this.props.classNames)[0].focus();
    }
  }, {
    key: 'focusLastDayOfMonth',
    value: function focusLastDayOfMonth() {
      var dayNodes = Helpers$1.getDayNodes(this.dayPicker, this.props.classNames);
      dayNodes[dayNodes.length - 1].focus();
    }
  }, {
    key: 'focusPreviousDay',
    value: function focusPreviousDay(dayNode) {
      var _this3 = this;

      var dayNodes = Helpers$1.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers$1.nodeListToArray(dayNodes).indexOf(dayNode);
      if (dayNodeIndex === -1) return;
      if (dayNodeIndex === 0) {
        this.showPreviousMonth(function () {
          return _this3.focusLastDayOfMonth();
        });
      } else {
        dayNodes[dayNodeIndex - 1].focus();
      }
    }
  }, {
    key: 'focusNextDay',
    value: function focusNextDay(dayNode) {
      var _this4 = this;

      var dayNodes = Helpers$1.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers$1.nodeListToArray(dayNodes).indexOf(dayNode);
      if (dayNodeIndex === -1) return;
      if (dayNodeIndex === dayNodes.length - 1) {
        this.showNextMonth(function () {
          return _this4.focusFirstDayOfMonth();
        });
      } else {
        dayNodes[dayNodeIndex + 1].focus();
      }
    }
  }, {
    key: 'focusNextWeek',
    value: function focusNextWeek(dayNode) {
      var _this5 = this;

      var dayNodes = Helpers$1.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers$1.nodeListToArray(dayNodes).indexOf(dayNode);
      var isInLastWeekOfMonth = dayNodeIndex > dayNodes.length - 8;

      if (isInLastWeekOfMonth) {
        this.showNextMonth(function () {
          var daysAfterIndex = dayNodes.length - dayNodeIndex;
          var nextMonthDayNodeIndex = 7 - daysAfterIndex;
          Helpers$1.getDayNodes(_this5.dayPicker, _this5.props.classNames)[nextMonthDayNodeIndex].focus();
        });
      } else {
        dayNodes[dayNodeIndex + 7].focus();
      }
    }
  }, {
    key: 'focusPreviousWeek',
    value: function focusPreviousWeek(dayNode) {
      var _this6 = this;

      var dayNodes = Helpers$1.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers$1.nodeListToArray(dayNodes).indexOf(dayNode);
      var isInFirstWeekOfMonth = dayNodeIndex <= 6;

      if (isInFirstWeekOfMonth) {
        this.showPreviousMonth(function () {
          var previousMonthDayNodes = Helpers$1.getDayNodes(_this6.dayPicker, _this6.props.classNames);
          var startOfLastWeekOfMonth = previousMonthDayNodes.length - 7;
          var previousMonthDayNodeIndex = startOfLastWeekOfMonth + dayNodeIndex;
          previousMonthDayNodes[previousMonthDayNodeIndex].focus();
        });
      } else {
        dayNodes[dayNodeIndex - 7].focus();
      }
    }

    // Event handlers

  }, {
    key: 'handleOutsideDayClick',
    value: function handleOutsideDayClick(day) {
      var currentMonth = this.state.currentMonth;
      var numberOfMonths = this.props.numberOfMonths;

      var diffInMonths = Helpers$1.getMonthsDiff(currentMonth, day);
      if (diffInMonths > 0 && diffInMonths >= numberOfMonths) {
        this.showNextMonth();
      } else if (diffInMonths < 0) {
        this.showPreviousMonth();
      }
    }
  }, {
    key: 'renderNavbar',
    value: function renderNavbar() {
      var _props2 = this.props,
          labels = _props2.labels,
          locale = _props2.locale,
          localeUtils = _props2.localeUtils,
          canChangeMonth = _props2.canChangeMonth,
          navbarElement = _props2.navbarElement,
          attributes = _objectWithoutProperties(_props2, ['labels', 'locale', 'localeUtils', 'canChangeMonth', 'navbarElement']);

      if (!canChangeMonth) return null;

      var props = {
        month: this.state.currentMonth,
        classNames: this.props.classNames,
        className: this.props.classNames.navBar,
        nextMonth: this.getNextNavigableMonth(),
        previousMonth: this.getPreviousNavigableMonth(),
        showPreviousButton: this.allowPreviousMonth(),
        showNextButton: this.allowNextMonth(),
        onNextClick: this.showNextMonth,
        onPreviousClick: this.showPreviousMonth,
        dir: attributes.dir,
        labels: labels,
        locale: locale,
        localeUtils: localeUtils
      };
      return _react2.default.isValidElement(navbarElement) ? _react2.default.cloneElement(navbarElement, props) : _react2.default.createElement(navbarElement, props);
    }
  }, {
    key: 'renderMonths',
    value: function renderMonths() {
      var months = [];
      var firstDayOfWeek = Helpers$1.getFirstDayOfWeekFromProps(this.props);
      for (var i = 0; i < this.props.numberOfMonths; i += 1) {
        var month = DateUtils$1.addMonths(this.state.currentMonth, i);
        months.push(_react2.default.createElement(_Month2.default, _extends({
          key: i
        }, this.props, {
          month: month,
          firstDayOfWeek: firstDayOfWeek,
          onDayKeyDown: this.handleDayKeyDown,
          onDayClick: this.handleDayClick
        })));
      }

      if (this.props.reverseMonths) {
        months.reverse();
      }
      return months;
    }
  }, {
    key: 'renderFooter',
    value: function renderFooter() {
      if (this.props.todayButton) {
        return _react2.default.createElement(
          'div',
          { className: this.props.classNames.footer },
          this.renderTodayButton()
        );
      }
      return null;
    }
  }, {
    key: 'renderTodayButton',
    value: function renderTodayButton() {
      return _react2.default.createElement(
        'button',
        {
          type: 'button',
          tabIndex: 0,
          className: this.props.classNames.todayButton,
          'aria-label': this.props.todayButton,
          onClick: this.handleTodayButtonClick
        },
        this.props.todayButton
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var className = this.props.classNames.container;

      if (!this.props.onDayClick) {
        className = className + ' ' + this.props.classNames.interactionDisabled;
      }
      if (this.props.className) {
        className = className + ' ' + this.props.className;
      }
      return _react2.default.createElement(
        'div',
        _extends({}, this.props.containerProps, {
          className: className,
          ref: function ref(el) {
            return _this7.dayPicker = el;
          },
          lang: this.props.locale
        }),
        _react2.default.createElement(
          'div',
          {
            className: this.props.classNames.wrapper,
            ref: function ref(el) {
              return _this7.wrapper = el;
            },
            tabIndex: this.props.canChangeMonth && typeof this.props.tabIndex !== 'undefined' ? this.props.tabIndex : -1,
            onKeyDown: this.handleKeyDown,
            onFocus: this.props.onFocus,
            onBlur: this.props.onBlur
          },
          this.renderNavbar(),
          _react2.default.createElement(
            'div',
            { className: this.props.classNames.months },
            this.renderMonths()
          ),
          this.renderFooter()
        )
      );
    }
  }]);

  return DayPicker;
}(React.Component);

DayPicker.propTypes = {
  // Rendering months
  initialMonth: _propTypes2.default.instanceOf(Date),
  month: _propTypes2.default.instanceOf(Date),
  numberOfMonths: _propTypes2.default.number,
  fromMonth: _propTypes2.default.instanceOf(Date),
  toMonth: _propTypes2.default.instanceOf(Date),
  canChangeMonth: _propTypes2.default.bool,
  reverseMonths: _propTypes2.default.bool,
  pagedNavigation: _propTypes2.default.bool,
  todayButton: _propTypes2.default.string,
  showWeekNumbers: _propTypes2.default.bool,
  showWeekDays: _propTypes2.default.bool,

  // Modifiers
  selectedDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),
  disabledDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),

  modifiers: _propTypes2.default.object,
  modifiersStyles: _propTypes2.default.object,

  // Localization
  dir: _propTypes2.default.string,
  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
  labels: _propTypes2.default.shape({
    nextMonth: _propTypes2.default.string.isRequired,
    previousMonth: _propTypes2.default.string.isRequired
  }),
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.shape({
    formatMonthTitle: _propTypes2.default.func,
    formatWeekdayShort: _propTypes2.default.func,
    formatWeekdayLong: _propTypes2.default.func,
    getFirstDayOfWeek: _propTypes2.default.func
  }),
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),

  // Customization
  showOutsideDays: _propTypes2.default.bool,
  enableOutsideDaysClick: _propTypes2.default.bool,
  fixedWeeks: _propTypes2.default.bool,

  // CSS and HTML
  classNames: _propTypes2.default.shape({
    body: _propTypes2.default.string,
    container: _propTypes2.default.string,
    day: _propTypes2.default.string.isRequired,
    disabled: _propTypes2.default.string.isRequired,
    footer: _propTypes2.default.string,
    interactionDisabled: _propTypes2.default.string,
    months: _propTypes2.default.string,
    month: _propTypes2.default.string,
    navBar: _propTypes2.default.string,
    outside: _propTypes2.default.string.isRequired,
    selected: _propTypes2.default.string.isRequired,
    today: _propTypes2.default.string.isRequired,
    todayButton: _propTypes2.default.string,
    week: _propTypes2.default.string,
    wrapper: _propTypes2.default.string
  }),
  className: _propTypes2.default.string,
  containerProps: _propTypes2.default.object,
  tabIndex: _propTypes2.default.number,

  // Custom elements
  renderDay: _propTypes2.default.func,
  renderWeek: _propTypes2.default.func,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(React.Component)]),
  navbarElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(React.Component)]),
  captionElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(React.Component)]),

  // Events
  onBlur: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onDayClick: _propTypes2.default.func,
  onDayKeyDown: _propTypes2.default.func,
  onDayMouseEnter: _propTypes2.default.func,
  onDayMouseLeave: _propTypes2.default.func,
  onDayMouseDown: _propTypes2.default.func,
  onDayMouseUp: _propTypes2.default.func,
  onDayTouchStart: _propTypes2.default.func,
  onDayTouchEnd: _propTypes2.default.func,
  onDayFocus: _propTypes2.default.func,
  onMonthChange: _propTypes2.default.func,
  onCaptionClick: _propTypes2.default.func,
  onWeekClick: _propTypes2.default.func,
  onTodayButtonClick: _propTypes2.default.func
};
DayPicker.defaultProps = {
  classNames: _classNames2.default,
  tabIndex: 0,
  numberOfMonths: 1,
  labels: {
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month'
  },
  locale: 'en',
  localeUtils: LocaleUtils$1,
  showOutsideDays: false,
  enableOutsideDaysClick: true,
  fixedWeeks: false,
  canChangeMonth: true,
  reverseMonths: false,
  pagedNavigation: false,
  showWeekNumbers: false,
  showWeekDays: true,
  renderDay: function renderDay(day) {
    return day.getDate();
  },
  renderWeek: function renderWeek(weekNumber) {
    return weekNumber;
  },
  weekdayElement: _react2.default.createElement(_Weekday2.default, null),
  navbarElement: _react2.default.createElement(_Navbar2.default, { classNames: _classNames2.default }),
  captionElement: _react2.default.createElement(_Caption2.default, { classNames: _classNames2.default })
};
DayPicker.VERSION = '7.4.8';


DayPicker.DateUtils = DateUtils$1;
DayPicker.LocaleUtils = LocaleUtils$1;
DayPicker.ModifiersUtils = ModifiersUtils$1;

exports.DateUtils = DateUtils$1;
exports.LocaleUtils = LocaleUtils$1;
exports.ModifiersUtils = ModifiersUtils$1;
exports.default = DayPicker;

});

unwrapExports(DayPicker_1);
var DayPicker_2 = DayPicker_1.ModifiersUtils;
var DayPicker_3 = DayPicker_1.LocaleUtils;
var DayPicker_4 = DayPicker_1.DateUtils;
var DayPicker_5 = DayPicker_1.DayPicker;

var build = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(DayPicker_1).default;
  }
});



Object.defineProperty(exports, 'DateUtils', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(DateUtils).default;
  }
});



Object.defineProperty(exports, 'LocaleUtils', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(LocaleUtils).default;
  }
});



Object.defineProperty(exports, 'ModifiersUtils', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(ModifiersUtils).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

});

var DayPicker = unwrapExports(build);

//  just wrap DayPicker and pass along unmanaged props

var DatePicker = function DatePicker(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  var containerClass = classnames('zola-ui', 'zola-ui__datepicker', className);
  return React.createElement("div", {
    className: containerClass
  }, React.createElement(DayPicker, props));
};

DatePicker.propTypes = {
  className: propTypes.string
};

/*
 *  ** provide 'formatDate' & 'parseDate' functions from web-repo
 *     - import date libraries at the repo level
 *     - day.js is recommended as the smallest
 *  ** - DO YOUR PART TO KEEP ZOLA-UI SMALL - 😁 **
 *
 *  ** NOTE: use these functions to convert your dates to UTC
 *     (assume that we are saving a Date Object on record)
 */

var DatePickerInput = function DatePickerInput(_ref) {
  var calendarIcon = _ref.calendarIcon,
      className = _ref.className,
      disabled = _ref.disabled,
      formatDate = _ref.formatDate,
      isRequired = _ref.isRequired,
      label = _ref.label,
      parseDate = _ref.parseDate,
      placeholder = _ref.placeholder,
      inputOnChange = _ref.inputOnChange,
      _ref$value = _ref.value,
      externalValue = _ref$value === void 0 ? null : _ref$value,
      inputFieldProps = _ref.inputFieldProps,
      datePickerOptions = _ref.datePickerOptions,
      _ref$isFormField = _ref.isFormField,
      isFormField = _ref$isFormField === void 0 ? false : _ref$isFormField;
  // *** hide / show functionality ***
  var ref = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showCal = _useState2[0],
      setShowCal = _useState2[1]; // *** handling date value ***


  var initialInputValue = externalValue || '';
  var initialDate = externalValue ? parseDate(externalValue) : null;

  var _useState3 = useState(initialInputValue),
      _useState4 = _slicedToArray(_useState3, 2),
      inputValue = _useState4[0],
      setInputValue = _useState4[1]; // string of formatted date


  var _useState5 = useState(initialDate),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedDay = _useState6[0],
      setSelectedDay = _useState6[1]; // Date object
  // for form fields, updates flow from externalValue --> inputValue


  useEffect(function () {
    if (isFormField && externalValue !== inputValue) {
      setInputValue(externalValue);
    }
  }, [externalValue, inputValue, isFormField, parseDate]); // on updates to inputValue --> update selectedDay

  useEffect(function () {
    var newVal = null; // if can be parsed properly

    if (parseDate(inputValue)) {
      newVal = parseDate(inputValue);
    } // update the selectedDay


    setSelectedDay(newVal);
  }, [inputValue, isFormField, parseDate]);

  var handleOutsideClick = function handleOutsideClick() {
    return setShowCal(false);
  };

  useOutsideClick(ref, function () {
    return handleOutsideClick();
  }); // when day clicked from calendar

  var handleDayClick = function handleDayClick(day) {
    var formattedDay = formatDate(day);

    if (isFormField && inputOnChange) {
      var e = {
        target: {
          value: formattedDay
        }
      };
      inputOnChange(e);
    } else {
      setInputValue(formattedDay);
    }

    setShowCal(false);
  }; // when typing into inputfield


  var handleInputChange = function handleInputChange(e) {
    e.preventDefault();

    if (isFormField && inputOnChange) {
      inputOnChange(e);
    } else {
      setInputValue(e.target.value);
    }
  };

  var onFocus = function onFocus(e) {
    e.preventDefault();
    setShowCal(true);
    if (inputFieldProps && inputFieldProps.onFocus) inputFieldProps.onFocus(e);
  }; // *** process classnames ***


  var containerClass = classnames('zola-ui', 'zola-ui__datepicker', 'zola-ui__datepicker-input', // TODO: eval RFF & redux-form
  // touched && error ? 'has-error' : '',
  className);
  var pickerClass = classnames(className, showCal ? 'active' : ''); // *** set up props ***

  var inputProps = Object.assign({}, inputFieldProps, {
    // prop overrides:
    addOn: calendarIcon && 'calendar',
    autoComplete: 'off',
    type: 'text',
    value: inputValue,
    allowChangeToEmpty: true,
    // first-class props (w/fallbacks):
    className: "".concat(inputFieldProps && inputFieldProps.className),
    disabled: disabled || inputFieldProps && inputFieldProps.disabled,
    isRequired: isRequired || inputFieldProps && inputFieldProps.isRequired,
    label: label || inputFieldProps && inputFieldProps.label,
    onFocus: onFocus,
    onChange: handleInputChange,
    placeholder: placeholder || inputFieldProps && inputFieldProps.placeholder
  });
  var pickerProps = Object.assign({}, datePickerOptions, {
    className: pickerClass,
    month: selectedDay,
    selectedDays: selectedDay,
    onDayClick: handleDayClick
  });
  return React.createElement("div", {
    className: containerClass,
    ref: ref
  }, React.createElement(InputFieldV2, inputProps), showCal && React.createElement(DayPicker, pickerProps));
};

DatePickerInput.propTypes = {
  /** Optional calendar icon withint the field */
  calendarIcon: propTypes.bool,

  /** Classname passed to container, input, and calendar */
  className: propTypes.string,

  /** handler for input change */
  inputOnChange: propTypes.func,

  /** disabled state */
  disabled: propTypes.bool,

  /** function to transform JS Date to desired string (return string) */
  formatDate: propTypes.func.isRequired,

  /** Adds red asterisk to the label */
  isRequired: propTypes.bool,

  /** Input label value */
  label: propTypes.string,

  /** function to validate Date (return boolean) */
  parseDate: propTypes.func.isRequired,

  /** defaulting to '02/18/2023' format */
  placeholder: propTypes.string,

  /** props passed to InputFieldV2 component */
  inputFieldProps: propTypes.shape({
    name: propTypes.string
  }),

  /** props passed through to 'DayPicker' library compenent (https://react-day-picker.js.org/api/DayPicker) */
  datePickerOptions: propTypes.shape({}),

  /** value extracted from input; external value from rff or redux-form */
  value: propTypes.string,
  isFormField: propTypes.bool
};
DatePickerInput.defaultProps = {
  placeholder: 'MM/DD/YYYY',
  calendarIcon: true
};

var DatePickerInputAdapter = function DatePickerInputAdapter(_ref) {
  var inputFieldProps = _ref.inputFieldProps,
      rest = _objectWithoutProperties(_ref, ["inputFieldProps"]);

  var input = inputFieldProps.input,
      meta = inputFieldProps.meta;
  var value = input.value,
      onChange = input.onChange;
  var errorMessage = meta && meta.touched && meta.error ? meta.error : '';

  var newInputProps = _objectSpread({}, inputFieldProps, input, meta, {
    errorMessage: errorMessage
  });

  delete newInputProps.input;
  return React.createElement(DatePickerInput, _extends({
    inputFieldProps: newInputProps,
    value: value,
    inputOnChange: onChange,
    isFormField: true
  }, rest));
};

DatePickerInputAdapter.propTypes = {
  value: propTypes.instanceOf(Date),
  inputFieldProps: propTypes.shape({
    input: propTypes.shape({
      name: propTypes.string.isRequired
    }),
    meta: propTypes.shape({
      touched: propTypes.bool,
      error: propTypes.string
    })
  }),
  datePickerOptions: propTypes.shape({})
};

var VideoModal = function VideoModal(props) {
  var videoId = props.videoId,
      title = props.title,
      className = props.className,
      iFrameOptions = props.iFrameOptions,
      videoHost = props.videoHost;
  var src = videoHost === 'VIMEO' ? "https://player.vimeo.com/video/".concat(videoId, "?autoplay=true") : "https://www.youtube.com/embed/".concat(videoId, "?rel=0&autoplay=true");
  var classes = classnames('zola-ui', className);
  return React.createElement("div", {
    id: "video-modal",
    className: classes
  }, React.createElement("div", {
    className: "modal-header"
  }, title ? React.createElement("h2", {
    className: "h3 modal-title"
  }, title) : null), React.createElement("div", {
    className: "modal-body"
  }, React.createElement("div", {
    className: "embed-responsive embed-responsive-16by9"
  }, React.createElement("iframe", _extends({
    title: title || 'video-iframe',
    src: src
  }, iFrameOptions)))));
};

VideoModal.propTypes = {
  className: propTypes.string,
  videoId: propTypes.string.isRequired,
  title: propTypes.string,
  iFrameOptions: propTypes.shape({}),
  videoHost: propTypes.oneOf(['YOUTUBE', 'VIMEO'])
};
VideoModal.defaultProps = {
  iFrameOptions: {
    allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',
    allowFullScreen: true,
    frameBorder: '0',
    className: 'embed-responsive-item'
  },
  videoHost: 'YOUTUBE'
};

var FAQ = function FAQ(props) {
  var question = props.question,
      answer = props.answer;
  return React.createElement("div", {
    className: "pre-auth__secondary-spacing--above"
  }, React.createElement("h3", {
    className: "pre-auth__h3"
  }, question), React.createElement("p", {
    className: "pre-auth__secondary-body-copy"
  }, answer));
};

FAQ.propTypes = {
  question: propTypes.string.isRequired,
  answer: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired
};
FAQ.defaultProps = {};

var FAQSection = function FAQSection(props) {
  var copy = props.copy,
      heading = props.heading,
      maxHeight = props.maxHeight,
      offset = props.offset;
  var content = [];

  for (var i = 0; i < copy.length; i += 2) {
    content.push(React.createElement("div", {
      className: "row",
      key: "FAQRow".concat(i)
    }, React.createElement("div", {
      className: "col-md-6 col-xs-12 faq-section_left-col"
    }, React.createElement(FAQ, {
      question: copy[i].question,
      answer: copy[i].answer
    })), i + 1 < copy.length ? React.createElement("div", {
      className: "col-md-6 col-xs-12 faq-section_right-col"
    }, React.createElement(FAQ, {
      question: copy[i + 1].question,
      answer: copy[i + 1].answer
    })) : null));
  }

  return React.createElement("div", {
    className: "zola-ui pre-auth__faq-section"
  }, React.createElement("div", {
    className: "pre-auth__page-section"
  }, React.createElement("div", {
    className: "container pre-auth__center-text"
  }, React.createElement(Drawer, {
    maxHeight: maxHeight || '350px',
    offset: offset || 70
  }, React.createElement("h4", {
    className: "pre-auth__h4"
  }, heading || 'A Few Frequently Asked Questions'), React.createElement("div", {
    className: "faq-section_content"
  }, content)))));
};

FAQSection.propTypes = {
  copy: propTypes.arrayOf(propTypes.shape({
    question: propTypes.string,
    answer: propTypes.oneOfType([propTypes.string, propTypes.node])
  })).isRequired,
  heading: propTypes.string,
  maxHeight: propTypes.string,
  offset: propTypes.number
};
FAQSection.defaultProps = {};

var PreAuthCTA = function PreAuthCTA(props) {
  var className = props.className,
      CTACopy = props.CTACopy,
      CTALink = props.CTALink,
      CTAMobileCopy = props.CTAMobileCopy,
      onClick = props.onClick,
      type = props.type,
      CTALinkRel = props.CTALinkRel;
  var classes = classnames('zola-ui', 'pre-auth__cta', className);

  if (type === 'primary') {
    return onClick ? React.createElement(ButtonV2, {
      onClick: onClick,
      className: classnames(classes, 'pre-auth__button')
    }, React.createElement("span", {
      className: "hidden-xs hidden-sm"
    }, CTACopy), React.createElement("span", {
      className: "visible-xs visible-sm"
    }, CTAMobileCopy || CTACopy)) : React.createElement(ButtonV2, {
      component: "a",
      href: CTALink,
      className: classnames(classes, 'pre-auth pre-auth__button'),
      rel: CTALinkRel
    }, React.createElement("span", {
      className: "hidden-xs hidden-sm"
    }, CTACopy), React.createElement("span", {
      className: "visible-xs visible-sm"
    }, CTAMobileCopy || CTACopy));
  }

  return React.createElement("a", {
    href: CTALink,
    className: "".concat(classes, " pre-auth__primary-link"),
    rel: CTALinkRel
  }, React.createElement("span", {
    className: "hidden-xs hidden-sm"
  }, CTACopy), React.createElement("span", {
    className: "visible-xs visible-sm"
  }, CTAMobileCopy || CTACopy));
};

PreAuthCTA.propTypes = {
  className: propTypes.string,
  CTALink: propTypes.string,
  CTALinkRel: propTypes.string,
  CTACopy: propTypes.string.isRequired,
  CTAMobileCopy: propTypes.string,
  onClick: propTypes.func,
  type: propTypes.oneOf(['primary', 'secondary']).isRequired
};

var Step = function Step(props) {
  var number = props.number,
      header = props.header,
      body = props.body;
  return React.createElement("li", {
    className: "row pre-auth__secondary-spacing--above"
  }, React.createElement("div", {
    className: "col-sm-2 col-md-1 col-xs-2"
  }, React.createElement("span", {
    className: "how-it-works__index"
  }, number)), React.createElement("div", {
    className: "col-sm-10 col-md-11 col-xs-10"
  }, React.createElement("h3", {
    className: "pre-auth__h3"
  }, header), React.createElement("p", {
    className: "pre-auth__secondary-body-copy"
  }, body)));
};

Step.propTypes = {
  number: propTypes.number.isRequired,
  header: propTypes.string.isRequired,
  body: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired
};
Step.defaultProps = {};

var HowItWorksSection = function HowItWorksSection(props) {
  var className = props.className,
      heading = props.heading,
      headingMobile = props.headingMobile,
      ctaCopy = props.ctaCopy,
      ctaCopyMobile = props.ctaCopyMobile,
      ctaLink = props.ctaLink,
      copy = props.copy,
      ctaOnClick = props.ctaOnClick,
      imageClickFn = props.imageClickFn;
  var classes = classnames('zola-ui', 'pre-auth__how-it-works-section', className);
  var stepEls = [];

  for (var i = 0; i < copy.length; i += 1) {
    stepEls.push(React.createElement(Step, {
      number: i + 1,
      header: copy[i].header,
      body: copy[i].body,
      key: "step-".concat(i + 1)
    }));
  }

  return React.createElement("div", {
    className: classes
  }, React.createElement("div", {
    className: "pre-auth__page-section"
  }, React.createElement("div", {
    className: "container"
  }, React.createElement("h2", {
    className: "pre-auth__h2 visible-xs"
  }, headingMobile || heading), React.createElement("div", {
    className: "row visible-xs"
  }, React.createElement("div", {
    className: "col-xs-12"
  }, React.createElement("div", {
    className: "how-it-works__image-wrapper"
  }, imageClickFn ? React.createElement("button", {
    type: "button",
    "aria-label": "How It Works Video",
    className: "how-it-works__image image-clickable__modal btn-link",
    onClick: function onClick() {
      imageClickFn();
    }
  }, React.createElement("span", {
    "aria-hidden": "true",
    className: "image-clickable__modal-icon zola-ui-icon zola-ui-icon-play"
  })) : React.createElement("div", {
    className: "how-it-works__image"
  })))), React.createElement("div", {
    className: "row how-it-works-section__row"
  }, React.createElement("div", {
    className: "how-it-works-section__step-container col-sm-6 col-xs-12"
  }, React.createElement("h2", {
    className: "pre-auth__h2 col-md-offset-1 hidden-xs"
  }, heading), React.createElement("ul", {
    className: "pre-auth__ul"
  }, stepEls), ctaCopy ? React.createElement("div", {
    className: "pre-auth__primary-spacing--above"
  }, React.createElement(PreAuthCTA, {
    onClick: ctaOnClick,
    CTACopy: ctaCopy,
    CTALink: ctaLink,
    type: "primary",
    className: "col-md-offset-1 hidden-xs hidden-sm"
  }), React.createElement(PreAuthCTA, {
    onClick: ctaOnClick,
    CTACopy: ctaCopy,
    CTAMobileCopy: ctaCopyMobile,
    CTALink: ctaLink,
    type: "primary",
    className: "col-sm-offset-2 visible-xs visible-sm"
  })) : null), React.createElement("div", {
    className: "col-sm-6 how-it-works-section__image-col hidden-xs"
  }, React.createElement("div", {
    className: "how-it-works__image-wrapper"
  }, imageClickFn ? React.createElement("button", {
    type: "button",
    "aria-label": "How It Works Video",
    className: "how-it-works__image image-clickable__modal btn-link",
    onClick: function onClick() {
      imageClickFn();
    }
  }, React.createElement("span", {
    "aria-hidden": "true",
    className: "image-clickable__modal-icon zola-ui-icon zola-ui-icon-play"
  })) : React.createElement("div", {
    className: "how-it-works__image"
  })))))));
};

HowItWorksSection.propTypes = {
  className: propTypes.string,
  copy: propTypes.arrayOf(propTypes.shape({
    header: propTypes.string,
    body: propTypes.oneOfType([propTypes.string, propTypes.node])
  })).isRequired,
  heading: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired,
  headingMobile: propTypes.string,
  ctaCopy: propTypes.string,
  ctaCopyMobile: propTypes.string,
  ctaLink: propTypes.string,
  ctaOnClick: propTypes.func,
  imageClickFn: propTypes.func
};
HowItWorksSection.defaultProps = {};

var ImageTile = function ImageTile(props) {
  var className = props.className,
      heading = props.heading,
      imgAlt = props.imgAlt,
      imgSrc = props.imgSrc,
      link = props.link;
  var classes = classnames('zola-ui', 'pre-auth__image-tile', className);
  return React.createElement("div", {
    className: classes
  }, React.createElement("a", {
    href: link
  }, React.createElement("div", {
    className: "image-tile__image-container"
  }, React.createElement("img", {
    src: imgSrc,
    alt: imgAlt,
    className: "image-tile__image"
  })), React.createElement("div", {
    className: "image-tile__heading pre-auth__secondary-body-copy"
  }, heading)));
};

ImageTile.propTypes = {
  className: propTypes.string,
  heading: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired,
  imgAlt: propTypes.string,
  imgSrc: propTypes.string,
  link: propTypes.string.isRequired
};

var ImageBgSection = function ImageBgSection(props) {
  var body = props.body,
      className = props.className,
      CTACopy = props.CTACopy,
      CTALink = props.CTALink,
      CTACopyMobile = props.CTACopyMobile,
      heading = props.heading,
      onClick = props.onClick,
      overlayContent = props.overlayContent,
      secondaryCTACopy = props.secondaryCTACopy,
      secondaryCTALink = props.secondaryCTALink,
      offset = props.offset,
      adjustedOffset = props.adjustedOffset;
  var classes = classnames('zola-ui', 'pre-auth-lp__image-bg-section', className);
  var columnClasses = classnames('col-xs-12', adjustedOffset ? 'col-sm-5 col-sm-offset-7' : 'col-sm-6', offset ? 'col-sm-offset-6' : '');
  return React.createElement("div", {
    className: classes
  }, React.createElement("div", {
    className: "pre-auth-lp__mobile-image visible-xs"
  }), React.createElement("div", {
    className: "pre-auth__page-section pre-auth-lp__bg-image"
  }, React.createElement("div", {
    className: "container"
  }, React.createElement("div", {
    className: "row"
  }, React.createElement("div", {
    className: columnClasses
  }, React.createElement("h2", {
    className: "pre-auth__h2"
  }, heading), React.createElement("div", {
    className: "pre-auth__primary-body-copy"
  }, body), React.createElement("div", {
    className: "pre-auth__ctas"
  }, React.createElement(PreAuthCTA, {
    CTACopy: CTACopy,
    CTACopyMobile: CTACopyMobile,
    CTALink: CTALink,
    onClick: onClick,
    type: "primary"
  }), secondaryCTACopy ? React.createElement("div", {
    className: "pre-auth__secondary-cta"
  }, React.createElement(PreAuthCTA, {
    CTACopy: secondaryCTACopy,
    CTALink: secondaryCTALink,
    type: "secondary"
  })) : null))), overlayContent ? React.createElement("div", {
    className: "pre-auth__overlay-content"
  }, overlayContent) : null)));
};

ImageBgSection.propTypes = {
  heading: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired,
  body: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired,
  CTACopy: propTypes.string,
  CTACopyMobile: propTypes.string,
  CTALink: propTypes.string,
  onClick: propTypes.oneOfType([propTypes.func, propTypes.string]),
  secondaryCTACopy: propTypes.string,
  secondaryCTALink: propTypes.string,
  offset: propTypes.bool,
  adjustedOffset: propTypes.bool,
  overlayContent: propTypes.oneOfType([propTypes.string, propTypes.node]),
  className: propTypes.string
};
ImageBgSection.defaultProps = {
  offset: false,
  adjustedOffset: false,
  overlayContent: null
};

var ImageWithTextSection = function ImageWithTextSection(props) {
  var className = props.className,
      CTACopy = props.CTACopy,
      CTALink = props.CTALink,
      CTAMobileCopy = props.CTAMobileCopy,
      CTAType = props.CTAType,
      heading = props.heading,
      dek = props.dek,
      offset = props.offset,
      onClick = props.onClick,
      overlayImg = props.overlayImg,
      secondaryCTACopy = props.secondaryCTACopy,
      secondaryCTALink = props.secondaryCTALink;
  var classes = classnames('zola-ui', 'pre-auth__image-with-text-section', className);
  var overlays = [];

  for (var i = 0; i < overlayImg; i += 1) {
    var identifier = "overlay-image-".concat(i + 1);
    overlays.push(React.createElement("div", {
      className: "pre-auth__overlay-image ".concat(identifier),
      key: identifier
    }));
  }

  return React.createElement("div", {
    className: classes
  }, React.createElement("div", {
    className: "pre-auth__page-section"
  }, React.createElement("div", {
    className: "container"
  }, React.createElement("div", {
    className: "row"
  }, React.createElement("div", {
    className: offset ? 'col-sm-6 col-xs-12 pull-right' : 'col-sm-6 col-xs-12'
  }, React.createElement("div", {
    className: "pre-auth__image-with-text-section__image-wrapper"
  }, React.createElement("div", {
    className: "pre-auth__image-with-text-section__image"
  }), overlays.length > 0 ? overlays : null)), React.createElement("div", {
    className: "col-sm-6 col-xs-12 pre-auth__image-with-text-section__copy-container"
  }, React.createElement("div", {
    className: "pre-auth__image-with-text-section__copy"
  }, React.createElement("h2", {
    className: "pre-auth__h2"
  }, heading), React.createElement("div", {
    className: "pre-auth__primary-body-copy"
  }, dek), React.createElement("div", {
    className: "pre-auth__ctas-container"
  }, React.createElement("div", {
    className: "pre-auth__ctas"
  }, React.createElement(PreAuthCTA, {
    CTACopy: CTACopy,
    CTALink: CTALink,
    CTAMobileCopy: CTAMobileCopy,
    onClick: onClick,
    type: CTAType
  }), secondaryCTACopy ? React.createElement("div", {
    className: "pre-auth__secondary-cta"
  }, React.createElement(PreAuthCTA, {
    CTACopy: secondaryCTACopy,
    CTALink: secondaryCTALink,
    type: "secondary"
  })) : null))))))));
};

ImageWithTextSection.propTypes = {
  className: propTypes.string,
  CTACopy: propTypes.string,
  CTALink: propTypes.string,
  CTAMobileCopy: propTypes.string,
  secondaryCTACopy: propTypes.string,
  secondaryCTALink: propTypes.string,
  CTAType: propTypes.oneOf(['primary', 'secondary']).isRequired,
  heading: propTypes.oneOfType([propTypes.string, propTypes.node]),
  dek: propTypes.oneOfType([propTypes.string, propTypes.node]),
  offset: propTypes.bool,
  onClick: propTypes.oneOfType([propTypes.func, propTypes.string]).isRequired,
  overlayImg: propTypes.number
};
ImageWithTextSection.defaultProps = {};

var Porthole = function Porthole(props) {
  var alt = props.alt,
      className = props.className,
      src = props.src;
  var classes = classnames('zola-ui', 'pre-auth-porthole-image', className);
  return React.createElement("div", {
    className: classes
  }, React.createElement("div", {
    className: "porthole-img__container"
  }, React.createElement("img", {
    src: src || null,
    alt: alt || '',
    className: "porthole-img"
  })));
};

Porthole.propTypes = {
  className: propTypes.string,
  alt: propTypes.string,
  src: propTypes.string.isRequired
};

var InfoTile = function InfoTile(props) {
  var className = props.className,
      heading = props.heading,
      dek = props.dek,
      imgAlt = props.imgAlt,
      imgSrc = props.imgSrc,
      href = props.href,
      clickEventHandler = props.onClick;
  var classes = classnames('zola-ui', 'pre-auth-info-tile', className);

  var handleTileClick = function handleTileClick(e) {
    // if event handler is provided, pass the event object to the handler
    if (clickEventHandler) {
      clickEventHandler(e);
    } // if href is provided, redirect by default


    if (href) {
      window.location.href = href;
    }
  };

  return React.createElement("div", {
    className: classes,
    onClick: handleTileClick
  }, imgSrc ? React.createElement(Porthole, {
    src: imgSrc,
    alt: imgAlt
  }) : null, React.createElement("h3", {
    className: "info-tile__heading pre-auth__h3"
  }, heading), React.createElement("div", {
    className: "info-tile__dek pre-auth__secondary-body-copy"
  }, dek));
};

InfoTile.propTypes = {
  className: propTypes.string,

  /** Header of the tile */
  heading: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired,
  dek: propTypes.oneOfType([propTypes.string, propTypes.node]),

  /** Icon Description */
  imgAlt: propTypes.string,

  /** Icon Source */
  imgSrc: propTypes.string,

  /** href for the link. Triggered by click */
  href: propTypes.string,

  /** click event callback that. event object will be passed in as parameter */
  onClick: propTypes.func
};

var InfoTileV2 = function InfoTileV2(_ref) {
  var className = _ref.className,
      heading = _ref.heading,
      dek = _ref.dek,
      imgAlt = _ref.imgAlt,
      imgSrc = _ref.imgSrc,
      ctaLink = _ref.ctaLink,
      _ref$ctaCopy = _ref.ctaCopy,
      ctaCopy = _ref$ctaCopy === void 0 ? 'Read more' : _ref$ctaCopy,
      ctaTarget = _ref.ctaTarget,
      ctaRel = _ref.ctaRel,
      hideDek = _ref.hideDek,
      handleCtaLinkClick = _ref.handleCtaLinkClick,
      displayAsColumn = _ref.displayAsColumn,
      moreSpace = _ref.moreSpace,
      href = _ref.href;
  var classes = classnames('zola-ui', 'info-tile', {
    'info-tile--column': displayAsColumn
  }, {
    'info-tile--moreSpace': moreSpace
  }, {
    'info-tile--pointer': href
  }, className);

  var renderCtaLink = function renderCtaLink() {
    if (!ctaLink) return null;
    if (typeof ctaLink === 'string') return React.createElement("a", {
      className: "info-tile__cta info-tile__cta--link",
      href: ctaLink,
      onClick: handleCtaLinkClick,
      target: ctaTarget,
      rel: ctaRel
    }, ctaCopy);
    return React.createElement("div", {
      className: "info-tile__cta"
    }, ctaLink);
  };

  var handleTileOnClick = function handleTileOnClick() {
    if (href) window.location.href = href;
  };

  return React.createElement("div", {
    className: classes,
    onClick: handleTileOnClick
  }, imgSrc && React.createElement(Porthole, {
    className: "info-tile__image info-tile__image--v2",
    src: imgSrc,
    alt: imgAlt
  }), React.createElement("div", {
    className: "info-tile__content"
  }, heading && React.createElement("h3", {
    className: "info-tile__heading"
  }, heading), dek && !hideDek && React.createElement("div", {
    className: "info-tile__dek"
  }, dek), renderCtaLink()));
};

InfoTileV2.propTypes = {
  className: propTypes.string,
  heading: propTypes.oneOfType([propTypes.string, propTypes.node]),
  dek: propTypes.oneOfType([propTypes.string, propTypes.node]),
  imgAlt: propTypes.string,
  imgSrc: propTypes.string,
  hideDek: propTypes.bool,
  ctaLink: propTypes.oneOfType([propTypes.string, propTypes.node]),
  ctaCopy: propTypes.string,
  ctaTarget: propTypes.string,
  ctaRel: propTypes.string,
  handleCtaLinkClick: propTypes.func,
  displayAsColumn: propTypes.bool,
  moreSpace: propTypes.bool,
  href: propTypes.string
};

var InfoTilesSection = function InfoTilesSection(_ref) {
  var title = _ref.title,
      dek = _ref.dek,
      tiles = _ref.tiles,
      className = _ref.className,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'white' : _ref$backgroundColor,
      twoColumn = _ref.twoColumn;
  var classNames = classnames('info-tiles-section', "info-tiles-section--".concat(backgroundColor), {
    'info-tiles-section--twoColumn': twoColumn
  }, className);
  return React.createElement("div", {
    className: classNames
  }, typeof title === 'string' ? React.createElement("h2", {
    className: "info-tiles-section__title zui__h2"
  }, title) : React.createElement(React.Fragment, null, title), dek && React.createElement("p", {
    className: "info-tiles-section__dek"
  }, dek), React.createElement("div", {
    className: "info-tiles-section__tiles"
  }, tiles.map(function (tile, i) {
    return React.createElement("div", {
      className: "info-tiles-section__tile",
      key: i
    }, tile);
  })));
};

InfoTilesSection.propTypes = {
  title: propTypes.oneOfType([propTypes.string, propTypes.element]),
  tiles: propTypes.arrayOf(propTypes.node).isRequired,
  dek: propTypes.string,
  className: propTypes.string,
  twoColumn: propTypes.bool,
  backgroundColor: propTypes.oneOf(['white', 'rose', 'secondary-background-gray', 'light-periwinkle', 'highlight-blue']) // these correspond to var names in src/styles/common/_variables.less

};

var CTAV2 = function CTAV2(_ref) {
  var _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'a' : _ref$component,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'blue' : _ref$color,
      children = _ref.children,
      _ref$arrow = _ref.arrow,
      arrow = _ref$arrow === void 0 ? true : _ref$arrow,
      _ref$larger = _ref.larger,
      larger = _ref$larger === void 0 ? false : _ref$larger,
      _ref$bold = _ref.bold,
      bold = _ref$bold === void 0 ? false : _ref$bold,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["component", "color", "children", "arrow", "larger", "bold", "className"]);

  var classes = classnames('cta-v2', {
    'cta-v2--larger': larger
  }, {
    'cta-v2--blue': color === 'blue'
  }, {
    'cta-v2--white': color === 'white'
  }, {
    'cta-v2--with-arrow': arrow
  }, {
    'cta-v2--bold': bold
  }, className);
  return React.createElement(Component, _extends({
    className: classes
  }, props), children);
};

CTAV2.propTypes = {
  component: propTypes.oneOf(['a', 'button']),
  color: propTypes.oneOf(['blue', 'teal', 'white']),
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  arrow: propTypes.bool,
  larger: propTypes.bool,
  bold: propTypes.bool,
  className: propTypes.string
};

var event = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.on = on;
exports.off = off;
function on(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.addEventListener) {
    el.addEventListener(eventName, callback, opts);
  } else if (el.attachEvent) {
    el.attachEvent("on" + eventName, function (e) {
      callback.call(el, e || window.event);
    });
  }
}

function off(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.removeEventListener) {
    el.removeEventListener(eventName, callback, opts);
  } else if (el.detachEvent) {
    el.detachEvent("on" + eventName, callback);
  }
}
});

unwrapExports(event);
var event_1 = event.on;
var event_2 = event.off;

var scrollParent = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * @fileOverview Find scroll parent
 */

exports.default = function (node) {
  if (!node) {
    return document.documentElement;
  }

  var excludeStaticParent = node.style.position === 'absolute';
  var overflowRegex = /(scroll|auto)/;
  var parent = node;

  while (parent) {
    if (!parent.parentNode) {
      return node.ownerDocument || document.documentElement;
    }

    var style = window.getComputedStyle(parent);
    var position = style.position;
    var overflow = style.overflow;
    var overflowX = style['overflow-x'];
    var overflowY = style['overflow-y'];

    if (position === 'static' && excludeStaticParent) {
      parent = parent.parentNode;
      continue;
    }

    if (overflowRegex.test(overflow) && overflowRegex.test(overflowX) && overflowRegex.test(overflowY)) {
      return parent;
    }

    parent = parent.parentNode;
  }

  return node.ownerDocument || node.documentElement || document.documentElement;
};
});

unwrapExports(scrollParent);

var debounce_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = debounce;
function debounce(func, wait, immediate) {
  var timeout = void 0;
  var args = void 0;
  var context = void 0;
  var timestamp = void 0;
  var result = void 0;

  var later = function later() {
    var last = +new Date() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) {
          context = null;
          args = null;
        }
      }
    }
  };

  return function debounced() {
    context = this;
    args = arguments;
    timestamp = +new Date();

    var callNow = immediate && !timeout;
    if (!timeout) {
      timeout = setTimeout(later, wait);
    }

    if (callNow) {
      result = func.apply(context, args);
      context = null;
      args = null;
    }

    return result;
  };
}
});

unwrapExports(debounce_1);

var throttle_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = throttle;
/*eslint-disable */
function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last, deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date(),
        args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}
});

unwrapExports(throttle_1);

var decorator = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _index2 = _interopRequireDefault(lib$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

exports.default = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function lazyload(WrappedComponent) {
    return function (_Component) {
      _inherits(LazyLoadDecorated, _Component);

      function LazyLoadDecorated() {
        _classCallCheck(this, LazyLoadDecorated);

        var _this = _possibleConstructorReturn(this, (LazyLoadDecorated.__proto__ || Object.getPrototypeOf(LazyLoadDecorated)).call(this));

        _this.displayName = 'LazyLoad' + getDisplayName(WrappedComponent);
        return _this;
      }

      _createClass(LazyLoadDecorated, [{
        key: 'render',
        value: function render() {
          return _react2.default.createElement(
            _index2.default,
            options,
            _react2.default.createElement(WrappedComponent, this.props)
          );
        }
      }]);

      return LazyLoadDecorated;
    }(React.Component);
  };
};
});

unwrapExports(decorator);

var lib$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forceCheck = exports.lazyload = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _reactDom2 = _interopRequireDefault(ReactDOM);



var _propTypes2 = _interopRequireDefault(propTypes);





var _scrollParent2 = _interopRequireDefault(scrollParent);



var _debounce2 = _interopRequireDefault(debounce_1);



var _throttle2 = _interopRequireDefault(throttle_1);



var _decorator2 = _interopRequireDefault(decorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * react-lazyload
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var defaultBoundingClientRect = { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
var LISTEN_FLAG = 'data-lazyload-listened';
var listeners = [];
var pending = [];

// try to handle passive events
var passiveEventSupported = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      passiveEventSupported = true;
    }
  });
  window.addEventListener('test', null, opts);
} catch (e) {}
// if they are supported, setup the optional params
// IMPORTANT: FALSE doubles as the default CAPTURE value!
var passiveEvent = passiveEventSupported ? { capture: false, passive: true } : false;

/**
 * Check if `component` is visible in overflow container `parent`
 * @param  {node} component React component
 * @param  {node} parent    component's scroll parent
 * @return {bool}
 */
var checkOverflowVisible = function checkOverflowVisible(component, parent) {
  var node = _reactDom2.default.findDOMNode(component);

  var parentTop = void 0;
  var parentHeight = void 0;

  try {
    var _parent$getBoundingCl = parent.getBoundingClientRect();

    parentTop = _parent$getBoundingCl.top;
    parentHeight = _parent$getBoundingCl.height;
  } catch (e) {
    parentTop = defaultBoundingClientRect.top;
    parentHeight = defaultBoundingClientRect.height;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;

  // calculate top and height of the intersection of the element's scrollParent and viewport
  var intersectionTop = Math.max(parentTop, 0); // intersection's top relative to viewport
  var intersectionHeight = Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop; // height

  // check whether the element is visible in the intersection
  var top = void 0;
  var height = void 0;

  try {
    var _node$getBoundingClie = node.getBoundingClientRect();

    top = _node$getBoundingClie.top;
    height = _node$getBoundingClie.height;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    height = defaultBoundingClientRect.height;
  }

  var offsetTop = top - intersectionTop; // element's top relative to intersection

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return offsetTop - offsets[0] <= intersectionHeight && offsetTop + height + offsets[1] >= 0;
};

/**
 * Check if `component` is visible in document
 * @param  {node} component React component
 * @return {bool}
 */
var checkNormalVisible = function checkNormalVisible(component) {
  var node = _reactDom2.default.findDOMNode(component);

  // If this element is hidden by css rules somehow, it's definitely invisible
  if (!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)) return false;

  var top = void 0;
  var elementHeight = void 0;

  try {
    var _node$getBoundingClie2 = node.getBoundingClientRect();

    top = _node$getBoundingClie2.top;
    elementHeight = _node$getBoundingClie2.height;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    elementHeight = defaultBoundingClientRect.height;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return top - offsets[0] <= windowInnerHeight && top + elementHeight + offsets[1] >= 0;
};

/**
 * Detect if element is visible in viewport, if so, set `visible` state to true.
 * If `once` prop is provided true, remove component as listener after checkVisible
 *
 * @param  {React} component   React component that respond to scroll and resize
 */
var checkVisible = function checkVisible(component) {
  var node = _reactDom2.default.findDOMNode(component);
  if (!node) {
    return;
  }

  var parent = (0, _scrollParent2.default)(node);
  var isOverflow = component.props.overflow && parent !== node.ownerDocument && parent !== document && parent !== document.documentElement;
  var visible = isOverflow ? checkOverflowVisible(component, parent) : checkNormalVisible(component);
  if (visible) {
    // Avoid extra render if previously is visible
    if (!component.visible) {
      if (component.props.once) {
        pending.push(component);
      }

      component.visible = true;
      component.forceUpdate();
    }
  } else if (!(component.props.once && component.visible)) {
    component.visible = false;
    if (component.props.unmountIfInvisible) {
      component.forceUpdate();
    }
  }
};

var purgePending = function purgePending() {
  pending.forEach(function (component) {
    var index = listeners.indexOf(component);
    if (index !== -1) {
      listeners.splice(index, 1);
    }
  });

  pending = [];
};

var lazyLoadHandler = function lazyLoadHandler() {
  for (var i = 0; i < listeners.length; ++i) {
    var listener = listeners[i];
    checkVisible(listener);
  }
  // Remove `once` component in listeners
  purgePending();
};

// Depending on component's props
var delayType = void 0;
var finalLazyLoadHandler = null;

var LazyLoad = function (_Component) {
  _inherits(LazyLoad, _Component);

  function LazyLoad(props) {
    _classCallCheck(this, LazyLoad);

    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));

    _this.visible = false;
    return _this;
  }

  _createClass(LazyLoad, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (typeof process !== 'undefined' && "development" !== 'production') {
        if (_react2.default.Children.count(this.props.children) > 1) {
          console.warn('[react-lazyload] Only one child is allowed to be passed to `LazyLoad`.');
        }

        if (this.props.wheel) {
          // eslint-disable-line
          console.warn('[react-lazyload] Props `wheel` is not supported anymore, try set `overflow` for lazy loading in overflow containers.');
        }

        // Warn the user if placeholder and height is not specified and the rendered height is 0
        if (!this.props.placeholder && this.props.height === undefined && _reactDom2.default.findDOMNode(this).offsetHeight === 0) {
          console.warn('[react-lazyload] Please add `height` props to <LazyLoad> for better performance.');
        }
      }

      // It's unlikely to change delay type on the fly, this is mainly
      // designed for tests
      var needResetFinalLazyLoadHandler = false;
      if (this.props.debounce !== undefined && delayType === 'throttle') {
        console.warn('[react-lazyload] Previous delay function is `throttle`, now switching to `debounce`, try setting them unanimously');
        needResetFinalLazyLoadHandler = true;
      } else if (delayType === 'debounce' && this.props.debounce === undefined) {
        console.warn('[react-lazyload] Previous delay function is `debounce`, now switching to `throttle`, try setting them unanimously');
        needResetFinalLazyLoadHandler = true;
      }

      if (needResetFinalLazyLoadHandler) {
        (0, event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
        (0, event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        finalLazyLoadHandler = null;
      }

      if (!finalLazyLoadHandler) {
        if (this.props.debounce !== undefined) {
          finalLazyLoadHandler = (0, _debounce2.default)(lazyLoadHandler, typeof this.props.debounce === 'number' ? this.props.debounce : 300);
          delayType = 'debounce';
        } else if (this.props.throttle !== undefined) {
          finalLazyLoadHandler = (0, _throttle2.default)(lazyLoadHandler, typeof this.props.throttle === 'number' ? this.props.throttle : 300);
          delayType = 'throttle';
        } else {
          finalLazyLoadHandler = lazyLoadHandler;
        }
      }

      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = 1 + +parent.getAttribute(LISTEN_FLAG);
          if (listenerCount === 1) {
            parent.addEventListener('scroll', finalLazyLoadHandler, passiveEvent);
          }
          parent.setAttribute(LISTEN_FLAG, listenerCount);
        }
      } else if (listeners.length === 0 || needResetFinalLazyLoadHandler) {
        var _props = this.props,
            scroll = _props.scroll,
            resize = _props.resize;


        if (scroll) {
          (0, event.on)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
        }

        if (resize) {
          (0, event.on)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        }
      }

      listeners.push(this);
      checkVisible(this);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return this.visible;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = +parent.getAttribute(LISTEN_FLAG) - 1;
          if (listenerCount === 0) {
            parent.removeEventListener('scroll', finalLazyLoadHandler, passiveEvent);
            parent.removeAttribute(LISTEN_FLAG);
          } else {
            parent.setAttribute(LISTEN_FLAG, listenerCount);
          }
        }
      }

      var index = listeners.indexOf(this);
      if (index !== -1) {
        listeners.splice(index, 1);
      }

      if (listeners.length === 0) {
        (0, event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        (0, event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.visible ? this.props.children : this.props.placeholder ? this.props.placeholder : _react2.default.createElement('div', { style: { height: this.props.height }, className: 'lazyload-placeholder' });
    }
  }]);

  return LazyLoad;
}(React.Component);

LazyLoad.propTypes = {
  once: _propTypes2.default.bool,
  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
  overflow: _propTypes2.default.bool,
  resize: _propTypes2.default.bool,
  scroll: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  throttle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  debounce: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  placeholder: _propTypes2.default.node,
  unmountIfInvisible: _propTypes2.default.bool
};

LazyLoad.defaultProps = {
  once: false,
  offset: 0,
  overflow: false,
  resize: false,
  scroll: true,
  unmountIfInvisible: false
};

var lazyload = exports.lazyload = _decorator2.default;
exports.default = LazyLoad;
exports.forceCheck = lazyLoadHandler;
});

var LazyLoad = unwrapExports(lib$1);
var lib_1 = lib$1.forceCheck;
var lib_2 = lib$1.lazyload;

var FooterArrow = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNTBweCIgaGVpZ2h0PSI2OHB4IiB2aWV3Qm94PSIwIDAgNTAgNjgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUyLjUgKDY3NDY5KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5Hcm91cCA1PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIj4KICAgICAgICA8ZyBpZD0iV2Vic2l0ZS1MYW5kaW5nIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtODA0LjAwMDAwMCwgLTUxMTguMDAwMDAwKSIgc3Ryb2tlPSIjMDAzQzU3IiBzdHJva2Utd2lkdGg9IjIiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAtNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoODMwLjc3Mzg0MSwgNTE1Mi45NDEyMzUpIHNjYWxlKC0xLCAxKSByb3RhdGUoLTEwLjAwMDAwMCkgdHJhbnNsYXRlKC04MzAuNzczODQxLCAtNTE1Mi45NDEyMzUpIHRyYW5zbGF0ZSg4MTAuNzczODQxLCA1MTE3Ljk0MTIzNSkiPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTExLjc5NTg2OTMsLTEuMDkxMzkzNjRlLTExIEMxMS43OTU4NjkzLC0xLjA5MTM5MzY0ZS0xMSAtMS42NzkzNTU5NCwxMy4wODUyNDI2IDAuMTc1MjcyNTA2LDMxLjk5OTEyODIgQzEuNzA5NDc2ODgsNDcuNjQyMTM5MSAxNC45ODc5Miw1OC45MDUzODU5IDMyLDY0IiBpZD0iU3Ryb2tlLTEiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0yNyw2OC4zNzQxODIxIEMyNyw2OC4zNzQxODIxIDU0LjY4Njk3NSw3Ny42MjM0NDkzIDI5LjI0OTcyLDUyIiBpZD0iU3Ryb2tlLTMiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+";

var PreAuthFooter = function PreAuthFooter(props) {
  var iconSrc = props.iconSrc,
      ctaLink = props.ctaLink,
      ctaCopy = props.ctaCopy,
      message = props.message,
      messageMobile = props.messageMobile,
      ctaOnClick = props.ctaOnClick;
  return React.createElement("div", {
    className: "zola-ui pre-auth__footer-section"
  }, React.createElement("div", {
    className: "pre-auth__page-section pre-auth__bg--periwinkle"
  }, React.createElement("div", {
    className: "container pre-auth__center-text"
  }, React.createElement("div", {
    className: "pre-auth__script-header-container"
  }, React.createElement("h2", {
    className: "pre-auth__h2"
  }, React.createElement("span", {
    className: "hidden-xs"
  }, message), React.createElement("span", {
    className: "visible-xs"
  }, messageMobile || message), React.createElement("img", {
    src: FooterArrow,
    alt: "",
    className: "footer-arrow hidden-xs"
  }))), React.createElement(PreAuthCTA, {
    onClick: ctaOnClick,
    CTACopy: ctaCopy,
    CTALink: ctaLink,
    type: "primary"
  }), React.createElement(LazyLoad, {
    offset: 100,
    once: true
  }, React.createElement("img", {
    src: iconSrc,
    alt: "",
    className: "footer-gift"
  })))));
};

PreAuthFooter.propTypes = {
  iconSrc: propTypes.string.isRequired,
  ctaLink: propTypes.string,
  ctaOnClick: propTypes.func,
  ctaCopy: propTypes.string.isRequired,
  message: propTypes.string,
  messageMobile: propTypes.string
};
PreAuthFooter.defaultProps = {
  message: 'Ready When You Are'
};

var PreAuthHero =
/*#__PURE__*/
function (_Component) {
  _inherits(PreAuthHero, _Component);

  function PreAuthHero(props) {
    var _this;

    _classCallCheck(this, PreAuthHero);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PreAuthHero).call(this, props));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PreAuthHero, [{
    key: "handleClick",
    value: function handleClick(e) {
      var offset = this.props.offset;
      var sectionId = 'first-section';
      e.preventDefault();
      scrollViewTo({
        id: sectionId,
        offset: offset || 45,
        behavior: 'smooth'
      });
      var focusSection = document.getElementById(sectionId);

      if (focusSection) {
        focusSection.focus();
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          heading = _this$props.heading,
          primaryCTACopy = _this$props.primaryCTACopy,
          primaryCTALink = _this$props.primaryCTALink,
          primaryCTALinkRel = _this$props.primaryCTALinkRel,
          secondaryCTACopy = _this$props.secondaryCTACopy,
          secondaryCTALink = _this$props.secondaryCTALink,
          secondaryCTALinkRel = _this$props.secondaryCTALinkRel,
          copy = _this$props.copy,
          primaryCTAOnClick = _this$props.primaryCTAOnClick,
          mobilePrimaryCTALink = _this$props.mobilePrimaryCTALink,
          mobilePrimaryCTACopy = _this$props.mobilePrimaryCTACopy,
          mobilePrimaryCTAOnClick = _this$props.mobilePrimaryCTAOnClick,
          className = _this$props.className;
      return React.createElement("div", {
        className: classnames('zola-ui', 'pre-auth__hero', className)
      }, React.createElement(LazyLoad, {
        height: "100%",
        offset: 100,
        once: true
      }, React.createElement("div", {
        className: "hero__image"
      }, React.createElement("div", {
        className: "hero__content-container container"
      }, React.createElement("h1", {
        className: "zui__h1"
      }, heading), copy && copy.length > 0 ? React.createElement("ul", {
        className: "pre-auth__primary-body-copy"
      }, React.createElement("li", null, React.createElement("span", {
        className: "list-item__bullet zola-ui-icon zola-ui-icon-checkmark",
        "aria-hidden": "true"
      }), copy[0]), React.createElement("li", null, React.createElement("span", {
        className: "list-item__bullet zola-ui-icon zola-ui-icon-checkmark",
        "aria-hidden": "true"
      }), copy[1]), React.createElement("li", null, React.createElement("span", {
        className: "list-item__bullet zola-ui-icon zola-ui-icon-checkmark",
        "aria-hidden": "true"
      }), copy[2])) : null, React.createElement("div", {
        className: "hero__ctas"
      }, primaryCTACopy ? React.createElement(PreAuthCTA, {
        onClick: primaryCTAOnClick,
        CTACopy: primaryCTACopy,
        CTALink: primaryCTALink,
        CTALinkRel: primaryCTALinkRel,
        type: "primary",
        className: "hidden-xs"
      }) : null, primaryCTACopy ? React.createElement(PreAuthCTA, {
        onClick: mobilePrimaryCTAOnClick || primaryCTAOnClick,
        CTACopy: mobilePrimaryCTACopy || primaryCTACopy,
        CTALink: mobilePrimaryCTALink || primaryCTALink,
        CTALinkRel: primaryCTALinkRel,
        type: "primary",
        className: "visible-xs"
      }) : null, secondaryCTACopy ? React.createElement("div", {
        className: "hero__secondary-cta"
      }, React.createElement(PreAuthCTA, {
        CTACopy: secondaryCTACopy,
        CTALink: secondaryCTALink,
        CTALinkRel: secondaryCTALinkRel,
        type: "secondary"
      })) : null)), React.createElement("div", {
        className: "hero__button-container hidden-sm hidden-xs"
      }, React.createElement(ChevronButton, {
        direction: "down",
        btnStyle: "secondary",
        onClick: this.handleClick,
        anchor: "first-section",
        ariaLabel: "Navigate to Next Section"
      })))));
    }
  }]);

  return PreAuthHero;
}(Component);

PreAuthHero.propTypes = {
  heading: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired,
  copy: propTypes.arrayOf(propTypes.oneOfType([propTypes.string, propTypes.node])),
  primaryCTALink: propTypes.string,
  primaryCTACopy: propTypes.string.isRequired,
  primaryCTAOnClick: propTypes.func,
  primaryCTALinkRel: propTypes.string,
  mobilePrimaryCTALink: propTypes.string,
  mobilePrimaryCTACopy: propTypes.string,
  mobilePrimaryCTAOnClick: propTypes.func,
  secondaryCTALink: propTypes.string,
  secondaryCTACopy: propTypes.string,
  secondaryCTALinkRel: propTypes.string,
  offset: propTypes.number,
  className: propTypes.string
};
PreAuthHero.defaultProps = {};

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _assertThisInitialized$2(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

var invariant_1 = invariant;

var MediaQueryListener =
/*#__PURE__*/
function () {
  function MediaQueryListener(targetWindow, query, listener) {
    var _this = this;

    this.nativeMediaQueryList = targetWindow.matchMedia(query);
    this.active = true; // Safari doesn't clear up listener with removeListener
    // when the listener is already waiting in the event queue.
    // Having an active flag to make sure the listener is not called
    // after we removeListener.

    this.cancellableListener = function () {
      _this.matches = _this.nativeMediaQueryList.matches;

      if (_this.active) {
        listener.apply(void 0, arguments);
      }
    };

    this.nativeMediaQueryList.addListener(this.cancellableListener);
    this.matches = this.nativeMediaQueryList.matches;
  }

  var _proto = MediaQueryListener.prototype;

  _proto.cancel = function cancel() {
    this.active = false;
    this.nativeMediaQueryList.removeListener(this.cancellableListener);
  };

  return MediaQueryListener;
}();

var queryType = propTypes.oneOfType([propTypes.string, propTypes.object, propTypes.arrayOf(propTypes.object.isRequired)]);
/**
 * Conditionally renders based on whether or not a media query matches.
 */

var Media =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose$1(Media, _React$Component);

  function Media(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty$2(_assertThisInitialized$2(_assertThisInitialized$2(_this)), "queries", []);

    _defineProperty$2(_assertThisInitialized$2(_assertThisInitialized$2(_this)), "getMatches", function () {
      var result = _this.queries.reduce(function (acc, _ref) {
        var _extends2;

        var name = _ref.name,
            mqListener = _ref.mqListener;
        return _extends$2({}, acc, (_extends2 = {}, _extends2[name] = mqListener.matches, _extends2));
      }, {}); // return result;


      return unwrapSingleQuery(result);
    });

    _defineProperty$2(_assertThisInitialized$2(_assertThisInitialized$2(_this)), "updateMatches", function () {
      var newMatches = _this.getMatches();

      _this.setState(function () {
        return {
          matches: newMatches
        };
      }, _this.onChange);
    });

    !(!(!props.query && !props.queries) || props.query && props.queries) ? invariant_1(false, '<Media> must be supplied with either "query" or "queries"') : void 0;
    !(props.defaultMatches === undefined || !props.query || typeof props.defaultMatches === "boolean") ? invariant_1(false, "<Media> when query is set, defaultMatches must be a boolean, received " + typeof props.defaultMatches) : void 0;
    !(props.defaultMatches === undefined || !props.queries || typeof props.defaultMatches === "object") ? invariant_1(false, "<Media> when queries is set, defaultMatches must be a object of booleans, received " + typeof props.defaultMatches) : void 0;

    if (typeof window !== "object") {
      // In case we're rendering on the server, apply the default matches
      var matches;

      if (props.defaultMatches !== undefined) {
        matches = props.defaultMatches;
      } else if (props.query) {
        matches = true;
      }
      /* if (props.queries) */
      else {
          matches = Object.keys(_this.props.queries).reduce(function (acc, key) {
            var _extends3;

            return _extends$2({}, acc, (_extends3 = {}, _extends3[key] = true, _extends3));
          }, {});
        }

      _this.state = {
        matches: matches
      };
      return _assertThisInitialized$2(_this);
    }

    _this.initialize(); // Instead of calling this.updateMatches, we manually set the initial state to prevent
    // calling setState, which could trigger an unnecessary second render


    _this.state = {
      matches: _this.props.defaultMatches !== undefined ? _this.props.defaultMatches : _this.getMatches()
    };

    _this.onChange();

    return _this;
  }

  var _proto = Media.prototype;

  _proto.initialize = function initialize() {
    var _this2 = this;

    var targetWindow = this.props.targetWindow || window;
    !(typeof targetWindow.matchMedia === "function") ? invariant_1(false, "<Media targetWindow> does not support `matchMedia`.") : void 0;
    var queries = this.props.queries || wrapInQueryObject(this.props.query);
    this.queries = Object.keys(queries).map(function (name) {
      var query = queries[name];
      var qs = typeof query !== "string" ? json2mq_1(query) : query;
      var mqListener = new MediaQueryListener(targetWindow, qs, _this2.updateMatches);
      return {
        name: name,
        mqListener: mqListener
      };
    });
  };

  _proto.componentDidMount = function componentDidMount() {
    this.initialize(); // If props.defaultMatches has been set, ensure we trigger a two-pass render.
    // This is useful for SSR with mismatching defaultMatches vs actual matches from window.matchMedia
    // Details: https://github.com/ReactTraining/react-media/issues/81

    if (this.props.defaultMatches !== undefined) {
      this.updateMatches();
    }
  };

  _proto.onChange = function onChange() {
    var onChange = this.props.onChange;

    if (onChange) {
      onChange(this.state.matches);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.queries.forEach(function (_ref2) {
      var mqListener = _ref2.mqListener;
      return mqListener.cancel();
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        render = _this$props.render;
    var matches = this.state.matches;
    var isAnyMatches = typeof matches === "object" ? Object.keys(matches).some(function (key) {
      return matches[key];
    }) : matches;
    return render ? isAnyMatches ? render(matches) : null : children ? typeof children === "function" ? children(matches) : !Array.isArray(children) || children.length // Preact defaults to empty children array
    ? isAnyMatches ? // We have to check whether child is a composite component or not to decide should we
    // provide `matches` as a prop or not
    React.Children.only(children) && typeof React.Children.only(children).type === "string" ? React.Children.only(children) : React.cloneElement(React.Children.only(children), {
      matches: matches
    }) : null : null : null;
  };

  return Media;
}(React.Component);
/**
 * Wraps a single query in an object. This is used to provide backward compatibility with
 * the old `query` prop (as opposed to `queries`). If only a single query is passed, the object
 * will be unpacked down the line, but this allows our internals to assume an object of queries
 * at all times.
 */


_defineProperty$2(Media, "propTypes", {
  defaultMatches: propTypes.oneOfType([propTypes.bool, propTypes.objectOf(propTypes.bool)]),
  query: queryType,
  queries: propTypes.objectOf(queryType),
  render: propTypes.func,
  children: propTypes.oneOfType([propTypes.node, propTypes.func]),
  targetWindow: propTypes.object,
  onChange: propTypes.func
});

function wrapInQueryObject(query) {
  return {
    __DEFAULT__: query
  };
}
/**
 * Unwraps an object of queries, if it was originally passed as a single query.
 */


function unwrapSingleQuery(queryObject) {
  var queryNames = Object.keys(queryObject);

  if (queryNames.length === 1 && queryNames[0] === "__DEFAULT__") {
    return queryObject.__DEFAULT__;
  }

  return queryObject;
}

var SCREEN_LG = 1200;
var SCREEN_LG_MIN = SCREEN_LG;
var SCREEN_MD = 992;
var SCREEN_MD_MIN = SCREEN_MD;
var SCREEN_MD_MAX = SCREEN_LG_MIN - 1;
var SCREEN_SM = 768;
var SCREEN_SM_MIN = SCREEN_SM;
var SCREEN_SM_MAX = SCREEN_MD_MIN - 1;
var SCREEN_XS_MAX = SCREEN_SM_MIN - 1;

var HeroV2 = function HeroV2(_ref) {
  var _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'section' : _ref$component,
      backgroundImage = _ref.backgroundImage,
      mobileBackgroundImage = _ref.mobileBackgroundImage,
      tabletBackgroundImage = _ref.tabletBackgroundImage,
      className = _ref.className,
      buttons = _ref.buttons,
      title = _ref.title,
      _ref$headerTag = _ref.headerTag,
      HeaderTag = _ref$headerTag === void 0 ? 'h1' : _ref$headerTag,
      caption = _ref.caption,
      body = _ref.body,
      backgroundChips = _ref.backgroundChips,
      height = _ref.height,
      _ref$displayAsBlockIm = _ref.displayAsBlockImage,
      displayAsBlockImage = _ref$displayAsBlockIm === void 0 ? false : _ref$displayAsBlockIm,
      _ref$borderBottomOnMo = _ref.borderBottomOnMobile,
      borderBottomOnMobile = _ref$borderBottomOnMo === void 0 ? false : _ref$borderBottomOnMo,
      props = _objectWithoutProperties(_ref, ["component", "backgroundImage", "mobileBackgroundImage", "tabletBackgroundImage", "className", "buttons", "title", "headerTag", "caption", "body", "backgroundChips", "height", "displayAsBlockImage", "borderBottomOnMobile"]);

  var backgroundStyle = {
    backgroundImage: "url(".concat(backgroundImage, ")"),
    height: height
  };
  var headerClasses = classnames('hero__title', "zui__".concat(HeaderTag));

  var renderPrimarySection = function renderPrimarySection() {
    return React.createElement("div", {
      className: "hero__primary"
    }, title && HeaderTag && React.createElement(HeaderTag, {
      className: headerClasses
    }, title), caption && React.createElement("div", {
      className: "body-copy"
    }, caption), React.createElement("div", {
      className: "hero__body"
    }, body && React.createElement("div", {
      className: "hero__text"
    }, body), buttons && React.createElement("div", {
      className: "hero__buttons"
    }, buttons)));
  };

  var renderBlockImage = function renderBlockImage() {
    return React.createElement(Media, {
      query: "(max-width: ".concat(SCREEN_MD_MAX, "px)")
    }, React.createElement("div", {
      className: "hero__blockImage",
      style: backgroundStyle
    }));
  };

  return React.createElement(Component, _extends({
    className: classnames('hero', {
      'hero--displayAsBlockImage': displayAsBlockImage
    }, {
      'hero--border-bottom': borderBottomOnMobile
    }, className),
    style: backgroundStyle
  }, props), displayAsBlockImage && renderBlockImage(), backgroundChips, React.createElement("div", {
    className: "hero__contents"
  }, renderPrimarySection()));
};

HeroV2.propTypes = {
  height: propTypes.string,
  backgroundImage: propTypes.string,
  mobileBackgroundImage: propTypes.string,
  tabletBackgroundImage: propTypes.string,
  className: propTypes.string,
  backgroundChips: propTypes.node,
  buttons: propTypes.node,
  secondaryContents: propTypes.node,
  title: propTypes.node,
  caption: propTypes.node,
  body: propTypes.node,
  secondaryRight: propTypes.bool,
  headerTag: propTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  component: propTypes.oneOf(['div', 'section']),
  alignCenterOnMobile: propTypes.bool,
  displayAsBlockImage: propTypes.bool,
  borderBottomOnMobile: propTypes.bool
};

var RatingsSection = function RatingsSection(props) {
  var className = props.className,
      ratingTiles = props.ratingTiles,
      heading = props.heading,
      subtitle = props.subtitle;
  var classes = classnames('zola-ui', 'pre-auth__ratings-section', className);
  var CTACopy = 'See More Reviews';
  var CTACopyMobile = CTACopy;
  var CTALink = '/wedding-registry/couple-reviews';
  return React.createElement("div", {
    className: classes
  }, React.createElement("div", {
    className: "pre-auth__page-section pre-auth__bg--tan"
  }, React.createElement("div", {
    className: "container pre-auth__center-text"
  }, React.createElement("h2", {
    className: "pre-auth__h2"
  }, heading), subtitle ? React.createElement("p", {
    className: "pre-auth__primary-body-copy hidden-sm hidden-xs"
  }, subtitle) : null, React.createElement("div", {
    className: "row pre-auth__secondary-spacing--above"
  }, React.createElement("div", {
    className: "hidden-xs"
  }, React.createElement("div", {
    className: "col-xs-4"
  }, ratingTiles[0]), React.createElement("div", {
    className: "col-xs-4"
  }, ratingTiles[1]), React.createElement("div", {
    className: "col-xs-4"
  }, ratingTiles[2])), React.createElement(Carousel, {
    content: ratingTiles,
    btnStyle: "tertiary",
    className: "visible-xs"
  })), React.createElement("div", {
    className: "row pre-auth__primary-spacing--above"
  }, React.createElement("div", {
    className: "col-xs-12"
  }, React.createElement(PreAuthCTA, {
    CTACopy: CTACopy,
    CTACopyMobile: CTACopyMobile,
    CTALink: CTALink,
    type: "primary"
  }))))));
};

RatingsSection.propTypes = {
  className: propTypes.string,
  ratingTiles: propTypes.arrayOf(propTypes.node).isRequired,
  heading: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired,
  subtitle: propTypes.string
};

var ReviewStars = "data:image/svg+xml;base64,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";

var RatingsTile = function RatingsTile(props) {
  var className = props.className,
      quote = props.quote,
      coupleName = props.coupleName,
      location = props.location,
      imgAlt = props.imgAlt,
      imgSrc = props.imgSrc,
      componentKey = props.componentKey;
  var classes = classnames('zola-ui', 'pre-auth-ratings-tile', className);
  return React.createElement("div", {
    className: classes,
    key: componentKey || null
  }, imgSrc ? React.createElement(Porthole, {
    src: imgSrc,
    alt: imgAlt
  }) : null, React.createElement("blockquote", {
    className: "ratings-tile__quote pre-auth__secondary-body-copy"
  }, quote), React.createElement("img", {
    src: ReviewStars,
    alt: "5 out of 5 stars",
    className: "review-stars"
  }), React.createElement("h5", {
    className: "ratings-tile__couple-name pre-auth__h5"
  }, coupleName), React.createElement("div", {
    className: "ratings-tile__couple-location pre-auth__tertiary-body-copy"
  }, location));
};

RatingsTile.propTypes = {
  className: propTypes.string,
  quote: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired,
  coupleName: propTypes.string.isRequired,
  location: propTypes.string.isRequired,
  imgAlt: propTypes.string,
  imgSrc: propTypes.string,
  componentKey: propTypes.string
};

var CenteredTitleSection = function CenteredTitleSection(_ref) {
  var title = _ref.title,
      titleColor = _ref.titleColor,
      bodyCopyLineOne = _ref.bodyCopyLineOne,
      bodyCopyLineTwo = _ref.bodyCopyLineTwo,
      bodyCopyColor = _ref.bodyCopyColor,
      backgroundColor = _ref.backgroundColor,
      children = _ref.children;
  var backgroundStyle = classnames('centered-title-section', {
    'hero--light-blue-bg': backgroundColor === 'lightBlue'
  }, {
    'hero--light-gray-bg': backgroundColor === 'lightGray'
  });
  var centerTitleStyle = classnames('zui__h2', {
    'title--dark-blue': titleColor === 'darkBlue'
  }, {
    'title--black': titleColor === 'black'
  });
  var bodyCopyStyle = classnames('body-copy', {
    'body-copy--light-gray': bodyCopyColor === 'lightGray'
  });
  return React.createElement("div", {
    className: backgroundStyle
  }, React.createElement("div", {
    className: "centered-title__section"
  }, React.createElement("div", {
    className: "center-text"
  }, React.createElement("h2", {
    className: centerTitleStyle
  }, title)), bodyCopyLineOne && React.createElement("div", {
    className: "center-text"
  }, React.createElement("div", {
    className: bodyCopyStyle
  }, bodyCopyLineOne, ' ', bodyCopyLineTwo && React.createElement(React.Fragment, null, React.createElement(Media, {
    query: "(min-width: ".concat(SCREEN_MD_MIN, "px)")
  }, React.createElement("br", null)), bodyCopyLineTwo))), children));
};

CenteredTitleSection.propTypes = {
  title: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  titleColor: propTypes.oneOf(['black', 'darkBlue']),
  bodyCopyLineOne: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  bodyCopyLineTwo: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  bodyCopyColor: propTypes.oneOf(['lightGray', 'primaryGray']),
  backgroundColor: propTypes.oneOf(['lightGray']),
  children: propTypes.node
};

var MobileCallToActionSection = function MobileCallToActionSection(_ref) {
  var _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'section' : _ref$component,
      title = _ref.title,
      caption = _ref.caption,
      backgroundColor = _ref.backgroundColor,
      backgroundImage = _ref.backgroundImage,
      _ref$headerTag = _ref.headerTag,
      HeaderTag = _ref$headerTag === void 0 ? 'h1' : _ref$headerTag,
      headerClassName = _ref.headerClassName,
      buttons = _ref.buttons,
      secondaryContents = _ref.secondaryContents,
      className = _ref.className,
      _ref$borderBottom = _ref.borderBottom,
      borderBottom = _ref$borderBottom === void 0 ? false : _ref$borderBottom,
      text = _ref.text;
  var backgroundStyle = backgroundImage ? {
    backgroundImage: backgroundImage
  } : {};
  var classes = classnames('ctaSection--mobile', {
    'ctaSection--mobile-border-bottom': borderBottom
  }, {
    'ctaSection--light-blue-bg': backgroundColor === 'lightBlue'
  }, {
    'ctaSection--soft-pink-bg': backgroundColor === 'softPink'
  }, {
    'ctaSection--light-gray-bg': backgroundColor === 'lightGray'
  }, {
    'ctaSection--baby-blue-bg': backgroundColor === 'babyBlue'
  }, {
    'ctaSection--registry-light-blue-bg': backgroundColor === 'registryLightBlue'
  }, {
    'ctaSection--light-green-bg': backgroundColor === 'lightGreen'
  }, {
    'ctaSection--humming-bird-bg': backgroundColor === 'hummingBird'
  }, className);
  var headerClasses = classnames('ctaSection__title', "zui__".concat(HeaderTag));
  var captionClasses = classnames('body-copy', 'body-copy--align-center', headerClassName);
  return React.createElement(Component, {
    style: backgroundStyle,
    className: classes
  }, React.createElement(HeaderTag, {
    className: headerClasses
  }, title), React.createElement("div", {
    className: "ctaSection__body-content--mobile"
  }, secondaryContents, React.createElement("div", {
    className: captionClasses
  }, caption), text, buttons));
};

MobileCallToActionSection.propTypes = {
  className: propTypes.string,
  headerTag: propTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  backgroundColor: propTypes.oneOf(['', 'white', 'lightBlue', 'softPink', 'lightGray', 'babyBlue', 'registryLightBlue', 'lightGreen', 'hummingBird']),
  backgroundImage: propTypes.string,
  component: propTypes.oneOf(['div', 'section']),
  buttons: propTypes.node,
  secondaryContents: propTypes.node,
  title: propTypes.oneOfType([propTypes.string, propTypes.node]),
  caption: propTypes.oneOfType([propTypes.string, propTypes.node]),
  borderBottom: propTypes.bool,
  headerClassName: propTypes.string,
  text: propTypes.node
};

var TabletCallToActionSection = function TabletCallToActionSection(_ref2) {
  var _ref2$component = _ref2.component,
      Component = _ref2$component === void 0 ? 'section' : _ref2$component,
      title = _ref2.title,
      className = _ref2.className,
      headerClassName = _ref2.headerClassName,
      secondaryContents = _ref2.secondaryContents,
      caption = _ref2.caption,
      backgroundColor = _ref2.backgroundColor,
      backgroundImage = _ref2.backgroundImage,
      _ref2$headerTag = _ref2.headerTag,
      HeaderTag = _ref2$headerTag === void 0 ? 'h1' : _ref2$headerTag,
      _ref2$borderBottom = _ref2.borderBottom,
      borderBottom = _ref2$borderBottom === void 0 ? false : _ref2$borderBottom,
      buttons = _ref2.buttons,
      text = _ref2.text,
      heroTitleAlwaysOnTop = _ref2.heroTitleAlwaysOnTop;
  var classes = classnames('ctaSection--tablet', {
    'ctaSection--mobile-border-bottom': borderBottom
  }, {
    'ctaSection--light-blue-bg': backgroundColor === 'lightBlue'
  }, {
    'ctaSection--soft-pink-bg': backgroundColor === 'softPink'
  }, {
    'ctaSection--light-gray-bg': backgroundColor === 'lightGray'
  }, {
    'ctaSection--baby-blue-bg': backgroundColor === 'babyBlue'
  }, {
    'ctaSection--registry-light-blue-bg': backgroundColor === 'registryLightBlue'
  }, {
    'ctaSection--light-green-bg': backgroundColor === 'lightGreen'
  }, {
    'ctaSection--humming-bird-bg': backgroundColor === 'hummingBird'
  }, className);
  var headerClasses = classnames('ctaSection__title', "zui__".concat(HeaderTag), headerClassName);
  var copyClasses = classnames('body-copy');
  var buttonClasses = classnames('ctaSection--tablet__buttons', 'ctaSection--tablet__buttons--center');
  var backgroundStyle = backgroundImage ? {
    backgroundImage: backgroundImage
  } : {};
  return React.createElement(Component, {
    style: backgroundStyle,
    className: classes
  }, heroTitleAlwaysOnTop && React.createElement(React.Fragment, null, React.createElement(HeaderTag, {
    className: headerClasses
  }, title), caption && React.createElement("div", {
    className: copyClasses
  }, caption), React.createElement("div", {
    className: "ctaSection__secondary-contents"
  }, secondaryContents)), !heroTitleAlwaysOnTop && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "ctaSection__secondary-contents"
  }, secondaryContents), React.createElement(HeaderTag, {
    className: headerClasses
  }, title), caption && React.createElement("div", {
    className: copyClasses
  }, caption)), text, React.createElement("div", {
    className: buttonClasses
  }, buttons));
};

TabletCallToActionSection.propTypes = {
  borderBottom: propTypes.bool,
  heroTitleAlwaysOnTop: propTypes.bool,
  caption: propTypes.oneOfType([propTypes.string, propTypes.node]),
  backgroundColor: propTypes.oneOf(['', 'white', 'lightBlue', 'softPink', 'lightGray', 'babyBlue', 'registryLightBlue', 'lightGreen', 'hummingBird']),
  backgroundImage: propTypes.string,
  className: propTypes.string,
  headerClassName: propTypes.string,
  secondaryContents: propTypes.node,
  component: propTypes.oneOf(['div', 'section']),
  title: propTypes.oneOfType([propTypes.string, propTypes.element]),
  buttons: propTypes.node,
  headerTag: propTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  text: propTypes.oneOfType([propTypes.string, propTypes.node])
};

var CallToActionSection = function CallToActionSection(_ref3) {
  var _ref3$component = _ref3.component,
      Component = _ref3$component === void 0 ? 'section' : _ref3$component,
      backgroundImage = _ref3.backgroundImage,
      mobileBackgroundImage = _ref3.mobileBackgroundImage,
      tabletBackgroundImage = _ref3.tabletBackgroundImage,
      className = _ref3.className,
      buttons = _ref3.buttons,
      title = _ref3.title,
      _ref3$headerTag = _ref3.headerTag,
      HeaderTag = _ref3$headerTag === void 0 ? 'h1' : _ref3$headerTag,
      caption = _ref3.caption,
      text = _ref3.text,
      _ref3$smallerTitle = _ref3.smallerTitle,
      smallerTitle = _ref3$smallerTitle === void 0 ? false : _ref3$smallerTitle,
      backgroundColor = _ref3.backgroundColor,
      backgroundChips = _ref3.backgroundChips,
      secondaryContents = _ref3.secondaryContents,
      _ref3$secondaryRight = _ref3.secondaryRight,
      secondaryRight = _ref3$secondaryRight === void 0 ? false : _ref3$secondaryRight,
      height = _ref3.height,
      _ref3$borderBottomOnM = _ref3.borderBottomOnMobile,
      borderBottomOnMobile = _ref3$borderBottomOnM === void 0 ? false : _ref3$borderBottomOnM,
      heroTitleAlwaysOnTop = _ref3.heroTitleAlwaysOnTop;
  var headerTagClasses = classnames('ctaSection__title', "zui__".concat(HeaderTag), {
    'ctaSection__title--smaller': smallerTitle
  });
  var ctaSectionClasses = classnames('ctaSection', {
    'ctaSection--light-blue-bg': backgroundColor === 'lightBlue'
  }, {
    'ctaSection--soft-pink-bg': backgroundColor === 'softPink'
  }, {
    'ctaSection--light-gray-bg': backgroundColor === 'lightGray'
  }, {
    'ctaSection--baby-blue-bg': backgroundColor === 'babyBlue'
  }, {
    'ctaSection--registry-light-blue-bg': backgroundColor === 'registryLightBlue'
  }, {
    'ctaSection--light-green-bg': backgroundColor === 'lightGreen'
  }, {
    'ctaSection--humming-bird-bg': backgroundColor === 'hummingBird'
  }, className);
  var elementStyle = backgroundImage ? {
    backgroundImage: backgroundImage,
    height: height
  } : {
    height: height
  };

  var renderPrimarySection = function renderPrimarySection() {
    return React.createElement("div", {
      className: "ctaSection__primary"
    }, title && HeaderTag && React.createElement(HeaderTag, {
      className: headerTagClasses
    }, title), caption && React.createElement("div", {
      className: "body-copy body-copy--light-gray"
    }, caption), text && React.createElement("div", {
      className: "ctaSection__text"
    }, text), buttons && React.createElement("div", {
      className: "ctaSection__buttons"
    }, buttons));
  };

  return React.createElement(React.Fragment, null, React.createElement(MobileCallToActionSection, {
    backgroundImage: mobileBackgroundImage || backgroundImage,
    backgroundColor: backgroundColor,
    buttons: buttons,
    caption: caption,
    headerTag: HeaderTag,
    secondaryContents: secondaryContents,
    title: title,
    borderBottom: borderBottomOnMobile,
    text: text,
    className: className
  }), React.createElement(TabletCallToActionSection, {
    backgroundImage: tabletBackgroundImage || backgroundImage,
    backgroundColor: backgroundColor,
    buttons: buttons,
    caption: caption,
    text: text,
    headerTag: HeaderTag,
    secondaryContents: secondaryContents,
    title: title,
    className: className,
    heroTitleAlwaysOnTop: heroTitleAlwaysOnTop
  }), React.createElement(Component, {
    className: ctaSectionClasses,
    style: elementStyle
  }, backgroundChips, secondaryRight ? React.createElement("div", {
    className: "ctaSection__contents"
  }, renderPrimarySection(), secondaryContents && React.createElement("div", {
    className: "ctaSection__secondary"
  }, secondaryContents)) : React.createElement("div", {
    className: "ctaSection__contents"
  }, secondaryContents && React.createElement("div", {
    className: "ctaSection__secondary"
  }, secondaryContents), renderPrimarySection())));
};

CallToActionSection.propTypes = {
  height: propTypes.string,
  backgroundImage: propTypes.string,
  mobileBackgroundImage: propTypes.string,
  tabletBackgroundImage: propTypes.string,
  className: propTypes.string,
  backgroundChips: propTypes.node,
  buttons: propTypes.node,
  secondaryContents: propTypes.node,
  smallerTitle: propTypes.bool,
  title: propTypes.node,
  caption: propTypes.node,
  text: propTypes.node,
  secondaryRight: propTypes.bool,
  backgroundColor: propTypes.oneOf(['', 'white', 'lightBlue', 'softPink', 'lightGray', 'babyBlue', 'registryLightBlue', 'lightGreen', 'hummingBird']),
  headerTag: propTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  component: propTypes.oneOf(['div', 'section']),
  borderBottomOnMobile: propTypes.bool,
  heroTitleAlwaysOnTop: propTypes.bool
};

var ReadyWhenYouAre = function ReadyWhenYouAre(_ref) {
  var _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'section' : _ref$component,
      _ref$titleElement = _ref.titleElement,
      TitleElement = _ref$titleElement === void 0 ? 'div' : _ref$titleElement,
      className = _ref.className,
      onClick = _ref.onClick,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? React.createElement(React.Fragment, null, React.createElement("span", {
    className: "ready-when-you-are__title--ready"
  }, "Ready\xA0"), "When You Are") : _ref$text,
      _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === void 0 ? 'Start Your Registry' : _ref$buttonText,
      link = _ref.link,
      props = _objectWithoutProperties(_ref, ["component", "titleElement", "className", "onClick", "text", "buttonText", "link"]);

  var classes = classnames('ready-when-you-are', className);
  return React.createElement(Component, _extends({
    className: classes
  }, props), React.createElement(TitleElement, {
    className: "ready-when-you-are__title"
  }, text), React.createElement(ButtonV2, {
    bordered: true,
    component: "a",
    variant: "primary",
    onClick: onClick,
    href: link
  }, buttonText));
};

ReadyWhenYouAre.propTypes = {
  buttonText: propTypes.string,
  text: propTypes.oneOfType([propTypes.string, propTypes.node]),
  onClick: propTypes.func,
  className: propTypes.string,
  titleElement: propTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span']),
  component: propTypes.oneOf(['section', 'div']),
  link: propTypes.string
};

var FAQSectionV2 = function FAQSectionV2(_ref) {
  var children = _ref.children,
      expandedByDefault = _ref.expandedByDefault,
      title = _ref.title,
      _ref$headerElement = _ref.headerElement,
      HeaderElement = _ref$headerElement === void 0 ? 'h2' : _ref$headerElement,
      maxHeight = _ref.maxHeight,
      maxExpandedHeight = _ref.maxExpandedHeight,
      offset = _ref.offset,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["children", "expandedByDefault", "title", "headerElement", "maxHeight", "maxExpandedHeight", "offset", "className"]);

  var classes = classnames('faq-section-v2', className);
  return React.createElement("section", {
    className: "faq-section-container-v2"
  }, title && React.createElement(HeaderElement, {
    className: classnames('faq-section-v2__title', "zui__".concat(HeaderElement))
  }, title), React.createElement("div", _extends({
    className: classes
  }, props), React.createElement(DrawerV2, {
    maxHeight: maxHeight,
    maxExpandedHeight: maxExpandedHeight,
    offset: offset,
    smallerArrows: false,
    expandedByDefault: expandedByDefault
  }, children)));
};

FAQSectionV2.propTypes = {
  className: propTypes.string,
  expandedByDefault: propTypes.bool,
  title: propTypes.string,
  headerElement: propTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span']),
  maxHeight: propTypes.string,
  maxExpandedHeight: propTypes.string,
  offset: propTypes.number,
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node])
};

var FAQSectionItem = function FAQSectionItem(_ref) {
  var children = _ref.children,
      title = _ref.title,
      _ref$titleElement = _ref.titleElement,
      TitleElement = _ref$titleElement === void 0 ? 'h3' : _ref$titleElement,
      description = _ref.description,
      props = _objectWithoutProperties(_ref, ["children", "title", "titleElement", "description"]);

  var classes = classnames('faq-section-item__title', "zui__".concat(TitleElement));
  return React.createElement("div", _extends({
    className: "faq-section-item"
  }, props), React.createElement(TitleElement, {
    className: classes
  }, title), description && React.createElement("div", {
    className: "faq-section-item__description"
  }, description));
};

FAQSectionItem.propTypes = {
  title: propTypes.oneOfType([propTypes.string, propTypes.node]),
  description: propTypes.node,
  titleElement: propTypes.oneOf(['h1,', 'h2', 'h3', 'h4', 'h5', 'h6', 'span']),
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node])
};

var NumberedItem = function NumberedItem(_ref) {
  var number = _ref.number,
      numberColor = _ref.numberColor,
      title = _ref.title,
      titleColor = _ref.titleColor,
      children = _ref.children,
      bodyCopyColor = _ref.bodyCopyColor;
  var numberClasses = classnames('numbered-item__number', "numbered-item__number-color--".concat(numberColor));
  var titleClasses = classnames('numbered-item__title', "numbered-item__title-color--".concat(titleColor));
  var bodyCopyClasses = classnames('body-copy', 'numbered-item__body', {
    'body-copy--light-gray': bodyCopyColor === 'lightGray'
  }, {
    'body-copy--primary-gray': bodyCopyColor === 'primaryGray'
  });
  return React.createElement("div", {
    className: "numbered-item"
  }, React.createElement("span", {
    className: numberClasses
  }, number, ". "), React.createElement("h3", {
    className: titleClasses
  }, title), React.createElement("div", {
    className: bodyCopyClasses
  }, children));
};

NumberedItem.propTypes = {
  number: propTypes.number,
  numberColor: propTypes.oneOf(['teal']),
  title: propTypes.string,
  titleColor: propTypes.oneOf(['navy']),
  bodyCopyColor: propTypes.oneOf(['primaryGray', 'lightGray']),
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node])
};

var BulletedList = function BulletedList(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'pink' : _ref$color,
      props = _objectWithoutProperties(_ref, ["children", "className", "color"]);

  var classes = classnames('bulleted-list', {
    'bulleted-list--pink': color === 'pink'
  }, {
    'bulleted-list--teal': color === 'teal'
  }, className);
  return React.createElement("ul", _extends({
    className: classes
  }, props), children);
};

BulletedList.propTypes = {
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  className: propTypes.string,
  color: propTypes.oneOf(['pink', 'teal'])
};

var HowItWorksSectionV2 = function HowItWorksSectionV2(_ref) {
  var children = _ref.children,
      largeImage = _ref.largeImage,
      smallImage = _ref.smallImage,
      numberedList = _ref.numberedList,
      howItWorksTitle = _ref.howItWorksTitle,
      howItWorksCTACopy = _ref.howItWorksCTACopy,
      howItWorksCTAUrl = _ref.howItWorksCTAUrl,
      howItWorksBackgroundColor = _ref.howItWorksBackgroundColor,
      displayPlayIcon = _ref.displayPlayIcon,
      _ref$displayTitleOnTo = _ref.displayTitleOnTop,
      displayTitleOnTop = _ref$displayTitleOnTo === void 0 ? true : _ref$displayTitleOnTo,
      _ref$centerButtons = _ref.centerButtons,
      centerButtons = _ref$centerButtons === void 0 ? true : _ref$centerButtons,
      onImageClick = _ref.onImageClick,
      _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'section' : _ref$component,
      props = _objectWithoutProperties(_ref, ["children", "largeImage", "smallImage", "numberedList", "howItWorksTitle", "howItWorksCTACopy", "howItWorksCTAUrl", "howItWorksBackgroundColor", "displayPlayIcon", "displayTitleOnTop", "centerButtons", "onImageClick", "component"]);

  var renderNumberedItem = function renderNumberedItem() {
    return numberedList.map(function (item, index) {
      return React.createElement(NumberedItem, {
        number: index + 1,
        key: index,
        title: item.title,
        numberColor: "teal",
        titleColor: "navy",
        bodyCopyColor: "primaryGray"
      }, item.description);
    });
  };

  var renderButtons = function renderButtons(_ref2) {
    var larger = _ref2.larger;
    // eslint-disable-line
    return React.createElement(React.Fragment, null, howItWorksCTACopy && React.createElement(CTAV2, {
      href: howItWorksCTAUrl,
      component: "a",
      color: "blue",
      larger: larger,
      bold: true,
      arrow: true
    }, howItWorksCTACopy));
  };

  var renderImageContainer = function renderImageContainer(image) {
    return React.createElement("div", {
      className: "how-it-works-section__image-container",
      onClick: onImageClick
    }, React.createElement("img", {
      className: "how-it-works-section__image",
      src: image,
      alt: "How Zola Registry works video placeholder"
    }), displayPlayIcon && React.createElement("span", {
      "aria-hidden": "true",
      className: "how-it-works-section__modal-icon zola-ui-icon zola-ui-icon-play"
    }));
  };

  return React.createElement(Component, _extends({
    className: "how-it-works-section"
  }, props), React.createElement("section", {
    className: "how-it-works-section-mobile"
  }, React.createElement("h2", {
    className: "how-it-works-section__title zui__h2"
  }, howItWorksTitle), renderImageContainer(smallImage), React.createElement("div", {
    className: "numbered-items__container"
  }, renderNumberedItem()), renderButtons({
    larger: false
  })), React.createElement("section", {
    className: "how-it-works-section-regular"
  }, React.createElement(CallToActionSection, {
    component: "div",
    backgroundColor: howItWorksBackgroundColor,
    title: howItWorksTitle,
    height: "auto",
    headerTag: "h2",
    text: React.createElement("div", {
      className: "how-it-works-section__list"
    }, React.createElement("div", {
      className: "numbered-items__container"
    }, renderNumberedItem())),
    secondaryRight: true,
    secondaryContents: renderImageContainer(largeImage),
    smallerTitle: true,
    buttons: renderButtons({
      larger: true
    }),
    heroTitleAlwaysOnTop: displayTitleOnTop,
    centerButtonsOnMobile: centerButtons
  })));
};

HowItWorksSectionV2.propTypes = {
  largeImage: propTypes.string,
  smallImage: propTypes.string,
  displayPlayIcon: propTypes.bool,
  centerButtons: propTypes.bool,
  displayTitleOnTop: propTypes.bool,
  howItWorksTitle: propTypes.oneOfType([propTypes.string, propTypes.element]),
  howItWorksCTACopy: propTypes.string,
  howItWorksCTAUrl: propTypes.string,
  component: propTypes.oneOf(['div', 'section']),
  numberedList: propTypes.arrayOf(propTypes.shape({
    key: propTypes.string,
    text: propTypes.string,
    description: propTypes.oneOfType([propTypes.string, propTypes.element])
  })),
  howItWorksBackgroundColor: propTypes.oneOf(['white', 'lightGray']),
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  onImageClick: propTypes.func,
  larger: propTypes.bool
};

var BrandsCarouselHero = function BrandsCarouselHero(_ref) {
  var _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'section' : _ref$component,
      carouselContent = _ref.carouselContent,
      className = _ref.className,
      _ref$ctaHref = _ref.ctaHref,
      ctaHref = _ref$ctaHref === void 0 ? '/shop/brands' : _ref$ctaHref,
      props = _objectWithoutProperties(_ref, ["component", "carouselContent", "className", "ctaHref"]);

  var xsItems = carouselContent.slice(0, 4);
  var classes = classnames('carousel-hero', className);
  return React.createElement(Component, _extends({
    className: classes
  }, props), React.createElement(Media, {
    query: "(max-width: ".concat(SCREEN_XS_MAX, "px)"),
    render: function render() {
      return React.createElement(React.Fragment, null, React.createElement("h2", null, "Our Store Carries Over 1,000 Top Brands"), React.createElement("div", {
        className: "carousel-hero__items--xs"
      }, xsItems), React.createElement(CTAV2, {
        href: ctaHref,
        component: "a",
        bold: true
      }, "View All Our Brands"));
    }
  }), React.createElement(Media, {
    query: "(min-width: ".concat(SCREEN_SM_MIN, "px)"),
    render: function render() {
      return React.createElement(React.Fragment, null, React.createElement("h2", null, "Our Store Carries Over 1,000 Top Brands", React.createElement(Media, {
        query: "(min-width: ".concat(SCREEN_MD_MIN, "px)"),
        render: function render() {
          return React.createElement(CTAV2, {
            href: ctaHref,
            className: "carousel-hero__view-all-our-brands-cta",
            bold: true,
            larger: true
          }, "View All Our Brands");
        }
      })), React.createElement(Carousel, {
        useV2ArrowStyles: true,
        content: carouselContent
      }));
    }
  }));
};

BrandsCarouselHero.propTypes = {
  className: propTypes.string,
  component: propTypes.oneOf(['div', 'section']),
  carouselContent: propTypes.arrayOf(propTypes.node),
  ctaHref: propTypes.string
};

var TestimonialsHero = function TestimonialsHero(_ref) {
  var _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'section' : _ref$component,
      children = _ref.children,
      title = _ref.title,
      className = _ref.className,
      _ref$headerTag = _ref.headerTag,
      HeaderTag = _ref$headerTag === void 0 ? 'h2' : _ref$headerTag,
      headerElement = _ref.headerElement,
      props = _objectWithoutProperties(_ref, ["component", "children", "title", "className", "headerTag", "headerElement"]);

  var classes = classnames('testimonials-hero', className);
  return React.createElement(Component, _extends({
    className: classes
  }, props), React.createElement("div", {
    className: "testimonials-hero__content"
  }, headerElement ? React.createElement(React.Fragment, null, headerElement) : React.createElement(HeaderTag, {
    className: classnames('testimonials-hero__title', "zui__".concat(HeaderTag))
  }, title), children, React.createElement("div", {
    className: "testimonials-hero__button-container"
  }, React.createElement(ButtonV2, {
    className: "testimonials-hero__button",
    component: "a",
    href: "/wedding-registry/couple-reviews"
  }, "See More Reviews"))));
};

TestimonialsHero.propTypes = {
  component: propTypes.oneOf(['div', 'section']),
  children: propTypes.oneOfType([propTypes.node, propTypes.arrayOf(propTypes.node)]),
  title: propTypes.oneOfType([propTypes.string, propTypes.node]),
  headerElement: propTypes.node,
  headerTag: propTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  className: propTypes.string
};

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : _baseSlice(array, start, end);
}

var _castSlice = castSlice;

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

var _hasUnicode = hasUnicode;

/** `Object#toString` result references. */
var regexpTag$2 = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == regexpTag$2;
}

var _baseIsRegExp = baseIsRegExp;

/* Node.js helper references. */
var nodeIsRegExp = _nodeUtil && _nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? _baseUnary(nodeIsRegExp) : _baseIsRegExp;

var isRegExp_1 = isRegExp;

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = _baseProperty('length');

var _asciiSize = asciiSize;

/** Used to compose unicode character classes. */
var rsAstralRange$1 = '\\ud800-\\udfff',
    rsComboMarksRange$1 = '\\u0300-\\u036f',
    reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$1 = '\\u20d0-\\u20ff',
    rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1,
    rsVarRange$1 = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange$1 + ']',
    rsCombo = '[' + rsComboRange$1 + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange$1 + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ$1 = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange$1 + ']?',
    rsOptJoin = '(?:' + rsZWJ$1 + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}

var _unicodeSize = unicodeSize;

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return _hasUnicode(string)
    ? _unicodeSize(string)
    : _asciiSize(string);
}

var _stringSize = stringSize;

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

var _asciiToArray = asciiToArray;

/** Used to compose unicode character classes. */
var rsAstralRange$2 = '\\ud800-\\udfff',
    rsComboMarksRange$2 = '\\u0300-\\u036f',
    reComboHalfMarksRange$2 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$2 = '\\u20d0-\\u20ff',
    rsComboRange$2 = rsComboMarksRange$2 + reComboHalfMarksRange$2 + rsComboSymbolsRange$2,
    rsVarRange$2 = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral$1 = '[' + rsAstralRange$2 + ']',
    rsCombo$1 = '[' + rsComboRange$2 + ']',
    rsFitz$1 = '\\ud83c[\\udffb-\\udfff]',
    rsModifier$1 = '(?:' + rsCombo$1 + '|' + rsFitz$1 + ')',
    rsNonAstral$1 = '[^' + rsAstralRange$2 + ']',
    rsRegional$1 = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair$1 = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ$2 = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod$1 = rsModifier$1 + '?',
    rsOptVar$1 = '[' + rsVarRange$2 + ']?',
    rsOptJoin$1 = '(?:' + rsZWJ$2 + '(?:' + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsOptVar$1 + reOptMod$1 + ')*',
    rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1,
    rsSymbol$1 = '(?:' + [rsNonAstral$1 + rsCombo$1 + '?', rsCombo$1, rsRegional$1, rsSurrPair$1, rsAstral$1].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode$1 = RegExp(rsFitz$1 + '(?=' + rsFitz$1 + ')|' + rsSymbol$1 + rsSeq$1, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode$1) || [];
}

var _unicodeToArray = unicodeToArray;

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return _hasUnicode(string)
    ? _unicodeToArray(string)
    : _asciiToArray(string);
}

var _stringToArray = stringToArray;

/** Used as default options for `_.truncate`. */
var DEFAULT_TRUNC_LENGTH = 30,
    DEFAULT_TRUNC_OMISSION = '...';

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Truncates `string` if it's longer than the given maximum string length.
 * The last characters of the truncated string are replaced with the omission
 * string which defaults to "...".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to truncate.
 * @param {Object} [options={}] The options object.
 * @param {number} [options.length=30] The maximum string length.
 * @param {string} [options.omission='...'] The string to indicate text is omitted.
 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
 * @returns {string} Returns the truncated string.
 * @example
 *
 * _.truncate('hi-diddly-ho there, neighborino');
 * // => 'hi-diddly-ho there, neighbo...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': ' '
 * });
 * // => 'hi-diddly-ho there,...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': /,? +/
 * });
 * // => 'hi-diddly-ho there...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'omission': ' [...]'
 * });
 * // => 'hi-diddly-ho there, neig [...]'
 */
function truncate(string, options) {
  var length = DEFAULT_TRUNC_LENGTH,
      omission = DEFAULT_TRUNC_OMISSION;

  if (isObject_1(options)) {
    var separator = 'separator' in options ? options.separator : separator;
    length = 'length' in options ? toInteger_1(options.length) : length;
    omission = 'omission' in options ? _baseToString(options.omission) : omission;
  }
  string = toString_1(string);

  var strLength = string.length;
  if (_hasUnicode(string)) {
    var strSymbols = _stringToArray(string);
    strLength = strSymbols.length;
  }
  if (length >= strLength) {
    return string;
  }
  var end = length - _stringSize(omission);
  if (end < 1) {
    return omission;
  }
  var result = strSymbols
    ? _castSlice(strSymbols, 0, end).join('')
    : string.slice(0, end);

  if (separator === undefined) {
    return result + omission;
  }
  if (strSymbols) {
    end += (result.length - end);
  }
  if (isRegExp_1(separator)) {
    if (string.slice(end).search(separator)) {
      var match,
          substring = result;

      if (!separator.global) {
        separator = RegExp(separator.source, toString_1(reFlags.exec(separator)) + 'g');
      }
      separator.lastIndex = 0;
      while ((match = separator.exec(substring))) {
        var newEnd = match.index;
      }
      result = result.slice(0, newEnd === undefined ? end : newEnd);
    }
  } else if (string.indexOf(_baseToString(separator), end) != end) {
    var index = result.lastIndexOf(separator);
    if (index > -1) {
      result = result.slice(0, index);
    }
  }
  return result + omission;
}

var truncate_1 = truncate;

/**
 * @param {Object} props
 * @param {string} props.component
 * @param {string} props.personName
 * @param {number} props.rating
 * @param {string} props.header
 * @param {string} props.description
 * @param {string} props.readMoreHref
 * @param {string} props.className
 */

var TestimonialCard = function TestimonialCard(_ref) {
  var _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'div' : _ref$component,
      personName = _ref.personName,
      rating = _ref.rating,
      header = _ref.header,
      className = _ref.className,
      description = _ref.description,
      readMoreHref = _ref.readMoreHref,
      _ref$truncateLimit = _ref.truncateLimit,
      truncateLimit = _ref$truncateLimit === void 0 ? 150 : _ref$truncateLimit,
      props = _objectWithoutProperties(_ref, ["component", "personName", "rating", "header", "className", "description", "readMoreHref", "truncateLimit"]);

  var firstLetter = personName[0].toUpperCase();
  var classes = classnames('testimonial-card', className);
  return React.createElement(Component, _extends({
    className: classes
  }, props), React.createElement("div", {
    className: "testimonial-card__title"
  }, React.createElement("div", {
    className: "testimonial-card__title--row"
  }, React.createElement("div", {
    className: "testimonial-card__title-first-letter"
  }, firstLetter), React.createElement("div", {
    className: "testimonial-card__title--column"
  }, React.createElement("h3", {
    className: "testimonial-card__title-name"
  }, personName), React.createElement("div", {
    className: "testimonial-card__title-rating"
  }, _toConsumableArray(Array(rating)).map(function (_e, i) {
    return React.createElement("span", {
      className: "testimonial-card__star",
      role: "img",
      "aria-label": "star",
      key: i
    });
  }))))), React.createElement("div", {
    className: "testimonial-card__body"
  }, React.createElement("h4", {
    className: "testimonial-card__body-header"
  }, header), React.createElement("p", {
    className: "testimonial-card__body-description"
  }, truncate_1(description, {
    length: truncateLimit
  }))), description.length >= truncateLimit ? React.createElement("div", {
    className: "testimonial-card__action"
  }, readMoreHref) : null);
};

TestimonialCard.propTypes = {
  component: propTypes.oneOf(['div', 'section']),
  personName: propTypes.string.isRequired,
  rating: propTypes.oneOf([1, 2, 3, 4, 5]).isRequired,
  header: propTypes.string.isRequired,
  description: propTypes.string.isRequired,
  readMoreHref: propTypes.node,
  truncateLimit: propTypes.number,
  className: propTypes.string
};

var GridSection = function GridSection(_ref) {
  var title = _ref.title,
      _ref$headerTag = _ref.headerTag,
      HeaderTag = _ref$headerTag === void 0 ? 'h2' : _ref$headerTag,
      dek = _ref.dek,
      imgSrc = _ref.imgSrc,
      imgSide = _ref.imgSide,
      className = _ref.className;
  var classes = classnames('grid-section', className);
  var imgContainer = React.createElement("div", {
    className: "grid-section__img-container"
  }, React.createElement("img", {
    src: imgSrc,
    alt: "grid-section-img",
    className: "grid-section__img"
  }));
  return React.createElement("div", {
    className: classes
  }, imgSide === 'left' && imgContainer, imgSide === 'right' && React.createElement(Media, {
    query: "(max-width: ".concat(SCREEN_SM_MAX, "px)")
  }, imgContainer), React.createElement("div", {
    className: "grid_section__hed-container"
  }, React.createElement(HeaderTag, {
    className: "zui__h2 grid_section__hed-container__title"
  }, title), React.createElement("p", {
    className: "body-copy grid_section__hed-container__dek"
  }, dek)), imgSide === 'right' && React.createElement(Media, {
    query: "(min-width: ".concat(SCREEN_MD_MIN, "px)")
  }, imgContainer));
};

GridSection.propTypes = {
  title: propTypes.node,
  headerTag: propTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span']),
  imgSide: propTypes.string,
  imgSrc: propTypes.string,
  dek: propTypes.string,
  className: propTypes.string
};

var Callout = function Callout(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$mixBlendMultiply = _ref.mixBlendMultiply,
      mixBlendMultiply = _ref$mixBlendMultiply === void 0 ? false : _ref$mixBlendMultiply,
      props = _objectWithoutProperties(_ref, ["children", "className", "mixBlendMultiply"]);

  var classes = classnames('callout-bubble', {
    'callout-bubble--mix-multiply': mixBlendMultiply
  }, className);
  return React.createElement("div", _extends({
    className: classes
  }, props), children);
};

Callout.propTypes = {
  className: propTypes.string,
  mixBlendMultiply: propTypes.bool,
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node])
};

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeRandom = Math.random;

/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */
function baseRandom(lower, upper) {
  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
}

var _baseRandom = baseRandom;

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject_1(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike_1(object) && _isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq_1(object[index], value);
  }
  return false;
}

var _isIterateeCall = isIterateeCall;

/** Built-in method references without a dependency on `root`. */
var freeParseFloat = parseFloat;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin$1 = Math.min,
    nativeRandom$1 = Math.random;

/**
 * Produces a random number between the inclusive `lower` and `upper` bounds.
 * If only one argument is provided a number between `0` and the given number
 * is returned. If `floating` is `true`, or either `lower` or `upper` are
 * floats, a floating-point number is returned instead of an integer.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Number
 * @param {number} [lower=0] The lower bound.
 * @param {number} [upper=1] The upper bound.
 * @param {boolean} [floating] Specify returning a floating-point number.
 * @returns {number} Returns the random number.
 * @example
 *
 * _.random(0, 5);
 * // => an integer between 0 and 5
 *
 * _.random(5);
 * // => also an integer between 0 and 5
 *
 * _.random(5, true);
 * // => a floating-point number between 0 and 5
 *
 * _.random(1.2, 5.2);
 * // => a floating-point number between 1.2 and 5.2
 */
function random(lower, upper, floating) {
  if (floating && typeof floating != 'boolean' && _isIterateeCall(lower, upper, floating)) {
    upper = floating = undefined;
  }
  if (floating === undefined) {
    if (typeof upper == 'boolean') {
      floating = upper;
      upper = undefined;
    }
    else if (typeof lower == 'boolean') {
      floating = lower;
      lower = undefined;
    }
  }
  if (lower === undefined && upper === undefined) {
    lower = 0;
    upper = 1;
  }
  else {
    lower = toFinite_1(lower);
    if (upper === undefined) {
      upper = lower;
      lower = 0;
    } else {
      upper = toFinite_1(upper);
    }
  }
  if (lower > upper) {
    var temp = lower;
    lower = upper;
    upper = temp;
  }
  if (floating || lower % 1 || upper % 1) {
    var rand = nativeRandom$1();
    return nativeMin$1(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
  }
  return _baseRandom(lower, upper);
}

var random_1 = random;

var ProgressRing =
/*#__PURE__*/
function (_Component) {
  _inherits(ProgressRing, _Component);

  function ProgressRing(props) {
    var _this;

    _classCallCheck(this, ProgressRing);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProgressRing).call(this, props));
    _this.radius = props.radius;
    _this.stroke = props.stroke; // make sure stroke does not overflow

    _this.normalizedRadius = _this.radius - _this.stroke * 2;
    _this.circumference = _this.normalizedRadius * 2 * Math.PI;
    _this.randomImageId = random_1(0, 1000000);
    _this.randomIconId = random_1(0, 1000000);
    return _this;
  }

  _createClass(ProgressRing, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          progress = _this$props.progress,
          baseColor = _this$props.baseColor,
          ringColor = _this$props.ringColor,
          iconColor = _this$props.iconColor,
          iconId = _this$props.iconId,
          backgroundImage = _this$props.backgroundImage,
          iconImage = _this$props.iconImage,
          text = _this$props.text,
          textColor = _this$props.textColor,
          className = _this$props.className,
          showCheckmark = _this$props.showCheckmark;
      var strokeDashoffset = this.circumference - progress / 100 * this.circumference;
      var pathname = window.location.href;
      var backgroundFill = backgroundImage ? "url(".concat(pathname, "#").concat(this.randomImageId, ")") : '';
      var iconFill = iconImage ? "url(".concat(pathname, "#").concat(this.randomIconId, ")") : '';
      var checkMarkIcon = React.createElement("div", {
        className: "progress-ring__checkmark-icon"
      }, React.createElement("i", {
        className: "zola-ui-icon zola-ui-icon-checkmark"
      }));
      /**
       * Center text in SVG. Shift text down by 0.3em to make sure the text is vertically centered.
       */

      var svgText = text ? React.createElement("text", {
        x: "50%",
        y: "50%",
        textAnchor: "middle",
        fill: textColor,
        dy: "0.3em"
      }, React.createElement("tspan", {
        x: "50%"
      }, text)) : null;
      return React.createElement("div", {
        className: "zola-ui progress-ring ".concat(className)
      }, showCheckmark && progress === 100 && checkMarkIcon, React.createElement("span", {
        className: "zola-ui-icon ".concat(iconId, " ").concat(iconColor)
      }), React.createElement("svg", {
        height: this.radius * 2,
        width: this.radius * 2,
        "aria-labelledby": "".concat(this.randomImageId, "-title")
      }, React.createElement("title", {
        id: "".concat(this.randomImageId, "-title")
      }, "A circle to display progress"), React.createElement("defs", null, React.createElement("pattern", {
        id: this.randomImageId,
        x: "0%",
        y: "0%",
        height: "100%",
        width: "100%",
        viewBox: "0 0 10 10",
        patternTransform: "rotate(90, 5, 5)"
      }, React.createElement("image", {
        x: "0%",
        y: "0%",
        width: "10",
        height: "10",
        xlinkHref: backgroundImage,
        href: backgroundImage
      })), React.createElement("pattern", {
        id: this.randomIconId,
        x: "25%",
        y: "15%",
        height: "100%",
        width: "100%",
        viewBox: "0 0 10 10",
        patternTransform: "rotate(90, 5, 5)"
      }, React.createElement("image", {
        x: "0%",
        y: "0%",
        width: "5",
        height: "5",
        xlinkHref: iconImage,
        href: iconImage
      }))), baseColor && React.createElement("circle", {
        className: "circle base-circle ".concat(baseColor),
        strokeWidth: this.stroke,
        strokeDasharray: "".concat(this.circumference, " ").concat(this.circumference),
        r: this.normalizedRadius,
        cx: this.radius,
        cy: this.radius,
        fill: "transparent",
        transform: "rotate(-90, ".concat(this.radius, ", ").concat(this.radius, ")"),
        stroke: baseColor
      }), React.createElement("circle", {
        className: "circle progress-circle ".concat(ringColor),
        strokeWidth: this.stroke,
        strokeDasharray: "".concat(this.circumference, " ").concat(this.circumference),
        style: {
          strokeDashoffset: strokeDashoffset
        },
        r: this.normalizedRadius,
        cx: this.radius,
        cy: this.radius,
        fill: backgroundFill || iconFill || 'transparent',
        transform: "rotate(-90, ".concat(this.radius, ", ").concat(this.radius, ")"),
        stroke: ringColor,
        strokeLinecap: "round"
      }), svgText));
    }
  }]);

  return ProgressRing;
}(Component);

ProgressRing.defaultProps = {
  progress: 0
};
ProgressRing.propTypes = {
  /**
   * percentage of a progress.
   */
  progress: propTypes.number,

  /**
   * the background color for progress ring
   */
  baseColor: propTypes.string,

  /**
   * the overlay color for progress ring
   */
  ringColor: propTypes.string,

  /**
   * Zola Color from style guide. You have to pass valid color like "color-primary-teal"
   */
  iconColor: propTypes.string,
  iconId: propTypes.string,

  /**
   * the text to be placed in the center of the circle
   */
  text: propTypes.string,

  /**
   * color of the text
   */
  textColor: propTypes.string,

  /**
   * the background image for progress ring
   */
  backgroundImage: propTypes.string,

  /**
   * source of the icon svg
   */
  iconImage: propTypes.string,

  /**
   * size of the ring
   */
  radius: propTypes.number.isRequired,

  /**
   * size of the ring border
   */
  stroke: propTypes.number.isRequired,

  /**
   * flag for showing check mark when progress is 100%
   */
  showCheckmark: propTypes.bool,
  className: propTypes.string
};

var heartsImagefile = "data:image/svg+xml;base64,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";

var ProgressBar =
/*#__PURE__*/
function (_Component) {
  _inherits(ProgressBar, _Component);

  function ProgressBar(props) {
    var _this;

    _classCallCheck(this, ProgressBar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProgressBar).call(this, props));
    _this.state = {
      progress: 0
    };
    return _this;
  }

  _createClass(ProgressBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          currentPageIndex = _this$props.currentPageIndex,
          onUpdateQuestionNumber = _this$props.onUpdateQuestionNumber;
      var currentQuestionNumber = this.onQuestion(currentPageIndex) ? this.getQuestionNumber() : this.getInterstitialNumber();
      onUpdateQuestionNumber(currentQuestionNumber);
      this.setProgress(currentPageIndex);
    } // this handles the behavior of updating the progress bar when going to next page or going back

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          currentPageIndex = _this$props2.currentPageIndex,
          onUpdateQuestionNumber = _this$props2.onUpdateQuestionNumber;
      var onQuestion = this.onQuestion(currentPageIndex);

      if (prevProps.currentPageIndex !== currentPageIndex) {
        this.setProgress(currentPageIndex);
        var newCurrentQuestionNumber = onQuestion ? this.getQuestionNumber(currentPageIndex) : this.getInterstitialNumber(currentPageIndex);
        setTimeout(function () {
          onUpdateQuestionNumber(newCurrentQuestionNumber);
        }, 500);
      }
    }
  }, {
    key: "onQuestion",
    value: function onQuestion(pageIndex) {
      var questionsPageIndex = this.props.questionsPageIndex;
      return questionsPageIndex.some(function (questionIndex) {
        return questionIndex === pageIndex;
      });
    }
  }, {
    key: "getQuestionNumber",
    value: function getQuestionNumber(index) {
      var _this$props3 = this.props,
          questionsPageIndex = _this$props3.questionsPageIndex,
          currentPageIndex = _this$props3.currentPageIndex;
      var pageIndex = index || currentPageIndex;
      var questionNumber = 0;

      forEach_1(questionsPageIndex, function (questionIndex, i) {
        if (questionIndex === pageIndex) {
          questionNumber = i + 1;
        }
      });

      return questionNumber;
    }
  }, {
    key: "getInterstitialNumber",
    value: function getInterstitialNumber(index) {
      var _this$props4 = this.props,
          currentPageIndex = _this$props4.currentPageIndex,
          questionsPageIndex = _this$props4.questionsPageIndex;
      var pageIndex = index || currentPageIndex;
      var interstitialNumber = 0;

      for (var i = 0; i < questionsPageIndex.length; i += 1) {
        if (questionsPageIndex[i] > pageIndex) {
          interstitialNumber = i;
          return interstitialNumber;
        }
      }

      return interstitialNumber;
    }
  }, {
    key: "getProgress",
    value: function getProgress(currentPageIndex) {
      var questionsPageIndex = this.props.questionsPageIndex; // default to 0;

      var progress = 0;
      var lastQuestion = questionsPageIndex[questionsPageIndex.length - 1]; // on a landing page after the last question

      if (lastQuestion < currentPageIndex) {
        progress = questionsPageIndex.length;
      } else {
        for (var i = 0; i < questionsPageIndex.length; i += 1) {
          var questionPageIndex = questionsPageIndex[i];

          if (questionPageIndex === currentPageIndex || questionPageIndex > currentPageIndex) {
            progress = i;
            return progress;
          }
        }
      }

      return progress;
    }
  }, {
    key: "setProgress",
    value: function setProgress(currentPageIndex) {
      var progress = this.getProgress(currentPageIndex);
      this.setState({
        progress: progress
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          total = _this$props5.total,
          currentPageIndex = _this$props5.currentPageIndex,
          questionNumber = _this$props5.questionNumber,
          hideProgress = _this$props5.hideProgress,
          className = _this$props5.className,
          onLogoClick = _this$props5.onLogoClick;
      var progress = this.state.progress;
      var onQuestion = this.onQuestion(currentPageIndex);
      var finishedSurvey = !onQuestion && questionNumber === total;
      var showQuestionNumbers = questionNumber > 0 && !finishedSurvey; // const showQuestionNumbers = !finishedSurvey;

      var width = progress / total * 100;
      var widthPercentage = width > 0 ? "".concat(width, "%") : '0px';
      var classes = classnames('zola-ui', 'progress-bar__container', className);
      return React.createElement("div", {
        className: classes
      }, React.createElement("a", {
        href: "/",
        onClick: onLogoClick
      }, React.createElement("img", {
        src: heartsImagefile,
        alt: "Zola Hearts Logo",
        id: "zola-ui-logo-hearts"
      })), !hideProgress && React.createElement("div", {
        className: "progress-bar__total"
      }, React.createElement("div", {
        className: "progress-bar__progress",
        style: {
          width: widthPercentage
        }
      })), showQuestionNumbers && React.createElement("div", {
        className: "progress-bar__question-numbers"
      }, questionNumber, " of ", total));
    }
  }]);

  return ProgressBar;
}(Component);

ProgressBar.defaultProps = {
  onLogoClick: function onLogoClick() {}
};
ProgressBar.propTypes = {
  currentPageIndex: propTypes.number,
  total: propTypes.number,
  questionsPageIndex: propTypes.arrayOf(propTypes.number),
  questionNumber: propTypes.number,
  onUpdateQuestionNumber: propTypes.func,
  hideProgress: propTypes.bool,
  className: propTypes.string,
  onLogoClick: propTypes.func
};

var OnboardRenderFieldWrapper = function OnboardRenderFieldWrapper(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return React.createElement("div", {
    className: classnames('onboard-input-field__container', className)
  }, children);
};

OnboardRenderFieldWrapper.propTypes = {
  className: propTypes.string,
  children: propTypes.node
};

var ProgressBarV2 = function ProgressBarV2(_ref) {
  var totalQuestions = _ref.totalQuestions,
      currentQuestionIndex = _ref.currentQuestionIndex,
      onLogoClick = _ref.onLogoClick,
      showQuestionNumbers = _ref.showQuestionNumbers,
      className = _ref.className,
      hideProgress = _ref.hideProgress;
  var width = currentQuestionIndex / totalQuestions * 100;
  var widthPercentage = width > 0 ? "".concat(width, "%") : '0px';
  return React.createElement("div", {
    className: classnames('zola-ui', 'progress-bar__container', className)
  }, React.createElement("a", {
    href: "/",
    onClick: onLogoClick
  }, React.createElement("img", {
    src: heartsImagefile,
    alt: "Zola Hearts Logo",
    id: "zola-ui-logo-hearts"
  })), !hideProgress && React.createElement("div", {
    className: "progress-bar__total"
  }, React.createElement("div", {
    className: "progress-bar__progress",
    style: {
      width: widthPercentage
    }
  })), showQuestionNumbers && React.createElement("div", {
    className: "progress-bar__question-numbers"
  }, currentQuestionIndex, " of ", totalQuestions));
};

ProgressBarV2.defaultProps = {
  onLogoClick: function onLogoClick() {}
};
ProgressBarV2.propTypes = {
  currentQuestionIndex: propTypes.number,
  onLogoClick: propTypes.func,
  totalQuestions: propTypes.number,
  showQuestionNumbers: propTypes.bool,
  hideProgress: propTypes.bool,
  className: propTypes.string
};

var Account = function Account(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Account' : _ref$title,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 14 16' : _ref$viewBox,
      props = _objectWithoutProperties(_ref, ["title", "viewBox"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: viewBox
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.727 0C4.602 0 2.883 1.672 2.883 3.734c0 1.645 1.097 3.043 2.617 3.54C2.355 7.886 0 10.82 0 14.311c0 .516.43.934.96.934.532 0 .962-.418.962-.934 0-2.94 2.176-5.289 4.805-5.289 2.628 0 4.804 2.348 4.804 5.29 0 .515.43.933.957.933.532 0 .961-.418.961-.934 0-3.492-2.355-6.425-5.5-7.039 1.524-.496 2.621-1.894 2.621-3.539C10.57 1.672 8.848 0 6.727 0zm0 1.867c1.058 0 1.921.836 1.921 1.867 0 1.032-.863 1.868-1.921 1.868-1.063 0-1.922-.836-1.922-1.868 0-1.03.86-1.867 1.922-1.867zm0 0"
  }));
};

Account.propTypes = {
  title: propTypes.string,
  viewBox: propTypes.string
};

var Add = function Add(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Add' : _ref$title,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 20 20' : _ref$viewBox,
      props = _objectWithoutProperties(_ref, ["title", "viewBox"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: viewBox
  }, props), React.createElement("path", {
    d: "M10 20C4.5 20 0 15.5 0 10S4.5 0 10 0s10 4.5 10 10-4.5 10-10 10zm0-18.5c-4.7 0-8.5 3.8-8.5 8.5s3.8 8.5 8.5 8.5 8.5-3.8 8.5-8.5-3.8-8.5-8.5-8.5zm.8 11.7H9.2v-2.5H6.8V9.2h2.5V6.8h1.5v2.5h2.5v1.5h-2.5v2.4z"
  }));
};

Add.propTypes = {
  title: propTypes.string,
  viewBox: propTypes.string
};

var Airplane = function Airplane(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Airplane' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54 15.542l-6.319-1.718C.057 13.507-.126 11.95.897 11.36l.072-.038L19.71 1.878c.963-.63 2.217.25 2.058 1.32v14.189c0 .848-.771 1.477-1.592 1.324l-.077-.017-6.433-1.589-2.692 4.556c-.639 1.082-2.28.777-2.487-.462l-.947-5.657zm.946-2.533l-3.17-.862 8.174-4.12-5.004 4.982zm10.59-5.058l-3.98 6.734 3.98.982V7.951zm-5.178 3.47l-3.365 5.694-.337-2.01 3.702-3.685z"
  }));
};

Airplane.propTypes = {
  title: propTypes.string
};

var Alert = function Alert(props) {
  return React.createElement(CreateIconComponent, _extends({
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.392 20.6668L11.9997 2.3335L1.60742 20.6668H22.392ZM12.0557 16.8615C12.6437 16.8615 13.1117 17.3295 13.1117 17.9175C13.1117 18.5055 12.6437 18.9735 12.0557 18.9735C11.4677 18.9735 10.9997 18.5055 10.9997 17.9175C10.9997 17.3295 11.4677 16.8615 12.0557 16.8615ZM13.313 8.00039L12.9797 15.1297H11.1317L10.7983 8.00039H13.313Z"
  }));
};

Alert.propTypes = {
  title: propTypes.string,
  viewBox: propTypes.string,
  style: propTypes.shape({})
};
Alert.defaultProps = {
  title: 'Alert',
  style: {
    // This icon was initially imported with a fill color
    color: '#FF9A00'
  }
};

var Calendar = function Calendar(props) {
  return React.createElement(CreateIconComponent, _extends({
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.38 1.056a1.122 1.122 0 00-2.241.066v.374H2.147c-.62 0-1.122.502-1.122 1.121v15.706c0 .62.503 1.121 1.122 1.121h15.705c.62 0 1.122-.502 1.122-1.121V2.617c0-.62-.502-1.121-1.122-1.121h-2.991v-.374l-.002-.066a1.122 1.122 0 00-2.242.066v.374H7.382v-.374l-.002-.066zm9.35 5.3V3.74h-1.87V4.86a1.122 1.122 0 01-2.24.066l-.003-.066V3.74H7.382V4.86a1.122 1.122 0 01-2.241.066l-.002-.066V3.74h-1.87v2.617h13.462zM3.27 8.6h13.46v8.601H3.27v-8.6zm8.933 6.73v-1.447h-1.95c1.473-.864 1.9-1.481 1.9-2.23 0-1.102-.929-1.892-2.352-1.892-.765 0-1.687.255-2.32.93l.905 1.102c.42-.353.864-.567 1.415-.567.386 0 .666.164.666.427 0 .412-.238.617-2.747 2.386v1.292h4.483z"
  }));
};

Calendar.propTypes = {
  title: propTypes.string,
  style: propTypes.shape({})
};
Calendar.defaultProps = {
  title: 'Calendar',
  style: {
    // This icon was initially imported with a fill color
    color: '#505050'
  }
};

var Caret = function Caret(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Caret' : _ref$title,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 8 5' : _ref$viewBox,
      props = _objectWithoutProperties(_ref, ["title", "viewBox"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: viewBox
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.293.293a1 1 0 011.414 0L4 2.586 6.293.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
  }));
};

Caret.propTypes = {
  title: propTypes.string,
  viewBox: propTypes.string
};

var Cart = function Cart(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Cart' : _ref$title,
      viewBox = _ref.viewBox,
      props = _objectWithoutProperties(_ref, ["title", "viewBox"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: viewBox
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.45 1.047a.857.857 0 00-.825-.664H.879C.434.41.082.797.082 1.27v.05c.027.47.395.84.848.84h.996l1.847 9.945.012.051c.094.39.434.668.82.668h1.7c-.782 0-1.414.664-1.414 1.485 0 .816.632 1.48 1.414 1.48.78 0 1.414-.664 1.414-1.48 0-.82-.633-1.485-1.414-1.485h4.804c-.777 0-1.414.664-1.414 1.485 0 .816.637 1.48 1.414 1.48.782 0 1.414-.664 1.414-1.48 0-.82-.632-1.485-1.414-1.485h1.75c.446-.027.797-.414.797-.886v-.055c-.027-.465-.394-.836-.847-.836H5.305l-.11-.594h7.668a.852.852 0 00.727-.543l2.262-5.629.02-.047c.194-.574-.212-1.187-.802-1.187H3.82l-.36-1.945zm.702 3.777l.715 3.852h7.38l1.546-3.852zm0 0"
  }));
};

Cart.propTypes = {
  title: propTypes.string,
  viewBox: propTypes.string
};
Cart.defaultProps = {
  viewBox: '0 0 16 16'
};

var CheckmarkCircle = function CheckmarkCircle(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'CheckmarkCircle' : _ref$title,
      viewBox = _ref.viewBox,
      props = _objectWithoutProperties(_ref, ["title", "viewBox"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: viewBox
  }, props), React.createElement("g", {
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h16v16H0z",
    fill: "none"
  }), React.createElement("path", {
    d: "M8 .444a7.556 7.556 0 110 15.112A7.556 7.556 0 018 .444zm2.975 4.81l-.025.022-4.47 4.471L5.151 8.42a.445.445 0 00-.605-.023l-.024.023a.443.443 0 00-.022.604l.022.024 1.957 1.957 5.1-5.1a.445.445 0 00-.604-.651z"
  })));
};

CheckmarkCircle.propTypes = {
  title: propTypes.string,
  viewBox: propTypes.string
};
CheckmarkCircle.defaultProps = {
  viewBox: '0 0 16 16'
};

var Close = function Close(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Close' : _ref$title,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 20 18' : _ref$viewBox,
      props = _objectWithoutProperties(_ref, ["title", "viewBox"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: viewBox
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.57.57a1.5 1.5 0 01.06 2.057l-.06.064-6.449 6.448 6.28 6.28a1.5 1.5 0 01-2.057 2.182l-.064-.06L10 11.26l-6.28 6.28a1.5 1.5 0 01-2.181-2.058l.06-.064 6.28-6.28L1.43 2.69A1.5 1.5 0 013.488.509l.064.06L10 7.019 16.448.57a1.5 1.5 0 012.122 0z"
  }));
};

Close.propTypes = {
  title: propTypes.string,
  viewBox: propTypes.string
};

var DeleteIcon = function DeleteIcon(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Delete' : _ref$title,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'delete-icon' : _ref$className,
      viewBox = _ref.viewBox,
      props = _objectWithoutProperties(_ref, ["title", "className", "viewBox"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    className: className,
    viewBox: viewBox
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.473.527c1.027 0 1.87.758 1.941 1.715l.004.125h3.238c.36 0 .649.278.649.617 0 .32-.262.586-.598.61l-.05.004h-.684l-.547 9.468c-.051.938-.836 1.676-1.805 1.739l-.137.004H4.516c-.989 0-1.813-.7-1.93-1.614l-.012-.129-.55-9.468h-.68c-.36 0-.649-.278-.649-.614 0-.324.262-.59.598-.613l.05-.004h3.239c0-.972.8-1.773 1.813-1.836l.132-.004zm3.203 3.07H3.324L3.867 13c.016.281.23.512.512.566l.086.012.05.004h5.97a.638.638 0 00.636-.5l.012-.082zM9.12 5.88c.34 0 .621.25.645.57l.004.043v5.606c0 .34-.293.617-.649.617a.637.637 0 01-.648-.57V6.492c0-.34.289-.613.648-.613zm-3.242 0c.344 0 .621.25.648.57v5.649c0 .34-.289.617-.648.617-.34 0-.621-.25-.645-.57l-.004-.047V6.492c0-.34.293-.613.649-.613zm2.594-4.125H6.527a.636.636 0 00-.64.531l-.008.082H9.12a.625.625 0 00-.52-.601l-.081-.008zm0 0"
  }));
};

DeleteIcon.propTypes = {
  title: propTypes.string,
  className: propTypes.string,
  viewBox: propTypes.string
};
DeleteIcon.defaultProps = {
  viewBox: '0 0 16 16'
};

var DownArrow = function DownArrow(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Down Arrow' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: "0 0 10 17"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.533 10.687a1.188 1.188 0 00.005 1.68l4.498 4.467 4.497-4.467.048-.05a1.188 1.188 0 00-.042-1.63l-.05-.048a1.188 1.188 0 00-1.63.042l-1.635 1.624V1.355l-.002-.07a1.188 1.188 0 00-2.375.07v10.95L2.213 10.68l-.05-.048a1.188 1.188 0 00-1.63.054z"
  }));
};

DownArrow.propTypes = {
  title: propTypes.string
};

/** A CaretIcon that isn't as thick.  This could be the same as LeftCaret and RightCaret with a position/rotation applied, but here we are. */

var DownCaret = function DownCaret(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'LeftCaret' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: "0 0 14 8"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.285 7.701a1.027 1.027 0 001.459-.01l5.937-5.919A1.02 1.02 0 0014 1.034 1.028 1.028 0 0012.257.3l-.003-.004-5.226 5.19L1.764.301 1.76.305A1.028 1.028 0 000 1.027c0 .298.13.561.333.748l5.95 5.93.002-.004z"
  }));
};

DownCaret.propTypes = {
  title: propTypes.string
};

var Download = function Download(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Download' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: "0 0 32 38"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 35.258a2 2 0 01-2 2H2l-.15-.006A2 2 0 012 33.258h28l.15.005A2 2 0 0132 35.258zm-4.333-15.625a2 2 0 00-2.71-2.939l-.109.101-6.598 6.553-.255-21.372a2 2 0 00-3.996-.102l-.004.15.254 21.213-6.485-6.442a2 2 0 00-2.72-.092l-.109.102a2 2 0 00-.092 2.72l.102.109 11.36 11.282 11.362-11.282z"
  }));
};

Download.propTypes = {
  title: propTypes.string
};

var EditIcon = function EditIcon(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Edit' : _ref$title,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'edit-icon' : _ref$className,
      viewBox = _ref.viewBox,
      props = _objectWithoutProperties(_ref, ["title", "className", "viewBox"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    className: className,
    viewBox: viewBox
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.645 1.535a3.659 3.659 0 010 5.176l-8.493 8.492a.715.715 0 01-.43.211l-4.706.566a.734.734 0 01-.813-.816l.567-4.707a.755.755 0 01.207-.43l8.492-8.492a3.659 3.659 0 015.176 0zM4.91 11.211l-2.66-.387-.059.063-.421 3.527 3.527-.422.016-.015zm7.149-3.98L8.953 4.124l-5.41 5.406 2.121.309c.297.043.54.265.606.558l.011.063.324 2.223zm1.55-4.66a2.2 2.2 0 00-3.105 0l-.516.519 3.106 3.105.515-.52c.84-.835.86-2.183.059-3.046zm0 0"
  }));
};

EditIcon.propTypes = {
  title: propTypes.string,
  className: propTypes.string,
  viewBox: propTypes.string
};
EditIcon.defaultProps = {
  viewBox: '0 0 16 16'
};

var Exclamation = function Exclamation(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'ExclamationMark' : _ref$title,
      viewBox = _ref.viewBox,
      props = _objectWithoutProperties(_ref, ["title", "viewBox"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: viewBox
  }, props), React.createElement("g", {
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h16v16H0z",
    fill: "none"
  }), React.createElement("path", {
    d: "M8 .444a7.556 7.556 0 110 15.112A7.556 7.556 0 018 .444zm-.049 9.79a.848.848 0 00-.84.828c0 .456.384.84.84.84a.84.84 0 00.828-.84.838.838 0 00-.828-.828zm.756-6.456H7.171L7.4 9.322h1.092l.216-5.544z"
  })));
};

Exclamation.propTypes = {
  title: propTypes.string,
  viewBox: propTypes.string
};
Exclamation.defaultProps = {
  viewBox: '0 0 16 16'
};

var GiftTracker = function GiftTracker(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'GiftTracker' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: "0 0 30 26"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), React.createElement("g", {
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M4 1.5a.5.5 0 00-.5.5v8a.5.5 0 00.5.5h8a.5.5 0 00.5-.5V2a.5.5 0 00-.5-.5H4zM4 0h8a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V2a2 2 0 012-2zM18 1.5a.5.5 0 00-.5.5v8a.5.5 0 00.5.5h8a.5.5 0 00.5-.5V2a.5.5 0 00-.5-.5h-8zM18 0h8a2 2 0 012 2v8a2 2 0 01-2 2h-8a2 2 0 01-2-2V2a2 2 0 012-2zM4 15.5a.5.5 0 00-.5.5v8a.5.5 0 00.5.5h8a.5.5 0 00.5-.5v-8a.5.5 0 00-.5-.5H4zM4 14h8a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2v-8a2 2 0 012-2zM18 15.5a.5.5 0 00-.5.5v8a.5.5 0 00.5.5h8a.5.5 0 00.5-.5v-8a.5.5 0 00-.5-.5h-8zm0-1.5h8a2 2 0 012 2v8a2 2 0 01-2 2h-8a2 2 0 01-2-2v-8a2 2 0 012-2z"
  }))));
};

GiftTracker.propTypes = {
  title: propTypes.string
};

var InfoFilled = function InfoFilled(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Info' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3332 11.9998C23.3332 18.2591 18.2591 23.3332 11.9998 23.3332C5.74061 23.3332 0.666504 18.2591 0.666504 11.9998C0.666504 5.74061 5.74061 0.666504 11.9998 0.666504C18.2591 0.666504 23.3332 5.74061 23.3332 11.9998ZM12.0558 9.7785C12.6438 9.7785 13.1118 9.3105 13.1118 8.7225C13.1118 8.1345 12.6438 7.6665 12.0558 7.6665C11.4678 7.6665 10.9998 8.1345 10.9998 8.7225C10.9998 9.3105 11.4678 9.7785 12.0558 9.7785ZM12.9798 16.3065V10.5105H11.1318V16.3065H12.9798Z"
  }));
};

InfoFilled.propTypes = {
  title: propTypes.string
};

var LeftCaret = function LeftCaret(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'LeftCaret' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: "0 0 9 15"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.799 6.785a1.027 1.027 0 00.01 1.459l5.919 5.937c.187.195.447.319.738.319a1.028 1.028 0 00.735-1.743l.004-.003-5.19-5.226 5.184-5.264-.004-.004A1.028 1.028 0 007.473.5c-.298 0-.561.13-.748.333l-5.93 5.95.004.002z"
  }));
};

LeftCaret.propTypes = {
  title: propTypes.string
};

var Link$1 = function Link(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Link' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: "0 0 25 24"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.88 3.214c-1.8-1.8-4.626-1.977-6.32-.282l-3.247 3.247-.052.055a1.273 1.273 0 001.852 1.746l3.248-3.248.057-.053c.658-.588 1.834-.492 2.662.336.852.852.928 2.072.282 2.718L14.596 12.5l-.057.054c-.659.587-1.835.491-2.662-.337l-.055-.05a1.273 1.273 0 00-1.746 1.851c1.8 1.8 4.626 1.977 6.32.283l4.767-4.767.081-.084c1.607-1.702 1.407-4.466-.364-6.236zm-6.77 6.77c-1.8-1.8-4.626-1.976-6.32-.282l-4.766 4.766-.082.084c-1.606 1.703-1.406 4.466.364 6.236 1.8 1.8 4.626 1.977 6.32.283l3.248-3.248.051-.054a1.273 1.273 0 00-1.852-1.747L7.826 19.27l-.057.054c-.659.587-1.834.491-2.662-.337-.852-.851-.928-2.072-.282-2.718l4.766-4.767.057-.053c.659-.588 1.834-.492 2.662.336l.054.051a1.273 1.273 0 001.746-1.852z"
  }), ' ');
};

Link$1.propTypes = {
  title: propTypes.string
};

var Lock = function Lock(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Lock' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.515 9.242h1.97c.653 0 1.182.529 1.182 1.181v10.243c0 .652-.53 1.182-1.182 1.182H4.515c-.653 0-1.182-.53-1.182-1.182V10.423c0-.652.53-1.181 1.182-1.181h1.97V7.957c0-3.19 2.451-5.806 5.515-5.806 3.024 0 5.45 2.548 5.514 5.68l.001.126v1.285zm-1.21 2.363H7.695a1.42 1.42 0 01-.059 0h-1.94v7.88h12.606v-7.88H16.304zm-1.153-2.363V7.957c0-1.917-1.43-3.442-3.152-3.442-1.691 0-3.1 1.47-3.15 3.338l-.001.104v1.285h6.303zm-2.364 6.487a1.575 1.575 0 10-1.576 0v1.393l.002.059a.788.788 0 001.574-.059V15.73z"
  }));
};

Lock.propTypes = {
  title: propTypes.string
};

var Mail = function Mail(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Mail' : _ref$title,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 16' : _ref$viewBox,
      props = _objectWithoutProperties(_ref, ["title", "viewBox"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: viewBox
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.955 2.484H5.045l6.71 4.904c.132.095.305.105.444.028l.045-.028 6.71-4.904zM.775.09A1.236 1.236 0 000 1.263v13.22c0 .685.556 1.241 1.242 1.241h21.517c.685 0 1.241-.556 1.241-1.241V1.242a1.231 1.231 0 00-.29-.799A1.233 1.233 0 0022.734 0H1.265a1.248 1.248 0 00-.49.091zm19.092 13.151L15.04 8.42l-1.331.972a2.897 2.897 0 01-3.322.068l-.096-.068-1.273-.93-4.786 4.78h15.635zm1.65-1.861V3.686L17.07 6.937l4.448 4.444zM2.483 3.686v7.794L6.989 6.98 2.483 3.686z"
  }));
};

Mail.propTypes = {
  title: propTypes.string,
  viewBox: propTypes.string
};

var ManageRegistry = function ManageRegistry(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'ManageRegistry' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: "0 0 30 24"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), React.createElement("g", {
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M2 12.5a.5.5 0 00-.5.5v8a.5.5 0 00.5.5h4a.5.5 0 00.5-.5v-8a.5.5 0 00-.5-.5H2zM2 11h4a2 2 0 012 2v8a2 2 0 01-2 2H2a2 2 0 01-2-2v-8a2 2 0 012-2zM12.91 12.5a.5.5 0 00-.5.5v8a.5.5 0 00.5.5h4a.5.5 0 00.5-.5v-8a.5.5 0 00-.5-.5h-4zm0-1.5h4a2 2 0 012 2v8a2 2 0 01-2 2h-4a2 2 0 01-2-2v-8a2 2 0 012-2zM24 12.5a.5.5 0 00-.5.5v8a.5.5 0 00.5.5h4a.5.5 0 00.5-.5v-8a.5.5 0 00-.5-.5h-4zm0-1.5h4a2 2 0 012 2v8a2 2 0 01-2 2h-4a2 2 0 01-2-2v-8a2 2 0 012-2zM14.91 6.59a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm-3.93-1.75H.762A.756.756 0 010 4.09c0-.413.341-.75.763-.75h10.216a4.001 4.001 0 017.86 0h10.398c.422 0 .763.337.763.75 0 .415-.341.75-.763.75H18.84a4.001 4.001 0 01-7.86 0z"
  }))));
};

ManageRegistry.propTypes = {
  title: propTypes.string
};

var Overview = function Overview(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Overview' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: "0 0 30 24"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), React.createElement("g", {
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M3 17a2 2 0 110-4 2 2 0 010 4zm0-1.5a.5.5 0 100-1 .5.5 0 000 1zM9 17a2 2 0 110-4 2 2 0 010 4zm0-1.5a.5.5 0 100-1 .5.5 0 000 1zM15 17a2 2 0 110-4 2 2 0 010 4zm0-1.5a.5.5 0 100-1 .5.5 0 000 1zM21 17a2 2 0 110-4 2 2 0 010 4zm0-1.5a.5.5 0 100-1 .5.5 0 000 1zM9 23a2 2 0 110-4 2 2 0 010 4zm0-1.5a.5.5 0 100-1 .5.5 0 000 1zM15 23a2 2 0 110-4 2 2 0 010 4zm0-1.5a.5.5 0 100-1 .5.5 0 000 1zM21 23a2 2 0 110-4 2 2 0 010 4zm0-1.5a.5.5 0 100-1 .5.5 0 000 1zM27 17a2 2 0 110-4 2 2 0 010 4zm0-1.5a.5.5 0 100-1 .5.5 0 000 1z"
  })), React.createElement("rect", {
    width: "12.5",
    height: "7.5",
    x: ".75",
    y: ".75",
    stroke: "currentColor",
    strokeWidth: "1.5",
    rx: "2"
  }), React.createElement("rect", {
    width: "12.5",
    height: "7.5",
    x: "16.75",
    y: ".75",
    stroke: "currentColor",
    strokeWidth: "1.5",
    rx: "2"
  })));
};

Overview.propTypes = {
  title: propTypes.string
};

var Preview = function Preview(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Preview' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: "0 0 40 41"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.172 4.935L20.586 17.521l-.102.11a2 2 0 002.93 2.719L36 7.764v5.473l.005.15a2 2 0 003.995-.15v-10.3V.936H28l-.15.005A2 2 0 0026 2.936l.006.149A2 2 0 0028 4.935h5.172zM18 4.935a2 2 0 01.15 3.995l-.15.006H4v28h28v-14a2 2 0 011.85-1.995l.15-.005a2 2 0 011.995 1.85l.005.15v16a2 2 0 01-1.85 1.994l-.15.005H2a2 2 0 01-1.995-1.85L0 38.935v-32a2 2 0 011.85-1.994L2 4.936h16z"
  }));
};

Preview.propTypes = {
  title: propTypes.string
};

var RegistryChecklist = function RegistryChecklist(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'RegistryChecklist' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: "0 0 30 24"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), React.createElement("g", {
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M5 4.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM5 6a3 3 0 110-6 3 3 0 010 6zM11.75 3.75a.75.75 0 010-1.5h15.5a.75.75 0 110 1.5h-15.5zM5 13.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM5 15a3 3 0 110-6 3 3 0 010 6zM11.75 12.75a.75.75 0 010-1.5h15.5a.75.75 0 110 1.5h-15.5z"
  }), React.createElement("g", null, React.createElement("path", {
    d: "M5 22.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM5 24a3 3 0 110-6 3 3 0 010 6zM11.75 21.75a.75.75 0 010-1.5h15.5a.75.75 0 110 1.5h-15.5z"
  })))));
};

RegistryChecklist.propTypes = {
  title: propTypes.string
};

var RightCaret = function RightCaret(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'RightCaret' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: "0 0 9 15"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.201 8.215a1.027 1.027 0 00-.01-1.459L2.271.82A1.02 1.02 0 001.534.5 1.028 1.028 0 00.8 2.243l-.004.003 5.19 5.226-5.184 5.264.004.004a1.028 1.028 0 00.722 1.76c.298 0 .561-.13.748-.333l5.93-5.95-.004-.002z"
  }));
};

RightCaret.propTypes = {
  title: propTypes.string
};

var Search = function Search(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Search' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    fillOpacity: ".01",
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.042.667a9.376 9.376 0 000 18.751 9.333 9.333 0 005.448-1.744l5.205 5.206.074.07a1.546 1.546 0 002.112-2.256l-5.206-5.205a9.334 9.334 0 001.743-5.447A9.376 9.376 0 0010.042.668zm0 3.09a6.285 6.285 0 110 12.57 6.285 6.285 0 010-12.57z"
  }));
};

Search.propTypes = {
  title: propTypes.string
};

var Star = function Star(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Star' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: "0 0 72 72"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.56 22.632l-19.33 2.81-.151.027c-1.529.336-2.108 2.263-.958 3.384L19.11 42.487l-3.302 19.254-.02.148c-.156 1.56 1.5 2.709 2.922 1.96L36 54.76l17.29 9.09.135.065c1.435.631 3.04-.588 2.768-2.173L52.89 42.487 66.88 28.853l.106-.111c1.039-1.17.375-3.07-1.215-3.3l-19.33-2.81-8.646-17.517c-.734-1.487-2.854-1.487-3.587 0L25.56 22.632z"
  }));
};

Star.propTypes = {
  title: propTypes.string
};

var StarOutline = function StarOutline(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Outline Star' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: "0 0 64 61"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.56 18.632l-19.33 2.81-.151.027c-1.529.336-2.108 2.263-.958 3.384L15.11 38.487l-3.302 19.254-.02.148c-.156 1.56 1.5 2.709 2.922 1.96L32 50.76l17.29 9.09.135.065c1.435.631 3.04-.588 2.768-2.173L48.89 38.487 62.88 24.853l.106-.111c1.039-1.17.375-3.07-1.215-3.3l-19.33-2.81-8.646-17.517c-.734-1.487-2.854-1.487-3.587 0L21.56 18.632zM32 6.519l7.317 14.826.079.144a2 2 0 001.427.95l16.361 2.377-11.839 11.542-.112.119a2 2 0 00-.463 1.65l2.795 16.296-14.634-7.693-.162-.076a2 2 0 00-1.7.076l-14.635 7.693 2.796-16.295.021-.163a2 2 0 00-.596-1.607L6.815 24.816l16.362-2.377a2 2 0 001.506-1.094L32 6.52z"
  }));
};

StarOutline.propTypes = {
  title: propTypes.string
};

var Unlock = function Unlock(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Unlock' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.334 8.655c.652 0 1.181-.53 1.181-1.182 0-3.19-2.451-5.806-5.515-5.806-3.064 0-5.515 2.616-5.515 5.806V9.94h-1.97c-.653 0-1.182.53-1.182 1.182v10.243c0 .652.53 1.181 1.182 1.181h14.97c.653 0 1.182-.529 1.182-1.181V11.12c0-.652-.53-1.182-1.182-1.182H8.849V7.473l.001-.104C8.9 5.5 10.31 4.03 12 4.03c1.723 0 3.152 1.525 3.152 3.443l.002.07c.036.62.55 1.112 1.18 1.112zm1.97 11.527v-7.879H5.696v7.879h12.606zm-5.516-3.756a1.575 1.575 0 10-1.576 0v1.392l.002.059a.788.788 0 001.574-.059v-1.392z"
  }));
};

Unlock.propTypes = {
  title: propTypes.string
};

var UpArrow = function UpArrow(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Up Arrow' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: "0 0 11 17"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.236 6.315a1.188 1.188 0 00-.006-1.68L5.732.167 1.235 4.634l-.048.05a1.188 1.188 0 00.042 1.63l.05.049c.466.417 1.182.403 1.63-.042l1.635-1.624v10.949l.002.07a1.188 1.188 0 002.375-.07V4.697l1.634 1.624.051.047a1.188 1.188 0 001.63-.053z"
  }));
};

UpArrow.propTypes = {
  title: propTypes.string
};

var UploadIcon = function UploadIcon(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Upload' : _ref$title,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'upload-icon' : _ref$className,
      viewBox = _ref.viewBox,
      props = _objectWithoutProperties(_ref, ["title", "className", "viewBox"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    className: className,
    viewBox: viewBox
  }, props), React.createElement("path", {
    d: "M8.25 5.703c.113 0 .227.055.309.14l2.312 2.493a.497.497 0 010 .668.41.41 0 01-.613 0l-1.57-1.691v7.773c0 .262-.196.469-.438.469s-.438-.207-.438-.47V7.313l-1.57 1.692a.402.402 0 01-.304.137.418.418 0 01-.31-.137.497.497 0 010-.668l2.313-2.492a.422.422 0 01.309-.14zM8.441 0c1.16 0 2.27.453 3.125 1.273a4.9 4.9 0 011.446 2.774c1.726.476 2.984 2.2 2.988 4.133a4.401 4.401 0 01-1.074 2.894c-.696.809-1.633 1.29-2.637 1.367H9.816a.452.452 0 01-.445-.464c0-.258.195-.465.445-.465h2.422c1.586-.13 2.875-1.617 2.875-3.332 0-1.617-1.105-3.035-2.57-3.297a.457.457 0 01-.371-.414C11.988 2.449 10.387.926 8.445.926c-1.445 0-2.773.883-3.386 2.25a.441.441 0 01-.559.238 1.515 1.515 0 00-.563-.105c-.906 0-1.648.777-1.648 1.73 0 .211.035.406.098.594a.474.474 0 01-.192.562C1.387 6.687.887 7.602.887 8.575c0 1.51 1.133 2.85 2.48 2.937h2.817c.246 0 .441.207.441.468a.451.451 0 01-.441.465H3.328c-.898-.05-1.734-.496-2.371-1.25A4.068 4.068 0 010 8.578c0-1.183.55-2.293 1.453-2.98a3.219 3.219 0 01-.05-.555c0-1.465 1.136-2.656 2.534-2.656.165 0 .329.015.489.047A4.715 4.715 0 015.93.777 4.455 4.455 0 018.44 0zm0 0"
  }));
};

UploadIcon.propTypes = {
  title: propTypes.string,
  className: propTypes.string,
  viewBox: propTypes.string
};
UploadIcon.defaultProps = {
  viewBox: '0 0 16 16'
};

var YourPerks = function YourPerks(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'YourPerks' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(CreateIconComponent, _extends({
    title: title,
    viewBox: "0 0 30 30"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M15 26.5c6.351 0 11.5-5.149 11.5-11.5S21.351 3.5 15 3.5 3.5 8.649 3.5 15 8.649 26.5 15 26.5zm0 1.5C7.82 28 2 22.18 2 15S7.82 2 15 2s13 5.82 13 13-5.82 13-13 13z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M15 17.305l2.71 1.425-.517-3.018 2.192-2.137-3.03-.44L15 10.389l-1.355 2.746-3.03.44 2.192 2.137-.517 3.018L15 17.305zM15 19l-4.702 2.472.898-5.236-3.804-3.708 5.257-.764L15 7l2.351 4.764 5.257.764-3.804 3.708.898 5.236L15 19z"
  })));
};

YourPerks.propTypes = {
  title: propTypes.string
};

/* keep this alphabetical please */

var SegmentControl =
/*#__PURE__*/
function (_Component) {
  _inherits(SegmentControl, _Component);

  function SegmentControl(prop) {
    var _this;

    _classCallCheck(this, SegmentControl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SegmentControl).call(this, prop));
    _this.state = {
      activeSegment: null
    };
    return _this;
  }

  _createClass(SegmentControl, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          activeSegment = _this$props.activeSegment,
          segments = _this$props.segments;
      this.setState({
        activeSegment: segments[activeSegment].key
      });
    }
  }, {
    key: "onSegmentClick",
    value: function onSegmentClick(key) {
      var onClick = this.props.onClick;
      this.setState({
        activeSegment: key
      });
      onClick(key);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          segments = _this$props2.segments,
          className = _this$props2.className,
          compact = _this$props2.compact;
      var activeSegment = this.state.activeSegment;
      var containerClassName = classnames('segment-control_btn-group', className);
      var segmentBlocks = segments.map(function (_ref) {
        var key = _ref.key,
            icon = _ref.icon,
            text = _ref.text;
        var labelClassName = classnames('zola-ui segment-control_btn', {
          active: activeSegment === key,
          'icon-only': !text,
          compact: compact
        });
        var formattedText = text ? " ".concat(text) : null;
        return React.createElement("button", {
          type: "button",
          className: labelClassName,
          onClick: function onClick() {
            _this2.onSegmentClick(key);
          },
          key: key,
          name: key
        }, React.createElement("h6", null, icon, formattedText));
      });
      return React.createElement("div", {
        className: containerClassName
      }, segmentBlocks);
    }
  }]);

  return SegmentControl;
}(Component);

SegmentControl.defaultProps = {
  compact: true,
  activeSegment: 0
};
SegmentControl.propTypes = {
  /** object contains information for constructing segment */
  segments: propTypes.arrayOf(propTypes.shape({
    key: propTypes.string,
    icon: propTypes.element,
    text: propTypes.string
  })).isRequired,

  /** custom class names */
  className: propTypes.string,

  /** make component compact (less horizontal padding)  */
  compact: propTypes.bool,

  /** initialize component with specific segment active */
  activeSegment: propTypes.number,

  /** click event handler. A callback function returns the key of the segment clicked
   *
   * Example:
   * function exampleCallback = (key) => {...}  */
  onClick: propTypes.func
};

var SCROLL_UNITS = 200; // keyboard key codes

var LEFT_ARROW = 37;
var RIGHT_ARROW = 39;
var TAB = 9;
/** Same responsive helper function as in zola-helpers
 */

var isMobile = function isMobile() {
  return window.matchMedia("(max-width: 767px)").matches;
};
/** Keyboard-accessible UI component for tab menu and panels
 */


var Tabs = function Tabs(_ref) {
  var arrowVariant = _ref.arrowVariant,
      smallVariant = _ref.smallVariant,
      tabItems = _ref.tabItems,
      initialTabId = _ref.initialTabId,
      classNames = _ref.classNames;
  var tabEl = useRef(null);

  var _useState = useState(initialTabId || tabItems[0].id),
      _useState2 = _slicedToArray(_useState, 2),
      currentTabId = _useState2[0],
      setCurrentTabId = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showFocusOutline = _useState4[0],
      setShowFocusOutline = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showArrows = _useState6[0],
      setShowArrows = _useState6[1];

  var _useState7 = useState({
    left: false,
    right: false
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      disabledArrows = _useState8[0],
      setDisabledArrows = _useState8[1];

  var _useState9 = useState(0),
      _useState10 = _slicedToArray(_useState9, 2),
      scrollBackPosition = _useState10[0],
      setScrollBackPosition = _useState10[1];

  var _useState11 = useState(null),
      _useState12 = _slicedToArray(_useState11, 2),
      scrollForwardPosition = _useState12[0],
      setScrollForwardPosition = _useState12[1];
  /**
   * Hook to run on initial load, which determines whether to display, enable,
   * or disable arrows for manual jump scrolling
   */


  useEffect(function () {
    if (arrowVariant) {
      var el = tabEl.current;

      if (el) {
        if (el.scrollWidth > el.offsetWidth) {
          setShowArrows(true);
        }

        if (el.scrollLeft < SCROLL_UNITS) {
          setDisabledArrows({
            left: true,
            right: false
          });
        }
      }
    }
  }, [tabEl, arrowVariant]);
  /**
   * Animate clicked tab into full view if mobile, call the tab's
   * custom click handler if it was passed down from props, and set the
   * clicked tab's id in state
   * @param {Object} e - event
   * @param {String} id - id of the element clicked
   */

  var handleTabClick = function handleTabClick(e, id) {
    var currentTab = tabItems.find(function (i) {
      return i.id === id;
    });

    if (typeof window !== 'undefined' && isMobile()) {
      e.target.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start'
      });
    }

    if (currentTab.onClick) {
      currentTab.onClick();
    }

    setCurrentTabId(id);
  };
  /**
   * Show tab nav focus ring for keyboard users, enable using left and right
   * keyboard arrows to change tab panel view if parent element is in focus
   * @param {Object} e - event
   */


  var onKeyUp = function onKeyUp(e) {
    // show focus ring if tabbed over
    if (e.keyCode === TAB) {
      setShowFocusOutline(true);
    }

    if (e.keyCode === LEFT_ARROW || e.keyCode === RIGHT_ARROW) {
      var currentTabIndex = findIndex_1(tabItems, function (i) {
        return i.id === currentTabId;
      });

      var targetTabIndex = 0; // select next tab if keyboard right arrow is pressed &
      // cycle back to the beginning if at the end

      if (e.keyCode === RIGHT_ARROW) {
        if (currentTabIndex + 1 < tabItems.length) {
          targetTabIndex = currentTabIndex + 1;
        }
      } // select prev tab if keyboard left arrow is pressed &
      // cycle back to the end if at the beginning


      if (e.keyCode === LEFT_ARROW) {
        if (currentTabIndex - 1 >= 0) {
          targetTabIndex = currentTabIndex - 1;
        } else {
          targetTabIndex = tabItems.length - 1;
        }
      }

      handleTabClick(e, tabItems[targetTabIndex].id);
    }
  };
  /**
   * When desktop pagination arrows are displayed, scroll to the left
   * or right on click
   * @param {Object} direction - object to set left/right to true/false
   */


  var desktopJumpScroll = function desktopJumpScroll() {
    var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      left: false,
      right: false
    };
    var currentPosition = tabEl.current.scrollLeft;

    if (direction.left) {
      var newPositionForward = currentPosition + SCROLL_UNITS;
      tabEl.current.scrollLeft = newPositionForward;
      setDisabledArrows({
        left: false,
        right: scrollBackPosition === newPositionForward
      });
      setScrollBackPosition(newPositionForward);
    }

    if (direction.right) {
      var newPositionBack = currentPosition - SCROLL_UNITS;
      tabEl.current.scrollLeft = newPositionBack;
      setDisabledArrows({
        left: scrollForwardPosition === newPositionBack,
        right: false
      });
      setScrollForwardPosition(newPositionBack);
    }
  };

  return React.createElement("div", {
    className: classnames('zola-ui tab-component', classNames, smallVariant ? 'small-tab-component' : '')
  }, React.createElement("div", {
    className: "tabs-list-container"
  }, React.createElement("div", {
    className: "tab-overlay"
  }, React.createElement("div", {
    className: classnames('fade-edges', showArrows ? 'narrow' : '')
  }), showArrows && React.createElement("div", {
    className: "tab-arrows"
  }, React.createElement("button", {
    type: "button",
    disabled: disabledArrows.left,
    className: "tab-arrow",
    onClick: function onClick() {
      return desktopJumpScroll({
        right: true
      });
    }
  }, React.createElement(LeftCaret, {
    className: "arrow-icon"
  })), React.createElement("button", {
    type: "button",
    disabled: disabledArrows.right,
    className: "tab-arrow",
    onClick: function onClick() {
      return desktopJumpScroll({
        left: true
      });
    }
  }, React.createElement(RightCaret, {
    className: "arrow-icon"
  })))), React.createElement("ul", {
    role: "tablist",
    className: classnames('tabs-list', showFocusOutline ? 'show-focus-outline' : '', showArrows ? 'with-arrows' : ''),
    onKeyUp: onKeyUp,
    tabIndex: 0,
    ref: tabEl
  }, tabItems.map(function (tab, index) {
    var isCurrentTab = currentTabId === tab.id;
    return React.createElement("li", {
      role: "tab",
      className: classnames('tab', isCurrentTab ? 'current-tab' : ''),
      id: "tab-".concat(index),
      "aria-controls": "panel-".concat(index),
      "aria-selected": isCurrentTab,
      onClick: function onClick(e) {
        return handleTabClick(e, tab.id);
      },
      key: tab.id
    }, tab.text);
  }))), React.createElement("div", {
    className: "tab-panels"
  }, tabItems.map(function (tab, index) {
    return React.createElement("div", {
      id: "panel-".concat(index),
      role: "tabpanel",
      "aria-labelledby": "tab-".concat(index),
      hidden: currentTabId !== tab.id,
      key: tab.id
    }, React.createElement("div", {
      className: "panel-content"
    }, tab.panelContent));
  })));
};

Tabs.propTypes = {
  /** array of tab data */
  tabItems: propTypes.arrayOf(propTypes.shape({
    id: propTypes.oneOfType([propTypes.string, propTypes.number]).isRequired,
    text: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired,
    onClick: propTypes.func,
    // optional function to be called when a tab is selected. see TABS_WITH_COMPONENTS_IN_PANEL in ./mockItems.jsx for an example usage
    panelContent: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired
  })).isRequired,

  /** id for tab that will be initially selected */
  initialTabId: propTypes.oneOfType([propTypes.string, propTypes.number]),

  /** flag for showing pagination arrows on desktop. this particular prop can't be used on server-rendered pages because it relies on browser web api values. see more info in example #5 on the storybook overview page. */
  arrowVariant: propTypes.bool,

  /** flag for using small typeface */
  smallVariant: propTypes.bool,

  /** any additional classes */
  classNames: propTypes.string
};

/** Basic UI component for a Tag
 * style guide ultimately calls for this to have hover, cursor states
 */

var Tag = function Tag(_ref) {
  var children = _ref.children,
      size = _ref.size,
      type = _ref.type,
      className = _ref.className,
      hasHoverState = _ref.hasHoverState,
      onClick = _ref.onClick,
      emoji = _ref.emoji;
  return React.createElement("div", {
    onClick: onClick,
    className: classnames('zola-ui', 'tag', "tag--".concat(size), "tag--".concat(type), {
      'hover-state': hasHoverState
    }, className)
  }, type === 'emoji' ? React.createElement(Fragment, null, React.createElement("span", {
    role: "img",
    "aria-label": emoji.ariaLabel,
    className: "symbol"
  }, emoji.symbol), children) : children, (type === 'filter' || type === 'white-filter') && React.createElement("i", {
    className: "zola-ui-icon zola-ui-icon-close"
  }));
};

Tag.defaultProps = {
  size: 'lg',
  type: 'primary'
};
Tag.propTypes = {
  /** Size of the tag.
   * NOTE: size will be ignored when type is "filter" or "emoji"
   * */
  size: propTypes.oneOf(['sm', 'lg']),

  /** type of the tag. Different style will be applied */
  type: propTypes.oneOf(['primary', 'secondary', 'light-navy', 'alternate', 'red', 'orange', 'filter', 'white-filter', 'emoji']),

  /** contents to be rendered for the tag */
  children: propTypes.node,

  /** self descriptive */
  className: propTypes.string,

  /** self descriptive */
  onClick: propTypes.func,

  /** flag for showing style in hover state */
  hasHoverState: propTypes.bool,

  /** Should be used with 'emoji' tag type. Example: { ariaLabel: 'blue heart emoji', symbol: '💙' } */
  emoji: propTypes.shape({
    ariaLabel: propTypes.string.isRequired,
    symbol: propTypes.string.isRequired
  })
};

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

var _baseIsNaN = baseIsNaN;

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

var _strictIndexOf = strictIndexOf;

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? _strictIndexOf(array, value, fromIndex)
    : _baseFindIndex(array, _baseIsNaN, fromIndex);
}

var _baseIndexOf = baseIndexOf;

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && _baseIndexOf(array, value, 0) > -1;
}

var _arrayIncludes = arrayIncludes;

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

var _arrayIncludesWith = arrayIncludesWith;

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop$1() {
  // No operation performed.
}

var noop_1 = noop$1;

/** Used as references for various `Number` constants. */
var INFINITY$3 = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(_Set && (1 / _setToArray(new _Set([,-0]))[1]) == INFINITY$3) ? noop_1 : function(values) {
  return new _Set(values);
};

var _createSet = createSet;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$1 = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = _arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = _arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE$1) {
    var set = iteratee ? null : _createSet(array);
    if (set) {
      return _setToArray(set);
    }
    isCommon = false;
    includes = _cacheHas;
    seen = new _SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

var _baseUniq = baseUniq;

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? _baseUniq(array) : [];
}

var uniq_1 = uniq;

var ToastActionTypes = {
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE'
};

var Toast =
/*#__PURE__*/
function (_Component) {
  _inherits(Toast, _Component);

  function Toast() {
    var _this;

    _classCallCheck(this, Toast);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Toast).call(this));
    _this.handleDismiss = _this.handleDismiss.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Toast, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          onRemove = _this$props.onRemove,
          _this$props$toast = _this$props.toast,
          id = _this$props$toast.id,
          autoDismissInSeconds = _this$props$toast.autoDismissInSeconds;
      if (autoDismissInSeconds !== 0) onRemove(id, autoDismissInSeconds * 1000);
    }
  }, {
    key: "handleDismiss",
    value: function handleDismiss() {
      var _this$props2 = this.props,
          onRemove = _this$props2.onRemove,
          _this$props2$toast = _this$props2.toast,
          id = _this$props2$toast.id,
          onDismiss = _this$props2$toast.onDismiss; // User propogated side effect func

      if (onDismiss) onDismiss(); // Default toast self-removal func

      onRemove(id);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          _this$props3$toast = _this$props3.toast,
          id = _this$props3$toast.id,
          type = _this$props3$toast.type,
          headline = _this$props3$toast.headline,
          dek = _this$props3$toast.dek,
          className = _this$props3$toast.className,
          dismissText = _this$props3$toast.dismissText,
          onRemove = _this$props3.onRemove,
          rest = _objectWithoutProperties(_this$props3, ["toast", "onRemove"]); // Used by CSSTransition


      var modifiedRest = Object.assign({}, rest);
      delete modifiedRest.onRemove;
      var IconComponent = type === ToastActionTypes.POSITIVE ? CheckmarkCircle : Exclamation;
      var classes = classnames('zui-toast', "zui-toast--".concat(type.toLowerCase()), className);
      return React.createElement(CSSTransition, _extends({
        classNames: "zui-toast"
      }, modifiedRest, {
        timeout: 600
      }), React.createElement("div", {
        id: "toast-".concat(id),
        className: classes
      }, React.createElement(IconComponent, {
        className: "zui-toast__icon",
        width: 16,
        height: 16,
        title: "".concat(type.toLowerCase(), "-icon")
      }), React.createElement("div", {
        className: "zui-toast__content"
      }, React.createElement("div", {
        className: "zui-toast__headline"
      }, headline), dek && React.createElement("div", {
        className: "zui-toast__dek"
      }, dek)), dismissText && React.createElement(Link, {
        variant: "tertiary",
        role: "button",
        className: "zui-toast__dismiss",
        onClick: this.handleDismiss
      }, dismissText)));
    }
  }]);

  return Toast;
}(Component);
Toast.propTypes = {
  toast: propTypes.shape({
    id: propTypes.number.isRequired,
    type: propTypes.oneOf([ToastActionTypes.POSITIVE, ToastActionTypes.NEGATIVE]).isRequired,
    headline: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired,
    dek: propTypes.oneOfType([propTypes.string, propTypes.node]),
    className: propTypes.string,
    autoDismissInSeconds: propTypes.number.isRequired,
    dismissText: propTypes.oneOfType([propTypes.string, propTypes.node]),
    onDismiss: propTypes.func
  }),
  onRemove: propTypes.func
};

var Toasts = function Toasts(_ref) {
  var toasts = _ref.toasts,
      onRemoveToast = _ref.onRemoveToast;

  var remove = function remove(id, timeout) {
    setTimeout(function () {
      return onRemoveToast(id);
    }, timeout);
  };

  var containerClasses = uniq_1(toasts.map(function (toast) {
    return toast.containerClass;
  }));

  var optClass = containerClasses.join(' ');
  var className = classnames('zui-toasts', optClass);
  return React.createElement(TransitionGroup, {
    className: className
  }, toasts.map(function (toast) {
    return React.createElement(Toast, {
      key: toast.id,
      toast: toast,
      onRemove: remove
    });
  }));
};

Toasts.propTypes = {
  toasts: propTypes.arrayOf(propTypes.shape({
    id: propTypes.number.isRequired,
    type: propTypes.oneOf([ToastActionTypes.POSITIVE, ToastActionTypes.NEGATIVE]).isRequired,
    headline: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired,
    dek: propTypes.oneOfType([propTypes.string, propTypes.node]),
    className: propTypes.string,
    autoDismissInSeconds: propTypes.number.isRequired,
    dismissText: propTypes.oneOfType([propTypes.string, propTypes.node]),
    onDismiss: propTypes.func
  })),
  onRemoveToast: propTypes.func.isRequired
};

var check = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement(
    'svg',
    { width: '14', height: '11', viewBox: '0 0 14 11' },
    _react2.default.createElement(
      'title',
      null,
      'switch-check'
    ),
    _react2.default.createElement('path', { d: 'M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0', fill: '#fff', fillRule: 'evenodd' })
  );
};
});

unwrapExports(check);

var x = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement(
    'svg',
    { width: '10', height: '10', viewBox: '0 0 10 10' },
    _react2.default.createElement(
      'title',
      null,
      'switch-x'
    ),
    _react2.default.createElement('path', { d: 'M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12', fill: '#fff', fillRule: 'evenodd' })
  );
};
});

unwrapExports(x);

var util = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pointerCoord = pointerCoord;
// Copyright 2015-present Drifty Co.
// http://drifty.com/
// from: https://github.com/driftyco/ionic/blob/master/src/util/dom.ts

function pointerCoord(event) {
  // get coordinates for either a mouse click
  // or a touch depending on the given event
  if (event) {
    var changedTouches = event.changedTouches;
    if (changedTouches && changedTouches.length > 0) {
      var touch = changedTouches[0];
      return { x: touch.clientX, y: touch.clientY };
    }
    var pageX = event.pageX;
    if (pageX !== undefined) {
      return { x: pageX, y: event.pageY };
    }
  }
  return { x: 0, y: 0 };
}
});

unwrapExports(util);
var util_1 = util.pointerCoord;

var component = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _classnames2 = _interopRequireDefault(classnames);



var _propTypes2 = _interopRequireDefault(propTypes);



var _check2 = _interopRequireDefault(check);



var _x2 = _interopRequireDefault(x);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Toggle = function (_PureComponent) {
  _inherits(Toggle, _PureComponent);

  function Toggle(props) {
    _classCallCheck(this, Toggle);

    var _this = _possibleConstructorReturn(this, (Toggle.__proto__ || Object.getPrototypeOf(Toggle)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleTouchStart = _this.handleTouchStart.bind(_this);
    _this.handleTouchMove = _this.handleTouchMove.bind(_this);
    _this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.previouslyChecked = !!(props.checked || props.defaultChecked);
    _this.state = {
      checked: !!(props.checked || props.defaultChecked),
      hasFocus: false
    };
    return _this;
  }

  _createClass(Toggle, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.checked !== this.props.checked) {
        this.setState({ checked: !!this.props.checked });
      }
    }
  }, {
    key: 'handleClick',
    value: function handleClick(event) {
      var checkbox = this.input;
      if (event.target !== checkbox && !this.moved) {
        this.previouslyChecked = checkbox.checked;
        event.preventDefault();
        checkbox.focus();
        checkbox.click();
        return;
      }

      var checked = this.props.hasOwnProperty('checked') ? this.props.checked : checkbox.checked;

      this.setState({ checked: checked });
    }
  }, {
    key: 'handleTouchStart',
    value: function handleTouchStart(event) {
      this.startX = (0, util.pointerCoord)(event).x;
      this.activated = true;
    }
  }, {
    key: 'handleTouchMove',
    value: function handleTouchMove(event) {
      if (!this.activated) return;
      this.moved = true;

      if (this.startX) {
        var currentX = (0, util.pointerCoord)(event).x;
        if (this.state.checked && currentX + 15 < this.startX) {
          this.setState({ checked: false });
          this.startX = currentX;
          this.activated = true;
        } else if (currentX - 15 > this.startX) {
          this.setState({ checked: true });
          this.startX = currentX;
          this.activated = currentX < this.startX + 5;
        }
      }
    }
  }, {
    key: 'handleTouchEnd',
    value: function handleTouchEnd(event) {
      if (!this.moved) return;
      var checkbox = this.input;
      event.preventDefault();

      if (this.startX) {
        var endX = (0, util.pointerCoord)(event).x;
        if (this.previouslyChecked === true && this.startX + 4 > endX) {
          if (this.previouslyChecked !== this.state.checked) {
            this.setState({ checked: false });
            this.previouslyChecked = this.state.checked;
            checkbox.click();
          }
        } else if (this.startX - 4 < endX) {
          if (this.previouslyChecked !== this.state.checked) {
            this.setState({ checked: true });
            this.previouslyChecked = this.state.checked;
            checkbox.click();
          }
        }

        this.activated = false;
        this.startX = null;
        this.moved = false;
      }
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus(event) {
      var onFocus = this.props.onFocus;


      if (onFocus) {
        onFocus(event);
      }

      this.setState({ hasFocus: true });
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur(event) {
      var onBlur = this.props.onBlur;


      if (onBlur) {
        onBlur(event);
      }

      this.setState({ hasFocus: false });
    }
  }, {
    key: 'getIcon',
    value: function getIcon(type) {
      var icons = this.props.icons;

      if (!icons) {
        return null;
      }
      return icons[type] === undefined ? Toggle.defaultProps.icons[type] : icons[type];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          _icons = _props.icons,
          inputProps = _objectWithoutProperties(_props, ['className', 'icons']);

      var classes = (0, _classnames2.default)('react-toggle', {
        'react-toggle--checked': this.state.checked,
        'react-toggle--focus': this.state.hasFocus,
        'react-toggle--disabled': this.props.disabled
      }, className);

      return _react2.default.createElement(
        'div',
        { className: classes,
          onClick: this.handleClick,
          onTouchStart: this.handleTouchStart,
          onTouchMove: this.handleTouchMove,
          onTouchEnd: this.handleTouchEnd },
        _react2.default.createElement(
          'div',
          { className: 'react-toggle-track' },
          _react2.default.createElement(
            'div',
            { className: 'react-toggle-track-check' },
            this.getIcon('checked')
          ),
          _react2.default.createElement(
            'div',
            { className: 'react-toggle-track-x' },
            this.getIcon('unchecked')
          )
        ),
        _react2.default.createElement('div', { className: 'react-toggle-thumb' }),
        _react2.default.createElement('input', _extends({}, inputProps, {
          ref: function ref(_ref) {
            _this2.input = _ref;
          },
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          className: 'react-toggle-screenreader-only',
          type: 'checkbox' }))
      );
    }
  }]);

  return Toggle;
}(React.PureComponent);

exports.default = Toggle;


Toggle.displayName = 'Toggle';

Toggle.defaultProps = {
  icons: {
    checked: _react2.default.createElement(_check2.default, null),
    unchecked: _react2.default.createElement(_x2.default, null)
  }
};

Toggle.propTypes = {
  checked: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  defaultChecked: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  className: _propTypes2.default.string,
  name: _propTypes2.default.string,
  value: _propTypes2.default.string,
  id: _propTypes2.default.string,
  'aria-labelledby': _propTypes2.default.string,
  'aria-label': _propTypes2.default.string,
  icons: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
    checked: _propTypes2.default.node,
    unchecked: _propTypes2.default.node
  })])
};
});

var ReactToggle = unwrapExports(component);

var Toggle = function Toggle(_ref) {
  var input = _ref.input,
      label = _ref.label,
      labelSide = _ref.labelSide,
      id = _ref.id,
      className = _ref.className,
      inline = _ref.inline,
      hasFormGroup = _ref.hasFormGroup,
      disabled = _ref.disabled,
      withIcons = _ref.withIcons,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      ariaLabel = _ref.ariaLabel;
  var inputValue = input.value !== 'false' && input.value;
  var hasError = touched && error;
  var mainClasses = classnames('zola-ui', 'zola-ui__toggle-container', className, {
    'zola-ui__toggle-container--inline': inline,
    'form-group': hasFormGroup,
    'has-error': hasError
  });
  var toggleWrapperClasses = classnames({
    'zola-ui__toggle-button-inline': labelSide === 'left' || labelSide === 'right'
  });
  var icons = withIcons ? {
    checked: React.createElement("span", {
      className: "zola-ui__toggle-option-label"
    }, React.createElement("i", {
      className: "zola-ui-icon zola-ui-icon-checkmark"
    })),
    unchecked: React.createElement("span", {
      className: "zola-ui__toggle-option-label"
    }, React.createElement("i", {
      className: "zola-ui-icon zola-ui-icon-close"
    }))
  } : null;
  return React.createElement("div", {
    className: mainClasses
  }, label && (labelSide === 'left' || labelSide === 'top') ? React.createElement("label", {
    htmlFor: id,
    className: "zola-ui__toggle-label"
  }, label) : null, React.createElement("div", {
    className: toggleWrapperClasses
  }, React.createElement(ReactToggle, {
    id: id,
    checked: inputValue,
    disabled: disabled,
    onChange: function onChange() {
      return input.onChange && input.onChange(!inputValue);
    },
    className: "zola-ui__toggle",
    icons: icons,
    "aria-label": ariaLabel
  })), label && labelSide === 'right' ? React.createElement("label", {
    htmlFor: id,
    className: "zola-ui__toggle-label--right"
  }, label) : null, hasError ? React.createElement("span", {
    className: "zola-ui__help-block"
  }, error) : null);
};

Toggle.defaultProps = {
  input: {
    value: false,
    onChange: function onChange() {}
  },
  id: '',
  className: '',
  label: '',
  labelSide: 'left',
  inline: true,
  hasFormGroup: false,
  disabled: false,
  withIcons: false,
  meta: {
    touched: true,
    error: ''
  }
};
Toggle.propTypes = {
  input: propTypes.shape({
    value: propTypes.oneOf(['true', 'false', true, false]),
    // To ensure backwards compatibility with redux-forms
    onChange: propTypes.func
  }),
  label: propTypes.oneOfType([propTypes.string, propTypes.node]),
  labelSide: propTypes.oneOf(['top', 'left', 'right']),
  id: propTypes.string,
  className: propTypes.string,
  inline: propTypes.bool,
  hasFormGroup: propTypes.bool,
  disabled: propTypes.bool,
  withIcons: propTypes.bool,
  meta: propTypes.shape({
    touched: propTypes.bool,
    error: propTypes.string
  }),

  /** For accessibility, use this prop when no labels exist for the input */
  ariaLabel: propTypes.string
};

var SideDrawerHeader = function SideDrawerHeader(_ref) {
  var header = _ref.header,
      handleClose = _ref.handleClose,
      children = _ref.children,
      style = _ref.style;
  var hasChildren = componentUtils.hasChildren(children);
  return React.createElement("div", {
    style: style,
    className: "zola-ui side-drawer-header__container"
  }, React.createElement("i", {
    className: "zola-ui-icon-close",
    onClick: handleClose
  }), React.createElement("div", {
    className: "side-drawer-header"
  }, React.createElement("h3", null, header), hasChildren && children));
};

SideDrawerHeader.propTypes = {
  header: propTypes.string.isRequired,
  handleClose: propTypes.func,
  children: propTypes.node,
  style: propTypes.shape({})
};

var SideDrawerFooter = function SideDrawerFooter(_ref) {
  var cta = _ref.cta,
      ctaOnClick = _ref.ctaOnClick,
      style = _ref.style;
  return React.createElement("div", {
    className: "side-drawer__footer",
    style: style
  }, React.createElement(ButtonV2, {
    className: "side-drawer__footer__button",
    onClick: ctaOnClick
  }, cta));
};

SideDrawerFooter.propTypes = {
  cta: propTypes.string.isRequired,
  ctaOnClick: propTypes.func,
  style: propTypes.string
};

var SideDrawer =
/*#__PURE__*/
function (_Component) {
  _inherits(SideDrawer, _Component);

  function SideDrawer(props) {
    var _this;

    _classCallCheck(this, SideDrawer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SideDrawer).call(this, props));
    _this.state = {
      drawerClosing: false
    };
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SideDrawer, [{
    key: "handleClose",
    value: function handleClose() {
      var onClose = this.props.onClose;
      this.setState({
        drawerClosing: true
      });
      onClose();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          header = _this$props.header,
          width = _this$props.width,
          children = _this$props.children,
          displayDrawer = _this$props.displayDrawer,
          cta = _this$props.cta,
          ctaOnClick = _this$props.ctaOnClick;
      var drawerClosing = this.state.drawerClosing;
      var hasChildren = componentUtils.hasChildren(children);
      var style = width ? {
        width: width
      } : null;
      return React.createElement("div", {
        className: "zola-ui side-drawer__container"
      }, React.createElement("div", {
        className: classnames({
          'side-drawer__background-overlay': displayDrawer
        }),
        onClick: this.handleClose
      }), React.createElement("div", {
        className: classnames('side-drawer__body', {
          'side-drawer__closing': !displayDrawer && drawerClosing
        }, {
          'side-drawer__opening': displayDrawer
        }),
        style: style
      }, React.createElement(SideDrawerHeader, {
        handleClose: this.handleClose,
        header: header,
        style: style
      }), React.createElement("div", {
        className: "side-drawer__content",
        style: style
      }, hasChildren && children), cta && React.createElement(SideDrawerFooter, {
        cta: cta,
        ctaOnClick: ctaOnClick,
        style: style
      })));
    }
  }]);

  return SideDrawer;
}(Component);

SideDrawer.propTypes = {
  children: propTypes.node,
  header: propTypes.string,
  displayDrawer: propTypes.bool,
  cta: propTypes.string,
  ctaOnClick: propTypes.func,
  onClose: propTypes.func,

  /** drawer width when open. e.g. "1rem", "400px", or "50%" */
  width: propTypes.string
};

var Dropdown =
/*#__PURE__*/
function (_Component) {
  _inherits(Dropdown, _Component);

  _createClass(Dropdown, null, [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props) {
      if (props.resetOrder) {
        return {
          selectedItem: props.facetList.options[0]
        };
      } // Return null if the state hasn't changed


      return null;
    }
  }]);

  function Dropdown(props) {
    var _this;

    _classCallCheck(this, Dropdown);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Dropdown).call(this, props));
    _this.onButtonToggle = _this.onButtonToggle.bind(_assertThisInitialized(_this));
    _this.onOptionClick = _this.onOptionClick.bind(_assertThisInitialized(_this));
    _this.setWrapperRef = _this.setWrapperRef.bind(_assertThisInitialized(_this));
    _this.handleClickOutside = _this.handleClickOutside.bind(_assertThisInitialized(_this));
    _this.renderOptions = _this.renderOptions.bind(_assertThisInitialized(_this));
    var _props$facetList$opti = props.facetList.options,
        options = _props$facetList$opti === void 0 ? [] : _props$facetList$opti;
    var selectedIndex = 0; // Set the selected item based on the first index with a `selected` key

    for (var index = 0; index < options.length; index += 1) {
      if (options[index].selected === true) {
        selectedIndex = index;
        break;
      }
    }

    _this.state = {
      expanded: false,
      selectedItem: options[selectedIndex]
    };
    return _this;
  }
  /**
   * Lifecycle function
   * setup listener for mouse click out side of the component
   */


  _createClass(Dropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
    /**
     * Lifecycle function
     * teardown listener for mouse click out side of the component
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
    /**
     * handle dropdown button click event
     */

  }, {
    key: "onButtonToggle",
    value: function onButtonToggle() {
      var _this$props = this.props,
          onButtonClick = _this$props.onButtonClick,
          facetList = _this$props.facetList;
      var expanded = this.state.expanded;
      this.setState({
        expanded: !expanded
      });

      if (onButtonClick) {
        onButtonClick(facetList.key);
      }
    }
    /**
     * handle dropdown options click event
     */

  }, {
    key: "onOptionClick",
    value: function onOptionClick(item) {
      var onSelect = this.props.onSelect;
      this.setState({
        expanded: false,
        selectedItem: item
      });
      onSelect(item.value);
    }
    /**
     *  attached ref for checking outside click
     */

  }, {
    key: "setWrapperRef",
    value: function setWrapperRef(node) {
      this.wrapperRef = node;
    }
    /**
     * Event Handler
     * handles mouse click outside of the component so it will close the option menu if it is opened
     * @param event
     */

  }, {
    key: "handleClickOutside",
    value: function handleClickOutside(event) {
      if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
        var expanded = this.state.expanded;

        if (expanded) {
          this.setState({
            expanded: false
          });
        }
      }
    }
    /**
     * render simple dropdown options. Possibly belongs to its own component
     * @returns {null || Object}
     */

  }, {
    key: "renderOptions",
    value: function renderOptions() {
      var _this2 = this;

      var facetList = this.props.facetList;
      var expanded = this.state.expanded;
      var dropdownClassNames = classnames('dropdown__options', {
        'dropdown__options--toggled': expanded
      });
      return expanded ? React.createElement("div", {
        className: dropdownClassNames
      }, facetList.options.map(function (item) {
        return React.createElement("span", {
          id: item.label,
          key: item.label
        }, React.createElement("a", {
          role: "button",
          onClick: function onClick() {
            _this2.onOptionClick(item);
          },
          className: classnames('dropdown__option', 'link-option', item.imgSrc && 'image-option')
        }, item.imgSrc ? React.createElement("img", {
          alt: item.label,
          src: item.imgSrc
        }) : item.label));
      })) : null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          facetList = _this$props2.facetList,
          position = _this$props2.position,
          label = _this$props2.label,
          dynamicLabel = _this$props2.dynamicLabel,
          className = _this$props2.className,
          id = _this$props2.id;
      var _this$state = this.state,
          expanded = _this$state.expanded,
          selectedItem = _this$state.selectedItem;
      var dropdownContainerClassName = classnames('facet-dropdown', className, {
        'pull-right': position === 'right',
        'pull-left': position === 'left',
        'has-label': label
      });
      var dropdownClassName = classnames('dropdown__select', {
        'dropdown__select--toggled': expanded
      });
      var dropdownOption = this.renderOptions();
      return React.createElement("div", {
        className: dropdownContainerClassName,
        ref: this.setWrapperRef,
        id: id
      }, label && React.createElement("span", {
        className: "dropdown__select-label"
      }, facetList.label, ": "), React.createElement("div", {
        className: dropdownClassName,
        onClick: this.onButtonToggle
      }, !dynamicLabel && facetList.label, " ", dynamicLabel && selectedItem.label, React.createElement("span", {
        className: "dropdown__icon zolaicon zola-ui-icon-chevron-down"
      })), dropdownOption);
    }
  }]);

  return Dropdown;
}(Component);

Dropdown.defaultProps = {
  position: 'left'
};
Dropdown.propTypes = {
  label: propTypes.string,

  /** If this flag is true, the dropdown will use the selected option as the dropdown label. */
  dynamicLabel: propTypes.bool,

  /**
   * Allow the parent component to reset the dropdown label.
   * The only use case at the moment is to reset the dropdown label when dynamicLabel is used.
   */
  resetOrder: propTypes.bool,
  // eslint-disable-line

  /** Options can include the boolean key "selected" to indicate that the option is initially selected. Only one option can be selected at a time. */
  facetList: propTypes.shape({
    key: propTypes.string,
    label: propTypes.string,
    options: propTypes.arrayOf(propTypes.shape({}))
  }).isRequired,
  position: propTypes.string,

  /**
   * Event handler callback for the dropdown.
   * onButtonClick(facetList.key)
   * */
  onButtonClick: propTypes.func,

  /**
   * Event handler callback for dropdown options.
   * onSelect(facetList.options.$.value)
   * */
  onSelect: propTypes.func.isRequired,
  className: propTypes.string,
  id: propTypes.string
};

/**
 * This component relies on Segment (analytics.js) to trigger a page view on route changes.
 * It should be placed within a <BrowserRouter> outside of a <Switch> in the main App router
 * so that it will render on every route change.
 */

var TrackPageViewComponent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TrackPageViewComponent, _React$Component);

  function TrackPageViewComponent() {
    _classCallCheck(this, TrackPageViewComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(TrackPageViewComponent).apply(this, arguments));
  }

  _createClass(TrackPageViewComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _document = document,
          referrer = _document.referrer;

      if (window && window.zola) {
        window.zola.referrer = referrer;
      }

      this.trackPageView(referrer);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var prevLocation = _ref.location;
      var _this$props$location = this.props.location,
          pathname = _this$props$location.pathname,
          search = _this$props$location.search;
      var isDifferentPathname = pathname !== prevLocation.pathname;
      var isDifferentSearch = search !== prevLocation.search;
      var protocol = window && window.location && window.location.protocol;
      var hostname = window && window.location && window.location.hostname;
      var referrer = prevLocation && prevLocation.pathname ? "".concat(protocol, "//").concat(hostname + prevLocation.pathname + prevLocation.search) : document.referrer; // Adds referrer on a global object to avoid the hassle of getting past and passing referrer to every component that calls an event.

      if (window && window.zola) {
        window.zola.referrer = referrer;
      }

      if (isDifferentPathname || isDifferentSearch) {
        this.trackPageView(referrer);
      }
    }
  }, {
    key: "trackPageView",
    value: function trackPageView(referrer) {
      var _this$props$location2 = this.props.location,
          pathname = _this$props$location2.pathname,
          search = _this$props$location2.search;

      if (window.analytics) {
        window.analytics.page({
          path: pathname,
          search: search,
          referrer: referrer,
          url: window.location.href,
          title: document && document.title
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return TrackPageViewComponent;
}(React.Component);
TrackPageViewComponent.propTypes = {
  /**
   * should be provided by wrapping this component with 'withRouter'
   */
  location: propTypes.shape({
    pathname: propTypes.string,
    search: propTypes.string
  }).isRequired
};

var UnderlinedText = function UnderlinedText(_ref) {
  var children = _ref.children,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'teal' : _ref$color,
      _ref$thick = _ref.thick,
      thick = _ref$thick === void 0 ? false : _ref$thick,
      _ref$borderTopLeftRad = _ref.borderTopLeftRadius,
      borderTopLeftRadius = _ref$borderTopLeftRad === void 0 ? '100%' : _ref$borderTopLeftRad,
      _ref$borderTopRightRa = _ref.borderTopRightRadius,
      borderTopRightRadius = _ref$borderTopRightRa === void 0 ? '100%' : _ref$borderTopRightRa,
      _ref$borderBottomRigh = _ref.borderBottomRightRadius,
      borderBottomRightRadius = _ref$borderBottomRigh === void 0 ? '20px' : _ref$borderBottomRigh,
      _ref$borderBottomLeft = _ref.borderBottomLeftRadius,
      borderBottomLeftRadius = _ref$borderBottomLeft === void 0 ? '0px' : _ref$borderBottomLeft;
  var classes = classnames('underlined-text__underline', "underlined-text__underline--".concat(color), {
    thick: thick
  });
  return React.createElement("span", {
    className: "underlined-text"
  }, children, React.createElement("div", {
    className: classes,
    style: {
      borderTopLeftRadius: borderTopLeftRadius,
      borderTopRightRadius: borderTopRightRadius,
      borderBottomRightRadius: borderBottomRightRadius,
      borderBottomLeftRadius: borderBottomLeftRadius
    }
  }));
};

UnderlinedText.propTypes = {
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  color: propTypes.oneOf(['teal', 'hardPink', 'white']),
  borderTopLeftRadius: propTypes.string,
  borderTopRightRadius: propTypes.string,
  borderBottomRightRadius: propTypes.string,
  borderBottomLeftRadius: propTypes.string,
  thick: propTypes.bool
};

var ZolaAppButton = function ZolaAppButton(_ref) {
  var variant = _ref.variant,
      deepLink = _ref.deepLink,
      onClick = _ref.onClick;
  var isIos = variant === 'iOS';
  var imgSrc = isIos ? appStoreBadge : googlePlayBadge;
  var altText = isIos ? 'Download On The App Store' : 'Get It On Google Play';
  var defaultLink = isIos ? 'https://itunes.apple.com/us/app/zola-wedding-registry-gifts/id852691916' : 'https://play.google.com/store/apps/details?id=com.zola.android.wedding&hl=en';
  return React.createElement("a", {
    className: "zolaAppButtonLink",
    href: deepLink || defaultLink,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: onClick
  }, React.createElement("img", {
    className: "zolaAppButtonImg",
    src: imgSrc,
    alt: altText
  }));
};

ZolaAppButton.propTypes = {
  /** Which button/store should be displayed */
  variant: propTypes.oneOf(['iOS', 'Android']).isRequired,

  /** Override the default store links with a deeplink */
  deepLink: propTypes.string,

  /** Perform any additional actions on button click */
  onClick: propTypes.func
};

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$1 = function() {
  return _root.Date.now();
};

var now_1 = now$1;

/** Error message constants. */
var FUNC_ERROR_TEXT$2 = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$3 = Math.max,
    nativeMin$2 = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce$2(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  wait = toNumber_1(wait) || 0;
  if (isObject_1(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax$3(toNumber_1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin$2(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now_1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now_1());
  }

  function debounced() {
    var time = now_1(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

var debounce_1$1 = debounce$2;

/**
 * Creates a debounced listener to the 'resize' event, which will force the component calling it to re-render after 500ms.
 */
function useForceUpdateOnWindowResize() {
    // Extract the setter func from index 1 of the array returned by useState().
    var _a = useState(), forceUpdate = _a[1];
    // If invoked multiple times, _debounce returns the result of the func passed to it until the wait time is exceeded.
    // Once the wait time is exceeded, the result of _debounce will have a new reference.
    var debounceFn = useMemo(function () { return debounce_1$1(forceUpdate, 500); }, [forceUpdate]);
    useEffect(function () {
        window.addEventListener('resize', debounceFn);
        return function () {
            window.removeEventListener('resize', debounceFn);
        };
    }, 
    // Because we memoized the debounce func, it will only invoke useEffect once the timeout completes.
    [debounceFn]);
}

export { Accordion, Account as AccountIcon, Add as AddIcon, Airplane as AirplaneIcon, Alert as AlertIcon, ArrowButton, Banner, BrandsCarouselHero, Breadcrumbs, BulletedList, ButtonV2, CTAV2, CalendarDay as CalendarDayIcon, Calendar as CalendarIcon, CallToActionSection, Callout as CalloutBubble, Card, CardField, Caret as CaretIcon, Carousel, Cart as CartIcon, Cash as CashIcon, CenteredTitleSection, CheckBoxField as CheckboxField, CheckboxFieldAdapter, CheckboxList, CheckmarkCircle as CheckmarkCircleIcon, Checkmark as CheckmarkIcon, ChevronButton, CircleIcon, ClearCircleIcon, Close as CloseIcon, CreamCircleIcon, DatePicker, DatePickerInput, DatePickerInputAdapter, DeleteIcon, DownArrow as DownArrowIcon, DownCaret as DownCaretIcon, Download as DownloadIcon, Drawer, DrawerV2, Dropdown, DropdownV2, DropdownV2Adapter, EditIcon, Error$1 as Error, Exclamation as ExclamationIcon, FAQSection, FAQSectionItem, FAQSectionV2, Footer, GeoPin as GeoPinIcon, GiftTracker as GiftTrackerIcon, GridSection as HalfGridSection, Hashtag as HashtagIcon, HeroV2, HowItWorksSection, HowItWorksSectionV2, IconButton, ImageBgSection, ImageTile, ImageWithTextSection, Info, InfoCard, InfoFilled as InfoFilledIcon, Info as InfoIcon, InfoTile, InfoTileV2, InfoTilesSection, InputField, InputFieldV2, InputFieldV2Adapter, LeftCaret as LeftCaretIcon, Link, Link$1 as LinkIcon, Lock as LockIcon, Mail as MailIcon, ManageRegistry as ManageRegistryIcon, MinimalFooter, NumberedItem, OnboardRenderFieldWrapper, Overview as OverviewIcon, Porthole as PortholeImage, PreAuthCTA, PreAuthFooter, PreAuthHero, Preview as PreviewIcon, ProgressBar, ProgressBarV2, ProgressRing, RadioField, RadioFieldAdapter, RatingsSection, RatingsTile, ReadyWhenYouAre, RegistryChecklist as RegistryChecklistIcon, Remove as RemoveIcon, RenderCardCheckBoxField, RenderCheckBoxField, RenderField, RenderPillField, RenderRadioField, RenderTextareaField, RightCaret as RightCaretIcon, SearchField, Search as SearchIcon, SegmentControl, SideDrawer, Star as StarIcon, StarOutline as StarOutlineIcon, Stepper, Tabs, Tag, TestimonialCard, TestimonialsHero, TextareaField, TextareaFieldAdapter, Toasts, Toggle, Tooltip, TrackPageViewComponent as TrackPageView, UnderlinedText, Unlock as UnlockIcon, UpArrow as UpArrowIcon, UploadIcon, VideoModal, WhiteCircleIcon, YourPerks as YourPerksIcon, ZolaAppButton, useForceUpdateOnWindowResize };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@zola/zola-ui/build/zola-ui.js
// module id = 3
// module chunks = 70